(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
require("../../modules/00_settings/script.js");
require("../../modules/01_introduction/script.js");
require("../../modules/02_colors/script.js");
require("../../modules/04_buttons/accordion-toggle/script.js");
require("../../modules/04_buttons/bottom-goop/script.js");
require("../../modules/04_buttons/button/script.js");
require("../../modules/04_buttons/circle-plus/script.js");
require("../../modules/04_buttons/close-modal-goop/script.js");
require("../../modules/04_buttons/left-goop/script.js");
require("../../modules/04_buttons/modal-view-more/script.js");
require("../../modules/04_buttons/read-more-goop/script.js");
require("../../modules/04_buttons/script.js");
require("../../modules/04_buttons/skip-button/script.js");
require("../../modules/05_tables/script.js");
require("../../modules/06_lists/script.js");
require("../../modules/07_forms/script.js");
require("../../modules/08_media/img-contain/script.js");
require("../../modules/08_media/img-cover/script.js");
require("../../modules/08_media/lazy-img/script.js");
require("../../modules/08_media/looping-video/script.js");
require("../../modules/08_media/modal-video-player/script.js");
require("../../modules/08_media/plyr-video/script.js");
require("../../modules/08_media/script.js");
require("../../modules/08_media/video-player/script.js");
require("../../modules/09_layout/script.js");
require("../../modules/10_header/header/script.js");
require("../../modules/10_header/script.js");
require("../../modules/10_header/top-nav/script.js");
require("../../modules/10_header/top-super-menu/script.js");
require("../../modules/11_footers/footer-links/script.js");
require("../../modules/11_footers/footer/script.js");
require("../../modules/11_footers/impact/script.js");
require("../../modules/11_footers/script.js");
require("../../modules/12_heroes/action-hero/script.js");
require("../../modules/12_heroes/hero/script.js");
require("../../modules/12_heroes/impact-hero/script.js");
require("../../modules/12_heroes/intro-hero/script.js");
require("../../modules/12_heroes/script.js");
require("../../modules/12_heroes/vision-hero/script.js");
require("../../modules/13_cards/script.js");
require("../../modules/14_carousels/script.js");
require("../../modules/15_brand_sections/script.js");
require("../../modules/16_routing/script.js");
require("../../modules/16_routing/scroll-nav/script.js");
require("../../modules/40_controllers/animation-controller/script.js");
require("../../modules/40_controllers/page-content-controller/script.js");
require("../../modules/40_controllers/page-hero-controller/script.js");
require("../../modules/40_controllers/script.js");
require("../../modules/40_controllers/site-controller/script.js");
require("../../modules/50_content/action/1-reliable-energy/script.js");
require("../../modules/50_content/action/2-cleaner-energy/script.js");
require("../../modules/50_content/action/3-powerful-partnerships/script.js");
require("../../modules/50_content/action/4-personalized-energy/script.js");
require("../../modules/50_content/action/5-our-people/script.js");
require("../../modules/50_content/action/6-positive-nrg/script.js");
require("../../modules/50_content/action/content-blocks/business-units/script.js");
require("../../modules/50_content/action/content-blocks/click-to-play-video/script.js");
require("../../modules/50_content/action/content-blocks/expanding-photo-cols/script.js");
require("../../modules/50_content/action/content-blocks/framed-text/script.js");
require("../../modules/50_content/action/content-blocks/icon-stats/script.js");
require("../../modules/50_content/action/content-blocks/logo-garden/script.js");
require("../../modules/50_content/action/content-blocks/read-more-text/script.js");
require("../../modules/50_content/action/content-blocks/scroll-overlay-slides/script.js");
require("../../modules/50_content/action/content-blocks/scroll-split-slides/script.js");
require("../../modules/50_content/action/content-blocks/split-read-more-graph/script.js");
require("../../modules/50_content/action/content-blocks/split-text-stat-image/script.js");
require("../../modules/50_content/action/content-blocks/stat-banner/script.js");
require("../../modules/50_content/impact/content-blocks/dark-quote/script.js");
require("../../modules/50_content/impact/content-blocks/dark-stats/script.js");
require("../../modules/50_content/impact/content-blocks/fractured-graph-block/script.js");
require("../../modules/50_content/impact/content-blocks/horizontal-graph-block/script.js");
require("../../modules/50_content/impact/content-blocks/icon-big-number/script.js");
require("../../modules/50_content/impact/content-blocks/icon-logo/script.js");
require("../../modules/50_content/impact/content-blocks/icon-number/script.js");
require("../../modules/50_content/impact/content-blocks/mini-stat/script.js");
require("../../modules/50_content/impact/content-blocks/scorecard/script.js");
require("../../modules/50_content/impact/content-blocks/scroll-hero/script.js");
require("../../modules/50_content/impact/content-blocks/stat-block/script.js");
require("../../modules/50_content/impact/content-blocks/vertical-graph-block/script.js");
require("../../modules/50_content/intro/intro-video/script.js");
require("../../modules/50_content/script.js");
require("../../modules/50_content/vision/ceo-hero/script.js");
require("../../modules/50_content/vision/mission/script.js");
require("../../modules/50_content/vision/quote/script.js");
require("../../modules/50_content/vision/signature/script.js");
require("../../modules/60_modals/script.js");
require("../../modules/70_ui/auto-rotator/script.js");
require("../../modules/70_ui/color-selector/script.js");
require("../../modules/70_ui/cursor-zoom/script.js");
require("../../modules/70_ui/image-swappable/script.js");
require("../../modules/70_ui/image-zoom/script.js");
require("../../modules/70_ui/progress-bar/script.js");
require("../../modules/70_ui/rating-stars/script.js");
require("../../modules/70_ui/script.js");
require("../../modules/70_ui/simple-slider/script.js");
require("../../modules/70_ui/size-selector/script.js");
require("../../modules/70_ui/wiggle-photo/script.js");
require("../../modules/80_bits/delaunay/script.js");
require("../../modules/80_bits/fractured-graph/script.js");
require("../../modules/80_bits/gradient-shape/script.js");
require("../../modules/80_bits/horizontal-graph/script.js");
require("../../modules/80_bits/polygon-background/script.js");
require("../../modules/80_bits/render-engine/script.js");
require("../../modules/80_bits/script.js");
require("../../modules/80_bits/stat/script.js");
require("../../modules/80_bits/text-splitter/script.js");
require("../../modules/80_bits/vertical-graph/script.js");
require("../../modules/90_utils/script.js");
require("../../modules/xx_shame/script.js");
},{"../../modules/00_settings/script.js":7,"../../modules/01_introduction/script.js":11,"../../modules/02_colors/script.js":12,"../../modules/04_buttons/accordion-toggle/script.js":13,"../../modules/04_buttons/bottom-goop/script.js":14,"../../modules/04_buttons/button/script.js":15,"../../modules/04_buttons/circle-plus/script.js":16,"../../modules/04_buttons/close-modal-goop/script.js":17,"../../modules/04_buttons/left-goop/script.js":18,"../../modules/04_buttons/modal-view-more/script.js":19,"../../modules/04_buttons/read-more-goop/script.js":20,"../../modules/04_buttons/script.js":21,"../../modules/04_buttons/skip-button/script.js":22,"../../modules/05_tables/script.js":23,"../../modules/06_lists/script.js":24,"../../modules/07_forms/script.js":27,"../../modules/08_media/img-contain/script.js":28,"../../modules/08_media/img-cover/script.js":29,"../../modules/08_media/lazy-img/script.js":30,"../../modules/08_media/looping-video/script.js":31,"../../modules/08_media/modal-video-player/script.js":32,"../../modules/08_media/plyr-video/script.js":33,"../../modules/08_media/script.js":34,"../../modules/08_media/video-player/script.js":35,"../../modules/09_layout/script.js":36,"../../modules/10_header/header/script.js":37,"../../modules/10_header/script.js":38,"../../modules/10_header/top-nav/script.js":39,"../../modules/10_header/top-super-menu/script.js":40,"../../modules/11_footers/footer-links/script.js":41,"../../modules/11_footers/footer/script.js":42,"../../modules/11_footers/impact/script.js":43,"../../modules/11_footers/script.js":44,"../../modules/12_heroes/action-hero/script.js":45,"../../modules/12_heroes/hero/script.js":46,"../../modules/12_heroes/impact-hero/script.js":47,"../../modules/12_heroes/intro-hero/script.js":48,"../../modules/12_heroes/script.js":49,"../../modules/12_heroes/vision-hero/script.js":50,"../../modules/13_cards/script.js":51,"../../modules/14_carousels/script.js":52,"../../modules/15_brand_sections/script.js":53,"../../modules/16_routing/script.js":54,"../../modules/16_routing/scroll-nav/script.js":55,"../../modules/40_controllers/animation-controller/script.js":56,"../../modules/40_controllers/page-content-controller/script.js":57,"../../modules/40_controllers/page-hero-controller/script.js":58,"../../modules/40_controllers/script.js":59,"../../modules/40_controllers/site-controller/script.js":60,"../../modules/50_content/action/1-reliable-energy/script.js":61,"../../modules/50_content/action/2-cleaner-energy/script.js":62,"../../modules/50_content/action/3-powerful-partnerships/script.js":63,"../../modules/50_content/action/4-personalized-energy/script.js":64,"../../modules/50_content/action/5-our-people/script.js":65,"../../modules/50_content/action/6-positive-nrg/script.js":66,"../../modules/50_content/action/content-blocks/business-units/script.js":67,"../../modules/50_content/action/content-blocks/click-to-play-video/script.js":68,"../../modules/50_content/action/content-blocks/expanding-photo-cols/script.js":69,"../../modules/50_content/action/content-blocks/framed-text/script.js":70,"../../modules/50_content/action/content-blocks/icon-stats/script.js":71,"../../modules/50_content/action/content-blocks/logo-garden/script.js":72,"../../modules/50_content/action/content-blocks/read-more-text/script.js":73,"../../modules/50_content/action/content-blocks/scroll-overlay-slides/script.js":74,"../../modules/50_content/action/content-blocks/scroll-split-slides/script.js":75,"../../modules/50_content/action/content-blocks/split-read-more-graph/script.js":76,"../../modules/50_content/action/content-blocks/split-text-stat-image/script.js":77,"../../modules/50_content/action/content-blocks/stat-banner/script.js":78,"../../modules/50_content/impact/content-blocks/dark-quote/script.js":79,"../../modules/50_content/impact/content-blocks/dark-stats/script.js":80,"../../modules/50_content/impact/content-blocks/fractured-graph-block/script.js":81,"../../modules/50_content/impact/content-blocks/horizontal-graph-block/script.js":82,"../../modules/50_content/impact/content-blocks/icon-big-number/script.js":83,"../../modules/50_content/impact/content-blocks/icon-logo/script.js":84,"../../modules/50_content/impact/content-blocks/icon-number/script.js":85,"../../modules/50_content/impact/content-blocks/mini-stat/script.js":86,"../../modules/50_content/impact/content-blocks/scorecard/script.js":87,"../../modules/50_content/impact/content-blocks/scroll-hero/script.js":88,"../../modules/50_content/impact/content-blocks/stat-block/script.js":89,"../../modules/50_content/impact/content-blocks/vertical-graph-block/script.js":90,"../../modules/50_content/intro/intro-video/script.js":91,"../../modules/50_content/script.js":92,"../../modules/50_content/vision/ceo-hero/script.js":93,"../../modules/50_content/vision/mission/script.js":94,"../../modules/50_content/vision/quote/script.js":95,"../../modules/50_content/vision/signature/script.js":96,"../../modules/60_modals/script.js":97,"../../modules/70_ui/auto-rotator/script.js":100,"../../modules/70_ui/color-selector/script.js":101,"../../modules/70_ui/cursor-zoom/script.js":102,"../../modules/70_ui/image-swappable/script.js":103,"../../modules/70_ui/image-zoom/script.js":104,"../../modules/70_ui/progress-bar/script.js":105,"../../modules/70_ui/rating-stars/script.js":106,"../../modules/70_ui/script.js":107,"../../modules/70_ui/simple-slider/script.js":108,"../../modules/70_ui/size-selector/script.js":109,"../../modules/70_ui/wiggle-photo/script.js":112,"../../modules/80_bits/delaunay/script.js":113,"../../modules/80_bits/fractured-graph/script.js":114,"../../modules/80_bits/gradient-shape/script.js":115,"../../modules/80_bits/horizontal-graph/script.js":116,"../../modules/80_bits/polygon-background/script.js":117,"../../modules/80_bits/render-engine/script.js":118,"../../modules/80_bits/script.js":119,"../../modules/80_bits/stat/script.js":120,"../../modules/80_bits/text-splitter/script.js":121,"../../modules/80_bits/vertical-graph/script.js":122,"../../modules/90_utils/script.js":132,"../../modules/xx_shame/script.js":136}],2:[function(require,module,exports){

/*

Render Frame

Global ticker for window.requestAnimationFrame();

Add / remove subscribers.
Very simple - objective is to remove requestAnimationFrame stacking.

// METHODS:
// on(callback, context, recurring, frameDelay){ }
// subscribe to frame trigger(s)

// - callback: callback method (required)
// - context: callback context (optional)
// - recurring: continue listening every frame (optional, default: true)
// - frameDelay: trigger after X frames (optiona, default: 1)

// one(callback, context, frameDelay){ }
// subscribe to only one frame trigger

// - callback: callback method (required)
// - context: callback context (optional)
// - frameDelay: trigger after X frames (optiona, default: 1)

// off(callback, context){ }
// remove listener

// - callback: callback method (required)
// - context: callback context (optional)

Last edited 04.13.17 by David Robbins

*/

class AnimationFrame {

	constructor(){

		this.animationFrame;
		this.frameCount = 0;
		this.subscribers;
		this._init();
	}

	_init(){
		this._tick();
	}

	// public methods

	on(callback, context, recurring, frameDelay){
		this._addListener(callback, context, recurring, frameDelay);
	}

	one(callback, context, frameDelay){
		this._addListener(callback, context, false, frameDelay);
	}

	off(callback, context){
		this._removeListener(callback, context);
	}

	// private methods

	_addListener(callback, context, recurring, frameDelay){

		if(typeof(context) === 'undefined'){ context = null; }
		if(typeof(recurring) === 'undefined'){ recurring = true; }
		if(typeof(frameDelay) === 'undefined'){ frameDelay = 1; }

		//

		if(!this.subscribers){ this.subscribers = []; }

		let match = false;
		for(let i=0, len=this.subscribers.length; i<len; i++){

			let subscriber = this.subscribers[i];

			if(subscriber.callback === callback
				&& subscriber.context === context
				&& subscriber.recurring === recurring
				&& subscriber.frameDelay === frameDelay){

				match = true;
				break;
			}
		}

		if(!match){
			this.subscribers.push({
				callback: callback,
				context: context,
				recurring: recurring,
				frameDelay: frameDelay,
				startFrame: this.frameCount
			});
		}

		// console.log('_addListener', this.subscribers);
	}

	_removeListener(callback, context, recurring, frameDelay){

		if(typeof(context) === 'undefined'){ context = null; }
		if(typeof(recurring) === 'undefined'){ recurring = true; }
		if(typeof(frameDelay) === 'undefined'){ frameDelay = 1; }

		//

		if(!this.subscribers){ this.subscribers = []; }

		for(let i=0, len=this.subscribers.length; i<len; i++){

			let subscriber = this.subscribers[i];

			if(subscriber.callback === callback
				&& subscriber.context === context
				&& subscriber.recurring === recurring
				&& subscriber.frameDelay === frameDelay){

				this.subscribers.splice(i, 1);
				break;
			}
		}
	}

	_triggerFrame(){

		if(this.subscribers && this.subscribers.length){

			// console.log('_triggerFrame b', this.subscribers);

			for(let i=0, len=this.subscribers.length; i<len; i++){

				let subscriber = this.subscribers[i];
				let frameAge = this.frameCount - subscriber.startFrame;

				if(subscriber.frameDelay === 1 || frameAge % subscriber.frameDelay === 0){
					subscriber.callback.apply(subscriber.context, []);
					if(!subscriber.recurring){
						this.subscribers.splice(i,1);
						len--;
						i--;
					}
				}
			}

			// console.log('_triggerFrame a', this.subscribers);
		}
	}

	// ticker

	_tick(){
		this.frameCount ++;
		this.animationFrame = window.requestAnimationFrame(() => {
			this._triggerFrame();
			this._tick();
		});
	}
}

module.exports = AnimationFrame;

},{}],3:[function(require,module,exports){

/*

Breakpoint

Retrieve media query result similar to SCSS breakpoint include.

Min-width and up:

Ex: if(window.SETTINGS.breakpoint.minWidth('screen-small')){ doStuff(); }

Max-width and down:

Ex: if(window.SETTINGS.breakpoint.maxWidth('screen-small')){ doStuff(); }

Last edited 04.14.17 by David Robbins

*/

class Breakpoint {

	constructor(params){
		this.breakpoints = params.breakpoints;
		this._init();
	}

	_init(){
		this._addListeners();
	}

	_addListeners(){

	}

	minWidth(breakpoint, isTouch){

		let breakpointValue = this.getBreakpointValue(breakpoint) + 1;

		if(Modernizr.mq('(min-width:' + breakpointValue + 'px)') && this.checkTouch(isTouch)){
			return true;
		}

		return false;
	}

	maxWidth(breakpoint, isTouch){

		let breakpointValue = this.getBreakpointValue(breakpoint);

		if(Modernizr.mq('(max-width:' + breakpointValue + 'px)') && this.checkTouch(isTouch)){
			return true;
		}

		return false;
	}

	minHeight(breakpoint, isTouch){

		let breakpointValue = this.getBreakpointValue(breakpoint, true) + 1;

		if(Modernizr.mq('(min-height:' + breakpointValue + 'px)') && this.checkTouch(isTouch)){
			return true;
		}

		return false;
	}

	maxHeight(breakpoint, isTouch){

		let breakpointValue = this.getBreakpointValue(breakpoint, true);

		if(Modernizr.mq('(max-height:' + breakpointValue + 'px)') && this.checkTouch(isTouch)){
			return true;
		}

		return false;
	}

	getBreakpointValue(breakpoint){

		let breakpointValue = false;

		if(isNaN(breakpoint)){

			let obj = _.findWhere(this.breakpoints, {id: breakpoint});

			if(typeof(obj.value) !== 'undefined'){
				breakpointValue = obj.value;
			}
		}
		else {
			breakpointValue = parseInt(breakpoint);
		}

		return breakpointValue;
	}

	checkTouch(isTouch){

		let supportsTouch = $('html').hasClass('supports-touchevents');

		if(isTouch === true){
			if(supportsTouch){ return true; }
			return false;
		}
		else if(isTouch === false){
			if(!supportsTouch){ return true; }
			return false;
		}

		return true;
	}
}

module.exports = Breakpoint;

},{}],4:[function(require,module,exports){

/*

DomScan


Last edited 02.07.17 by David Robbins

Specify selector or container to activate element code.

Can be housed within addContainer...
Example:

window.SETTINGS.domScan.addContainer($('#header-wrapper'), ($scanContainer) => {
	window.SETTINGS.domScan.addElement($scanContainer, [data-my-module], () => {
		// do stuff
	});
});

Or independently specified...
Example:

window.SETTINGS.domScan.addElement($('#element-wrapper'), [data-my-module], () => {
	// do stuff
});


*/

let Vent = require('./vent.js');

let instance = null; // singleton pt. 1/3

class DomScan {

	constructor(){

		// singleton pt. 2/3
		// is only called by first instance

		if(!instance){
			instance = this;
			this.init();
		}

		// singleton pt. 3/3

		return instance;
	}

	init(){

		if(!window.vent){
			window.vent = new Vent();
		}
	}

	// public methods

	addContainer($scanContainer, callback, subCats){

		// register a container that may contain mods at some point
		// allows for faster, more specific scans than if everything were in $('.body')

		let onDomUpdate = ((e, obj) => {
			$scanContainer = this._validateScanContainer($scanContainer);
			callback.apply(null, [$scanContainer]);
		});

		let eventName = 'domUpdate' + (subCats ? ':' + subCats.trim() : '');
		window.vent.on(eventName, onDomUpdate, this);

		onDomUpdate();
	};

	addElement($scanContainer, selector, callback, subCats){

		$scanContainer = this._validateScanContainer($scanContainer);
		$scanContainer.find(selector).each(function(){

			let $this = $(this);

			if ( !$this.data('ds-initialized') || $this.data('ds-initialized').indexOf(selector) < 0) {

				if(!$this.data('ds-initialized')){
					$this.data('ds-initialized', []);
				}

				if($this.data('auto-init') !== false){
					$this.data('ds-initialized').push(selector);
					callback.apply($this);
				}
			}
		});
	};

	// private

	_validateScanContainer($scanContainer){

		if ( typeof($scanContainer) === 'undefined' || !$scanContainer ) {
			$scanContainer = $('body');
		}

		if(!$scanContainer instanceof jQuery){
			$scanContainer = $($scanContainer);
		}

		return $scanContainer;
	};
}

module.exports = DomScan;

},{"./vent.js":10}],5:[function(require,module,exports){

let el = document.createElement('x-test');

let supportsBackgroundClipText = typeof el.style.BackgroundClip !== 'undefined' && (el.style.BackgroundClip = 'text', el.style.BackgroundClip === 'text');

let supportsWebkitBackgroundClipText = typeof el.style.webkitBackgroundClip !== 'undefined' && (el.style.webkitBackgroundClip = 'text', el.style.webkitBackgroundClip === 'text');

if(!supportsBackgroundClipText && !supportsWebkitBackgroundClipText) {
	$('body').addClass('no-background-clip-text');
}

// window.location.origin fix for IE

if (!window.location.origin) {
  window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
}

},{}],6:[function(require,module,exports){

const Navigo = require('../90_utils/Navigo');

let instance = null; // singleton

class Router {

	constructor(el, params){

		if(!instance){
			instance = this;
			this._init();
		}

		return instance;
	}

	_init(){

		// vars

		this.routeObj;
		this.isSilent;
		this.isPending;

		// config router

		this._config();
		this._firstPage();
	}

	_config(){

		this.router = new Navigo(window.SETTINGS.paths.root);

		let processRoute = (pageId, params) => {
			console.log('processRoute', pageId, params, 'silent?', this.isSilent);
			if(!this.isSilent){
				let sectionId = params ? this._validateSubsection(pageId, params.subsection) : '';
				this._triggerContentChange(pageId, sectionId);
			}
			this.isSilent = false;
		}

		this.router.on({

			'intro/*': (params) => { processRoute('intro', null); },
			'intro': (params) => { processRoute('intro', null); },

			'home/*': (params) => { processRoute('intro', null); },
			'home': (params) => { processRoute('intro', null); },

			'vision/:subsection': (params) => { processRoute('vision', params); },
			'vision/:subsection/*': (params) => { processRoute('vision', params); },
			'vision': (params) => { processRoute('vision', params); },

			'action/:subsection': (params) => { processRoute('action', params); },
			'action/:subsection/*': (params) => { processRoute('action', params); },
			'action': (params) => { processRoute('action', params); },

			'impact/:subsection': (params) => { processRoute('impact', params); },
			'impact/:subsection/*': (params) => { processRoute('impact', params); },
			'impact': (params) => { processRoute('impact', params); }

		}).resolve();

		this.router.notFound((query) => {
			this._triggerContentChange('intro');
		});

		this._addListeners();
	}

	_firstPage(){
		let route = this.getRoute() || 'intro';
		this._navigateTo(route);
	}

	// listeners -------------------------------------------------------------------------------  /

	_addListeners(){
		window.vent.on('changeRoute', this._onChangeRoute, this);
		window.vent.on('silentRoute', this._onSilentRoute, this);
		window.vent.on('domUpdate', this._onLinkScan, this);
	}

	// listener methods

	_onChangeRoute(e, params){
		if(params && params.route && this.getRoute() !== this._cleanRoute(params.route)){
			this._navigateTo(params.route);
		}
	}

	_onSilentRoute(e, params){
		if(params && params.route && this.getRoute() !== this._cleanRoute(params.route)){
			this._navigateTo(params.route, true);
		}
	}

	_onLinkScan(e){

		let $a = $('a');
		$a.off('click', $.proxy(this._onLinkClick, this));
		$a.on('click', $.proxy(this._onLinkClick, this));

		$('a[target="_blank"]').attr('title', 'This link will open a new window or tab depending on your browser settings.');
		$a.addClass('linked');
	}

	_onLinkClick(e){

		let $target = $(e.currentTarget);
		let href = this._cleanRoute($target.attr('href'));
		let hrefObj = href.split('/');
		let target = $target.attr('target');

		if(href && href !== 'javascript:;' && target !== '_blank' && !this.isPending){

			let route = this.getRoute();
			let routeObj = this.getRouteObj();

			if($('body').hasClass('page-loaded')){

				let delay = 0;
				let modalCloseDelay = 0;

				this.isPending = true;

				if($('.modaal-wrapper').length){

					// let modal close before content changes

					delay = 400;

					if(window.SETTINGS.breakpoint.maxWidth('screen-medium', true)){
						delay = 600;
						modalCloseDelay = 300;
					}

					window.setTimeout(() => {
						window.vent.trigger('closeModal');
					}, modalCloseDelay);
				}

				window.setTimeout(() => {

					this.isPending = false;

					if(href === route || (hrefObj[0] === routeObj.pageId && !hrefObj[1] && !routeObj.sectionId)){
						window.vent.trigger('silentRoute', {route: href});
					} else {
						window.vent.trigger('linkChangeRoute', {route:$target.attr('href')});
						window.vent.trigger('changeRoute', {route: href});
					}
				}, delay);
			}
			e.preventDefault();
		}
	}

	// primary methods -------------------------------------------------------------------------  /

	// change page URL (will trigger content change through router)

	_navigateTo(newRoute, isSilent){
		this.isSilent = (isSilent === true);
		this.router.navigate(this._cleanRoute(newRoute));
	}

	// change page content (render changes on dom)

	_triggerContentChange(pageId, sectionId){

		let newRoute = this._cleanRoute(this._cleanRoute(pageId) + '/' + this._cleanRoute(sectionId));

		if(!this.routeObj || this.routeObj.route !== newRoute){

			sectionId = sectionId ? sectionId : null;

			let route = {
				pageId: pageId,
				sectionId: sectionId,
				route: newRoute
			}

			this.routeObj = route;

			window.vent.trigger('changePageContent', {id:pageId, sectionId:sectionId});
		}
	}

	// utils -----------------------------------------------------------------------------------  /

	// remove extra slashes from route, format for comparison and router.navigate

	_cleanRoute(newRoute){

		if(newRoute){

			newRoute = newRoute.replace(/\/+$/, '') + '/';

			let splitRoute = (route) => {
				if(route.charAt(0) === '/'){ route = route.substr(1); }
				if(route.charAt(route.length-1) === '/'){ route = route.substr(0, route.length-1); }
				return route.split('/');
			}

			return splitRoute(newRoute).join('/');
		}

		return '';
	}

	_validateSubsection(pageId, sectionId){

		if(pageId && sectionId){
			let pageObj = window.SETTINGS.pageSections[pageId].sections;
			if(pageObj){
				let result = _.findWhere(pageObj, {id: sectionId});
				if(result){ return sectionId; }
			}
		}
		return '';
	}

	// getters ---------------------------------------------------------------------------------  /

	getRoute(){
		return this.getRouteObj().route;
	}

	getRouteObj(){
		return Object.assign({}, this.routeObj);
	}

	getParams(){
		return this.router.getParams();
	}
}

module.exports = Router;

},{"../90_utils/Navigo":127}],7:[function(require,module,exports){
const AnimationUtils 		= require('../90_utils/AnimationUtils');
const BrowserUtils 			= require('../90_utils/BrowserUtils');
const DOMUtils 				= require('../90_utils/DOMUtils');
const NumberUtils 			= require('../90_utils/NumberUtils');
const PositioningUtils 		= require('../90_utils/PositioningUtils');
const Loader 				= require('../90_utils/Loader');

const AnimationFrame		= require('./animation-frame');
const Breakpoint 			= require('./breakpoint');
const DomScan 				= require('./dom-scan');
const Router 				= require('./router');
const ScrollAnimations 		= require('./scroll-animations');

// const RenderEngine 	    	= require('../80_bits/render-engine/script');
const SiteController 		= require('../40_controllers/site-controller/script');

require('./polyfill.js');

(function($){

	/* jshint devel:true */
	'use strict';

	// global var buckets (public)

	window.SETTINGS = {};

	// internal vars

	let $window     = $(window);
	let	$body       = $(document.body);
	let	$html       = $(document.documentElement);
	let $main 		= $('#main');

	let	WS          = window.SETTINGS;

	// templates

	WS.templates = {
		content : [
			{ id: 'intro' },
			{ id: 'vision' },
			{
				id: 'action',
				sections: [
					{ id: 'reliable-energy' },
					{ id: 'cleaner-energy' },
					{ id: 'powerful-partnerships' },
					{ id: 'personalized-energy' },
					{ id: 'our-people' },
					{ id: 'positive-nrg' }
				]
			},
			{ id: 'impact' }
		],
		heroes : [
			{ id: 'intro' },
			{ id: 'vision' },
			{
				id: 'action',
				sections: [
					{ id: 'reliable-energy' },
					{ id: 'cleaner-energy' },
					{ id: 'powerful-partnerships' },
					{ id: 'personalized-energy' },
					{ id: 'our-people' },
					{ id: 'positive-nrg' }
				]
			},
			{ id: 'impact' }
		],
		modals : [
			{ id: 'downloads' },
			{ id: 'employer-brand-video' },
			{ id: 'index' },
			{ id: 'intro-video' },
			{ id: 'lobby-video' },
			{ id: 'mgm' },
			{ id: 'new-ideas' },
			{ id: 'petra-nova' },
			{ id: 'positive-nrg' },
			{ id: 'positive-nrg-video' },
			{ id: 'xprize-video' }
		]
	};

	// page / section associations

	WS.pageSections = {
		action: {
			title: 'NRG Year in Review - Action',
			sections: [
				{
					id: 'reliable-energy',
					title: 'Reliable Energy'
				},
				{
					id: 'cleaner-energy',
					title: 'Cleaner Energy'
				},
				{
					id: 'powerful-partnerships',
					title: 'Powerful Partnerships'
				},
				{
					id: 'personalized-energy',
					title: 'Personalized Energy'
				},
				{
					id: 'our-people',
					title: 'Our People'
				},
				{
					id: 'positive-nrg',
					title: 'positiveNRG'
				}
			]
		},
		impact: {
			title: 'NRG Year in Review - Impact',
			scrollSections: true,
			sections: [
				{
					id: 'numbers',
					title: '2016 By the Numbers'
				},
				{
					id: 'finances',
					title: 'Our Financial Strength'
				},
				{
					id: 'portfolio',
					title: 'A Leading Portfolio'
				},
				{
					id: 'growth',
					title: 'Renewable Footprint Growth'
				},
				{
					id: 'service',
					title: 'Award-Winning Service'
				},
				{
					id: 'community',
					title: 'A Generous Community'
				}
			]
		},
		intro: {
			title: 'NRG Year in Review - Intro'
		},
		vision: {
			title: 'NRG Year in Review - Vision',
			scrollSections: true,
			sections: [
				{
					id: 'ceo-introduction',
					title: 'CEO Bio'
				},
				{
					id: 'vision-mission',
					title: 'Vision / Mission'
				}
			]
		}
	}

	// global coords

	WS.coords = {
		containerWidth: 1920
	};

	// breakpoint detection

	WS.breakpoint = new Breakpoint({

		breakpoints: [
			{
				id: 'screen-tiny',
				value: 480
			},
			{
				id: 'screen-phablet',
				value: 640
			},
			{
				id: 'screen-small',
				value: 768
			},
			{
				id: 'screen-medium',
				value: 1024
			},
			{
				id: 'screen-large',
				value: 1280
			},
			{
				id: 'screen-xlarge',
				value: 1480
			},
			{
				id: 'screen-xxlarge',
				value: 1600
			},
			{
				id: 'screen-xxlarge',
				value: 1920
			}
		]
	});

	// paths

	WS.paths = {
		root 	: window.location.origin + ''
	}

	// modals

	WS.modals = {};

	// global variables (use sparingly)

	WS.vars = {
		svgIndex: 0
	};

	// global dom elements

	WS.elems            = {};
	WS.elems.html       = $('html');
	WS.elems.body       = $('body');

	// utility classes

	WS.domScan 			= new DomScan();
	WS.animationFrame	= new AnimationFrame();

	// animation settings

	WS.animation 		= {};
	WS.frameInterval 	= 160;
	WS.maxShakes 		= 16;

	// SimpleAnchors

	$.simpleAnchors({
		offset: -1, // 80-1, header height on scroll
		easing: 'easeInOutCubic'
	});

	// super duper throttled window resize event listener

	WS.coords.getDocHeight = () => {
		return $main.outerHeight();
	}

	let updateWinCoords = () => {
		WS.coords.winWidth			= window.innerWidth;
		WS.coords.winHeight			= window.innerHeight;
		WS.coords.docWidth			= $main.outerWidth();
		WS.coords.docHeight			= $main.outerHeight();
		WS.coords.viewportWidth		= Math.min(WS.coords.containerWidth, WS.coords.winWidth);
		WS.coords.scrollbarWidth	= Math.abs(WS.coords.winWidth - WS.coords.docWidth);
	}

	updateWinCoords();

	// let triggerResizeEvent = ((e) => {
	// 	updateWinCoords();
	// 	window.vent.trigger('windowResize', {originalEvent:e});
	// });

	// let resizeThrottler = _.throttle(triggerResizeEvent, 400);

	// $window.on('resize', resizeThrottler);
	// $window.on('orientationchange', resizeThrottler);
	// $window.on('load', resizeThrottler);

	// window.requestAnimationFrame(resizeThrottler);

	// global mouse coords

	$body.on('mousemove', (e) => {

		WS.coords.pageX = e.pageX;
		WS.coords.pageY = e.pageY;
		WS.coords.clientX = e.clientX;
		WS.coords.clientY = e.clientY;

		window.vent.trigger('mousemove', {
			originalEvent: e,
			pageX: WS.coords.pageX,
			pageY: WS.coords.pageY,
			clientX: WS.coords.clientX,
			clientY: WS.coords.clientY
		});
	});

	// initialize site

	if($('#main').length){

		WS.controllers = {}
		WS.controllers.site = new SiteController($('#main'), {});

		WS.router = new Router();
	}

	WS._scrollAnimations = new ScrollAnimations();

	//

	window.vent.trigger('domUpdate');
	// window.RENGINE = new RenderEngine();

	//

	let onResize = (e) => {

		updateWinCoords();
		window.vent.trigger('windowResize', {originalEvent:e});

		if(window.SETTINGS.breakpoint.maxWidth('screen-small')){
			// window.RENGINE.pause();
		}
		else {
			// window.RENGINE.unpause();
		}
	};

	$window.on('resize', onResize);
	$window.on('orientationchange', onResize);
	$window.on('load', onResize);

	window.requestAnimationFrame(() => {
		FastClick.attach(document.body);
		onResize();
	});

})(window.jQuery);

},{"../40_controllers/site-controller/script":60,"../90_utils/AnimationUtils":123,"../90_utils/BrowserUtils":124,"../90_utils/DOMUtils":125,"../90_utils/Loader":126,"../90_utils/NumberUtils":128,"../90_utils/PositioningUtils":129,"./animation-frame":2,"./breakpoint":3,"./dom-scan":4,"./polyfill.js":5,"./router":6,"./scroll-animations":8}],8:[function(require,module,exports){

const Loader = require('./skrollex');

let instance = null; // singleton pt. 1/3

class ScrollAnimations {

	constructor(el, params){

		// singleton pt. 2/3
		// is only called by first instance

		if(!instance){

			instance = this;

			// vars

			this.$el = $(el);
			this.params = params;

			this.skrollex;

			// init

			this.init();
		}

		// singleton pt. 3/3

		return instance;
	}

	init(){

		this.scrollObj;

		this.addListeners();
		this.skrollex();
	}

	// event listeners

	addListeners(){
		window.vent.on('scrollTo', this._onScrollTo, this);
		window.vent.on('cancelScroll', this._onCancelScroll, this);
	}

	// listener methods

	_onScrollTo(e, params){

		let $window = $(window);
		let animationTime = (params && !isNaN(params.animationTime)) ? params.animationTime : 0.8;
		let scrollTop = (params && !isNaN(params.scrollTop)) ? params.scrollTop : 0;

		window.vent.trigger('windowResize');

		this.scrollObj = {scrollTop: $window.scrollTop()};
		TweenMax.to(this.scrollObj, animationTime, {scrollTop: scrollTop, ease:'scrollEase', onUpdate:() => {
			$window.scrollTop(this.scrollObj.scrollTop);
		}});
	}

	_onCancelScroll(){
		if(this.scrollObj){
			TweenMax.killTweensOf(this.scrollObj);
			this.scrollObj = null;
		}
	}

	// skrollex initialization

	skrollex(){

		this.skrollex = new Skrollex({

			minWidth: 1024,
			staggerBefore: 0.04,
			staggerAfter: 0.04,

			onRender: function(e, params){

			},

			onPendingShow: function(e, params){

			},

			onPendingHide: function(e, params){

			},

			onViewportEnter: function(e, params){

				// if ( e.$el.is('video') ) {
				// 	e.$el[0].play();
				// }

				// let attr = e.$el.data('plyr-video');

				// if ( typeof attr !== typeof undefined && attr !== false ) {
				// 	e.$el.triggerHandler('play');
				// }
			},

			onViewportLeave: function(e, params){

				// if ( e.$el.is('video') ) {
				// 	e.$el[0].pause();
				// }

				// let attr = e.$el.data('plyr-video');

				// if ( typeof attr !== typeof undefined && attr !== false ) {
				// 	e.$el.triggerHandler('pause');
				// }
			},

			onShow: function(e, params){

				let $el = e.$el;
				$el.addClass('anim-start');

				window.utils.AnimationUtils.oneTransitionComplete($el, () => {

					$el.removeClass('anim-start');
					$el.addClass('anim-in');

					checkUniqueStarts();

				}, () => {

					$el.removeClass('anim-in');
					$el.addClass('anim-in-complete');

					checkUniqueCompletes();

				}, true);

				//

				function checkUniqueStarts(){

					// if(typeof($el.attr('data-split-text')) !== 'undefined'){

					// 	$el.find('.line').each((index, value) => {

					// 		let $line = $(value);

					// 		TweenMax.set($line, {
					// 			'transform-origin' : Math.round(Math.random() * 100) + '% ' + Math.round(Math.random() * 100) + '%',
					// 			'rotation' : (Math.random() * 4 - Math.random() * 4) * 15,
					// 			'y' : 100 + Math.round(Math.random() * 4) * 20
					// 		});
					// 	});
					// }
				}

				function checkUniqueCompletes(){

				}
			},

			onHide: function(e, params){

			},

			onRemove: function(e, params){

			}
		});
	}
}

module.exports = ScrollAnimations;

},{"./skrollex":9}],9:[function(require,module,exports){

/*

Modernizr Media Query detection:

https://modernizr.com/docs

Modernizr.mq('(min-width: 900px)');

*

** Skrollex.js **

Features:

- Tracks scroll triggered elements on the page, fires events when visible.
- Allows 'scroll locking' to a specific zone (when using scrolling modals, for example).

---

Dependencies:

- jQuery
- Modernizr
- GSAP

---

Todo:

- Adjust delay based on vertical height of object.
- Allow for multiple scroll groups
- Make gutter distance based on scroll speed

---

Last update 12.13.16 by David Robbins

*/

;(function(window){

	'use strict';

	function Skrollex(options){

		// vars

		var self = this;
		var timer;

		self.options = options || {};
		self.defaults = {

			$el: null,							// if left empty will default to body
			$container: null,					// if left empty will default to window

			autoStart: true,					// automatically initialize event listeners and scroll checking
			disableOnTablet: true,				// do not initialize on tablet
			disableOnMobile: true,				// do not initialize on mobile

			// tweaks

			zSort: false,											// sort all elements on-screen with by z-index
			force3D: false,											// enable gpu acceleration for all elements (only recommended for opaque elements)
			staggerBefore: 0.06,									// delay before element is triggered (stacks in queue when grouped)
			staggerAfter: 0.06,										// delay applied to next element in queue
			staggerDownOnly: true,									// only stagger elements based on position when scrolling down
			initClass: 'sk-active',									// identifies which modules have been initialized with skrollex
			hideOffscreen: false,									// hide elements off screen (will re-animate in, also can be performance boost)
			hideClass: 'invisible',									// class used to hide elements(invisible, opacity-0, display-none, hide)
			showClass: 'sk-showing',								// class signifying skrollex has triggered an 'onShow' event
			viewportEnterClass: 'sk-viewport-enter',				// class signifying skrollex has triggered an 'onShow' event
			minWidth: 768,											// minimum width for scroll hide/show, otherwise always visible
			showGutterTop: 0,										// pixels inside of screen for trigger events to happen
			showGutterBottom: 80,									// pixels inside of screen for trigger events to happen
			renderGutterTop: 0,										// pixels outside of screen for hide class to be added/removed
			renderGutterBottom: 0,									// pixels outside of screen for hide class to be added/removed

			// data attributes

			staggerId: 'skrollex',									// required attribute to be included to skrollex
			groupId: 'sk-group',									// required attribute for grouped timing

			// individual override data attributes
			// * indicates default if no value specified

			zSortId: 'sk-z-sort',									// override zSort (true*, false)
			force3DId: 'sk-force3d',								// override force3D (true*, false)
			staggerBeforeId: 'sk-sb-delay',							// override staggerBefore (Number)
			staggerAfterId: 'sk-sa-delay',							// override staggerAfter (Number)
			staggerDownOnlyId: 'sk-stagger-down',					// override staggerTime (Number)
			hideOffscreenId: 'sk-hide-offscreen',					// override hideOffscreen (true, false*)
			hideClassId: 'sk-hide-class',							// override hideClass (invisible*, opacity-0, display-none, hide)
			showClassId: 'sk-show-class',							// override showClass (String)
			viewportEnterClassId: 'sk-viewport-enter-class',		// override viewportEnterClass (String)
			minWidthId: 'sk-min-width',								// override minWidth (Number)
			showGutterTopId: 'sk-show-gutter-top',					// override showGutterTop (Number)
			showGutterBottomId: 'sk-show-gutter-bottom',			// override showGutterBottom (Number)
			renderGutterTopId: 'sk-render-gutter-top',				// override renderGutterTop (Number)
			renderGutterBottomId: 'sk-render-gutter-bottom',		// override renderGutterBottom (Number);

			// callbacks

			onRender: null,						// callback when element is triggered to render
			onViewportEnter: null,				// callback when element has entered the viewport
			onViewportLeave: null,				// callback when element has left the viewport
			onPendingShow: null,				// callback when element is waiting to appear
			onPendingHide: null,				// callback when element is waiting to disappear
			onShow: null,						// callback when element is triggered to appear
			onHide: null,						// callback when element is triggered to disappear
			onReset: null,						// callback when element is reset
			onRemove: null,						// callback when element is removed
		};

		//

		self.$el = null,
		self.$container = null;

		// scroll triggering

		self.lastGroupTriggerTime = 0;
		self.lastGroupTriggerDelay = 0;
		self.scrollTriggeredElements = [];
		self.scrollTriggersQueued = [];
		self.modules = [];

		// window vars

		self.winWidth = null;
		self.winHeight = null;
		self.scrollTop = null;
		self.lastScrollTop = null;

		//

		self.throttleTimer = null;
		self.isTicked = false;

		// init

		self._init();
	}

	//

	Skrollex.prototype = {

		_init: function(){

			var self = this;
			self.options = self._merge(self.options, self.defaults);

			// $('body').addClass('skrollex-enabled');
			$(function(){
				self._domReady();
			});
		},

		update: function(){

			var self = this;
			self._scanDom();
		},

		// begin private methods ---------------------------------------------------------------  /

		_domReady: function(){

			var self = this;

			self.$el = self.options.$el = self._checkVal(self.options.$el, $('body'));
			self.$container = self.options.$container = self._checkVal(self.options.$container, $(window));

			self._addListeners();
			self._windowResize();
			self._scanDom();

			window.SETTINGS.animationFrame.one(function(){
				self._scrollTick();
			});
		},

		// listeners ---------------------------------------------------------------------------  /

		_addListeners: function(){

			var self = this;

			var timer;

			self.$container.on('resize', $.proxy(this._onWindowResize, this));
			self.$container.on('scroll', $.proxy(this._onScroll, this));
			// self.$container.mousewheel($.proxy(this._onMouseWheel, this));

			// global vent object listeners
			// create window.vent if necessary

			window.vent.on('domUpdate', self._onDomUpdate, self);
		},

		_removeListeners: function(){

			var self = this;

			var timer;

			self.$container.off('resize', $.proxy(this._onWindowResize, this));
			self.$container.off('scroll', $.proxy(this._onScroll, this));
			// self.$container.unmousewheel($.proxy(this._onMouseWheel, this));

			// global vent object listeners

			window.vent.off('domUpdate', self._onDomUpdate, self);
		},

		// listener methods

		_onWindowResize: function(){

			var self = this;
			self._windowResize();
			self._scrollTick();
		},

		_onScroll: function(){

			var self = this;
			self._scrollTick();
		},

		_onMouseWheel: function(e, delta){

			var self = this;
			self._scrollTick();
		},

		// vent object listener methods

		_onDomUpdate: function(){

			var self = this;
			self._scanDom();

			window.SETTINGS.animationFrame.one(function(){
				self._scrollTick();
			});
		},

		// scan dom for changes ----------------------------------------------------------------  /

		_scanDom: function(){

			var self = this;
			self._updateScrollTriggerElements();
		},

		// scroll triggered elements ----------------------------------------------------------------  /

		// dom elements w/ scroll-triggered class will be animated as they appear
		// animation options can be specified with data-scroll-animation-id attribute

		_updateScrollTriggerElements: function(){

			var self = this;
			var $scrollTriggeredElements = self.$el.find('[data-' + self.options.staggerId + ']');
			var $sortedTriggeredElements = self._sortDomElements($scrollTriggeredElements);

			// look for new scroll triggered elements that are not already tracked

			var foundElements = [];
			var newElements = [];

			for(var i=0; i<$sortedTriggeredElements.length; i++){

				var $scrollElement = $($sortedTriggeredElements[i]);
				var isFound = false;

				for(var k=0; k<self.scrollTriggeredElements.length; k++){

					var scrollTriggeredElement = self.scrollTriggeredElements[k];

					if(scrollTriggeredElement.$el[0] === $scrollElement[0]){

						if(foundElements.indexOf(scrollTriggeredElement) === -1){
							if(Modernizr.mq('(min-width:' + scrollTriggeredElement.minWidth + 'px)')){
								foundElements.push(scrollTriggeredElement);
							}
						}

						isFound = true;
						break;
					}
				}

				if(!isFound){

					var elementConfig = {

						$el: $scrollElement,
						$container: self.$el,

						// data vars options

						zSort: self._parseBool(self._checkVal($scrollElement.attr('data-' + self.options.zSortId), self.options.zSort, true)),
						force3D: self._parseBool(self._checkVal($scrollElement.attr('data-' + self.options.force3DId), self.options.force3D, true)),
						staggerBefore: parseFloat(self._checkVal($scrollElement.attr('data-' + self.options.staggerBeforeId), self.options.staggerBefore)),
						staggerAfter: parseFloat(self._checkVal($scrollElement.attr('data-' + self.options.staggerAfterId), self.options.staggerAfter)),
						staggerDownOnly: self._parseBool(self._checkVal($scrollElement.attr('data-' + self.options.staggerDownOnlyId), self.options.staggerDownOnly, true)),
						hideOffscreen: self._parseBool(self._checkVal($scrollElement.attr('data-' + self.options.hideOffscreenId), self.options.hideOffscreen, true)),
						hideClass: self._checkVal($scrollElement.attr('data-' + self.options.hideClassId), self.options.hideClass),
						showClass: self._checkVal($scrollElement.attr('data-' + self.options.showClassId), self.options.showClass),
						viewportEnterClass: self._checkVal($scrollElement.attr('data-' + self.options.viewportEnterClassId), self.options.viewportEnterClass),
						minWidth: self._checkVal($scrollElement.attr('data-' + self.options.minWidthId), self.options.minWidth),
						showGutterTop: self._checkVal($scrollElement.attr('data-' + self.options.showGutterTopId), self.options.showGutterTop),
						showGutterBottom: self._checkVal($scrollElement.attr('data-' + self.options.showGutterBottomId), self.options.showGutterBottom),
						renderGutterTop: self._checkVal($scrollElement.attr('data-' + self.options.renderGutterTopId), self.options.renderGutterTop),
						renderGutterBottom: self._checkVal($scrollElement.attr('data-' + self.options.renderGutterBottomId), self.options.renderGutterBottom),

						// default variables

						isEnabled: true,
						isTriggered: false,
						isPendingTrigger: false,
						isInitialConfig: true,
						isInViewport: false,
						isRendered: false,
						isShowing: false,
						isOut: true,

						// display delay timer

						delayedCall: null,

						//

						sk: self
					};

					if(Modernizr.mq('(min-width:' + elementConfig.minWidth + 'px)')){
						$scrollElement.addClass(self.options.initClass);
						$scrollElement.data('skrollex', elementConfig);
						newElements.push(elementConfig);
					}
				}
			}

			// find what's not on screen and remove/destroy

			var removedElements = self._difference(self.scrollTriggeredElements, foundElements);

			self._each(removedElements, function(scrollElement, i){
				self.removeElement(scrollElement);
			});

			// combine new and existing

			self.scrollTriggeredElements = self._union(newElements, foundElements);
			self._sortZIndexElements(self.$el);
			self._setElementSizeClasses();

			if(self._isDesktop()){

				self._each(self.scrollTriggeredElements, function(scrollElement){
					self._tickElement(scrollElement);
				});
			}
			else {

				self._each(self.scrollTriggeredElements, function(scrollElement){
					self.showElement(scrollElement);
				});
			}
		},

		// remove all elements

		_removeScrollTriggerElements: function(){

			var self = this;

			self._each(self.scrollTriggeredElements, function(scrollElement){
				self.removeElement(scrollElement);
			});

			self.scrollTriggeredElements = [];
		},

		// tick element

		_tickElement: function(scrollElement){

			var self = this;

			if(self._isDesktop()){

				if(self.$el){

					var elOffset = scrollElement.$el.offset();

					if(elOffset && self.scrollTop !== null){

						var elPos = {x:elOffset.left, y:elOffset.top - self.scrollTop};
						var elHeight = scrollElement.$el.outerHeight(true);

						var elTop = elPos.y;
						var elBottom = elTop + elHeight;

						var showRegionTop = 0 + scrollElement.showGutterTop;
						var showRegionBottom = self.winHeight - scrollElement.showGutterBottom;

						var renderRegionTop = 0 - scrollElement.renderGutterTop;
						var renderRegionBottom = self.winHeight + scrollElement.renderGutterBottom;

						// set rendering mode if need be

						if(scrollElement.isInitialConfig){

							if(scrollElement.gpuAccelerate){
								TweenMax.set(scrollElement.$el, {force3D:true});
							}

							scrollElement.isInitialConfig = false;
						}

						// trigger direction

						var scrollDirection;

						if(self.lastScrollTop < self.scrollTop){ scrollDirection = 'down'; }
						else if(self.lastScrollTop > self.scrollTop){ scrollDirection = 'up'; }
						else { scrollDirection = 'none'; }

						// check if on screen at all
						// render if within render gutter

						if(elBottom >= renderRegionTop && elTop <= renderRegionBottom){

							// fire event - element is in viewport

							if(!scrollElement.isInViewport){
								self._triggerElementEnterViewport(scrollElement, { direction: scrollDirection });
							}

							// render element

							if(scrollElement.isOut !== false && scrollElement.isTriggered && !scrollElement.isPendingTrigger){
								self.renderElement(scrollElement);
							}
						}

						// check for triggers

						if((elBottom >= showRegionTop || self.scrollTop <= showRegionTop) && elTop <= showRegionBottom){

							// within show region - show element

							if(!scrollElement.isPendingTrigger && !scrollElement.isTriggered){
								self._triggerElementShow(scrollElement, { direction: scrollDirection });
							}
						}
						else if(elTop >= renderRegionBottom || elBottom <= renderRegionTop) {

							// fire event - element has left viewport

							if(scrollElement.isInViewport){
								self._triggerElementLeaveViewport(scrollElement, { direction: scrollDirection });
							}

							// outside show region - hide element

							if(scrollElement.hideOffscreen || !scrollElement.animateOnce){

								var exitDirection;

								if(elBottom <= renderRegionTop){ exitDirection = 'top'; }
								else if(elTop >= renderRegionBottom){ exitDirection = 'bottom'; }

								if(exitDirection && (scrollElement.isTriggered || scrollElement.isPendingTrigger)){

									if(scrollElement.hideOffscreen){
										self._triggerElementHide(scrollElement, { direction: scrollDirection, exitDirection: exitDirection });
									}
								}
							}
						}
					}
					else {
						self._scrollTick();
					}
				}

			} else {
				self.showElement(scrollElement);
			}
		},

		_triggerElementEnterViewport: function(scrollElement, params){

			var self = this;

			if(!scrollElement.isInViewport){

				scrollElement.isInViewport = true;

				if($.isFunction(self.options.onViewportEnter)){
					self.options.onViewportEnter.apply(null, [scrollElement, params]);
				}

				scrollElement.$el.addClass(scrollElement.viewportEnterClass);
				scrollElement.$el.triggerHandler('viewportEnter', self._extend({}, params));
			}
		},

		_triggerElementLeaveViewport: function(scrollElement, params){

			var self = this;

			if(scrollElement.isInViewport){

				scrollElement.isInViewport = false;

				if($.isFunction(self.options.onViewportLeave)){
					self.options.onViewportLeave.apply(null, [scrollElement, params]);
				}

				scrollElement.$el.removeClass(scrollElement.viewportEnterClass);
				scrollElement.$el.triggerHandler('viewportLeave', self._extend({}, params));
			}
		},

		_triggerElementShow: function(scrollElement, params){

			var self = this;

			if(!scrollElement.isTriggered){

				scrollElement.isTriggered = true;
				scrollElement.isPendingTrigger = true;

				// trigger pending show

				if($.isFunction(self.options.onPendingShow)){
					self.options.onPendingShow.apply(null, [scrollElement, params]);
				}

				scrollElement.$el.triggerHandler('pendingShow', self._extend({}, params));

				// determine if showing will also include a grouping delay

				if(self._isDesktop()){

					var $el = scrollElement.$el;
					var useStaggerGroup = (typeof($el.data(self.options.groupId)) !== 'undefined');

					if(useStaggerGroup && (params.direction === 'up' && self.options.staggerDownOnly)){
						useStaggerGroup = false;
					}

					// check if timing needs to be queued with other newly visible elements

					if(useStaggerGroup){

						self.scrollTriggersQueued.push({
							scrollElement: scrollElement,
							params: params
						});

						// check to make sure queued elements aren't being delayed by elements above the fold

						self._updateDelayQueue();
					}
					else {
						self.showElement(scrollElement, self._extend({instant:false}, params));
					}
				}
				else {
					self.showElement(scrollElement, self._extend({instant:true}, params));
				}
			}
		},

		_triggerElementHide: function(scrollElement, params){

			var self = this;

			if(scrollElement.isTriggered){

				scrollElement.isTriggered = false;
				scrollElement.isPendingTrigger = false;

				// trigger pending hide

				if($.isFunction(self.options.onPendingHide)){
					self.options.onPendingHide.apply(null, [scrollElement, params]);
				}

				scrollElement.$el.triggerHandler('pendingHide', self._extend({}, params));

				//

				if(scrollElement.delayedCall){ scrollElement.delayedCall.kill(); }
				self.hideElement(scrollElement, params);
			}
		},

		// change element state ----------------------------------------------------------------  /

		renderElement: function(scrollElement, params){

			var self = this;

			if(!scrollElement.isRendered){

				scrollElement.isRendered = true;
				scrollElement.$el.triggerHandler('render', params);

				if($.isFunction(self.options.onRender)){
					self.options.onRender.apply(null, [scrollElement, params]);
				}
			}
		},

		showElement: function(scrollElement, params){

			var self = this;

			if(!scrollElement.isRendered){ self.renderElement(scrollElement, params); }
			if(scrollElement.isOut){

				scrollElement.isOut = false;
				scrollElement.isShowing = true;
				scrollElement.$el.removeClass(scrollElement.hideClass);
				scrollElement.$el.addClass(scrollElement.showClass);
				scrollElement.$el.triggerHandler('show', params);

				if($.isFunction(self.options.onShow)){
					self.options.onShow.apply(null, [scrollElement, params]);
				}
			}
		},

		hideElement: function(scrollElement, params){

			var self = this;

			if(!scrollElement.isOut){

				scrollElement.isOut = true;
				scrollElement.isShowing = false;
				scrollElement.isPendingTrigger = false;

				scrollElement.$el.addClass(scrollElement.hideClass);
				scrollElement.$el.removeClass(scrollElement.showClass);
				scrollElement.$el.triggerHandler('hide', params);

				if($.isFunction(self.options.onHide)){
					self.options.onHide.apply(null, [scrollElement, params]);
				}
			}
		},

		resetElement: function(scrollElement, params){

			var self = this;

			scrollElement.$el.triggerHandler('reset', params);

			if($.isFunction(self.options.onReset)){
				self.options.onReset.apply(null, [scrollElement, params]);
			}
		},

		removeElement: function(scrollElement){

			var self = this;

			if(scrollElement.isRendered){

				scrollElement.isRendered = false;
				scrollElement.isOut = true;
				scrollElement.isPendingTrigger = false;

				if(scrollElement.delayedCall){ scrollElement.delayedCall.kill(); }
				scrollElement.$el.triggerHandler('remove');

				if($.isFunction(self.options.onRemove)){
					self.options.onRemove.apply(null, [scrollElement]);
				}
			}
		},

		// queued items display timing ---------------------------------------------------------  /

		_getScrollTriggerDelay: function(scrollElement){

			var self = this;
			var pos = 0;
			var d = 0;

			for(var i=0; i<self.scrollTriggersQueued.length; i++){

				var queuedElement = self.scrollTriggersQueued[i].scrollElement;
				var $element = queuedElement.$el;
				var staggerBefore = queuedElement.staggerBefore

				// affect delay by object size

				if($element.hasClass('sk-obj-small')){ staggerBefore *= 0.25; }
				else if($element.hasClass('sk-obj-medium')){ staggerBefore *= 0.5; }
				else if($element.hasClass('sk-obj-large')){ staggerBefore *= 0.75; }
				else if($element.hasClass('sk-obj-xlarge')){ staggerBefore *= 1; }

				//

				if(queuedElement === scrollElement){
					d += staggerBefore;
					break;
				}
				else {
					d += staggerBefore + queuedElement.staggerAfter;
				}
			}

			return d;
		},

		_getQueuedElementIndex: function(scrollElement){

			var self = this;
			var pos = -1;

			for(var i=0; i<self.scrollTriggersQueued.length; i++){
				if(self.scrollTriggersQueued[i].scrollElement === scrollElement){
					pos = i;
					break;
				}
			}

			return pos;
		},

		_updateDelayQueue: function(){

			var self = this;
			var optimizedQueue = [];
			var d = 0;

			// trim display queue based on whether elements have been scrolled offscreen

			for(var i=0; i<self.scrollTriggersQueued.length; i++){

				var queuedTrigger = self.scrollTriggersQueued[i];
				var queuedElement = queuedTrigger.scrollElement;
				var queuedParams = queuedTrigger.params;

				var $queuedEl = queuedElement.$el;
				var topDistance = $queuedEl.offset().top - self.$container.scrollTop();
				var isValid = !(!$queuedEl.is(':visible') || topDistance <= 0);

				d = !isValid ? queuedElement.staggerBefore : self._getScrollTriggerDelay(queuedElement);

				// only items with actual delays remain in queue

				if(isValid){ optimizedQueue.push(queuedTrigger); }
				queuedParams.delay = d;

				// prep delayed calls for when each element should display

				if(queuedElement.delayedCall){ queuedElement.delayedCall.kill(); }
				queuedElement.delayedCall = TweenMax.delayedCall(d, self._onQueuedElementTriggered.bind(self, queuedTrigger));
			}

			self.scrollTriggersQueued = optimizedQueue;

			//

			self.lastGroupTriggerTime = (new Date()).getTime();
			self.lastGroupTriggerDelay = d;
		},

		_onQueuedElementTriggered: function(queuedTrigger){

			var self = this;
			var queuedElement = queuedTrigger.scrollElement;

			self.scrollTriggersQueued.splice(self._getQueuedElementIndex(queuedElement), 1);

			self.showElement(queuedElement, self._extend({instant:false}, self._extend({}, queuedElement.params)));
		},

		// scroll position checking loop -----------------------------------------------------------  /

		_scrollTick: function(){

			var self = this;
			self.lastScrollTop = self.scrollTop;
			self.scrollTop = self.$container.scrollTop();

			if(!self.lastScrollTop){ self.lastScrollTop = self.scrollTop; }

			// trying throttling using timeout instead of every animation frame

			if (!self.throttleTimer){

				self._isTicked = false;

				self.throttleTimer = window.setTimeout(function() {
					window.clearTimeout(self.throttleTimer);
					self.throttleTimer = null;
					self._isTicked = true;
					self._tick();
				}, 20);
			}
		},

		//

		_tick: function(force){

			var self = this;

			if(self._isDesktop() && (self._isTicked || force === true)){

				self._isTicked = true;
				self._isPendingDelay = false;

				for(var i=0; i<self.scrollTriggeredElements.length; i++){
					self._tickElement(self.scrollTriggeredElements[i]);
				}
			}
		},

		// window listeners ------------------------------------------------------------------------  /

		_windowResize: function(e){

			let self = this;
			let wasDisabled = $('body').hasClass('skrollex-disabled');

			self.winWidth = window.innerWidth;
			self.winHeight = window.innerHeight;


			//

			self._setElementSizeClasses();

			if((self.options.disableOnMobile && self._isMobile(false, true)) || (self.options.disableOnTablet && self._isMobile(true, false))){
				$('body').addClass('skrollex-disabled');
			}
			else {

				$('body').removeClass('skrollex-disabled');

				_.each(self.scrollTriggeredElements, function(scrollElement, i){
					self._tickElement(scrollElement);
				});
			}

			if(!$('body').hasClass('skrollex-disabled') && wasDisabled){

				self._scanDom();

				window.SETTINGS.animationFrame.one(function(){
					self._scrollTick();
				});
			}
		},

		// destroy ---------------------------------------------------------------------------------  /

		destroy: function(e){

			var self = this;
			self._removeListeners();
			self._removeScrollTriggerElements();
		},

		// utils -----------------------------------------------------------------------------------  /

		_setElementSizeClasses: function(){

			var self = this;

			_.each(self.scrollTriggeredElements, function(scrollElement, i){

				// check size of object (slower animations for larger objects)

				let bounds = scrollElement.$el[0].getBoundingClientRect();
				let area = bounds.width * bounds.height;

				scrollElement.$el.removeClass('sk-obj-xlarge sk-obj-large sk-obj-medium sk-obj-small');

				if(bounds.height > 400 && area > 180000){
					scrollElement.$el.addClass('sk-obj-xlarge');
				}
				if(bounds.height > 240 && area > 120000){
					scrollElement.$el.addClass('sk-obj-large');
				}
				else if(bounds.height > 90 && area > 24000){
					scrollElement.$el.addClass('sk-obj-medium');
				}
				else {
					scrollElement.$el.addClass('sk-obj-small');
				}
			});
		},

		_sortDomElements: function(elements){

			// sort elements by display order, top first, then left to right and down

			var sortedElements = elements.sort(

				function(a, b){

					var $a = $(a);
					var $b = $(b);
					var aOffset = $a.offset();
					var bOffset = $b.offset();

					if(aOffset.top < bOffset.top){
						return -1;
					}
					else if(aOffset.top == bOffset.top){

						if(aOffset.left < bOffset.left){ return -1; }
						else if(aOffset.left == bOffset.left){ return 0; }
						else { return 1; }
					}

					return 1;
				}
			);

			return sortedElements;
		},

		_sortZIndexElements: function($container){

			// assure that elements higher and further to the left have higher z-index than lower and rightward objects

			var self = this;
			var $zIndexElements = self.options.zSort ? $container.find('[data-' + self.options.staggerId + ']') : $container.find('[data-' + self.options.zSortId + ']');
			var maxZIndex = 0;

			$zIndexElements = this._sortDomElements($zIndexElements);

			for(var i=0; i<$zIndexElements.length; i++){
				var $zIndexElement = $($zIndexElements[i]);
				zIndex = parseInt($zIndexElement.css('z-index')) || 0;
				if(zIndex > maxZIndex){ maxZIndex = zIndex; }
			}

			for(var i=0; i<$zIndexElements.length; i++){
				var $zIndexElement = $($zIndexElements[i]);
				var zIndex = maxZIndex+(i+1);
				$zIndexElement.css('z-index', zIndex);
			}
		},

		_checkVal: function(val, fallbackVal, emptyVal){

			if(typeof(val) !== 'undefined'){
				if(val === '' && typeof(emptyVal) !== undefined){ return emptyVal; }
				else if(val !== null && !(typeof(val) === 'number' && isNaN(val))){ return val; }
			}

			return fallbackVal;
		},

		_parseBool: function(val){
			return (String(val).toLowerCase() === 'true');
		},

		_merge: function(options, defaults){

			var merged = $.extend({}, defaults);

			for(var key in options){

				var val = options[key];

				if(typeof(val) !== 'undefined' && val !== null && !(typeof(val) === 'number' && isNaN(val))){
					merged[key] = val;
				}
			}

			return merged;
		},

		_extend: function(obj, extending){

			var self = this;
			return self._merge(extending, obj);
		},

		_each: function(array, callback){

			for(var key in array){
				callback.apply(null, [array[key]]);
			}
		},

		_difference: function(array1, array2){

			var diff = [];

			for(var i=0; i<array1.length; i++){

				var obj1 = array1[i];
				if(array2.indexOf(obj1) === -1){
					diff.push(obj1);
				}
			}

			return diff;
		},

		_union: function(array1, array2){

			var self = this;
			var union = [];

			for(var i=0; i<array1.length; i++){

				var obj = array1[i];
				if(union.indexOf(obj) === -1){
					union.push(obj);
				}
			}

			for(var i=0; i<array2.length; i++){

				var obj = array2[i];
				if(union.indexOf(obj) === -1){
					union.push(obj);
				}
			}

			return union;
		},

		_isMobile: function(detectTablets, detectPhones){

			if(typeof(detectTablets) === 'undefined'){ detectTablets = false; }
			if(typeof(detectPhones) === 'undefined'){ detectPhones = true; }

			function isPhone(){
				if(/android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase())) { return true; }
				return false;
			}

			function isTablet(){
				if(/ipad|(android|chrome) ([.0-9]*)(.*)(mobile)/i.test(navigator.userAgent.toLowerCase())){ return true; }
				return false;
			}

			//

			if(detectTablets && isTablet()) { return true; }
			if(detectPhones && isPhone()) { return true; }

			return false;
		},

		_isDesktop: function(){
			return !this._isMobile(true, true);
		}

		// -----------------------------------------------------------------------------------------  /

	};

	window.Skrollex = Skrollex;

})(window);

},{}],10:[function(require,module,exports){

/*

Vent

Global communications object.

Add / remove listeners, dispatch events.
Events can be listened to or dispatched by sub-category, for example:

// vent.on('domUpdate:header', myMethod.bind(this));

The object listening can be triggered by a generic
// vent.dispatch('domUpdate');

... or a more specific, categorized call (that will exclude irrelevant listeners)
// vent.dispatch('domUpdate:header');

This can be any number of levels deep, for example vent.dispatch('domUpdate:header:nav:navItem');
Good for expensive events. $$$

Listeners can be removed in bulk by leaving the specific callback blank in vent.off().

Last edited 02.07.17 by David Robbins

*/

class Vent {

	constructor(){

		this._vents;
		this._init();
	}

	_init(){

		// bloop bloop
	}

	// public methods

	on(event, callback, context){
		this._addListener(event, callback, context);
	}

	off(event, callback, context){
		this._removeListener(event, callback, context);
	}

	trigger(event, params){
		this._dispatchEvent(event, params);
	}

	// private methods

	_addListener(event, callback, context){

		if(typeof(context) === 'undefined'){ context = null; }

		let split = event.split(':');
		event = split[0].trim();

		//

		if(!this._vents){ this._vents = {}; }

		let dir = this._vents;
		let curDir = dir;

		for(let i=0, len=split.length; i<len; i++){

			let val = split[i].trim();

			if(val){

				let nextDir = curDir[val];

				if(!nextDir){
					nextDir = curDir[val] = {
						listeners: [],
						contexts: [],
						subCats: []
					};
				}

				curDir = nextDir;
				curDir.listeners.push(callback);
				curDir.contexts.push(context);
			}
			else {
				break;
			}
		}
	}

	_removeListener(event, callback, context){

		let split = event.split(':');
		event = split[0].trim();

		//

		if(!this._vents){ this._vents = {}; }
		let dir = this._vents;
		let curDir = dir;

		for(let i=0, len=split.length; i<len; i++){

			let val = split[i].trim();

			if(val){

				let nextDir = curDir[val];

				if(nextDir){

					curDir = nextDir;

					if(callback){

						// clear only listeners with matching callbacks

						let listenerPos = [];
						let contextPos = [];

						for(let k=0; k<curDir.listeners.length; k++){
							let tListener = curDir.listeners[k];
							if(tListener === callback){
								listenerPos.push(k);
							}
						}

						for(let k=0; k<curDir.contexts.length; k++){
							let tContext = curDir.contexts[k];
							if(tContext === context){
								contextPos.push(k);
							}
						}

						let doubleMatchPos = -1;

						for(let k=0; k<listenerPos.length; k++){
							if(listenerPos[k] === contextPos[k]){
								// console.log("_removeListener", event);
								doubleMatchPos = listenerPos[k];
								break;
							}
						}

						if(doubleMatchPos >= 0){
							curDir.listeners.splice(doubleMatchPos, 1);
							curDir.contexts.splice(doubleMatchPos, 1);
						}
					}
					else {

						// clear all listeners of type

						curDir.listeners = [];
					}
				}
				else {
					break;
				}
			}
			else {
				break;
			}
		}
	}

	_dispatchEvent(event, params){

		let split = event.split(':');
		event = split[0].trim();
		params = params ? params : {};

		let e = {event: event};
		let returnObj = params ? params : {};

		//

		if(!this._vents){ this._vents = {}; }
		let dir = this._vents;
		let curDir = dir;

		for(let i=0, len=split.length; i<len; i++){

			let val = split[i].trim();
			let nextDir = curDir[val];

			if(val && nextDir){

				curDir = nextDir;

				if(i === split.length - 1){

					// if at deepest level of specificity, trigger callback

					if(curDir){

						let curDirListeners = curDir.listeners;
						let curDirContexts = curDir.contexts;

						for(let k=0; k<curDirListeners.length; k++){
							let curCallback = curDirListeners[k];
							let curContext = curDirContexts[k];
							if(curCallback){
								curCallback.apply(curContext, [e, returnObj]);
							}
						}
					}
				}
			}
			else {
				break;
			}
		}
	}
}

module.exports = Vent;

},{}],11:[function(require,module,exports){
window.SETTINGS.domScan.addContainer( null, ($scanContainer) => {

});

},{}],12:[function(require,module,exports){
arguments[4][11][0].apply(exports,arguments)
},{"dup":11}],13:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class AccordionToggle extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$button = this.$el.find('button');
		this.$accordionParent = this.$el.closest('[data-accordion-toggle-parent]');

		if(!this.$accordionParent.length){ this.$accordionParent = this.$el.parent(); }
	}

	// basemodule methods

	_domReady(){
	}

	_addListeners(){
		this.$button.on('click', $.proxy(this._onClick, this));
	}

	_removeListeners(){
		this.$button.off('click', $.proxy(this._onClick, this));
	}

	// listener methods

	_onClick(e){
		this.toggle();
	}

	//

	toggle(){
		if(this.$el.hasClass('is-active')){
			this.$el.removeClass('is-active');
			this.$accordionParent.removeClass('is-expanded');
		}
		else {
			this.$el.addClass('is-active');
			this.$accordionParent.addClass('is-expanded');
		}
	}

	//

	_show(){}

	_hide(){}

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){
	}
}

module.exports = AccordionToggle;

},{"../../90_utils/base/BaseModule":131}],14:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class BottomGoop extends BaseModule {

	constructor(el, params) {

		super(el);

		this.gradientTopColor = this.checkVal(this.$el.data('gradient-start-color'), '#25c4f6');
		this.gradientBottomColor = this.checkVal(this.$el.data('gradient-end-color'), '#f6379a');

		this.$shape;
		this.$gradient;
		this.$gradientStops;
		this.$goopPath;
		this.$buttonInner;
		this.$window = $(window);

		this.caption;

		this.isVideo;
		this.isLastPage = false;
		this.isPageLoaded = false;
		this.isTransitionLocked = false;
		this.isOverFooter = false;
		this.isSiteLoaded = false;
		this.isModalOpen = false;

		// init shapes

		this.$innerContent = this.$el.find('.inner-content');
		this.$shape = this.$el.find('.svg');
		this.$gradient = this.$shape.find('#gradient');
		this.$gradientStops = this.$gradient.find('stop');
		this.$goopPath = this.$shape.find('#bulge-path');

		this.rectData = 'M427.5,78C280.5,75,326,76,269,76s-11.6-1-158.5,2H-1284v8H1822V78H427.5Z';

		if(isNaN(window.SETTINGS.vars.svgIndex)){ window.SETTINGS.vars.svgIndex = 0; }
		else { window.SETTINGS.vars.svgIndex++; }

		let gradientId = window.SETTINGS.vars.svgIndex;
		this.$gradient.attr('id', 'gradient' + gradientId);
		this.$shape.find('path').attr('fill', 'url(#gradient' + gradientId + ')');
	}

	// basemodule methods

	_domReady(){ }

	_addListeners(){

		// let options = {preventDefault:true};
		// this.$el.find('.continue').hammer(options).on('tap', $.proxy(this._onButtonClick, this));

		this.$window.on('scroll', $.proxy(this._onScroll, this));
		this.$el.find('.goop-button').on('click', $.proxy(this._onButtonClick, this));
		this.$el.find('.continue').on('click', $.proxy(this._onButtonClick, this));

		window.vent.on('modalOpen', this._onModalOpen, this);
		window.vent.on('modalClose', this._onModalClose, this);
		window.vent.on('siteLoadComplete', this._onSiteLoadComplete, this);
		window.vent.on('heroChangeRoute', this._onHeroChangeRoute, this);
		window.vent.on('pageChangeStart', this._onPageChangeStart, this);
		window.vent.on('pageChangeComplete', this._onPageChangeComplete, this);
	}

	_removeListeners(){

		this.$window.off('scroll', $.proxy(this._onScroll, this));
		this.$el.find('.goop-button').off('click', $.proxy(this._onButtonClick, this));
		this.$el.find('.continue').off('click', $.proxy(this._onButtonClick, this));

		window.vent.off('modalOpen', this._onModalOpen, this);
		window.vent.off('modalClose', this._onModalClose, this);
		window.vent.off('siteLoadComplete', this._onSiteLoadComplete, this);
		window.vent.off('heroChangeRoute', this._onHeroChangeRoute, this);
		window.vent.off('pageChangeStart', this._onPageChangeStart, this);
		window.vent.off('pageChangeComplete', this._onPageChangeComplete, this);
	}

	// event methods

	_onButtonClick(e){

		e.preventDefault();

		if(this.isPageLoaded){

			if(this.isOverFooter){
				let href = $('.footer-hero .centered-quote a.title-link').attr('data-href');
				window.vent.trigger('heroChangeRoute', {route: href});
				window.vent.trigger('changeRoute', {route: href});
			}
			else {

				if($('body').hasClass('page-action') && window.SETTINGS.breakpoint.minWidth('screen-medium')){
					window.vent.trigger('triggerScrollStep', {delta:1});
				}
				else {
					window.vent.trigger('scrollTo', {scrollTop:$(window).innerHeight()});
				}
			}
		}
	}

	_onScroll(){

		let scrollTop = this.$window.scrollTop();
		let shouldShow = true;

		if(this.isPageLoaded && !this.isTransitionLocked && !this.isModalOpen){

			let docHeight = window.SETTINGS.coords.getDocHeight();
			let winHeight = window.SETTINGS.coords.winHeight;
			let edgeLeeway = 100;

			// conditions to hide

			if(scrollTop >= docHeight - winHeight - edgeLeeway){

				if(!this.isLastPage){
					shouldShow = true;
					this.$el.addClass('is-over-footer');
					this.isOverFooter = true;
				}
				else {
					shouldShow = false;
					this.$el.removeClass('is-over-footer');
					this.isOverFooter = false;
				}
			}

			if(scrollTop < docHeight - winHeight - edgeLeeway && scrollTop > edgeLeeway){

				shouldShow = false;

				this.$el.removeClass('is-over-footer');
				this.isOverFooter = false;

				this.caption = 'Read More';
				this.isVideo = false;
			}

			if(shouldShow){

				if(!this.$innerContent.hasClass('is-showing')){

					if(this.isOverFooter){ this._redraw(); }
					else { this._checkPage(); }

					this.$innerContent.addClass('is-showing');

					let d = this.$goopPath.attr('d');

					TweenMax.set(this.$buttonInner, { opacity: 0 });
					this.$goopPath.attr('d', this.rectData);

					if(window.SETTINGS.breakpoint.minWidth('screen-medium')){

						let delay = 0.2;

						TweenMax.to(this.$goopPath, 0.48, {
							morphSVG: d,
							delay: delay,
							ease: 'progressSlide'
						});

						TweenMax.to(this.$buttonInner, 0.2, {
							opacity: 1,
							clearProps: 'opacity',
							ease: 'fade',
							delay: delay
						});
					}
				}
			}
			else {

				if(this.$innerContent.hasClass('is-showing')){

					if(window.SETTINGS.breakpoint.minWidth('screen-medium')){

						TweenMax.to(this.$goopPath, 0.4, {
							morphSVG: this.rectData,
							delay: 0.2,
							ease: 'progressSlide'
						});

						TweenMax.to(this.$buttonInner, 0.1, {
							opacity: 0,
							ease: 'fade'
						});
					}

					TweenMax.delayedCall(0.1, ()=>{
						this.$innerContent.removeClass('is-showing');
					});
				}
			}
		}
	}

	_onModalOpen(){
		this.isModalOpen = true;
	}

	_onModalClose(){
		this.isModalOpen = false;
	}

	_onHeroChangeRoute(){
		this.isTransitionLocked = true;
		this.$innerContent.removeClass('is-showing');
	}

	_onPageChangeStart(){

		this.isPageLoaded = false;

		if(!this.isTransitionLocked){
			this.$innerContent.removeClass('is-showing');
		}
	}

	_onPageChangeComplete(){

		if(this.isSiteLoaded){

			if(this.isTransitionLocked){
				window.setTimeout(() => {
					this.isTransitionLocked = false;
				}, 500);
			}
			else {
				this.isTransitionLocked = false;
			}

			this.isPageLoaded = true;
			this._checkPage();
			this._onScroll();
		}
	}

	_onSiteLoadComplete(){

		this.isSiteLoaded = true;

		// show video

		// this._onPageChangeComplete();
	}

	// change goop based on page

	_checkPage(){

		let routeObj = window.SETTINGS.router.getRouteObj();
		let pageId = routeObj.pageId;

		switch(pageId){

			case 'impact':
			this.caption = 'Our Impact';
			this.isVideo = false;
			this.gradientTopColor = '#25c4f6';
			this.gradientBottomColor = '#6643c9';
			break;

			case 'action':
			this.caption = 'Explore';
			this.isVideo = false;
			this.gradientTopColor = '#ed3b44';
			this.gradientBottomColor = '#fbdc30';
			break;

			case 'intro':
			this.caption = 'Play';
			this.isVideo = true;
			this.gradientTopColor = '#5be745';
			this.gradientBottomColor = '#25c4f6';
			break;

			case 'vision':
			this.caption = 'Our Vision';
			this.isVideo = false;
			this.gradientTopColor = '#25c4f6';
			this.gradientBottomColor = '#f6379a';
			break;
		}

		if(window.SETTINGS.router.getRouteObj().pageId === 'impact'){
			this.isLastPage = true;
		}
		else {
			this.isLastPage = false;
		}

		this._redraw();
	}

	_redraw(){

		if(this.isOverFooter){
			this.gradientTopColor = '#ffffff';
			this.gradientBottomColor = '#ffffff';
		}

		// text and icon

		this.$el.find('.goop-button-inner').removeClass('is-showing');

		if(this.isVideo){
			this.$buttonInner = this.$el.find('.goop-button-inner--video');
		}
		else {
			this.$buttonInner = this.$el.find('.goop-button-inner--scroll');
		}

		this.$buttonInner.addClass('is-showing');
		this.$buttonInner.find('.title').html(this.caption);

		// goop shape

		let scale = window.SETTINGS.breakpoint.minWidth('screen-small') ? 1 : 2.5625;
		let containerWidth = this.$el.outerWidth() * scale;
		let bulgeWidth = 538;
		let bleed = (containerWidth - bulgeWidth)/2;

		let newD = 'M427.5,77.4C280.5,74.4,326,0,269,0s-11.6,74.4-158.5,77.4C109.1,77.4,2.3,78,2.3,78L' + (0 - bleed) + ',78v8 h' + containerWidth + 'v-8l-1.5,0C536.5,78,428.9,77.4,427.5,77.4z';

		this.$gradientStops.eq(0).attr('stop-color', this.gradientTopColor);
		this.$gradientStops.eq(1).attr('stop-color', this.gradientBottomColor);
		this.$goopPath.attr('d', newD);
	}

	//

	_show(){
		this.$el.addClass('is-showing');
	}

	_hide(){
		this.$el.removeClass('is-showing');
	}

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){
		this._redraw();
	}
}

module.exports = BottomGoop;

},{"../../90_utils/base/BaseModule":131}],15:[function(require,module,exports){

},{}],16:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class CirclePlus extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$expandedCaption = this.$el.parent().find('.expanded-caption');
		this.$bgPanel = this.$expandedCaption.find('.bg-panel');
		this.$caption = this.$expandedCaption.find('.caption');
		this.$statBlock = this.$el.closest('.content-block--stat-block');

		this.$gradient = this.$el.find('>.gradient-circle');
		this.$plus = this.$el.find('>.icon-plus');

		this.isHover = false;
		this.isClickToggled = false;
		this.isAnimating = false;
		this.isStatBlock = this.$statBlock.length ? true : false;
	}

	// basemodule methods

	_domReady(){
		this._resetPositions();
	}

	_addListeners(){

		let options = {preventDefault:true};
		this.$el.hammer(options).on('tap', $.proxy(this._onClick, this))

		this.$el.on('click', $.proxy(this._onClick, this));
		this.$el.on('mouseenter', $.proxy(this._onMouseEnter, this));
		this.$el.on('mouseleave', $.proxy(this._onMouseLeave, this));
	}

	_removeListeners(){

		this.$el.hammer().off('tap', $.proxy(this._onClick, this))

		this.$el.off('click', $.proxy(this._onClick, this));
		this.$el.off('mouseenter', $.proxy(this._onMouseEnter, this));
		this.$el.off('mouseleave', $.proxy(this._onMouseLeave, this));

		$('#main').off('click', $.proxy(this._onOut, this));
	}

	// listener methods

	_onClick(e){
		this.toggle(true);
	}

	_onMouseEnter(e){
		this.isHover = true;
		this.toggle(false);
	}

	_onMouseLeave(e){
		this.isHover = false;
		this._checkHover();
		this.toggle(false);
	}

	_onOut(e){
		if(!this.$el[0].contains(e.target) && !this.$expandedCaption[0].contains(e.target)){
			this.toggle(true);
		}
	}

	//

	toggle(isClick){

		isClick = (isClick === true);

		if(!this.isAnimating && (!this.isClickToggled || (this.isClickToggled && isClick))){

			TweenMax.killTweensOf([this.$expandedCaption, this.$caption, this.$bgPanel]);

			let $caption = this.$expandedCaption.find('.caption');
			let panelHeight = Math.round(this.$bgPanel.outerHeight());

			if(this.$el.hasClass('is-active') && (!this.isHover || (this.isClickToggled && isClick))){

				this.$el.removeClass('is-active');
				this.isAnimating = true;

				if( this.$expandedCaption.length ){
					if(this.isStatBlock){
						let $statInner = this.$statBlock.find('>.inner-block');
						TweenMax.to(this.$expandedCaption, 0.16, {opacity:0, ease:'fadeOut'});
						TweenMax.to($statInner, 0.24, {paddingBottom:0, ease:'fadeOut'});
						TweenMax.to(this.$el, 0.24, {y:0, ease:'fadeOut'});
						TweenMax.to(this.$bgPanel, 0.24, {y:0, opacity:0, ease:'fadeOut'});
						TweenMax.to(this.$caption, 0.2, {y:panelHeight, opacity:0, ease:'fadeOut', onComplete:this._resetPositions.bind(this)});
					}
					else {
						TweenMax.to(this.$expandedCaption, 0.24, {opacity:0, ease:'fadeOut'});
						TweenMax.to(this.$bgPanel, 0.24, {y:0, opacity:0, ease:'fadeOut'});
						TweenMax.to(this.$caption, 0.2, {y:0, opacity:0, ease:'fadeOut', onComplete:this._resetPositions.bind(this)});
					}
				}
			}
			else if(!this.$el.hasClass('is-active') && this.isHover) {

				this.$el.addClass('is-active');
				this.isAnimating = true;

				if( this.$expandedCaption.length ){
					if(this.isStatBlock){
						let $statInner = this.$statBlock.find('>.inner-block');
						TweenMax.to([this.$expandedCaption, this.$bgPanel, this.$caption], 0.16, {visibility:'visible', opacity:1, ease:'fade'});
						TweenMax.to($statInner, 0.24, {paddingBottom:panelHeight, ease:'fade'});
						TweenMax.to(this.$el, 0.24, {y:panelHeight, ease:'fade'});
						TweenMax.to(this.$bgPanel, 0.24, {y:panelHeight, ease:'fade'});
						TweenMax.to(this.$caption, 0.3, {y:panelHeight, ease:'fade', onComplete:() => {
							this.isAnimating = false;
						}});
					}
					else {
						TweenMax.to([this.$expandedCaption, this.$bgPanel, this.$caption], 0.16, {visibility:'visible', opacity:1, ease:'fade'});
						TweenMax.to(this.$bgPanel, 0.16, {y:0, ease:'fade'});
						TweenMax.to(this.$caption, 0.24, {y:0, ease:'fade', onComplete:() => {
							this.isAnimating = false;
						}});
					}
				}
			}

			if(isClick){

				if(this.$el.hasClass('is-active')){

					this.isClickToggled = true;
					$('#main').off('click', $.proxy(this._onOut, this));

					window.requestAnimationFrame(() => {
						$('#main').on('click', $.proxy(this._onOut, this));
					});
				}
				else {
					this.isClickToggled = false;
					$('#main').off('click', $.proxy(this._onOut, this));
				}
			}
		}

		this._checkHover();
	}

	_checkHover(){

		TweenMax.killTweensOf([this.$gradient, this.$plus]);

		if(this.$el.hasClass('is-active')){
			TweenMax.to(this.$plus, 0.2, {rotation:45, ease:'fade'});
		}
		else {
			TweenMax.to(this.$plus, 0.2, {rotation:0, ease:'fade'});
		}

		if(this.isHover){
			TweenMax.to(this.$gradient, 0.2, {scale: 1.12, rotation:0.1, ease:'fade'});
		}
		else {
			TweenMax.to(this.$gradient, 0.2, {scale: 1.01, ease:'fade'});
		}
	}

	//

	_resetPositions(){

		this.isAnimating = false;

		if(this.isStatBlock){

			let panelHeight = this.$bgPanel.outerHeight();
			TweenMax.set(this.$bgPanel, {y:0, opacity:0});
			TweenMax.set(this.$caption, {y:panelHeight-12, opacity:0});
		}
		else {
			TweenMax.set(this.$bgPanel, {y:12, opacity:0});
			TweenMax.set(this.$caption, {y:12, opacity:0});
		}
	}

	//

	_show(){}

	_hide(){}

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){
	}
}

module.exports = CirclePlus;

},{"../../90_utils/base/BaseModule":131}],17:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],18:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class LeftGoop extends BaseModule {

	constructor(el, params) {
		super(el);
	}

	// basemodule

	_domReady(){

		let $goop = this.$el;
		let $goopPath = $goop.find('#bulge-path');
		let $gradient = $goop.find('#left-gradient');
		let $gradientStops = $gradient.find('stop');

		$gradientStops.eq(0).attr('stop-color', '#f6379a');
		$gradientStops.eq(1).attr('stop-color', '#25c4f6');
	}

	_addListeners(){ }
	_removeListeners(){ }

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){ }
}

module.exports = LeftGoop;

},{"../../90_utils/base/BaseModule":131}],19:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],20:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class ReadMoreGoop extends BaseModule {

	constructor(el, params) {
		super(el);

		this.gradientTopColor = this.checkVal(this.$el.data('gradient-start-color'), '#25c4f6');
		this.gradientBottomColor = this.checkVal(this.$el.data('gradient-end-color'), '#f6379a');

		this.$shape;
		this.$gradient;
		this.$gradientStops;
		this.$goopPath;
		this.$line;

		// init shapes

		this.$shape = this.$el.find('.svg');
		this.$gradient = this.$shape.find('#gradient');
		this.$gradientStops = this.$gradient.find('stop');
		this.$goopPath = this.$shape.find('#bulge-path');
		this.$line = this.$el.find('.line');

		if(isNaN(window.SETTINGS.vars.svgIndex)){ window.SETTINGS.vars.svgIndex = 0; }
		else { window.SETTINGS.vars.svgIndex++; }

		let gradientId = window.SETTINGS.vars.svgIndex;
		this.$gradient.attr('id', 'gradient' + gradientId);
		this.$shape.find('path').attr('fill', 'url(#gradient' + gradientId + ')');
	}

	// basemodule methods

	_domReady(){}

	_addListeners(){

	}

	_removeListeners(){

	}

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){

		let scale = window.SETTINGS.breakpoint.minWidth('screen-small') ? 1 : 1.5769230769;
		let containerWidth = this.$el.outerWidth() * 2 * scale; // scaled down by half, need to double assumed container (dumb)
		let bulgeWidth = 538;
		let bleed = (containerWidth - bulgeWidth)/2;

		let newD = 'M427.5,77.4C280.5,74.4,326,0,269,0s-11.6,74.4-158.5,77.4C109.1,77.4,2.3,78,2.3,78L' + (0 - bleed) + ',78v4 h' + containerWidth + 'v-4l-1.5,0C536.5,78,428.9,77.4,427.5,77.4z';

		this.$gradientStops.eq(0).attr('stop-color', this.gradientTopColor);
		this.$gradientStops.eq(1).attr('stop-color', this.gradientBottomColor);
		this.$goopPath.attr('d', newD);
		this.$line.css('background', this.gradientBottomColor);
	}
}

module.exports = ReadMoreGoop;

},{"../../90_utils/base/BaseModule":131}],21:[function(require,module,exports){
const AccordionToggle = require('./accordion-toggle/script.js');
const BottomGoopButton = require('./bottom-goop/script.js');
const LeftGoopButton = require('./left-goop/script.js');
const ReadMoreGoop = require('./read-more-goop/script.js');
const CirclePlus = require('./circle-plus/script.js');

window.SETTINGS.domScan.addContainer( null, ($scanContainer) => {

	window.SETTINGS.domScan.addElement($scanContainer, '[data-accordion-toggle]', function() {
		new AccordionToggle(this, {});
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-bottom-goop]', function() {
		new BottomGoopButton(this, {});
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-left-goop-button]', function() {
		new LeftGoopButton(this, {});
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-read-more-goop]', function() {
		new ReadMoreGoop(this, {});
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-circle-plus]', function() {
		new CirclePlus(this, {});
	});
});

},{"./accordion-toggle/script.js":13,"./bottom-goop/script.js":14,"./circle-plus/script.js":16,"./left-goop/script.js":18,"./read-more-goop/script.js":20}],22:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],23:[function(require,module,exports){
arguments[4][11][0].apply(exports,arguments)
},{"dup":11}],24:[function(require,module,exports){
arguments[4][11][0].apply(exports,arguments)
},{"dup":11}],25:[function(require,module,exports){

// TODO
// param starting value, perhaps

class PlusMinusField {

	constructor($el, params){

		this.$el = $el;

		// elements

		this.$minusButton	= this.$el.find('.plus-minus-field--minus');
		this.$plusButton	= this.$el.find('.plus-minus-field--plus');
		this.$number		= this.$el.find('.plus-minus-field--number');
		this.$numberInput	= this.$number.find('input');

		// dom ready

		$(() => {
			this._onDomReady();
		});
	}

	_onDomReady(){
		this._addListeners();
		this.changeVal(parseInt(this.$numberInput.val()));
	}

	_addListeners(){

		this.$minusButton.on('click', this._onMinusClick.bind(this));
		this.$plusButton.on('click', this._onPlusClick.bind(this));

		this.$el.on('val', () => {
			this.$el.triggerHandler('change', {val:parseInt(this.$numberInput.val())});
		});
	}

	_onMinusClick(e){

		e.preventDefault();

		let count = parseInt(this.$numberInput.val());
		this.changeVal(count - 1);
	}

	_onPlusClick(e){

		e.preventDefault();

		let count = parseInt(this.$numberInput.val());
		this.changeVal(count + 1);
	}

	updateVal(newVal){
		this.$numberInput.val(newVal);
		this.$el.attr('data-val', newVal);
	}

	changeVal(newVal){

		if(newVal >= 1 && newVal <= 99){
			this.updateVal(newVal);
			this.$el.triggerHandler('change', {val:newVal});
		}
	}
}

module.exports = PlusMinusField;

},{}],26:[function(require,module,exports){
// TODO! add formfiles to submit data

class DragDropUpload {

	constructor(el) {
		this.$el      = el;
		this.$input   = el.find('input');
		this.$label   = el.find('label');
		this.$preview = el.find('.preview-zone');
		this.$window  = $(window);

		this.multipleFiles = el.data('multiple-files') || false;
		this.maxFiles      = el.data('max-files') || 6;

		this.reader;

		try {
			this.reader = new FileReader();
		} catch (e) {
			console.warn('No FileReader support');
		}

		this.formfiles = [],
		this.queuing   = [],
		this.reading   = false;

		this.addEventListeners();
	}

	addFiles(files) {
		if(this.formfiles.length < this.maxFiles) {
			let legal = files.length + this.formfiles.length > this.maxFiles ? this.maxFiles - this.formfiles.length : files.length
			for (var i = 0; i < legal; ++i) {
				this.formfiles.push(files[i]);
				this.queuing.push(files[i]);
			}
			if (this.reader && !this.reading) this.readFiles();
		}
	}

	removeFile(index) {
		this.$preview.find('li').eq(index).remove();
		this.formfiles.splice(index, 1);
		if(!this.formfiles.length) this.$el.removeClass('has-files');
	}

	readFiles() {
		this.reading = true;
		let file = this.queuing[0];
		this.reader.onload = (e) => {
			if(file.type.indexOf('video') > -1) {
				this.appendVideo(e.target.result);
			} else {
				this.appendThumb(e.target.result);
			}
			this.$el.addClass('has-files');
			this.queuing.shift();
			this.queuing.length ? this.readFiles() : this.reading = false;
		}
		this.reader.readAsDataURL(file);
	}

	appendThumb(src) {
		let $li = $('<li><div style="background-image:url(' + src + ');"><a href="javascript:;" class="delete">' + this.$el.data('remove-label') + '</a></div></li>');
		$li.find('.delete').on('click', this.previewOnDelete);
		this.$preview.append($li);
	}

	appendVideo(src) {
		let video = document.createElement('video'),
			$li = $('<li><div><a href="javascript:;" class="delete">' + this.$el.data('remove-label') + '</a></div></li>');
		$(video).prop('autoplay', true).prop('loop', true).attr({'src': src, 'muted': true});
		$li.find('div').prepend(video);
		$li.find('.delete').on('click', this.previewOnDelete);
		this.$preview.append($li);
	}

	// events
	inputOnChange(e) {
		if (e.target.files && e.target.files.length) this.addFiles(e.target.files);
	}

	windowOnDragEnter(e) {
		e.preventDefault();
		e.stopPropagation();
	}

	labelOnDragOver(e) {
		e.preventDefault();
		e.stopPropagation();
		this.$label.addClass('hover');
	}

	labelOnDragLeave(e) {
		this.$label.removeClass('hover');
	}

	labelOnDrop(e) {
		e.preventDefault();
		this.addFiles(e.originalEvent.dataTransfer.files);
		this.labelOnDragLeave();
	}

	previewOnDelete(e) {
		let index = $(e.currentTarget).closest('li').index();
		this.removeFile(index);
	}

	addEventListeners() {
		this.inputOnChange = this.inputOnChange.bind(this);
		this.windowOnDragEnter = this.windowOnDragEnter.bind(this);
		this.labelOnDragOver = this.labelOnDragOver.bind(this);
		this.labelOnDragLeave = this.labelOnDragLeave.bind(this);
		this.labelOnDrop = this.labelOnDrop.bind(this);
		this.previewOnDelete = this.previewOnDelete.bind(this);

		this.$input.on('change', this.inputOnChange);
		this.$window.on('dragenter', this.windowOnDragEnter);
		this.$label
			.on('dragover', this.labelOnDragOver)
			.on('dragleave', this.labelOnDragLeave)
			.on('drop', this.labelOnDrop);
	}

	removeEventListeners() {
		this.$input.off('change', this.inputOnChange);
		this.$window.off('dragenter', this.windowOnDragEnter);
		this.$label
			.off('dragover', this.labelOnDragOver)
			.off('dragleave', this.labelOnDragLeave)
			.off('drop', this.labelOnDrop);
	}

}

module.exports = DragDropUpload;

},{}],27:[function(require,module,exports){
const PlusMinusField = require('./controls/plus-minus-field'),
	  DragDropUpload = require('./fields/drag-drop-upload');

window.SETTINGS.domScan.addContainer( null, ($scanContainer) => {

	/*

	// custom selects

	window.SETTINGS.domScan.addElement($scanContainer, 'select.custom-select', function() {

		let hideActive = $(this).data('hide-active');

		$(this).selectize({
			allowEmptyOption: true,
			hideSelected: typeof hideActive !== typeof undefined && hideActive !== false
		});

		// disable input type/search
		$('.selectize-input input').prop('disabled', true);
	});

	// drag and drop

	window.SETTINGS.domScan.addElement($scanContainer, '[data-drag-drop-upload]', function () {
		new DragDropUpload(this);
	});

	// form validation (with pseudo page change submit)

	window.SETTINGS.domScan.addElement($scanContainer, '[data-validate]', function(){

		let $this = $(this);

		$this.validate({

			// selectize support
			ignore: ':hidden:not([class~=selectized]),:hidden > .selectized, .selectize-control .selectize-input input',

			rules: {
				password: {
					required: true,
					minlength: 5
				},
				password2: {
					required: true,
					minlength: 5,
					equalTo: "#password"
				},
				phone: {
					required: true,
					digits: true,
					phoneUS: true
				}
			},

			errorPlacement: function(error, element) {
				error.insertBefore(element);
			},

			success: function(label, element) {
				label.addClass('valid').text(element.getAttribute('data-msg-success'));
			},

			showErrors: function(errorMap, errorList) {

				let $errorBlock		= $this.parents('.modal').find('.form-alert-block--error');
				let $messageSpan	= $errorBlock.find('span');

				if ( this.numberOfInvalids() > 0 ) {
					$messageSpan.html("No Bueno! Your form contains " + this.numberOfInvalids()	+ " errors, see details below.");
					$errorBlock.addClass('is-visible');
				} else {
					$errorBlock.removeClass('is-visible');
				}
				this.defaultShowErrors();
			},

			submitHandler: function(form) {

				let curVars 	= window.location.search; // returns path only
				let url      	= window.location.href; // returns full URL
				let newVars		= $this.data('url-vars') || ''; // specifically add url vars
				let removeVars	= $this.data('remove-vars') || ''; // specifically remove url vars
				let modalId		= $this.data('modal-id') || ''; // opens modal instead of refreshing page

				let mergedVarsObj = window.utils.BrowserUtils.mergeURLParams(newVars, curVars);

				if ( removeVars ){

					let removeVarsObj = window.utils.BrowserUtils.getUrlParameters(removeVars);

					for ( let key in removeVarsObj ){
						if ( typeof(mergedVarsObj[key]) !== 'undefined' ){
							delete mergedVarsObj[key];
						}
					}
				}

				if ( this.currentForm.dataset["dontSend"] ) {
					$(this.currentForm).addClass("data-sent")
				} else if(modalId){
					// $.magnificPopup.open({
					// 	items: { src: '#' + modalId },
					// 	type: 'inline'
					// });
				} else {
					location.href = url.split('?')[0] + '?' + window.utils.BrowserUtils.param(mergedVarsObj);
				}
			}

		});
	});

	// link to add variable form url

	window.SETTINGS.domScan.addElement($scanContainer, '[data-add-vars]', function(){

		let $this = $(this);

		$this.on('click', (e) => {

			let curVars 	= window.location.search; 	// Returns path only
			let url      	= window.location.href;     // Returns full URL
			let newVars		= $this.data('url-vars') || '';

			let mergedVarsObj = window.utils.BrowserUtils.mergeURLParams(newVars, curVars);
			location.href = url.split('?')[0] + '?' + window.utils.BrowserUtils.param(mergedVarsObj);
		});

	});

	// link to remove variable form url

	window.SETTINGS.domScan.addElement($scanContainer, '[data-remove-vars]', function(){

		let $this = $(this);

		$this.on('click', (e) => {

			let curVars			= window.location.search; 	// Returns path only
			let url				= window.location.href;     // Returns full URL
			let removeVars		= $this.data('remove-vars') || '';

			let curVarsObj		= window.utils.BrowserUtils.getUrlParameters(curVars);
			let removeVarsObj	= window.utils.BrowserUtils.getUrlParameters(removeVars);

			for ( let key in removeVarsObj ){
				if ( typeof(curVarsObj[key]) !== 'undefined' ){
					delete curVarsObj[key];
				}
			}

			e.preventDefault();
			location.href = url.split('?')[0] + '?' + window.utils.BrowserUtils.param(curVarsObj);
		});
	});

	// plus minus fields

	window.SETTINGS.domScan.addElement($scanContainer, '[data-plus-minus-field]', function(){

		let $this = $(this);
		let plusMinusField = new PlusMinusField($this, {});
	});

	// drop down where selected menu item changes initial label

	window.SETTINGS.domScan.addElement($scanContainer, '[data-select-dd-swap-label]', function(){

		let $this = $(this);
		let $select = $this.find('.custom-select');
		let $label = $this.find('label');
		let $strong = $label.find('strong');
		let selectizeControl = $select[0].selectize;

		if($label.length){

			// methods

			let updateLabel = () => {
				let title = selectizeControl.getItem($select.val()).text();
				$strong.html(title);
			}

			// listeners

			selectizeControl.on('change', () => {
				updateLabel();
			});

			selectizeControl.on('initialize', () => {
				updateLabel();
			});

			selectizeControl.on('dropdown_open', () => {
				$this.addClass('is-open');
			});

			selectizeControl.on('dropdown_close', () => {
				$this.removeClass('is-open');
			});

			//

			window.requestAnimationFrame(() => {
				updateLabel();
			});
		}

	});

	//

	window.SETTINGS.domScan.addElement($scanContainer, '[data-cf-cost-form]', function(){

		// how-to:

		// displayed
		// [data-cf-cost-item] : anything that adds cost to the total
		// [data-cf-cost-selector] : custom selector that adds cost to the total
		// [data-cf-tax-item] : tax cost (added to total not subtotal)
		// [data-cf-cost-subtotal] : where to display subtotal
		// [data-cf-cost-total] : where to display total

		// non-displayed
		// [data-subtotal] : attr of $this - stores subtotal (not including tax)
		// [data-total] : attr of $this - stores total (includes tax)

		let $this			= $(this);

		let $inputs			= $this.find('input, textarea, select, [data-form-item]');
		let $costItems		= $this.find('[data-cf-cost-item], [data-cf-tax-item]');
		let $costSelectors	= $this.find('[data-cf-cost-selector]');
		let $taxItems		= $this.find('[data-cf-tax-item]');
		let $promoCodes		= $this.find('[data-promo-code]');
		let $menuBagItems	= $this.find('[data-menu-bag-item]');
		let $costSubTotal	= $this.find('[data-cf-cost-subtotal]');
		let $costTotal		= $this.find('[data-cf-cost-total]');
		let $zipTaxRow		= $this.find('[data-cf-zip-tax-row]');

		let currency		= $this.data('cf-cost-currency') || '$';
		let taxRate			= $this.data('cf-tax-rate') || 0.09;
		let tax				= 0;
		let discounts		= 0;
		let subTotal		= 0;
		let total			= 0;

		let debouncer		= null;

		// initialize zip tax rows

		$zipTaxRow.each((index, value) => {

			let $ztr		= $(value);
			let $zipField	= $ztr.find('[data-zip-input]');
			let $taxItem	= $ztr.find('[data-cf-tax-item]');
			let $button		= $ztr.find('button');

			let checkZip = () => {

				$this.validate().element($zipField);

				if ( $zipField.hasClass('valid') ) {
					$taxItem.attr('data-cf-valid', true);
				} else {
					$taxItem.removeAttr('data-cf-valid');
				}

				updateTotals();
			}

			$zipField.on('change keyup blur', () => {
				checkZip();
			});

			$button.on('click', (e) => {
				e.preventDefault();
				checkZip();
			});
		});

		// interactions with cost selectors

		$costSelectors.each((index, value) => {

			let $costSelector = $(value);
			let $costItem = $costSelector.find('[data-cf-cost-item]');
			let $select = $costSelector.find('select');

			let checkVal = () => {

				let cost = window.utils.BrowserUtils.getUrlParameters($select.val()).cost;
				if(!cost){ cost = 0; }

				$costItem.text('$' + window.utils.NumberUtils.formatNumber(cost, 0, 2, true));
			}

			$select.on('change', checkVal.bind(this));
		});

		// listen for promo code updates

		$promoCodes.on('change', (e) => {

			let $target 	= $(e.currentTarget);
			let $discount 	= $target.find('[data-pc-discount-item]');
			let number		= Number($discount.text().replace(/[^0-9\.\-]+/g,""));

			if(!$target.attr('data-applied') || $target.attr('data-applied') === 'false'){ number = 0; }

			$target.attr('data-cf-promo-discount', number);
			updateTotals();
		});

		//

		let onInputUpdate = (e, params) => {

			if ( !params || !params.silent ) {
				$this.triggerHandler('change', {
					silent: true
				});
			}

			updateTotals();
		}

		let updateTotals = () => {

			subTotal	= 0;
			tax			= 0;
			discounts 	= 0;

			$costItems.each((index, value) => {

				let $costItem	= $(value);
				let costText	= $costItem.text();
				let number		= Number(costText.replace(/[^0-9\.\-]+/g,""));

				if ( $costItem.attr('data-active') != 'false' ) {

					if ( typeof($costItem.data('cf-tax-item')) === 'undefined' ) {
						subTotal += number;
					}
				}
			});

			$menuBagItems.each((index, value) => {

				let $menuBagItem	= $(value);
				let totalCost		= parseFloat($menuBagItem.attr('data-mbi-total-cost'));

				if ( totalCost ) {
					subTotal += totalCost;
				}
			});

			$promoCodes.each((index, value) => {

				let $promoCode	= $(value);
				let discount	= parseFloat($promoCode.attr('data-cf-promo-discount'));

				if ( discount ) {
					discounts += discount;
				}
			});

			// adjust subtotal with discounts

			subTotal -= discounts;

			// calculate tax

			tax = subTotal * taxRate;

			// display tax

			let isTaxing = false;

			$taxItems.each((index, value) => {
				let $taxItem = $(value);
				if ( $taxItem.attr('data-cf-valid') ) {
					isTaxing = true;
					$taxItem.text('$' + window.utils.NumberUtils.formatNumber(tax, 0, 2, true));
				} else {
					$taxItem.text('$' + window.utils.NumberUtils.formatNumber(0, 0, 2, true));
				}
			});

			if ( !isTaxing ){
				tax = 0;
			}

			// calculate total

			total = subTotal + tax;

			// store total/subtotal as data attributes to make available for other mods

			$this.attr('data-cf-subtotal', subTotal);
			$this.attr('data-cf-total', subTotal + tax);

			// format totals with commas and currency

			$costSubTotal.text(currency + window.utils.NumberUtils.formatNumber(subTotal, 0, 2, true));
			$costTotal.text(currency + window.utils.NumberUtils.formatNumber(subTotal + tax, 0, 2, true));

		}

		// debounce updates to inputs

		debouncer = _.debounce(onInputUpdate, 250);

		// listen for changes

		$menuBagItems.on('change', updateTotals);

		$costItems.on('change', debouncer);
		$inputs.on('change', debouncer);
		$inputs.on('keyup', debouncer);

		// initial calculations

		updateTotals();
		$this.validate();

	});

	// zip input validation

	window.SETTINGS.domScan.addElement($scanContainer, '[data-zip-input]', function(){

		let $this = $(this);

		jQuery.validator.addMethod('zipcode', function(value, element) {
			return this.optional(element) || (value && value.length === 5 && !!value.trim().match(/^\d{5}(?:[-\s]\d{4})?$/));
		}, 'Invalid zip code');

	});

	// // phone
	// // supports: (123) 456 7899, (123).456.7899, (123)-456-7899, 123-456-7899, 123 456 7899, 1234567899
	// window.SETTINGS.domScan.addElement($scanContainer, '[data-phone-input]', function(){

	// 	let $this = $(this);

	// 	jQuery.validator.addMethod('phone', function(value, element) {
	// 		return this.optional(element) || (value && value.trim().match(/\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/));
	// 	}, 'Invalid phone number');

	// });

	*/

});

},{"./controls/plus-minus-field":25,"./fields/drag-drop-upload":26}],28:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class ImgContain extends BaseModule {

	constructor(el, params) {

		super(el);

		this.contentRatio;
		this.centerX = 0.5;
		this.centerY = 0.5;

		this.isLoading;
		this._checkContentRatio();
	}

	// basemodule methods

	_domReady(){ }

	_checkContentRatio(){

		let el = this.$el[0];
		if(el.complete){
			this.contentRatio = el.naturalWidth / el.naturalHeight;
			this._resize();
			this.$el.addClass('is-loaded');
		}
		else if(!this.isLoading){
			this.$el.on('load', (e) => {
				this.contentRatio = el.naturalWidth / el.naturalHeight;
				this._resize();
				this.$el.addClass('is-loaded');
			});
		}
	}

	_addListeners(){ }
	_removeListeners(){ }

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){

		if(this.contentRatio){
			let $parent = this.$el.parent();
			window.utils.PositioningUtils.fitToObject(this.$el, $parent, this.contentRatio, this.centerX, this.centerY, false);
		}
	}
}

module.exports = ImgContain;

},{"../../90_utils/base/BaseModule":131}],29:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class ImgCover extends BaseModule {

	constructor(el, params) {

		super(el);

		this.contentRatio;
		this.centerX = 0.5;
		this.centerY = 0.5;

		this._checkContentRatio();
	}

	// basemodule methods

	_domReady(){ }

	_checkContentRatio(){

		let el = this.$el[0];
		if(el.complete){
			this.contentRatio = el.naturalWidth / el.naturalHeight;
			this._resize();
			this.$el.addClass('is-loaded');
		}
	}

	_addListeners(){

		let el = this.$el[0];

		this.$el.on('imageChange', $.proxy(this._onImageChange, this));
		this.$el.on('load', (e) => {
			this.contentRatio = el.naturalWidth / el.naturalHeight;
			this._resize();
			this.$el.addClass('is-loaded');
		});
	}
	_removeListeners(){ }

	_onImageChange(e){

	}

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){

		if(this.contentRatio){
			let $parent = this.$el.parent();
			window.utils.PositioningUtils.fitToObject(this.$el, $parent, this.contentRatio, this.centerX, this.centerY, true);
		}
	}
}

module.exports = ImgCover;

},{"../../90_utils/base/BaseModule":131}],30:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class LazyImg extends BaseModule {

	constructor(el, params) {

		super(el);

		this.currentURL;
		this.desktopURL;
		this.mobileURL;
	}

	// basemodule methods

	_domReady(){
		this._updateAttributes();
	}

	_updateAttributes(){
		this.desktopURL = this.$el.attr('data-desktop-src');
		this.mobileURL = this.$el.attr('data-mobile-src');
		this._resize();
	}

	_changeImage(imageURL){

		if(imageURL && this.currentURL !== imageURL){

			this.$el.removeClass('is-loaded');

			if(this.currentURL){
				this.$el.off('load', $.proxy(this._onLoaded, this));
				this.$el.triggerHandler('loadCanceled');
			}

			// let anyone who is listening know this image is about to change

			this.$el.triggerHandler('imageChange', {target:this, imageURL:imageURL});

			//

			this.currentURL = imageURL;
			this.$el.on('load', $.proxy(this._onLoaded, this));
			this.$el.attr('src', imageURL);
		}
	}

	_onLoaded(e){
		this.$el.off('load', $.proxy(this._onLoaded, this));
		this.$el.triggerHandler('load', {target:this, imageURL:this.currentURL, originalEvent:e});
		this.$el.addClass('is-loaded');
	}

	_addListeners(){ }
	_removeListeners(){ }

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){

		if(window.SETTINGS.breakpoint.minWidth('screen-phablet') && window.SETTINGS.breakpoint.minHeight('screen-phablet')){
			this._changeImage(this.desktopURL);
		}
		else {
			this._changeImage(this.mobileURL);
		}
	}
}

module.exports = LazyImg;

},{"../../90_utils/base/BaseModule":131}],31:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class LoopingVideo extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$video = this.$el.find('.video');
		this.$poster = this.$el.find('.poster');

		this.iframeURL;

		this.isEnabled = false;
		this.isPlaying = false;
	}

	// basemodule methods

	_domReady(){
	}

	_addListeners(){

		this.$el.on('viewportEnter', $.proxy(this._onViewportEnter, this));
		this.$el.on('viewportLeave', $.proxy(this._onViewportLeave, this));
	}

	_removeListeners(){

		this.$video.off('playing', $.proxy(this._onBufferComplete, this));
		this.$video.off('canplaythrough', $.proxy(this._onBufferComplete, this));

		this.$el.off('viewportEnter', $.proxy(this._onViewportEnter, this));
		this.$el.off('viewportLeave', $.proxy(this._onViewportLeave, this));
	}

	//

	_onViewportEnter(){
		this.isPlaying = true;
		this._play();
	}

	_onViewportLeave(){
		this.isPlaying = true;
		this._pause();
	}

	_buffer(){

		this.$video.on('playing', $.proxy(this._onBufferComplete, this));
		this.$video.on('canplaythrough', $.proxy(this._onBufferComplete, this));

		this.$el.addClass('is-buffering');
		// this.$video[0].pause();
	}

	_onBufferComplete(){

		this.$video.off('playing', $.proxy(this._onBufferComplete, this));
		this.$video.off('canplaythrough', $.proxy(this._onBufferComplete, this));

		this.$el.removeClass('is-buffering');
		this.$el.addClass('is-buffered');

		if(this.isEnabled && this.isPlaying){
			this._play();
		}
	}

	//

	_checkStatus(){

		console.log(this.isEnabled, this.isPlaying);

		if(this.isEnabled && this.isPlaying){
			this._play();
		}
		else {
			this._pause();
		}
	}

	//

	_play(){

		if(this.isEnabled){

			if(!this.$el.hasClass('is-buffering')){

				// this.$video[0].play();

				if(!this.$el.hasClass('is-buffered')){
					this._buffer();
				}
			}
		}
	}

	_pause(){
		// this.$video[0].pause();
		this.isPlaying = false;
	}

	//

	_show(){}

	_hide(){}

	_enable(){ }
	_disable(){

	}

	_domUpdate(){

	}
	_resize(){

		if(window.SETTINGS.breakpoint.minWidth('screen-small')){

			this.isEnabled = true;

			if(this.iframeURL){
				this.$el.find('iframe').attr('src', this.iframeURL);
			}
		}
		else {

			this.isEnabled = false;

			if(!this.iframeURL){
				this.iframeURL = this.$el.find('iframe').attr('src');
			}

			this.$el.find('iframe').attr('src', '');
		}

		let videoHeight = this.$el.outerHeight() * 1.04;
		let topBleed = this.$el.outerHeight() * 0.04 / 2;
		let classes = this.$el.find('.video .scaler').attr('class');
		let ratioSplit = classes.split('scaler-')[1].split('x');
		let aspectRatio = ratioSplit[0] / ratioSplit[1];

		this.$el.find('.video').css({
			top: 0 - topBleed,
			left: Math.round((window.SETTINGS.coords.viewportWidth - videoHeight * aspectRatio)/2),
			width: Math.round(videoHeight * aspectRatio),
			height: videoHeight
		});

		this._checkStatus();
	}
}

module.exports = LoopingVideo;

},{"../../90_utils/base/BaseModule":131}],32:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],33:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class PlyrVideo extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$playerWrapper = this.$el.find('.player-wrapper');
		this.$player 		= this.$el.find('.player');
		this.$playBtn    	= this.$el.find('button.play');
		this.$pauseBtn    	= this.$el.find('button.pause');
		this.$videoThumb 	= this.$el.find('.video-thumb');
		this.$domData 		= this.$el.find('.dom-data');

		this.id        		= this.$domData.attr('data-plyr-video-id');
		this.provider  		= this.$domData.attr('data-plyr-video-provider');
		this.autoplay  		= (this.$domData.attr('data-plyr-autostart') === true);

		this.controlsTemplate = this.$el.find('#plyr__controls_template').html();

		this.playerId;
		this.player;
		this.plyrInstance;

		this.isEnabled = false;
		this.isInitialized = false;
	}

	// basemodule methods

	_domReady(){

	}

	//

	_initVideo(forceAutoPlay){

		if(!this.isInitialized){

			this.playerId = `plyr-video-${++window.SETTINGS.vars.svgIndex}`;
			this.$player.attr('id', this.playerId);
			this.$player.addClass(this.playerId);

			this.$player.attr('data-type', this.provider);
			this.$player.attr('data-video-id', this.id);

			let autoplay = (forceAutoPlay === true) ? true : this.autoplay;

			this.player = plyr.setup('#' + this.playerId, {
				clickToPlay: false,
				disableContextMenu: true,
				hideControls: false,
				html: this.controlsTemplate,
				debug: false,
				autoplay: false //autoplay
			});

			this.isInitialized = true;

			this.player[0].on('ready', (e) => {

				this.plyrInstance = e.detail.plyr;

				this.plyrInstance.on('playing', (e) => {
					this.$el.triggerHandler('playing', {target:this, plyr:this.plyrInstance, originalEvent:e});
					this.$el.removeClass('video-pause');
					this.$el.addClass('video-playing');
				});

				this.plyrInstance.on('pause', (e) => {
					this.$el.triggerHandler('pause', {target:this, plyr:this.plyrInstance, originalEvent:e});
					this.$el.removeClass('video-playing');
					this.$el.addClass('video-pause');
				});

				this.$el.triggerHandler('ready', {target:this, plyr:this.plyrInstance, originalEvent:e});
				this.$el.addClass('video-ready');

				if(autoplay){
					this._play();
				}
			});
		}
	}

	//

	_addListeners(){

		this.$el.on('plyr-init', this._onInit.bind(this));
		this.$el.on('plyr-play', this._onPlayTriggered.bind(this));
		this.$el.on('plyr-pause', this._onPauseTriggered.bind(this));
		this.$el.on('plyr-destroy', this._onDestroyTriggered.bind(this));
	}

	_removeListeners(){

		this.$el.off('plyr-init', this._onInit.bind(this));
		this.$el.off('plyr-play', this._onPlayTriggered.bind(this));
		this.$el.off('plyr-pause', this._onPauseTriggered.bind(this));
		this.$el.off('plyr-destroy', this._onDestroyTriggered.bind(this));
	}

	//

	_onInit(){
		if ( !this.isInitialized ){
			this._initVideo();
		}
	}

	_onPlayClick(e){
		e.preventDefault();
		this._play();
	}

	_onPlayTriggered(){
		this._play();
	}

	_onPauseTriggered(){

	}

	_onDestroyTriggered(){

		this._stop();

		if(this.player && this.plyrInstance){
			this.plyrInstance.destroy();
			this.plyrInstance = null;
		}
	}

	//

	_play(){

		if(!this.isInitialized){
			this._initVideo(true);
		}
		else {

			if(this.player && this.plyrInstance){
				this.plyrInstance.play();
			}
		}
	}

	_pause(){

		if(this.player && this.plyrInstance){
			this.plyrInstance.pause();
		}
	}

	_stop(){

		if(this.player && this.plyrInstance){
			this.plyrInstance.stop();
		}
	}

	//

	_show(){}

	_hide(){}

	_enable(){ }
	_disable(){
		this._onDestroyTriggered();
	}

	_domUpdate(){

	}

	_resize(){

		if ( window.SETTINGS.breakpoint.minWidth('screen-small') ) {
			this.isEnabled = true;
		} else {
			this.isEnabled = false;
		}
	}
}

module.exports = PlyrVideo;

},{"../../90_utils/base/BaseModule":131}],34:[function(require,module,exports){
var ImgContain   = require("./img-contain/script");
var ImgCover     = require("./img-cover/script");
var LazyImg      = require("./lazy-img/script");
var LoopingVideo = require("./looping-video/script");
var PlyrVideo    = require("./plyr-video/script");

window.SETTINGS.domScan.addContainer($('body'), function($scanContainer){

	window.SETTINGS.domScan.addElement($scanContainer, '[data-img-contain]', function(){
		new ImgContain(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-img-cover]', function(){
		new ImgCover(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-lazy-img]', function(){
		new LazyImg(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-looping-video]', function(){
		new LoopingVideo(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-plyr-video]', function(){
		new PlyrVideo(this);
	});

});

},{"./img-contain/script":28,"./img-cover/script":29,"./lazy-img/script":30,"./looping-video/script":31,"./plyr-video/script":33}],35:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],36:[function(require,module,exports){
window.SETTINGS.domScan.addContainer( null, ($scanContainer) => {

	window.SETTINGS.domScan.addElement($scanContainer, '[data-z-group]', function () {

		let $this = $(this);

		let sortElements = () => {

			let lowZ = $this.data('low-z');
			let $zIndexElements = $this.find('[data-desc-z]');

			if(typeof(lowZ) === 'undefined'){ lowZ = 1; }

			let sortedZIndexElements = $zIndexElements.sort(

				function(a, b){

					let $a = $(a);
					let $b = $(b);
					let aOffset = $a.offset();
					let bOffset = $b.offset();

					if(aOffset.top < bOffset.top){
						return 1;
					}
					else if(aOffset.top == bOffset.top){

						if(aOffset.left < bOffset.left){ return -1; }
						else if(aOffset.left == bOffset.left){ return 0; }
						else { return 1; }
					}

					return -1;
				}
			);

			for(let i=0; i<sortedZIndexElements.length; i++){
				let $zIndexElement = $(sortedZIndexElements[i]);
				$zIndexElement.css('z-index', '');
				let zIndex = parseInt($zIndexElement.css('z-index')) || lowZ;
				$zIndexElement.css('z-index', zIndex+(i+1));
			}
		}

		window.vent.on('domUpdate', (e, obj) => {
			if(obj && obj.$scanContainer[0] === $this[0]){
				sortElements();
			}
		});

		sortElements();

	});
});

},{}],37:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],38:[function(require,module,exports){
const TopNav = require('./top-nav/script.js');
const TopSuperMenu = require('./top-super-menu/script.js');

window.SETTINGS.domScan.addContainer( null, ($scanContainer) => {

	window.SETTINGS.domScan.addElement($scanContainer, '[data-top-nav]', function() {
		new TopNav(this, {});
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-top-super-menu]', function() {
		new TopSuperMenu(this, {});
	});
});

},{"./top-nav/script.js":39,"./top-super-menu/script.js":40}],39:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class TopNav extends BaseModule {

	constructor(el, params) {

		super(el);

		// element vars

		this.$collapsed          	= this.$el.find('.top-nav--collapsed');
		this.$expanded				= this.$el.find('.top-nav--expanded');

		this.$burger  				= this.$el.find('.nav-items--right .burger');
		this.$close  				= this.$el.find('.nav-items--right .close');
		this.$yir 					= this.$el.find('.nav-items--yir');

		this.$currentNavItem;
		this.$window  				= $(window);

		this.stickyScrollPos     	= -1;
		this.isAnimating        	= false;
		this.isTransitionLocked 	= false;
		this.scrollTop				= 0;

		this.isSiteLoaded 			= false;

		// save original settings

		if(!this.$yir.attr('data-href')){
			this.$yir.attr('data-href', this.$yir.find('a').attr('href'));
			this.$yir.attr('data-title', this.$yir.find('.title').text());
		}

		CustomEase.create("underline", "M0,0 C0.358,0.158 0.094,0.986 1,1");
	}

	// private methods

	_domReady(){

	}

	_addListeners(){

		this.$burger.on('click', $.proxy(this._onBurgerClick, this));
		this.$close.on('click', $.proxy(this._onCloseClick, this));

		this.$el.on('open', this.open.bind(this));
		this.$el.on('close', this.close.bind(this));

		this.$el.find('.nav-items .nav-item').on('mouseenter', $.proxy(this._onNavItemOver, this));
		this.$el.find('.nav-items .nav-item').on('mouseleave', $.proxy(this._onNavItemOut, this));
		this.$el.find('.nav-items .nav-item').on('click', $.proxy(this._onNavItemClick, this));

		this.$window.on('scroll', $.proxy(this._onScroll, this));

		window.vent.on('siteLoadComplete', this._onSiteLoadComplete, this);
		window.vent.on('heroChangeRoute', this._onHeroChangeRoute, this);
		window.vent.on('pageChangeStart', this._onPageChangeStart, this);
		window.vent.on('pageChangeComplete', this._onPageChangeComplete, this);

	}

	_removeListeners(){

	}

	// element event listeners

	_onBurgerClick(e){
		this.open();
	}

	_onCloseClick(e){
		this.close();
	}

	_onScroll(e){

		let scrollTop = Math.round(this.$window.scrollTop());

		if(scrollTop >= window.SETTINGS.coords.winHeight / 4 * 3){

			if(!this.$el.hasClass('is-sticky') && !this.isAnimating){

				$('body').addClass('sticky-nav');

				this.isAnimating = true;
				this.$el.addClass('is-sticky');

				TweenMax.to($('.progress-bar'), 0.3, {y:60, ease:'fade'});
				TweenMax.fromTo(this.$collapsed, 0.3, {y:-60}, {y:0, ease:'fade', onComplete:() => {
					this.isAnimating = false;
					this._onScroll();
				}});
			}
		}
		else {

			if(this.$el.hasClass('is-sticky') && !this.isAnimating && !this.isTransitionLocked){

				this.isAnimating = true;

				TweenMax.to($('.progress-bar'), 0.2, {y:0, ease:Cubic.easeOut});
				TweenMax.to(this.$collapsed, 0.3, {y:-60, ease:'fade', onComplete:() => {

					$('body').removeClass('sticky-nav');

					this.isAnimating = false;
					this.$el.removeClass('is-sticky');

					TweenMax.fromTo(this.$el, 0.2, {opacity:0}, {opacity:1, ease:Cubic.easeOut});
					TweenMax.set(this.$collapsed, {y:0});

					this._onScroll();
				}});
			}
		}
	}

	_onNavItemOver(e){

		let $target = $(e.currentTarget);
		this._navItemEnter($target);
	}

	_onNavItemOut(e){

		let $target = $(e.currentTarget);
		this._navItemLeave($target);
	}

	_onNavItemClick(e){

		let $target = $(e.currentTarget);
	}

	_onPageChangeStart(){
		this._checkRoute();
		this._changeYirOut();
		this.close();
	}

	_onHeroChangeRoute(){
		this.isTransitionLocked = true;
	}

	_onPageChangeComplete(){

		if(this.isTransitionLocked){

			let onScroll = () => {
				if(this.$window.scrollTop() >= window.SETTINGS.coords.winHeight){
					this.isTransitionLocked = false;
					this.$window.off('scroll', onScroll);
				}
			}

			this.$window.on('scroll', onScroll);
		}

		this._changeYirIn();
	}

	_onSiteLoadComplete(){
		this.isSiteLoaded = true;
		this._checkRoute();
	}

	//

	_changeYirOut(){

		let title = this._getYirTitle();

		if(title && this.$yir.find('.title').text() !== title){
			TweenMax.killTweensOf(this.$yir);
			TweenMax.to(this.$yir, 0.3, {opacity: 0, ease:'fade'});
		}
	}

	_changeYirIn(){
		let title = this._getYirTitle();
		this._setYirTitle(title);
	}

	_getYirTitle(){

		let router = window.SETTINGS.router;
		let pageId = router.getRouteObj().pageId;
		let title = this.$el.find(`.nav-item[data-id=\"${pageId}\"]`).find('.title').text();

		if(pageId === 'intro' || window.SETTINGS.breakpoint.minWidth('screen-medium')){
			title = this.$yir.attr('data-title');
		}

		return title;
	}

	_setYirTitle(title){

		let router = window.SETTINGS.router;
		let href = router.getRoute();
		let pageId = router.getRouteObj().pageId;

		if(pageId === 'intro' || window.SETTINGS.breakpoint.minWidth('screen-medium')){
			href = this.$yir.attr('data-href');
		}

		if(title && this.$yir.find('.title').text() !== title){
			this.$yir.find('.yir').attr('href', href);
			this.$yir.find('.title').text(title);
		}

		TweenMax.killTweensOf(this.$yir);
		TweenMax.to(this.$yir, 0.3, {opacity: 1, ease:'fade'});
	}

	//

	_navItemEnter($target){

		if(this.isSiteLoaded){

			let $underline = $target.find('.underline');

			TweenMax.killTweensOf($underline);
			TweenMax.to($underline, 0.24, {opacity: 1, ease:Cubic.easeOut});
			TweenMax.to($underline, 0.24, {scaleY: 1, y:0, ease:"underline"});
		}
	}

	_navItemLeave($target){

		if(!$target.hasClass('is-active')){

			let $underline = $target.find('.underline');

			TweenMax.killTweensOf($underline);
			TweenMax.to($underline, 0.2, {opacity: 0, ease:"underline", onComplete:() => {
				TweenMax.set($underline, {clearProps: 'all'});
			}});
		}
	}

	_checkRoute(){

		let routeObj = window.SETTINGS.router.getRouteObj();
		let $selectedNavItem = this.$el.find(`.nav-items ul > [data-id='${routeObj.pageId}']`);

		if(!this.$currentNavItem || !$selectedNavItem.hasClass('is-active')){

			if(this.$currentNavItem){
				this.$currentNavItem.removeClass('is-active');
				this._navItemLeave(this.$currentNavItem);
			}

			this._navItemEnter($selectedNavItem);

			this.$currentNavItem = $selectedNavItem;
			this.$currentNavItem.addClass('is-active');
		}
	}

	// open / close

	open(){

		if ( !this.$collapsed.hasClass('is-open') ) {
			// this.$collapsed.addClass('is-open');
		}

		this.$expanded.triggerHandler('open');
	}

	close(){

		if ( this.$collapsed.hasClass('is-open') ) {
			// this.$collapsed.removeClass('is-open');
		}

		this.$expanded.triggerHandler('close');
	}

	//

	_domUpdate(){
		this._updateHeroCoords();
	} // use me!

	_resize(){

		this._updateHeroCoords();

		let title = this._getYirTitle();
		this._setYirTitle(title);

	} // use me!

	_updateHeroCoords(){

		let $heroes = $('.hero:not(.is-hidden)');
		let $topHero;
		let topOffset;

		$heroes.each((index, value) => {

			let $hero = $(value);
			let offset = $hero.offset();

			if(isNaN(topOffset) || (offset.top < topOffset && offset.top >= 0)){
				topOffset = offset.top;
				$topHero = $hero;
			}
		});

		if($topHero && $topHero.length){
			this._onScroll();
		}
	}
}

module.exports = TopNav;

},{"../../90_utils/base/BaseModule":131}],40:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class TopSuperMenu extends BaseModule {

	constructor(el, params) {

		super(el);

		this.isSiteLoaded = false;
	}

	// private methods

	_domReady(){

	}

	_addListeners(){

		this.$el.on('open', $.proxy(this._onOpenTrigger, this));
		this.$el.on('close', $.proxy(this._onCloseTrigger, this));
		this.$el.find('a').on('click', $.proxy(this._onNavItemClick, this));

		window.vent.on('siteLoadComplete', this._onSiteLoadComplete, this);
		window.vent.on('pageChangeStart', this._onPageChangeStart, this);
	}

	_removeListeners(){

		this.$el.off('open', $.proxy(this._onOpenTrigger.bind, this));
		this.$el.off('close', $.proxy(this._onCloseTrigger.bind, this));
		this.$el.find('a').off('click', $.proxy(this._onNavItemClick, this));

		window.vent.off('siteLoadComplete', this._onSiteLoadComplete, this);
		window.vent.off('pageChangeStart', this._onPageChangeStart, this);
	}

	// element event listeners

	_onOpenTrigger(){
		this.open();
	}

	_onCloseTrigger(){
		this.close();
	}

	_onNavItemClick(e){
		let $target = $(e.currentTarget);
		if(typeof($target.attr('target')) === 'undefined' && $target.attr('href') !== 'javascript:;'){
			this.close();
		}
	}

	_onPageChangeStart(){
		this._updateSelectedLinks();
	}

	_onSiteLoadComplete(){
		this.isSiteLoaded = true;
		this._updateSelectedLinks();
	}

	//

	_updateSelectedLinks(){

		let $el = $('.top-super-menu'); // gets moved around from modaal, but somehow listeners work
		let routeObj = window.SETTINGS.router.getRouteObj();

		let $page = $el.find(`[data-page-id="${routeObj.pageId}"]`);
		let $section = $el.find(`[data-section-id="${routeObj.sectionId}"]`);

		if($page.length){
			$el.find('[data-page-id]').removeClass('is-active');
			$page.addClass('is-active');
		}

		if($section.length){
			$el.find('[data-section-id]').removeClass('is-active');
			// $section.addClass('is-active');
		}
	}

	//

	open(){

		if(!this.$el.hasClass('is-open')){
			this.$el.addClass('is-open');
		}
	}

	close(){

		if(this.$el.hasClass('is-open')){
			this.$el.removeClass('is-open');
		}

		$('#top-nav [data-modal-link="foo"]').eq(0).modaal('close');
	}

	//

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){ }
}

module.exports = TopSuperMenu;

},{"../../90_utils/base/BaseModule":131}],41:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],42:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],43:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class ImpactFooter extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$background = this.$el.find('.footer-bg');
		this.$headline = this.$el.find('.quote');
		this.$blurb = this.$el.find('.blurb');
	}

	// basemodule methods

	_domReady(){

		// console.log(this.$headline);
	}

	_addListeners(){

		// this.$headline.on('show', $.proxy(this._showHeadline, this));
	}

	_removeListeners(){ }

	//

	_showHeadline(){


	}

	//

	_show(){

		TweenMax.set([this.$background, this.$headline, this.$blurb], { opacity: 0 });

		TweenMax.to(this.$background, 1.6, {
			opacity: 1,
			ease: 'longFade'
		});

		this.$headline.one('show', ()=>{
			TweenMax.fromTo(this.$headline, 0.6, {opacity:0, y:30}, {opacity:1, y:0, ease:'longFade'});
			TweenMax.fromTo(this.$blurb, 0.6, {opacity:0, y:30}, {opacity:1, y:0, delay:0.5, ease:'longFade'});
		});
	}

	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){

		if(window.SETTINGS.breakpoint.minWidth('screen-medium')){
			TweenMax.killTweensOf([this.$background, this.$headline, this.$blurb]);
			TweenMax.set([this.$background, this.$headline, this.$blurb], {opacity:1, y:0});
		}
		else {
			TweenMax.killTweensOf([this.$background, this.$headline, this.$blurb]);
			TweenMax.set([this.$background, this.$headline, this.$blurb], {clearProps:'opacity, y'});
		}
	}
}

module.exports = ImpactFooter;

},{"../../90_utils/base/BaseModule":131}],44:[function(require,module,exports){

const ImpactFooter = require('./impact/script');

window.SETTINGS.domScan.addContainer( null, ($scanContainer) => {

	window.SETTINGS.domScan.addElement($scanContainer, '[data-impact-footer]', function () {
		new ImpactFooter($(this));
	});
});

},{"./impact/script":43}],45:[function(require,module,exports){
const Hero = require('../hero/script');

class ActionHero extends Hero {

	constructor(el, params) {

		super(el);

		// element vars


	}

	// basemodule methods

	_domReady(){ super._domReady(); }

	_addListeners(){ super._addListeners(); }
	_removeListeners(){ super._removeListeners(); }

	//

	_show(){
		super._show();
	}

	_hide(){
		super._hide();
	}

	_enable(){ super._enable(); }
	_disable(){ super._disable(); }

	_domUpdate(){ super._domUpdate(); }
	_resize(){ super._resize(); }
}

module.exports = ActionHero;

},{"../hero/script":46}],46:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');
const ScrollStepListener = require('../../90_utils/ScrollStepListener');

class Hero extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$window = $(window);
		this.$innerWrapper = this.$el.find('.inner-wrapper');
		this.scrollStepListener;
		this.scrollDelay;

		this.stepIndex = 0;
		this.hasFrameText = false;

		this.isFirstIntro = true;
		this.isFooterHero = this.$el.hasClass('footer-hero');
		this.isInFramedText = false;
		this.isInSteps = false;
		this.isMobile = false;
		this.isModalOpen = false;
		this.isPageLoaded = false;
		this.isPendingSection = false;
		this.isScrollLocked = true;

		this.status;

		this.$el.addClass('id' + (++window.SETTINGS.vars.svgIndex));

		this._checkScrollPos();
	}

	// private methods

	_domReady(){
		if(!this.$el.hasClass('is-hidden')){
			this.show();
		}
	}

	_addListeners(){

		if(!this.$el.hasClass('is-hidden')){

			this.$el.on('completeIntro', $.proxy(this._onCompleteIntro, this));
			this.$el.on('updateStatus', $.proxy(this._onUpdateStatus, this));

			this.$window.on('scroll', $.proxy(this._onScroll, this));
			this.$window.on('mousewheel', $.proxy(this._onMouseWheel, this));
			this.$el.find('.centered-quote a.title-link').on('click', $.proxy(this._onClick, this));
			this.$el.find('.mobile-continue').on('click', $.proxy(this._onClick, this));

			window.vent.on('pageLoadComplete', this._onPageLoadComplete, this);
			window.vent.on('pageChangeStart', this._onPageChangeStart, this);
			window.vent.on('pageChangeComplete', this._onPageChangeComplete, this);
			window.vent.on('modalOpen', this._onModalOpen, this);
			window.vent.on('modalClose', this._onModalClose, this);

			if(this.$el.find('[data-framed-text]').length){
				this.hasFrameText = true;
			}

			if(!this.isFooterHero){
				window.vent.on('triggerScrollStep', this._onTriggerScrollStep, this);
			}

			// if(!this.scrollStepListener){
			// 	this.scrollStepListener = new ScrollStepListener($('body'), {
			// 		$touchEl: this.$el,
			// 		onTriggerCallback: this._onScrollStep.bind(this),
			// 		onScrollCompleteCallback: this._onScrollComplete.bind(this)
			// 	});
			// }

			this._checkScrollPos();
		}
	}

	_removeListeners(){

		this.$el.off('completeIntro', $.proxy(this._onCompleteIntro, this));
		this.$el.off('updateStatus', $.proxy(this._onUpdateStatus, this));

		this.$window.off('scroll', $.proxy(this._onScroll, this));
		this.$window.off('mousewheel', $.proxy(this._onMouseWheel, this));
		this.$el.find('.centered-quote a').off('click', $.proxy(this._onClick, this));
		this.$el.find('.mobile-continue').off('click', $.proxy(this._onClick, this));

		window.vent.off('pageLoadComplete', this._onPageLoadComplete, this);
		window.vent.off('pageChangeStart', this._onPageChangeStart, this);
		window.vent.off('pageChangeComplete', this._onPageChangeComplete, this);
		window.vent.off('triggerScrollStep', this._onTriggerScrollStep, this);
		window.vent.off('modalOpen', this._onModalOpen, this);
		window.vent.off('modalClose', this._onModalClose, this);

		if(this.scrollStepListener){
			this.hasFrameText = false;
			this.scrollStepListener.destroy();
			this.scrollStepListener = null;
		}
	}

	//

	_onScroll(e){
		this._checkScrollPos();

		if(this.scrollDelay){ window.clearTimeout(this.scrollDelay); }
		this.scrollDelay = window.setTimeout(() => {
			window.clearTimeout(this.scrollDelay);
			this.scrollDelay = null;
			this._onScrollStep(0);
		}, 500);
	}

	_onMouseWheel(e){
		this._checkScrollPos(e);
		if(this.isScrollLocked && this.isPageLoaded && !this.isMobile){
			e.preventDefault();
		}
	}

	_onClick(e){

		e.preventDefault();

		let $target = $(e.currentTarget);
		let href = $target.attr('data-href');

		this._changeRoute({route: href});
	}

	_onPageLoadComplete(){
		this.isPageLoaded = true;
	}

	_onPageChangeStart(){
		this.isScrollLocked = true;
	}

	_onPageChangeComplete(){
		this._killScrollLock();
	}

	_onTriggerScrollStep(e, params){
		this._onScrollStep(params.delta);
	}

	_onModalOpen(){
		this.isModalOpen = true;
	}

	_onModalClose(){
		this.isModalOpen = false;
	}

	_onCompleteIntro(){
		this._completeIntro();
		this._addScrollLock(1400);
	}

	_onUpdateStatus(){
		this._updateStatus();
	}

	//

	_onScrollStep(delta){

		let docHeight = window.SETTINGS.coords.getDocHeight();
		let winHeight = window.SETTINGS.coords.winHeight;
		let triggerLeeway = 40;

		// console.log('isInSteps', this.isInSteps, '!isScrollLocked', !this.isScrollLocked, '!isMobile', !this.isMobile, '!isModalOpen', !this.isModalOpen, 'isFooterHero', this.isFooterHero, 'delta', delta, );

		if(this.isInSteps && !this.isScrollLocked && !this.isMobile && !this.isModalOpen){

			let willScroll = false;
			let willDelay = false;
			let scrollLockDelay = 1400;
			let scrollPos = 0;

			// extra winHeight of buffer room in there for magic mice (stupid)

			if(this.hasFrameText && !this.isFooterHero){

				if(delta >= 0){
					if(this.scrollTop < winHeight){
						scrollPos = winHeight;
						willScroll = true;
					}
					else {
						willScroll = false;
					}
				}
				else {
					if(this.scrollTop <= winHeight){
						scrollPos = 0;
						willScroll = true;
						this.isInFramedText = false;
					}
					else if(this.scrollTop > winHeight && this.scrollTop < winHeight * 1.67) {
						scrollPos = winHeight;
						willScroll = true;
					}
				}
			}
			else if(this.isFooterHero) {

				if(delta >= 0){
					if(this.scrollTop > docHeight - winHeight * 2){

						if(this.isPendingSection && this.scrollTop >= docHeight - winHeight - triggerLeeway){
							// console.log('_onScrollStep CHANGE ROUTE', this.$el.attr('data-section-link'));
							this._changeRoute({route: this.$el.attr('data-section-link')});
							willScroll = false;
							willDelay = true;
						}
						else if(this.scrollTop >= docHeight - winHeight / 4 * 6){
							this.isPendingSection = true;
							willScroll = true;
							scrollPos = docHeight - winHeight; // - $('#main-footer').outerHeight();
						}
					}
				}
				else {
					willScroll = false;
					this.isPendingSection = false;
				}
			}
			else {
				willScroll = false;
			}

			if(willScroll){
				// console.log('willScroll', scrollPos);
				this._addScrollLock(scrollLockDelay);
				window.vent.trigger('scrollTo', {scrollTop: scrollPos});
			}
			else if(willDelay){
				this._addScrollLock(scrollLockDelay);
			}
		}

		this._checkScrollPos();
	}

	_onScrollComplete(delta){
		if(!this.isPendingSection){
			this._onScrollStep(delta);
		}
	}

	//

	_changeRoute(params){
		if(params){
			// console.log('HERO _changeRoute', params);
			window.vent.trigger('heroChangeRoute', params);
			window.vent.trigger('changeRoute', params);
		}
	}

	//

	_checkScrollPos(){

		let docHeight = window.SETTINGS.coords.getDocHeight();
		let winHeight = window.SETTINGS.coords.winHeight;
		let wasInSteps = this.isInSteps;
		let lastScrollPos = this.scrollTop;

		this.scrollTop = Math.round(this.$window.scrollTop());

		if(this.isMobile){
			this.$innerWrapper.removeClass('is-fixed is-bottomed');
			this.isInSteps = false;
		}
		else if(!this.isFirstIntro && !this.isModalOpen) {

			let delta = this.scrollTop - lastScrollPos;

			if(this.hasFrameText && !this.isFooterHero){

				if(this.scrollTop <= winHeight * 2){
					this.isInSteps = true;
					if(this.scrollTop < winHeight/2 && this.status !== 'intro' && delta <= 0){
						this._showIntro();
					}
					else if(this.scrollTop >= winHeight/2 && this.status !== 'framed-text' && delta > 0){
						this._showFramedText();
					}
				}
				else {
					this.isInSteps = false;
				}

				if(this.scrollTop <= winHeight * 3){

					if(this.scrollTop <= winHeight){
						this.$innerWrapper.addClass('is-fixed');
						this.$innerWrapper.removeClass('is-bottomed');
					}
					else {
						this.$innerWrapper.removeClass('is-fixed');
						this.$innerWrapper.addClass('is-bottomed');
					}
				}
				else {
					this.$innerWrapper.removeClass('is-fixed');
					this.$innerWrapper.addClass('is-bottomed');
				}
			}
			else if(this.isFooterHero) {

				if(this.scrollTop > docHeight - winHeight * 3){

					this.isInSteps = true;

					if(this.scrollTop >= docHeight - winHeight/4 * 5 && this.status !== 'half-intro' && delta > 0){
						this._halfIntro();
					}
					else if(this.scrollTop < docHeight - winHeight/2 * 3 && this.status !== 'half-intro-return' && delta < 0){
						this._halfIntroReturn();
					}
				}
				else {
					this.isInSteps = false;
				}
			}

			this.$el.addClass('is-scroll-set');
		}
	}

	// add / remove scroll lock

	_addScrollLock(delay){

		delay = delay || 1000;

		this._killScrollLock();
		this.isScrollLocked = true;

		this.scrollLock = window.setTimeout(() => {
			this.isScrollLocked = false;
		}, delay);
	}

	_killScrollLock(){
		if(this.scrollLock){
			window.clearTimeout(this.scrollLock);
			this.scrollLock = null;
		}
		this.isScrollLocked = false;
	}

	//

	_showFramedText(){

		if(this.status !== 'framed-text' && !this.isInFramedText){

			let $introContent = this.$innerWrapper.find('>.content');
			let $quote = this.$innerWrapper.find('.centered-quote');
			let $polyWrapper = this.$innerWrapper.find('.poly-wrapper');
			let $bg = this.$innerWrapper.find('.hero-bg');

			let $framedText = this.$innerWrapper.find('>.content-block--framed-text');
			let $framedQuote = $framedText.find('.text-content');

			TweenMax.killTweensOf([$introContent, $quote, $polyWrapper, $bg, $framedText, $framedQuote]);

			if(!this.isInFramedText){
				TweenMax.set($framedText, {opacity:1});
				TweenMax.to($quote, 0.6, {opacity:0, y:-30, ease:'fade'});
				TweenMax.fromTo($framedQuote, 0.4, {opacity:0, y:30}, {opacity:1, y:0, delay:0.3, ease:'fade'});
				TweenMax.to([$introContent, $polyWrapper, $bg], 0.6, {opacity:0, ease:'longFade', onComplete:() => {
					$framedText.css('z-index', 8);
				}});
			}

			this.isInFramedText = true;
			this.status = 'framed-text';
		}
	}

	_showIntro(){

		console.log('_showIntro', this.status);

		if(this.status !== 'intro' && this.isInFramedText){

			let $introContent = this.$innerWrapper.find('>.content');
			let $quote = this.$innerWrapper.find('.centered-quote');
			let $polyWrapper = this.$innerWrapper.find('.poly-wrapper');
			let $bg = this.$innerWrapper.find('.hero-bg');

			let $framedText = this.$innerWrapper.find('>.content-block--framed-text');
			let $framedQuote = $framedText.find('.text-content');

			TweenMax.killTweensOf([$introContent, $quote, $polyWrapper, $bg, $framedText, $framedQuote]);

			TweenMax.set($framedText, {clearProps:'z-index'});
			TweenMax.to($framedQuote, 0.4, {opacity:0, y:30, ease:'fade'});
			TweenMax.to([$introContent, $polyWrapper, $bg], 0.3, {opacity:1, ease:'fade'});
			TweenMax.fromTo($quote, 0.6, {opacity:0, y:-30}, {opacity:1, y:0, delay:0.3, ease:'fade'});

			this.isInFramedText = false;
			this.status = 'intro';
		}
	}

	//

	_fullIntro(){

		console.log('_fullIntro', this.status);

		if(this.status !== 'intro'){

			let $quote = this.$el.find('.centered-quote');
			let $polyWrapper = this.$el.find('.poly-wrapper');
			let $bg = this.$el.find('.hero-bg');

			let delay = 0.6;

			TweenMax.killTweensOf([$quote, $polyWrapper]);
			TweenMax.fromTo($quote, 0.6, {opacity:0, y:10}, {opacity:1, y:0, delay:delay + 0.4, ease:'fade'});
			TweenMax.fromTo($polyWrapper, 1.2, {opacity:0, visibility:'visible'}, {opacity:1, delay:delay, ease:'longFade', onStart:() => {
				this.$el.addClass('is-in');
			},
			onComplete:() => {
				window.vent.trigger('heroIntroComplete', {$el: this.$el});
			}});

			this.status = 'intro';
		}
		else {
			window.setTimeout(() => {
				window.vent.trigger('heroIntroComplete', {$el: this.$el});
			}, 500);
		}
	}

	_halfIntro(){

		if(this.status !== 'half-intro'){

			let $quote = this.$el.find('.centered-quote');
			let $polyWrapper = this.$el.find('.poly-wrapper');
			let $bg = this.$el.find('.hero-bg');

			let delay = 0.3;

			TweenMax.killTweensOf([$quote, $polyWrapper]);
			TweenMax.to($quote, 0.6, {opacity:1, y:0, delay:delay + 0.2, ease:'fade'});
			TweenMax.fromTo($polyWrapper, 1.0, {opacity:0, visibility:'visible'}, {opacity:1, delay:delay + 0.0, ease:'longFade'});

			this.status = 'half-intro';
		}
	}

	_halfIntroReturn(){

		if(this.status !== 'half-intro-return'){

			let $quote = this.$el.find('.centered-quote');
			let $polyWrapper = this.$el.find('.poly-wrapper');
			let $bg = this.$el.find('.hero-bg');

			TweenMax.killTweensOf([$quote, $polyWrapper]);
			TweenMax.to($quote, 0.6, {opacity:0, ease:'fade', onComplete: () => {
				TweenMax.set($quote, {y:20});
			}});
			TweenMax.to($polyWrapper, 1.2, {opacity:0, ease:'longFade'});

			this.status = 'half-intro-return';
		}
	}

	_completeIntro(){

		if(this.status !== 'intro'){

			let $quote = this.$el.find('.centered-quote');
			let $polyWrapper = this.$el.find('.poly-wrapper');
			let $bg = this.$el.find('.hero-bg');

			this._instantHalf();

			window.SETTINGS.animationFrame.one(() => {

				this._instantIntro();

				window.setTimeout(() => {
					window.vent.trigger('heroIntroComplete', {$el: this.$el});
				}, 500);
			});

			this.status = 'intro';
		}
		else {
			window.setTimeout(() => {
				window.vent.trigger('heroIntroComplete', {$el: this.$el});
			}, 500);
		}
	}

	_instantHalf(){

		if(this.status !== 'half-intro'){

			let $quote = this.$el.find('.centered-quote');
			let $polyWrapper = this.$el.find('.poly-wrapper');
			let $bg = this.$el.find('.hero-bg');

			TweenMax.killTweensOf([$quote, $polyWrapper]);
			TweenMax.set($quote, {opacity:1, y:0});
			TweenMax.set($polyWrapper, {opacity:0.5});

			this.status = 'half-intro';
		}
	}

	_instantIntro(){

		if(this.status !== 'intro'){

			let $introContent = this.$innerWrapper.find('>.content');
			let $quote = this.$el.find('.centered-quote');
			let $polyWrapper = this.$el.find('.poly-wrapper');
			let $bg = this.$el.find('.hero-bg');

			TweenMax.killTweensOf([$quote, $polyWrapper]);
			TweenMax.set([$introContent, $bg, $quote], {opacity:1, y:0});

			if($polyWrapper.length){
				TweenMax.set($polyWrapper, {opacity:1, visibility:'visible'});
			}
			else {
				TweenMax.set($polyWrapper, {opacity:0.5});
			}

			this.status = 'intro';
		}
	}

	//

	_show(){

		this.$el.addClass('is-showing');

		if(!this.isFooterHero && !this.$el.hasClass('is-hidden')){
			if($('#page-content-controller').hasClass('is-scroll-swap')){
				this._completeIntro();
				this._addScrollLock(1400);
			}
			else {
				this._fullIntro();
				this._addScrollLock(2000);
			}
		}

		this.isFirstIntro = false;
	}

	_hide(){
		this.$el.removeClass('is-showing');
	}

	// update footer status

	_updateStatus(){
		this.isFooterHero = this.$el.hasClass('footer-hero');
		this._removeListeners();
		this._addListeners();
	}

	//

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){

		let wasMobile = this.isMobile;

		if(window.SETTINGS.breakpoint.minWidth('screen-medium')){
			this.isMobile = false;
			if(wasMobile === true){
				this._instantIntro();
			}
		}
		else {
			this.isMobile = true;
			if(wasMobile === false){ // could be undefined, doesn't count
				this._instantIntro();
			}
		}

		this.$el.css('width', window.SETTINGS.coords.docWidth);
		this._checkScrollPos();
	}
}

module.exports = Hero;

},{"../../90_utils/ScrollStepListener":130,"../../90_utils/base/BaseModule":131}],47:[function(require,module,exports){
const Hero = require('../hero/script');

class ImpactHero extends Hero {

	constructor(el, params) {

		super(el);

		// element vars


	}

	// basemodule methods

	_domReady(){ super._domReady(); }

	_addListeners(){ super._addListeners(); }
	_removeListeners(){ super._removeListeners(); }

	//

	_show(){
		super._show();
	}

	_hide(){
		super._hide();
	}

	_enable(){ super._enable(); }
	_disable(){ super._disable(); }

	_domUpdate(){ super._domUpdate(); }
	_resize(){ super._resize(); }
}

module.exports = ImpactHero;

},{"../hero/script":46}],48:[function(require,module,exports){
const Hero = require('../hero/script');

class IntroHero extends Hero {

	constructor(el, params) {

		super(el);
	}

	// basemodule methods

	_domReady(){ super._domReady(); }

	_addListeners(){ super._addListeners(); }
	_removeListeners(){ super._removeListeners(); }

	//

	_show(){
		super._show();
	}

	_hide(){
		super._hide();
	}

	_enable(){ super._enable(); }
	_disable(){ super._disable(); }

	_domUpdate(){ super._domUpdate(); }
	_resize(){

		let videoHeight = window.SETTINGS.coords.winHeight * 1.04;
		let topBleed = window.SETTINGS.coords.winHeight * 0.04 / 2;

		this.$el.find('.bg-video').css({
			top: 0 - topBleed,
			left: Math.round((window.SETTINGS.coords.viewportWidth - videoHeight * (1552/728))/2),
			width: Math.round(videoHeight * (1552/728)),
			height: videoHeight
		});
	}
}

module.exports = IntroHero;

},{"../hero/script":46}],49:[function(require,module,exports){
const ActionHero = require('./action-hero/script.js');
const ImpactHero = require('./impact-hero/script.js');
const IntroHero = require('./intro-hero/script.js');
const VisionHero = require('./vision-hero/script.js');

window.SETTINGS.domScan.addContainer( null, ($scanContainer) => {

	window.SETTINGS.domScan.addElement($scanContainer, '[data-action-hero]', function() {
		new ActionHero(this, {});
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-intro-hero]', function() {
		new IntroHero(this, {});
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-vision-hero]', function() {
		new VisionHero(this, {});
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-impact-hero]', function() {
		new ImpactHero(this, {});
	});
});

},{"./action-hero/script.js":45,"./impact-hero/script.js":47,"./intro-hero/script.js":48,"./vision-hero/script.js":50}],50:[function(require,module,exports){
const Hero = require('../hero/script');

class VisionHero extends Hero {

	constructor(el, params) {

		super(el);

		// element vars


	}

	// basemodule methods

	_domReady(){ super._domReady(); }

	_addListeners(){ super._addListeners(); }
	_removeListeners(){ super._removeListeners(); }

	//

	_show(){
		super._show();
	}

	_hide(){
		super._hide();
	}

	_enable(){ super._enable(); }
	_disable(){ super._disable(); }

	_domUpdate(){ super._domUpdate(); }
	_resize(){ super._resize(); }
}

module.exports = VisionHero;

},{"../hero/script":46}],51:[function(require,module,exports){
arguments[4][11][0].apply(exports,arguments)
},{"dup":11}],52:[function(require,module,exports){
arguments[4][11][0].apply(exports,arguments)
},{"dup":11}],53:[function(require,module,exports){
arguments[4][11][0].apply(exports,arguments)
},{"dup":11}],54:[function(require,module,exports){
const ScrollNav = require('./scroll-nav/script.js');

window.SETTINGS.domScan.addContainer( null, ($scanContainer) => {

	window.SETTINGS.domScan.addElement($scanContainer, '[data-scroll-nav]', function() {
		new ScrollNav(this, {});
	});
});

},{"./scroll-nav/script.js":55}],55:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class ScrollNav extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$window = $(window);
		this.$navContent = this.$el.find('.scroll-nav-content-wrapper');

		this.$contentController = $('#page-content-controller');
		this.$mobileToggle = this.$el.find('.mobile-toggle');
		this.$bottomHero;
		this.$heroes;
		this.$heroes;
		this.$hitArea;
		this.$navItems;
		this.$primaryContentInnerBlocks;
		this.$progressHandles;
		this.$progressIndicators;
		this.$progressLines;
		this.$selectedNavItem;
		this.$topHero;

		this.navTemplate = _.template(this.$el.find('#scroll-nav-template').html());

		this.isBadPage = false;
		this.isPartitionedPage = true;
		this.isScrollSwap = false;

		this.isInteractionLocked = false;
		this.isMobile = false;
		this.isPageChanging = false;
		this.isPendingRebuild = false;
		this.isSectionShowing = false;
		this.isTrans = false;
		this.isTransOut = true;

		this.isHover = false;
		this.isLabelTransOut = false;
		this.isLabelVisible = true;
		this.isOverHero = false;
		this.isScrollVisible = false;
		this.isSiteLoaded = false;
		this.isTouch = false;

		this.labelDelay;
		this.labelDelayTime;
		this.pageChangeDelay;
		this.pageId;
		this.sectionId;

		this.footerHeroBounds;
		this.hitAreaBounds;
		this.mouseCoords;
		this.topHeroBounds;

		this.scrollTop = 0;
	}

	// built in methods

	_domReady(){
		this.$el.find('#scroll-nav-template').remove(); // cleanup
	}

	// listeners

	_addListeners(){

		this.$window.on('scroll', $.proxy(this._onScroll, this));
		this.$mobileToggle.on('click', $.proxy(this._onMobileToggleClick, this));
		this.$el.on('click', $.proxy(this._onClick, this));

		window.vent.on('siteLoadComplete', this._onSiteLoadComplete, this);
		window.vent.on('linkChangeRoute', this._onLinkChangeRoute, this);
		window.vent.on('heroChangeRoute', this._onHeroChangeRoute, this);
		window.vent.on('heroChangeRouteComplete', this._onHeroChangeRouteComplete, this);
		window.vent.on('pageChangeStart', this._onPageChangeStart, this);
		window.vent.on('pageChangeComplete', this._onPageChangeComplete, this);
		window.vent.on('showScrollNav', this._onShowScrollNav, this);
		window.vent.on('hideScrollNav', this._onHideScrollNav, this);
		window.vent.on('expandScrollNav', this._onExpandScrollNav, this);
		window.vent.on('collapseScrollNav', this._onCollapseScrollNav, this);
		window.vent.on('mousemove', this._onMouseMove, this);
	}

	_removeListeners(){

		this.$window.off('scroll', $.proxy(this._onScroll, this));
		this.$mobileToggle.off('click', $.proxy(this._onMobileToggleClick, this));
		this.$el.off('click', $.proxy(this._onClick, this));

		window.vent.off('siteLoadComplete', this._onSiteLoadComplete, this);
		window.vent.off('linkChangeRoute', this._onLinkChangeRoute, this);
		window.vent.off('heroChangeRoute', this._onHeroChangeRoute, this);
		window.vent.off('heroChangeRouteComplete', this._onHeroChangeRouteComplete, this);
		window.vent.off('pageChangeStart', this._onPageChangeStart, this);
		window.vent.off('pageChangeComplete', this._onPageChangeComplete, this);
		window.vent.off('showScrollNav', this._onShowScrollNav, this);
		window.vent.off('hideScrollNav', this._onHideScrollNav, this);
		window.vent.off('expandScrollNav', this._onExpandScrollNav, this);
		window.vent.off('collapseScrollNav', this._onCollapseScrollNav, this);
		window.vent.off('mousemove', this._onMouseMove, this);
	}

	// listener methods

	_onScroll(){

		let oldScrollTop = this.scrollTop;
		this.scrollTop = this.$window.scrollTop();
		let scrollDelta = this.scrollTop - oldScrollTop;

		if(!this.isBadPage && this.pageId){

			let winHeight = window.SETTINGS.coords.winHeight;
			let topHeroHeight = $('body').hasClass('page-action') ? winHeight * 2 : winHeight;
			let docHeight = window.SETTINGS.coords.getDocHeight();

			// TODO: check all heroes, not just top and bottom

			if((this.scrollTop < topHeroHeight - winHeight/2) ||
				(this.scrollTop <= docHeight - winHeight && this.scrollTop >= docHeight - winHeight/2*3)){

				if(!this.isOverHero){
					this.isOverHero = true;
					this.$el.addClass('is-over-hero');
				}
			}
			else {

				if(this.isOverHero){
					this.isOverHero = false;
					this.isInteractionLocked = false;
					this.$el.removeClass('is-over-hero');
				}
			}

			if(this.isInteractionLocked && scrollDelta !== 0){
				if(this.isScrollSwap && this.scrollTop >= winHeight * 1.25){
					this.isInteractionLocked = false;
					// console.log('interaction locked false');
				}
				else if(!this.isScrollSwap && this.scrollTop >= winHeight * 0.25){
					this.isInteractionLocked = false;
					// console.log('interaction locked false');
				}
			}

			// progress indicators

			if(this.isPartitionedPage){

				let routeObj = window.SETTINGS.router.getRouteObj();
				let pageSections = window.SETTINGS.pageSections[routeObj.pageId];
				let currentSection = routeObj.sectionId ? routeObj.sectionId : (pageSections.sections ? pageSections.sections[0].id : '');
				let pageSectionObj = pageSections && currentSection ? _.findWhere(pageSections.sections, {id: currentSection}) : null;

				if(pageSectionObj){

					let sectionIndex = pageSectionObj ? pageSections.sections.indexOf(pageSectionObj) : 0;

					if(!this.$primaryContentInnerBlocks || !this.$primaryContentInnerBlocks.length){
						this._updateCachedElements();
					}

					if(this.$progressIndicators && this.$primaryContentInnerBlocks && this.$primaryContentInnerBlocks.length){

						for(let i=0; i<this.$progressIndicators.length; i++){

							let scrollProgress = 0;
							let lineHeight = this.$progressLines.eq(0).outerHeight();

							if(i < sectionIndex){ scrollProgress = 1; }
							else if(i > sectionIndex){ scrollProgress = 0; }
							else {

								let $primaryBlock = this.$primaryContentInnerBlocks.eq(0);
								let blockScrollTop = $primaryBlock.offset().top;
								let blockHeight = $primaryBlock.outerHeight();

								scrollProgress = (this.scrollTop - blockScrollTop)/blockHeight;
							}

							this.$progressHandles.eq(i).css('height', Math.min(lineHeight, Math.max(0, scrollProgress) * lineHeight));
						}
					}
				}
			}
			else {

				this._setActiveNavItem();

				if(this.$progressIndicators && this.$primaryContentInnerBlocks && this.$primaryContentInnerBlocks.length){

					let scrollProgressStart = this.$contentController.offset().top;
					let maxProgress = this.$contentController.outerHeight() - scrollProgressStart;
					let numBlocks = Math.min(this.$progressIndicators.length, this.$primaryContentInnerBlocks.length);

					for(let i=0; i<numBlocks; i++){

						let $primaryBlock = this.$primaryContentInnerBlocks.eq(i);
						let blockHeight = $primaryBlock.outerHeight();
						let blockTop = $primaryBlock.offset().top;
						let blockBottom = blockTop + blockHeight;
						let lineHeight = this.$progressLines.eq(i).outerHeight();
						let scrollProgress = (this.scrollTop + winHeight - blockTop)/(blockHeight + winHeight);

						this.$progressHandles.eq(i).css('height', Math.min(lineHeight, Math.max(0, scrollProgress) * lineHeight));
					}
				}
			}
		}

		if(!this.isHover && !this.isInteractionLocked){
			this._hideLabels(0);
		}

		this._checkMousePos();
	}

	_onMobileToggleClick(e){

		if(e){ e.preventDefault(); }

		if(this.isHover){
			this._hitAreaOut();
			$('#main').off('click', $.proxy(this._onClickOut, this));
		}
		else {
			this._hitAreaOver();
			window.SETTINGS.animationFrame.one(() => {
				$('#main').on('click', $.proxy(this._onClickOut, this));
			});
		}
	}

	_onClick(e){

		if(!this.isHover && !this.isMobile){

			e.preventDefault();
			this._hitAreaOver();

			window.SETTINGS.animationFrame.one(() => {
				$('#main').on('click', $.proxy(this._onClickOut, this));
			});
		}
	}

	_onClickOut(e){

		let $target = $(e.target);

		if(!this.$el[0].contains($target[0])){

			e.preventDefault();
			this._hitAreaOut();

			$('#main').off('click', $.proxy(this._onClickOut, this));
		}
	}

	_onMouseMove(e, params){

		this.mouseCoords = {
			pageX: params.pageX,
			pageY: params.pageY,
			clientX: params.clientX,
			clientY: params.clientY
		}

		this._checkMousePos();
	}

	_onSiteLoadComplete(){
		this.isSiteLoaded = true;
		this._onPageChangeStart(null, {id: window.SETTINGS.router.getRouteObj.pageId});
		this._onScroll();
	}

	_onLinkChangeRoute(){
		this.isScrollSwap = false;
	}

	_onHeroChangeRoute(){
		this.isScrollSwap = true;
	}

	_onHeroChangeRouteComplete(){

	}

	_onPageChangeStart(e, params){
		this.isPageChanging = true;
		this._setPageStatus(params.id);
		this._sectionHide();
		this._resize();
	}

	_onPageChangeComplete(){

		let routeObj = window.SETTINGS.router.getRouteObj();

		this.isPageChanging = false;
		this._setPageStatus(routeObj.pageId);

		let isNewPage = (routeObj.pageId !== this.pageId);

		if(isNewPage){
			this.pageId = routeObj.pageId;
			this.sectionId = routeObj.sectionId;
		}

		if(!this.isBadPage){

			if(isNewPage){
				this._rebuild();
				this._sectionShow();
			}
			else {
				this._updateCachedElements();
				this._forceSectionShow();
			}
		}

		window.SETTINGS.animationFrame.one(() => {
			this._checkScrollVisibility();
			this._resize();
		});
	}

	_setPageStatus(pageId){

		this.isBadPage = false;
		this.isPartitionedPage = false;

		switch(pageId){

			case 'intro':
			case 'vision':
			this.isBadPage = true;
			break;

			case 'action':
			this.isPartitionedPage = true;
			break;
		}
	}

	_onShowScrollNav(){ }
	_onHideScrollNav(){ }
	_onExpandScrollNav(){ }
	_onCollapseScrollNav(){	}

	// template listeners (rebuilt every time nav is rebuilt)

	_addTemplateListeners(){

		let $buttons = this.$el.find('.nav-item a');
		$buttons.off('click');
		$buttons.on('click', this._onButtonClick.bind(this));
	}

	_onButtonClick(e){

		let $target = $(e.currentTarget);
		let $navItem = $target.closest('.nav-item');
		let $heroes = $('.hero');

		if(this.isPartitionedPage){

			let $closestHero = this._getClosestHero();
			let closestDistance = Math.abs(this.scrollTop + window.SETTINGS.coords.winHeight/2 - $closestHero.offset().top);

			if(closestDistance < window.SETTINGS.coords.winHeight/2){

				window.vent.trigger('scrollTo', {scrollTop: $closestHero.offset().top});

				this._killPageChangeDelay();
				this.pageChangeDelay = window.setTimeout(() => {
					window.vent.trigger('changeRoute', {route: '/' + this.pageId + '/' + $navItem.attr('data-anchor-id')});
				}, 750);
			}
			else {
				window.vent.trigger('changeRoute', {route: '/' + this.pageId + '/' + $navItem.attr('data-anchor-id')});
			}
		}
		else {

			let $selectedHero = $heroes.siblings(`[data-content-id="${$navItem.attr('data-anchor-id')}"]`);
			let pageSections = window.SETTINGS.pageSections[this.pageId];
			let heroOffset = $selectedHero.offset();

			this.isInteractionLocked = true;
			window.vent.trigger('changeRoute', {route: '/' + this.pageId + '/' + $navItem.attr('data-anchor-id')});
			window.vent.trigger('scrollTo', {scrollTop: heroOffset.top});
		}

		this._close();
	}

	_killPageChangeDelay(){
		if(this.pageChangeDelay){
			window.clearTimeout(this.pageChangeDelay);
			this.pageChangeDelay = null;
		}
	}

	// show / hide nav labels

	_showLabels(){

		if(!this.isLabelVisible || this.isLabelTransOut){

			let $navItems = this.$el.find('.nav-item');
			let routeObj = window.SETTINGS.router.getRouteObj();
			let pageSections = window.SETTINGS.pageSections[this.pageId];
			let sectionId = routeObj.sectionId || (pageSections.sections ? pageSections.sections[0].id : '');

			this._setActiveNavItem();

			if(this.labelDelay){
				window.clearTimeout(this.labelDelay);
				this.labelDelay = null;
			}

			if(this.isLabelTransOut){

				$navItems.each((index, value) => {

					let $navItem = $(value);
					let $title = $navItem.find('.title');
					let $dash = $navItem.find('.dash');

					TweenMax.killTweensOf([$navItem, $title, $dash]);
					TweenMax.to($dash, 0.3, {opacity:1, ease:'fade'});
					TweenMax.to($title, 0.3, {opacity:1, ease:'fade'});
				});
			}
			else {

				let stagger = 0.06;
				let initialDelay = 0.12;

				$navItems.each((index, value) => {

					let $navItem = $(value);
					let $title = $navItem.find('.title');
					let $dash = $navItem.find('.dash');

					TweenMax.killTweensOf([$navItem, $title, $dash]);
					TweenMax.fromTo($dash, 0.3, {scaleX:0, opacity:0, transformOrigin:'100% 50%'}, {scaleX:1, opacity:1, delay:stagger * index + initialDelay, ease:'fade'});
					TweenMax.fromTo($title, 0.3, {opacity:0, x:5}, {opacity:1, x:0, delay:stagger * index + 0.04 + initialDelay, ease:'fade'});
				});
			}

			this.$el.addClass('is-buttons-visible');

			this.isLabelVisible = true;
			this.isLabelTransOut = false;
		}
	}

	_hideLabels(delay){

		if(typeof(delay) === 'undefined'){ delay = 0; }

		if(!this.labelDelay || this.labelDelayTime >= delay){

			if(this.isLabelVisible){

				if(this.labelDelay){ window.clearTimeout(this.labelDelay); }

				this.labelDelayTime = delay;
				this.isLabelTransOut = true;

				this.labelDelay = window.setTimeout(() => {

					this.isLabelVisible = false;
					this.isLabelTransOut = false;

					let $navItems = this.$el.find('.nav-item');

					$navItems.each((index, value) => {

						let $navItem = $(value);
						let $title = $navItem.find('.title');
						let $dash = $navItem.find('.dash');

						TweenMax.killTweensOf([$navItem, $title, $dash]);
						TweenMax.to($dash, 0.3, {opacity:0, ease:'fade'});
						TweenMax.to($title, 0.3, {opacity:0, ease:'fade'});
					});

					this.labelDelay = null;
					this._updateHitArea();

					this.$el.removeClass('is-buttons-visible');

				}, delay * 1000);
			}
		}
	}

	// rebuild

	_rebuild(){

		if(!this.isTrans){

			this.isPendingRebuild = false;

			this._rebuildOut().then(() => {
				this._rebuildTemplate();
				this._addTemplateListeners();
				this._rebuildIn();
			});

		}
		else {
			this.isPendingRebuild = true;
		}
	}

	_checkPendingRebuild(){
		if(this.isPendingRebuild && !this.isTrans){
			this._rebuild();
		}
	}

	_updateCachedElements(){

		this.$primaryContentInnerBlocks = $('.primary-content:not(.old) .primary-content-inner');
		this.$progressIndicators = this.$navContent.find('.vert-progress');
		this.$progressHandles = this.$navContent.find('.vert-progress .progress-indicator');
		this.$progressLines = this.$navContent.find('.vert-progress .vert-line');
		this.$navItems = this.$el.find('.nav-item');
		this.$hitArea = this.$el.find('.hit-area');
		this.$heroes = $('.hero');

		this.isTouch = $('html').hasClass('supports-touchevents');
	}

	_updateHitArea(){

		let bounds = window.utils.PositioningUtils.getScrollOffset(this.$navContent);
		let maxWidth = 60; // initial hit area

		if(this.isHover || this.isLabelVisible){

			// expanded hit area

			this.$el.find('.nav-item a').each((index, value) => {

				let $navItem = $(value);
				let navItemWidth = $navItem.outerWidth();

				if(navItemWidth > maxWidth){
					maxWidth = navItemWidth;
				}
			});
		}

		this.hitAreaBounds = {
			top: bounds.top,
			bottom: bounds.bottom,
			left: bounds.right - maxWidth,
			right: bounds.right,
			width: maxWidth,
			height: bounds.height
		}

		this._checkMousePos();
	}

	_checkMousePos(){

		if(this.hitAreaBounds && this.mouseCoords && !this.isMobile){
			if(this.mouseCoords.clientX >= this.hitAreaBounds.left &&
				this.mouseCoords.clientX <= this.hitAreaBounds.right &&
				this.mouseCoords.clientY >= this.hitAreaBounds.top &&
				this.mouseCoords.clientY <= this.hitAreaBounds.bottom){

				if(!this.isHover){
					this._hitAreaOver();
					this.isInteractionLocked = false;
					// console.log('interaction locked false');
				}
			}
			else {
				if(this.isHover && !this.isInteractionLocked){
					this._hitAreaOut();
				}
			}
		}
	}

	_hitAreaOver(force){

		force = typeof(force) === 'undefined' ? false : (force === true);

		if((!this.isHover || force) && $('body').hasClass('page-loaded')){
			this.isHover = true;
			this.$el.addClass('is-hover');
			this._showLabels();
			this._updateHitArea();
			$('body').on('click', $.proxy(this._onOut, this));
		}
	}

	_hitAreaOut(delay, force){

		delay = typeof(delay) === 'undefined' ? 0.2 : delay;
		force = typeof(force) === 'undefined' ? false : (force === true);

		if(this.isHover || force){
			this.isHover = false;
			this.$el.removeClass('is-hover');
			this._hideLabels(delay);
			this._updateHitArea();
			$('body').off('click', $.proxy(this._onOut, this));
		}
	}

	_onOut(e){
		this._checkMousePos();
	}

	_setActiveNavItem(){

		if(this.pageId){

			let $closestHero;
			let heroIndex = 0;
			let routeObj = window.SETTINGS.router.getRouteObj();
			let pageSections = window.SETTINGS.pageSections[this.pageId];
			let sectionId = routeObj.sectionId || (pageSections.sections ? pageSections.sections[0].id : '');
			let heroLeeway = 20;

			if(this.$heroes && this.$navItems){

				if(this.isPartitionedPage){
				}
				else {

					for(let i=0; i<this.$heroes.length; i++){
						if(this.scrollTop >= this.$heroes.eq(i).offset().top - heroLeeway){
							heroIndex = i;
							$closestHero = this.$heroes.eq(i);
							sectionId = $closestHero.attr('data-content-id');
						}
						else {
							break;
						}
					}
				}

				if(this.sectionId !== sectionId || !this.$selectedNavItem || !this.$selectedNavItem.length || this.$selectedNavItem.attr('data-anchor-id') !== sectionId){

					this.$selectedNavItem = this.$navItems.siblings(`[data-anchor-id="${sectionId}"]`);

					this.$navItems.removeClass('is-active');
					this.$selectedNavItem.closest('.nav-item').addClass('is-active');
					this.sectionId = sectionId;

					if(!this.isPageChanging){

						let newRoute = '/' + this.pageId + '/';
						if(this.sectionId){ newRoute += this.sectionId + '/'; }

						window.vent.trigger('silentRoute', {route: newRoute});
					}
				}
			}
		}
	}

	_close(){
		this._hitAreaOut(0, true);
	}

	_rebuildTemplate(){

		let navItems = [];
		let pageSections = window.SETTINGS.pageSections[this.pageId];

		if(pageSections.sections){

			for(let i=0; i<pageSections.sections.length; i++){
				navItems.push({
					title: pageSections.sections[i].title,
					anchorId: pageSections.sections[i].id
				});
			}
		}

		this.$navContent.html(this.navTemplate({
			navItems: navItems
		}));

		this._updateCachedElements();
		this._updateHitArea();
	}

	_rebuildOut(){

		return new Promise((resolve, reject) => {

			// status method

			let checkStatus = () => {
				this.isTrans = false;
				this.$navContent.empty();
				this._checkPendingRebuild();
				resolve();
			}

			//

			if(!this.isTrans){

				this.isTrans = true;
				this.isTransOut = true;

				if(this.isTransOut || !this.isSectionShowing){ checkStatus(); }
				else {

					TweenMax.to(this.$navContent, 0.3, {opacity:0, ease:'fade', onComplete:() => {
						checkStatus();
					}});
				}
			}
		});
	}

	_rebuildIn(){

		return new Promise((resolve, reject) => {

			// status method

			let checkStatus = () => {
				this.isTrans = false;
				this._checkPendingRebuild();
				resolve();
			}

			//

			if(!this.isTrans){

				this.isTrans = true;
				this.isTransOut = false;

				TweenMax.fromTo(this.$navContent, 0.6, {opacity:0}, {opacity:1, ease:'fade', onComplete:() => {
					this._forceSectionShow();
					checkStatus();
				}});
			}
		});
	}

	// show / hide between sections

	_sectionShow(){

		this.isSectionShowing = true;

		this._onScroll();
		this._checkScrollVisibility();
	}

	_forceSectionShow(){

		this._sectionShow();

		if(window.SETTINGS.breakpoint.minWidth(1270)){
			this.isInteractionLocked = true;
			this._hitAreaOver(true);
		}
	}

	_sectionHide(){

		this.isSectionShowing = false;

		this._onScroll();
		this._checkScrollVisibility();
	}

	// show / hide

	_show(){
		this._sectionShow();
	}

	_hide(){
		this._sectionHide();
	}

	_checkScrollVisibility(){

		// console.log('_checkScrollVisibility', this.isSectionShowing, this.isScrollVisible, !this.isBadPage);

		if(this.isSectionShowing && !this.isBadPage){
			this.$el.addClass('is-showing');
		}
		else {
			this.$el.removeClass('is-showing');
			this._hitAreaOut(0, true);
		}
	}

	_updateHeroes(){

		let $heroes = $('.hero:not(.is-hidden)');
		let topOffset;

		// find top hero

		$heroes.each((index, value) => {

			let $hero = $(value);
			let offset = $hero.offset();

			if(isNaN(topOffset) || (offset.top < topOffset && offset.top >= 0)){
				topOffset = offset.top;
				this.$topHero = $hero;
			}
		});

		this.topHeroBounds = window.utils.PositioningUtils.getScrollOffset(this.$topHero);

		// bottom hero

		let $footerHeroes = $('.hero.footer-hero');
		let bottomOffset;

		$footerHeroes.each((index, value) => {

			let $hero = $(value);
			let offset = $hero.offset();

			if(isNaN(bottomOffset) || (offset.top > bottomOffset && offset.top >= 0)){
				bottomOffset = offset.top;
				this.$footerHero = $hero;
			}
		});

		if(this.$footerHero && this.$footerHero.length){
			this.footerHeroBounds = window.utils.PositioningUtils.getScrollOffset(this.$footerHero);
		}
		else {
			this.footerHeroBounds = {
				top: window.SETTINGS.coords.getDocHeight() - window.SETTINGS.coords.winHeight,
				left: 0,
				right: window.SETTINGS.coords.docWidth,
				bottom: window.SETTINGS.coords.getDocHeight(),
				width: window.SETTINGS.coords.docWidth,
				height: window.SETTINGS.coords.winHeight
			}
		}

	}

	//

	_getClosestHero(){

		let $heroes = $('.hero');
		let $closestHero;
		let closestDistance = -1;

		$heroes.each((index, value) => {

			let $hero = $(value);
			let heroOffset = window.utils.PositioningUtils.getExtendedOffset($hero);

			let topDist = Math.abs(this.scrollTop + window.SETTINGS.coords.winHeight/2 - heroOffset.top);
			let bottomDist = Math.abs(this.scrollTop + window.SETTINGS.coords.winHeight/2 - heroOffset.bottom);

			if(closestDistance < 0 || topDist < closestDistance){
				$closestHero = $hero;
				closestDistance = topDist;
			}
			else if(bottomDist < closestDistance){
				$closestHero = $hero;
				closestDistance = topDist;
			}
		});

		return $closestHero;
	}

	//

	_enable(){ }
	_disable(){ }

	_domUpdate(){
		this._updateHeroes();
	}

	_resize(){

		let docWidth = window.SETTINGS.coords.docWidth;
		let containerWidth = window.SETTINGS.coords.containerWidth;

		if(window.SETTINGS.breakpoint.maxWidth('screen-medium')){ // && this.isTouch){
			this.isMobile = true;
		}
		else {
			this.isMobile = false;
		}

		// console.log(docWidth, containerWidth);

		if(docWidth > containerWidth){
			TweenMax.set(this.$el, {x: 0 - Math.round((docWidth - containerWidth)/2)});
		}
		else {
			TweenMax.set(this.$el, {clearProps: 'x'});
		}

		this._updateHeroes();
		this._updateHitArea();
		this._onScroll();
	}
}

module.exports = ScrollNav;

},{"../../90_utils/base/BaseModule":131}],56:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class AnimationController extends BaseModule {

	constructor(el, params) {

		super(el);

		CustomEase.create('fade', 'M0,0 C0.384,0.104 0.242,0.942 1,1');
		CustomEase.create("fadeOut", "M0,0 C0.242,0.132 0.65,0.66 1,1")
		CustomEase.create('longFade', 'M0,0 C0.488,0.128 0.242,0.942 1,1');
		CustomEase.create("progressSlide", "M0,0 C0.074,0.138 0.048,0.682 0.238,0.83 0.428,0.978 0.816,0.995 1,1");
		CustomEase.create("sectionFade", "M0,0 C0.149,0 0.279,0.253 0.436,0.518 0.54,0.694 0.698,1 1,1");
		CustomEase.create("scrollEase", "M0,0 C0.124,0.036 0.192,0.094 0.242,0.188 0.292,0.283 0.423,0.772 0.486,0.866 0.561,0.977 0.704,1 1,1");
	}

	//

	_domReady(){ }

	_addListeners(){ }
	_removeListeners(){ }

	// show / hide

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){ }
}

module.exports = AnimationController;

},{"../../90_utils/base/BaseModule":131}],57:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');
const Loader = require('../../90_utils/Loader');

class ContentController extends BaseModule {

	constructor(el, params) {

		super(el);

		this.data = params.data;

		// element vars

		this.pageId;
		this.sectionId;

		this.$contentWrapper = this.$el.find('#primary-content-wrapper');
		this.$currentContent = this.$contentWrapper.find('.primary-content');
		this.$oldContent;

		this.pageLoader;
		this.isLoading = false;
		this.isFirstPage = true;
		this.isPendingAppend = false;
	}

	// basemodule methods

	_domReady(){ }

	_addListeners(){ }

	_removeListeners(){ }

	//

	_onHeroIntroComplete(e, params){ }

	// content changing

	transOutContent(){

		return new Promise((resolve, reject) => {

			if(this.$currentContent && this.$currentContent.length){

				this.$currentContent.find('[data-js-module]').each((index, value) => {
					$(value).triggerHandler('disable');
					resolve();
				});

				if(window.SETTINGS.breakpoint.maxWidth('screen-medium')){
					this.$currentContent.remove();
					this.$currentContent = null;
					window.SETTINGS.animationFrame.one(() => {
						resolve();
					});
				}
			}

		});
	}

	transInContent(){

		return new Promise((resolve, reject) => {

			if(this.$currentContent && this.$currentContent.length){

				// window.vent.on('heroIntroComplete', this._onHeroIntroComplete, this);

				if(this.$oldContent && this.$oldContent.length){

					TweenMax.killTweensOf(this.$oldContent);

					if(this.$el.hasClass('is-scroll-swap')){

						if(window.SETTINGS.breakpoint.minWidth('screen-medium')){

							window.SETTINGS.animationFrame.one(() => {
								this.$oldContent.remove();
								this.$oldContent = null;
								resolve();
							});
						}
						else {

							window.SETTINGS.animationFrame.one(() => {
								this.$oldContent.remove();
								this.$oldContent = null;
								resolve();
							});
						}
					}
					else {

						if(window.SETTINGS.breakpoint.minWidth('screen-medium')){

							this.$oldContent.remove();
							this.$oldContent = null;
							window.SETTINGS.animationFrame.one(() => {
								resolve();
							});

						} else {

							this.$oldContent.remove();
							this.$oldContent = null;
							window.SETTINGS.animationFrame.one(() => {
								resolve();
							});
						}
					}
				}
				else {
					console.log('transInContent - SWAP REJECT - No Old Content');
					resolve();
				}
			}
			else {
				console.log('transInContent - SWAP REJECT - No Current Content');
				resolve();
			}
		});
	}

	swapContentByIndex(index){
		this.swapContentById(this.templates[index].id);
	}

	swapContentById(pageId, sectionId, isScrollSwap){

		console.log('swapContentById', pageId, sectionId, isScrollSwap);

		return new Promise((resolve, reject) => {

			if(pageId !== this.pageId || sectionId !== this.sectionId || this.isFirstPage){

				if(this.isFirstPage){
					this.$currentContent = this.$el.find('.primary-content');
					this.pageId = pageId;
					this.sectionId = sectionId;
					this.isFirstPage = false;
					resolve();
				}
				else {

					let $newContent;
					let pageObj = _.findWhere(window.SETTINGS.templates.content, {id: pageId});

					if(sectionId && sectionId.length){
						let sectionData = _.findWhere(pageObj.sections, {id: sectionId}).template;
						$newContent = $(sectionData);
					}
					else {
						$newContent = $(pageObj.template);
					}

					this.$oldContent = this.$currentContent;
					this.$currentContent = $newContent.hasClass('primary-content') ? $newContent : $(`<div class="primary-content ${pageId}-content ${pageId}-content-${sectionId}"></div>`).append($newContent);
					this.pageId = pageId;
					this.sectionId = sectionId;
					this.isPendingAppend = true;

					let onPageContentLoaded = () => {

						this._appendCurrentContent();
						window.vent.off('pageContentLoaded', onPageContentLoaded, this);

						let resolveDelay = window.SETTINGS.breakpoint.minWidth('screen-medium') ? 2000 : 1000;

						window.setTimeout(() => {
							console.log("content load resolve");
							window.vent.trigger('pageLoadComplete');
							resolve();
						}, resolveDelay);
					}

					window.vent.on('pageContentLoaded', onPageContentLoaded, this);
					this._loadPageContent(this.$currentContent);
				}
			}
			else {
				console.log('SWAP REJECT - Invalid Page Id');
				resolve();
			}
		});
	}

	_appendCurrentContent(){

		if(this.isPendingAppend){

			console.log('_appendCurrentContent');

			this.isPendingAppend = false;

			if(this.$oldContent && this.$oldContent.length){
				this.$oldContent.addClass('old');
			}

			this.$contentWrapper.append(this.$currentContent);

			window.vent.trigger('domUpdate');
		}
	}

	// load page content

	_loadPageContent($content){

		console.log('_loadPageContent', $content);

		let onLoadItemComplete = (e) => {
			window.vent.trigger('pageLoadUpdate', {progress: e.progress});
		}

		let onLoadComplete = (e) => {
			this.isLoading = false;
			window.vent.trigger('pageContentLoaded');
		}

		if(!this.isLoading){

			this.isLoading = true;

			// lock scrolling

			console.log('_loadPageContent - trigger pageLoadStart');
			window.vent.trigger('pageLoadStart');

			// extract urls
			let urls = [];

			if(window.SETTINGS.breakpoint.minWidth('screen-medium') && !window.utils.BrowserUtils.isIE()){

				let $imgs = $content.find('img');
				let $bgImages = $content.find('figure.bg-abs');

				$imgs.each((index, value) => {

					let $img = $(value);
					let url = $img.attr('src');

					if(url && (url.indexOf('.png') >= 0 || url.indexOf('.jpg') >= 0)){
						url = window.utils.BrowserUtils.qualifyURL(url); // convert relative urls to absolute
						if(!_.findWhere(urls, {url:url})){
							urls.push({
								url: url,
								callback:onLoadItemComplete
							});
						}
					}
				});

				$bgImages.each((index, value) => {

					let $figure = $(value);
					let url = $figure.css('background-image');

					if(url && (url.indexOf('.png') >= 0 || url.indexOf('.jpg') >= 0)){
						url = url.slice(4, -1).replace(/["|']/g, ""); // remove url('') wrapper
						url = window.utils.BrowserUtils.qualifyURL(url); // convert relative urls to absolute
						if(!_.findWhere(urls, {url:url})){
							urls.push({
								url: url,
								callback:onLoadItemComplete
							});
						}
					}
				});
			}

			if(this.pageLoader){
				this.pageLoader.emptyQueue();
			}
			else {
				this.pageLoader = new Loader({
					autoStart: false,
					onCompleteCallback: onLoadComplete
				});
			}

			console.log('_loadPageContent - urls', urls);

			if(urls.length){
				this.pageLoader.addToQueue(urls);
				this.pageLoader.start();
			}
			else {
				window.SETTINGS.animationFrame.one(() => {
					onLoadComplete();
				});
			}
		}
	}

	// show / hide

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){ }
}

module.exports = ContentController;

},{"../../90_utils/Loader":126,"../../90_utils/base/BaseModule":131}],58:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class HeroController extends BaseModule {

	constructor(el, params) {

		super(el);

		this.data = params.data;

		// element vars

		this.pageId;
		this.sectionId;

		this.$currentHero = this.$el.find('.hero');
		this.$footerHero;

		this.isFirstPage = true;
	}

	// basemodule methods

	_domReady(){ }

	_addListeners(){ }
	_removeListeners(){ }

	// content changing

	transOutContent(pageId, sectionId, isScrollSwap){

		return new Promise((resolve, reject) => {

			if(this.$currentHero && this.$currentHero.length){

				this.$currentHero.triggerHandler('disable');
				this.$currentHero.find('[data-js-module]').each((index, value) => {
					$(value).triggerHandler('disable');
				});

				TweenMax.killTweensOf(this.$currentHero);

				console.log('transOutContent', pageId, sectionId, isScrollSwap, this.$footerHero);

				if(isScrollSwap && this.$footerHero && this.$footerHero.length){
					this.$footerHero.find('.inner-wrapper').addClass('is-fixed');
				}

				resolve();
			}
		});
	}

	transInContent(pageId, sectionId, isScrollSwap){

		return new Promise((resolve, reject) => {

			if(this.$currentHero && this.$currentHero.length){

				this.$currentHero.find('.inner-wrapper').removeClass('is-fixed');
				this.$currentHero.triggerHandler('show');

				TweenMax.killTweensOf(this.$currentHero);
				resolve();
			}
		});
	}

	swapContentById(pageId, sectionId, isScrollSwap){

		// console.log('hero swapContentById', pageId, sectionId);

		return new Promise((resolve, reject) => {

			let addFooter = (id) => {

				let footerObj = this.getNextFooterById(id);

				console.log(`addFooter '${id}' '${footerObj}'`);

				if(footerObj){

					if(this.$footerHero && this.$footerHero.length){
						this.$footerHero.triggerHandler('disable');
						this.$footerHero.remove();
						this.$footerHero = null;
					}

					this.$footerHero = $(footerObj.template);
					this.$footerHero.addClass('footer-hero');
					this.$el.append(this.$footerHero);

					window.vent.trigger('domUpdate');
				}
			}

			if(pageId !== this.pageId || sectionId !== this.sectionId || this.isFirstPage){

				let $oldHero;
				let $oldFooter;
				let resolveDelay = window.SETTINGS.breakpoint.minWidth('screen-medium') ? 200 : 200;

				if(this.isFirstPage){

					console.log("first page");

					this.isFirstPage = false;
					this.pageId = pageId;
					this.sectionId = sectionId;

					this.$currentHero = this.$el.find('.hero');
					resolve();
				}
				else {

					console.log("not first page");

					this.pageId = pageId;
					this.sectionId = sectionId;

					if(isScrollSwap){

						$oldHero = this.$currentHero;
						$oldHero.addClass('old');
						$oldHero.triggerHandler('disable');

						this.$currentHero = this.$footerHero;
						this.$footerHero = null;

						this.$currentHero.removeClass('footer-hero');

						this.$currentHero.triggerHandler('updateStatus'); // you're no longer a footer, son.
						this.$currentHero.triggerHandler('completeIntro'); // second half of intro

						console.log('complete footer', this.$currentHero);
					}
					else {

						$oldHero = this.$currentHero;
						$oldHero.addClass('old');
						$oldHero.triggerHandler('disable');

						if(this.$footerHero && this.$footerHero.length){
							$oldFooter = this.$footerHero;
							$oldFooter.addClass('old');
							$oldFooter.triggerHandler('disable');
						}

						this.$currentHero = $(this.getHeroById(this.sectionId || this.pageId).template);
						this.$footerHero = null;

						// console.log('!!! get hero', this.getHeroById(this.sectionId || this.pageId));

						this.$el.append(this.$currentHero);

						if(window.SETTINGS.breakpoint.minWidth('screen-medium')){

							this.$currentHero.css('opacity', 0);

							if($(window).scrollTop() > $oldHero.outerHeight()){
								$oldHero.css('opacity', 0);
							}

							window.setTimeout(() => {
								window.vent.trigger('domUpdate');
							}, 0);

							TweenMax.fromTo(this.$currentHero, 0.4, {opacity:0}, {opacity:1, ease:'longFade'});
							resolveDelay = 400;
						}
					}
				}

				window.setTimeout(() => {

					// console.log("hero resolve");

					if($oldHero && $oldHero.length){
						$oldHero.remove();
					}

					if($oldFooter && $oldFooter.length){
						$oldFooter.remove();
					}

					addFooter(this.sectionId || this.pageId);
					resolve();

				}, resolveDelay);
			}
			else {
				resolve();
			}
		});
	}

	swapContentByIndex(index){
		this.swapContentById(window.SETTINGS.templates.heroes[index].id);
	}

	//

	getHeroById(id){

		let recursiveSearch = (container, id) => {
			// console.log('getHeroById', id, container);
			for(let i=0; i<container.length; i++){
				let child = container[i];
				if(child.id === id){
					return child;
				}
				if(child.sections){
					let returnObj = recursiveSearch(child.sections, id);
					if(returnObj){ return returnObj; }
				}
			}
		}

		let result = recursiveSearch(window.SETTINGS.templates.heroes, id);
		return (result === true) ? null : result;
	}

	getNextFooterById(id){

		let checkForChildren = (footerContainer) => {
			if(footerContainer.sections){
				return footerContainer.sections[0];
			}
			return footerContainer;
		}

		let recursiveSearch = (container, id) => {

			for(let i=0; i<container.length; i++){

				let child = container[i];

				if(child.id === id){
					if(child.sections){
						return child.sections[1];
					}
					else if(i + 1 < container.length){
						return checkForChildren(container[i + 1]);
					}
					else {
						return true;
					}
				}

				if(child.sections){

					let nextFooter = recursiveSearch(child.sections, id);

					if(nextFooter === true){
						if(i + 1 < container.length){
							return checkForChildren(container[i + 1]);
						}
						else {
							return true;
						}
					}
					else if(nextFooter){
						return checkForChildren(nextFooter);
					}
				}
			}

			return '';
		}

		let result = recursiveSearch(window.SETTINGS.templates.heroes, id);
		return (result === true) ? null : result;
	}

	// show / hide

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){ }
}

module.exports = HeroController;

},{"../../90_utils/base/BaseModule":131}],59:[function(require,module,exports){
arguments[4][11][0].apply(exports,arguments)
},{"dup":11}],60:[function(require,module,exports){
const AnimationController = require('../animation-controller/script.js');
const ContentController = require('../page-content-controller/script.js');
const HeroController = require('../page-hero-controller/script.js');

const BaseModule = require('../../90_utils/base/BaseModule');
const Loader = require('../../90_utils/Loader');

class SiteController extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$controls = this.$el.find('.controls');
		this.$prevArrow = this.$controls.find('.prev');
		this.$nextArrow = this.$controls.find('.next');
		this.$progressBar = this.$el.find('.progress-bar');
		this.$progressBarInner = this.$el.find('.progress-bar .bar-progress');

		this.$currentContent = this.$el.find('.content');
		this.$currentHero = this.$el.find('.hero');

		// tallies

		this.pageIndex = -1;
		this.pageId;
		this.sectionId;

		// flags

		this.isTrans = false;
		this.isFirstPage = true;
		this.isScrollSwap = false;
		this.isInitialized = false;

		// settings

		this.minLoadTime = 1000;
		this.loadTimeStart;
		this.loadTimeout;

		// configuration

		this.data = {

			pages : [

			  {
			  	id : 'intro',
			    title : 'Intro',
			    content : {
			      isHidden : true
			    }

			  },

			  {
			  	id : 'vision',
			    title : 'Vision',
			    content : {

			    }
			  },

			 {
			 	id : 'action',
			    title : 'Action',
			    content : {

			    }
			  },

			  {
			  	id : 'impact',
			    title : 'Impact',
			    content : {

			    }
			  }
			]
		};

		// controllers

		this.$contentController = $('#page-content-controller');
		this.$heroController = $('#page-hero-controller');

		this.animationController = new AnimationController(this.$el, {data: this.data});
		this.contentController = new ContentController(this.$contentController, {data: this.data});
		this.heroController = new HeroController(this.$heroController, {data: this.data});
	}

	// init

	init(){
		if(!this.isInitialized){
			this._loadSiteTemplates();
			this.isInitialized = true;
		}
	}

	// private methods

	_domReady(){
		this.init();
	}

	_addListeners(){

		this.$controls.find('.next').on('click', this._onNextClick.bind(this));
		this.$controls.find('.prev').on('click', this._onPrevClick.bind(this));

		window.vent.on('silentRoute', this._onSilentRoute, this);
		window.vent.on('heroChangeRoute', this._onHeroChangeRoute, this);
		window.vent.on('linkChangeRoute', this._onLinkChangeRoute, this);
		window.vent.on('changePageContent', this._onChangePageContent, this);
		window.vent.on('pageChangeStart', this._onPageChangeStart, this);
		window.vent.on('pageChangeComplete', this._onPageChangeComplete, this);
		window.vent.on('pagePopulate', this._onPagePopulate, this);
		window.vent.on('pagePopulateComplete', this._onPagePopulateComplete, this);
		window.vent.on('pageTransitionOutComplete', this._onPageTransitionOutComplete, this);
		window.vent.on('pageTransitionInComplete', this._onPageTransitionInComplete, this);

		window.vent.on('pageLoadStart', this._onPageLoadStart, this);
		window.vent.on('pageLoadUpdate', this._onPageLoadUpdate, this);
		window.vent.on('pageLoadComplete', this._onPageLoadComplete, this);
	}

	_removeListeners(){

	}

	// element event listeners

	_onNextClick(){
		let newIndex = Math.max(Math.min(this.getPageIndex() + 1, this.data.pages.length-1), 0);
		window.vent.trigger('changeRoute', {route:this.data.pages[newIndex].id});
	}

	_onPrevClick(){
		let newIndex = Math.max(Math.min(this.getPageIndex() - 1, this.data.pages.length-1), 0);
		window.vent.trigger('changeRoute', {route:this.data.pages[newIndex].id});
	}

	_onSilentRoute(e, params){

		let route = params.route;

		if(route && $('.modaal-wrapper').length){

			let routeObj = route.split('/');
			let pageId = routeObj[0];
			let sectionId = routeObj[1] || '';

			window.vent.trigger('closeModal');

			this._scrollToSection(sectionId);
		}
	}

	_onHeroChangeRoute(e, params){

		this.isScrollSwap = true;

		this.$contentController.addClass('is-scroll-swap');
		this.$heroController.addClass('is-scroll-swap');

		// window.RENGINE.reset();

		$(window).off('mousewheel', $.proxy(this._killMouseWheel, this));
		$(window).on('mousewheel', $.proxy(this._killMouseWheel, this));
	}

	_onLinkChangeRoute(e, params){

		this.isScrollSwap = false;

		this.$contentController.removeClass('is-scroll-swap');
		this.$heroController.removeClass('is-scroll-swap');

		// window.RENGINE.reset();

		$(window).off('mousewheel', $.proxy(this._killMouseWheel, this));
		$(window).on('mousewheel', $.proxy(this._killMouseWheel, this));
	}

	_onChangePageContent(e, params){

		if(typeof(params) !== 'undefined' && params.id){
			this._changePageById(params.id, params.sectionId);
		}
	}

	_onPageChangeStart(e, params){

		$('body').removeClass('page-loaded');
		$('body').addClass('page-loading');

		this._progressBarInit();
	}

	_onPagePopulate(e, params){

	}

	_onPagePopulateComplete(e, params){
		window.vent.trigger('windowResize');
	}

	_onPageTransitionInComplete(){

	}

	_onPageTransitionOutComplete(){
		// $('body').removeClass('page-loaded');
		// $('body').addClass('page-loading');
	}

	// initial template loading

	_loadSiteTemplates(){

		let	WS = window.SETTINGS;
		let loader = new Loader();
		let isFirstLoad = true;

		$('body').addClass('site-loading');

		let onLoadComplete = () => {

			if(isFirstLoad){

				isFirstLoad = false;

				this._progressBarComplete().then(() => {

					$('body').removeClass('site-loading');
					$('body').addClass('sk-ready site-loaded');
					window.vent.trigger('siteLoadComplete');

					this._setFirstRoute();
				});
			}
		}

		let loadCallback = (params) => {
			this._progressBarUpdate(params.progress);
			if(params.success && params.loadItem && params.loadItem.obj){
				params.loadItem.obj.template = params.data;
				if(params.loadItem.isModal){
					$('#modal-templates').append(params.data);
				}
			}
		}

		let loadTemplatesByType = (array, folderName, fileName, isModal) => {
			for(let i=0; i<array.length; i++){
				loader.addToQueue({
					id: array[i].id,
					obj: array[i],
					url: '/' + folderName + '/' + array[i].id + '/' + fileName,
					callback: loadCallback,
					pushToFront: true,
					isModal: (isModal === true)
				});
			}
		}

		loader = new Loader({
			autoStart: false,
			onCompleteCallback: onLoadComplete
		});

		loadTemplatesByType(WS.templates.content, 'page-templates', 'index.html');
		loadTemplatesByType(WS.templates.heroes, 'hero-templates', 'index.html');
		loadTemplatesByType(WS.templates.modals, 'modal-templates', 'index.html', true);

		loadTemplatesByType(_.findWhere(WS.templates.content, {id:'action'}).sections, 'page-templates/action', 'index.html');
		loadTemplatesByType(_.findWhere(WS.templates.heroes, {id:'action'}).sections, 'hero-templates/action', 'index.html');

		this._progressBarInit();
		loader.start();
	}

	// progress bar status updates

	_progressBarInit(){

		this.loadTimeStart = (new Date()).getTime();
		this.$progressBar.addClass('is-loading');

		TweenMax.killTweensOf([this.$progressBar, this.$progressBarInner], {y: false});
		TweenMax.set(this.$progressBar, {clearProps: 'opacity'});
		TweenMax.set(this.$progressBarInner, {clearProps: 'all'});
		TweenMax.to(this.$progressBarInner, 0.4, {x:window.SETTINGS.coords.viewportWidth * (-0.9), ease:'fade'});
		TweenMax.to(this.$progressBar, 0.4, {opacity:1, ease:'fade'});
	}

	_progressBarUpdate(progress, animationTime){

		if(typeof(animationTime) === 'undefined'){ animationTime = 3; }

		if(!isNaN(progress)){
			TweenMax.killTweensOf(this.$progressBarInner, {x:true});
			TweenMax.to(this.$progressBarInner, animationTime, {x:window.SETTINGS.coords.viewportWidth * (progress * 0.9 + 0.1 - 1), ease:'progressSlide'});
		}
	}

	_progressBarComplete(minLoadTime){

		if(typeof(minLoadTime) === 'undefined'){ minLoadTime = 0; }

		let endTime = (new Date()).getTime();
		let loadTimeRemaining = Math.max(minLoadTime - (endTime - this.loadTimeStart), 200);

		return new Promise((resolve, reject) => {

			if(this.loadTimeout){
				window.clearTimeout(this.loadTimeout);
			}

			this._progressBarUpdate(1, 0.3);

			this.loadTimeout = window.setTimeout(() => {

				TweenMax.to(this.$progressBar, 0.5, {opacity:0, delay:0.2, ease:'fade', onComplete:() => {
					this.$progressBar.removeClass('is-loading');
				}});

				window.clearTimeout(this.loadTimeout);
				this.loadTimeout = null;

				resolve();

			}, loadTimeRemaining);
		});
	}

	// page loading

	_onPageLoadStart(){
		// this._progressBarInit();
	}

	_onPageLoadUpdate(e, params){
		this._progressBarUpdate(params.progress);
	}

	_onPageLoadComplete(){

		this._progressBarComplete(this.minLoadTime).then(() => {

			let routeObj = window.SETTINGS.router.getRouteObj();
			let pageSections = window.SETTINGS.pageSections[routeObj.pageId];

			if(pageSections.scrollSections) {

				$('body').addClass('page-loaded');
				$('body').removeClass('page-loading');

				this._scrollToSection(routeObj.sectionId);

				window.setTimeout(() => {
					window.vent.trigger('pageChangeComplete', {pageId: this.pageId, sectionId: this.sectionId});
				}, 500);
			}
			else {

				$('body').addClass('page-loaded');
				$('body').removeClass('page-loading');

				window.setTimeout(() => {
					window.vent.trigger('pageChangeComplete', {pageId: this.pageId, sectionId: this.sectionId});
				}, 500);
			}
		});
	}

	// transition methods

	_killMouseWheel(e){
		console.log("_killMouseWheel (mousewheel locked)");
		e.preventDefault();
	}

	_onPageChangeComplete(){

		console.log("_onPageChangeComplete");

		// slide to content area (below hero)

		if(this.isScrollSwap){
			window.vent.trigger('scrollTo', {scrollTop: window.SETTINGS.coords.winHeight});
			window.setTimeout(() => {
				$(window).off('mousewheel', $.proxy(this._killMouseWheel, this));
				window.vent.trigger('heroChangeRouteComplete');
				window.vent.trigger('windowResize');
			}, 500);
		}
		else {
			$(window).off('mousewheel', $.proxy(this._killMouseWheel, this));
		}

		//

		this.isScrollSwap = false;
		this.$contentController.removeClass('is-scroll-swap');
		this.$heroController.removeClass('is-scroll-swap');

		window.SETTINGS.animationFrame.one(() => {
			window.vent.trigger('windowResize');
		});
	}

	_scrollToSection(sectionId){

		$(window).off('mousewheel', $.proxy(this._killMouseWheel, this));
		$(window).on('mousewheel', $.proxy(this._killMouseWheel, this));

		let seekScroll = () => {

			window.vent.off('modalClose', seekScroll, this);
			window.SETTINGS.animationFrame.one(() => {

				let $sectionContent = sectionId ? $(`[data-content-id=\"${sectionId}\"]`) : null;
				let sectionTop = ($sectionContent && $sectionContent.length) ? $sectionContent.offset().top : 0;

				window.vent.trigger('cancelScroll');
				window.vent.trigger('scrollTo', {scrollTop: sectionTop});

				window.setTimeout(() => {
					$(window).off('mousewheel', $.proxy(this._killMouseWheel, this));
				}, 500);
			});
		}

		if($('.modaal-noscroll').length){
			window.vent.on('modalClose', seekScroll, this);
		}
		else {
			seekScroll();
		}
	}

	//

	_changePageById(id, sectionId){

		id = this._cleanId(id);

		let curPageId = this.pageId;
		let curSubsectionId = this.sectionId;
		let curPageObj = curPageId ? _.findWhere(this.data.pages, {id:curPageId}) : {};
		let nextPageObj = _.findWhere(this.data.pages, {id:id});
		let lastPageId = this.pageId;
		let lastSectionId = this.sectionId;

		let pageSections = window.SETTINGS.pageSections[id];

		console.log('_changePageById', id, sectionId, 'firstPage', this.isFirstPage);

		if(id && (id !== curPageId || (id === curPageId && sectionId !== curSubsectionId) || (id == curPageId && pageSections.scrollSections) || this.isFirstPage) && nextPageObj && !this.isTrans){

			let wasFirstPage = this.isFirstPage;

			this.pageId = id;
			this.sectionId = sectionId;
			this.pageIndex = this.data.pages.indexOf(nextPageObj);
			this.isFirstPage = false;

			if(id === curPageId && pageSections.scrollSections && !wasFirstPage){

				// scroll to content

				if(!sectionId){
					sectionId = pageSections.sections[0].id;
				}

				if($('.modaal-wrapper').length){
					let onModalClose = () => {
						window.vent.off('modalClose', onModalClose);
						this._scrollToSection(sectionId);
					}

					window.vent.on('modalClose', onModalClose);
				}
				else {
					this._scrollToSection(sectionId);
				}
			}
			else {

				// swap content

				let swapSectionId = sectionId;

				if(pageSections.scrollSections){
					swapSectionId = '';
				}

				window.vent.trigger('pageChangeStart', nextPageObj);

				// transition methods

				let transOut = () => {

					window.vent.trigger('pageTransitionOut', nextPageObj);

					this.heroController.transOutContent(id, swapSectionId, this.isScrollSwap).then(() => {
						this.contentController.transOutContent(id, swapSectionId, this.isScrollSwap).then(() => {
							transOutComplete();
						});
					});
				}

				let transOutComplete = () => {
					window.vent.trigger('pageTransitionOutComplete', curPageObj);
					populatePage();
				}

				let populatePage = () => {

					window.vent.trigger('pagePopulate', nextPageObj);

					this.heroController.swapContentById(id, swapSectionId, this.isScrollSwap).then(() => {
						this.contentController.swapContentById(id, swapSectionId, this.isScrollSwap).then(() => {
							populatePageComplete();
						});
					});
				}

				let populatePageComplete = () => {
					window.vent.trigger('pagePopulateComplete', nextPageObj);
					transIn();
				}

				let transIn = () => {

					window.vent.trigger('pageTransitionIn', nextPageObj);

					this.heroController.transInContent(id, swapSectionId, this.isScrollSwap).then(() => {
						this.contentController.transInContent(id, swapSectionId, this.isScrollSwap).then(() => {
							transInComplete();
						});
					});
				}

				let transInComplete = () => {

					window.vent.trigger('pageTransitionInComplete', nextPageObj);

					// if page has changed somehow, change content

					this.isTrans = false;

					if(this.getPageId() !== id){
						this._changePageById(this.getPageId());
					}
					else if(wasFirstPage){
						this._onPageLoadComplete(true);
					}
				}

				// don't trans out first page

				if(this.pageIndex >= 0){

					if(wasFirstPage){
						window.vent.trigger('pageTransitionOutComplete', curPageObj);
						populatePage();
					}
					else if(curPageId){
						this.isTrans = true;
						transOut();
					}
				}
				else {
					console.log("ERROR - Invalid Page Index");
				}
			}
		}

		// update page class

		let routeObj = window.SETTINGS.router.getRouteObj();

		if(routeObj){
			$('body').removeClass('page-' + lastPageId);
			$('body').removeClass('section-' + lastSectionId);
		}

		$('body').addClass('page-' + routeObj.pageId);

		if(routeObj.sectionId){
			$('body').addClass('section-' + routeObj.sectionId);
		}

		// update page title

		let pageTitle = window.SETTINGS.pageSections[routeObj.pageId].title;
		let sectionObj = routeObj.sectionId ? _.findWhere(window.SETTINGS.pageSections[routeObj.pageId].sections, {id: routeObj.sectionId}) : null;
		let sectionTitle = sectionObj ? sectionObj.title : '';

		if(sectionTitle){
			pageTitle += ' - ' + sectionTitle;
		}

		document.title = pageTitle;
	}

	_changePageByIndex(index){

		if(index !== this.pageIndex && index >= 0 && index < this.data.pages.length){

			let id = this.data.pages[index].id;
			if(id){
				this._changePageById(id);
			}
		}
	}

	_setFirstRoute(){
		let routeObj = window.SETTINGS.router.getRouteObj();
		this._changePageById(routeObj.pageId, routeObj.sectionId);
	}

	_updateArrowStatus(){

		// prev arrow

		if(this.getPageIndex() <= 0){
			this.$prevArrow.removeClass('is-showing');
		}
		else {
			this.$prevArrow.addClass('is-showing');
		}

		// next arrow

		if(this.getPageIndex() >= this.data.pages.length){
			this.$nextArrow.removeClass('is-showing');
		}
		else {
			this.$nextArrow.addClass('is-showing');
		}
	}

	_cleanId(id){
		if(id){
			if(id.charAt(0) === '/'){ id = id.substr(1); }
			return id.split('/')[0];
		}
		return null;
	}

	getPageId(){
		return this._cleanId(window.SETTINGS.router.getRouteObj().pageId);
	}

	getPageIndex(){
		let pageIndex = this.data.pages.indexOf(_.findWhere(this.data.pages, {id: this.getPageId()}));
		return isNaN(pageIndex) ? 0 : pageIndex;
	}

	//

	_domUpdate(){ } // use me!
	_resize(){ } // use me!
}

module.exports = SiteController;

},{"../../90_utils/Loader":126,"../../90_utils/base/BaseModule":131,"../animation-controller/script.js":56,"../page-content-controller/script.js":57,"../page-hero-controller/script.js":58}],61:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],62:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],63:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],64:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],65:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],66:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],67:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],68:[function(require,module,exports){
const BaseModule = require('../../../../90_utils/base/BaseModule');

class ClickToPlayVideo extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$plyrVideo = this.$el.find('[data-plyr-video]');
	}

	// basemodule methods

	_domReady(){
		this.$plyrVideo.triggerHandler('plyr-init');
	}

	_addListeners(){

		this.$el.find('.inner-content').on('click', $.proxy(this._onClick, this));

		if(this.$plyrVideo.hasClass('video-playing')){
			this._showPlayer();
		}
		else {
			this.$plyrVideo.on('playing', $.proxy(this._onVideoPlaying, this));
		}
	}

	_removeListeners(){

		this.$el.find('.inner-content').off('click', $.proxy(this._onClick, this));
		this.$plyrVideo.off('playing', $.proxy(this._onVideoPlaying, this));
	}

	//

	_onClick(e){

		if(window.SETTINGS.breakpoint.minWidth('screen-small')){

			this.$el.find('.inner-content').off('click', $.proxy(this._onClick, this));

			let $playButton = this.$el.find('.video-play');
			TweenMax.to($playButton, 0.2, {scale:1.1, ease:Cubic.easeIn});
			TweenMax.to($playButton, 0.2, {scale:0.9, opacity:0, ease:Quad.easeOut, delay:0.2});

			let $title = this.$el.find('.title');
			if($title.length){
				TweenMax.to($title, 0.5, {opacity:0, ease:'fade'});
			}

			let $spinner = this.$el.find('.circle-loader');
			TweenMax.to($spinner, 1, {opacity:1, delay:0.5, ease:'fade'});
			TweenMax.to($spinner, 3, {rotation:'+=360', repeat:-1, ease:Linear.none});

			this._play();
		}
	}

	_onVideoPlaying(e){
		this._showPlayer();
		this.$plyrVideo.off('playing', $.proxy(this._onVideoPlaying, this));
	}

	//

	_play(){
		if(!this.$el.hasClass('is-playing')){
			this.$el.find('[data-plyr-video]').triggerHandler('plyr-play');
		}
	}

	_pause(){

	}

	// hide poster

	_showPlayer(){

		let $playButton = this.$el.find('.video-play');
		let $spinner = this.$el.find('.circle-loader');

		window.setTimeout(() => {
			TweenMax.killTweensOf([$playButton, $spinner]);
		}, 500);

		this.$el.addClass('is-playing');
	}

	//

	_show(){}

	_hide(){}

	_enable(){ }
	_disable(){ }

	_domUpdate(){

	}
	_resize(){

	}
}

module.exports = ClickToPlayVideo;

},{"../../../../90_utils/base/BaseModule":131}],69:[function(require,module,exports){
const BaseModule = require('../../../../90_utils/base/BaseModule');

class ExpandingPhotoCols extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$navItems = this.$el.find('> ul > li');
		this.$photos = this.$el.find('> ul > li .photo');
		this.$photoItems = this.$el.find('.photo-items');

		this.numPhotos = this.$photos.length;
		this.isHover = false;
	}

	// basemodule methods

	_domReady(){

	}

	_addListeners(){

		this.$navItems.on('click', $.proxy(this._onPhotoTap, this));

		this.$photoItems.on('mouseenter', $.proxy(this._onPhotoItemsOver, this));
		this.$photoItems.on('mouseleave', $.proxy(this._onPhotoItemsOut, this));
	}

	_removeListeners(){

		this.$photoItems.off('mousemove', $.proxy(this._onMouseMove, this));
	}

	//

	_onPhotoItemsOver(){
		if(!this.isHover){
			this.isHover = true;
			this.$photoItems.on('mousemove', $.proxy(this._onMouseMove, this));
		}
	}

	_onPhotoItemsOut(){
		if(this.isHover){
			this.isHover = false;
			this.$photoItems.off('mousemove', $.proxy(this._onMouseMove, this));
			this._restorePhotos();
		}
	}

	_onMouseMove(e){

		if(window.SETTINGS.breakpoint.minWidth('screen-small')){

			let pageX = window.SETTINGS.coords.pageX;
			let bounds = this.$photoItems.offset();
			bounds.width = this.$photoItems.outerWidth();

			let photoIndex = Math.round(((pageX - (bounds.left + bounds.width)) / bounds.width + 1) * (this.numPhotos - 1));

			this._expandPhoto(this.$navItems.eq(photoIndex));
		}
	}

	_onPhotoTap(e){

		if(window.SETTINGS.breakpoint.maxWidth('screen-small')){
			let $target = $(e.currentTarget);
			let $navItem = $target.closest('.photo-item');
			this._expandPhoto($navItem);

			window.requestAnimationFrame(() => {
				$('body').on('click', $.proxy(this._onOut, this));
			});
		}
	}

	_onOut(e){
		if(!this.$photoItems[0].contains(e.target)){
			$('body').off('click', $.proxy(this._onOut, this));
			this._restorePhotos();
		}
	}

	//

	_expandPhoto($navItem){

		if(!$navItem.hasClass('is-active') && window.SETTINGS.breakpoint.minWidth('screen-phablet')){

			let $photo = $navItem.find('.photo');
			let $cropMask = $photo.find('.crop-mask');
			let $croppedPhoto = $photo.find('.cropped-photo');
			let $description = $navItem.find('.description');
			let fullWidth = $croppedPhoto.outerWidth();
			let photoWidth = $photo.outerWidth();
			let photoHeight = $photo.outerHeight();

			let totalWidth = photoWidth * 4; // + 20 * 3;
			let squishedWidth = Math.round((totalWidth - fullWidth)/3);
			let squishedDiff = photoWidth - squishedWidth;
			let navItemIndex = $navItem.index();
			let cropX = 0 - squishedDiff * navItemIndex;

			this.$navItems.removeClass('is-active');
			$navItem.addClass('is-active');

			window.requestAnimationFrame(() => {

				TweenMax.killTweensOf([$description, $cropMask, $croppedPhoto]);
				TweenMax.to($cropMask, 0.3, {x:cropX, clip:`rect(0px ${fullWidth}px ${photoHeight}px 0px)`, ease:'fade'});
				TweenMax.to($description, 0.3, {x: Math.round(cropX + (fullWidth - photoWidth)/2), opacity:1, ease:'fade'});
				TweenMax.to($croppedPhoto, 0.3, {x: 0, ease:'fade'});

				this.$navItems.each((index, value) => {

					let $tNavItem = $(value);

					if($tNavItem[0] !== $navItem[0]){

						let tCropX = fullWidth - photoWidth - squishedDiff * (index - 1);
						if(index < navItemIndex){ tCropX = 0 - squishedDiff * index; }

						let $tCropMask = $tNavItem.find('.crop-mask');
						let $tDescription = $tNavItem.find('.description');

						TweenMax.killTweensOf([$tDescription, $tCropMask, $tNavItem]);
						TweenMax.to($tDescription, 0.2, {opacity:0, ease:'fade'});
						TweenMax.to($tCropMask, 0.3, {x:tCropX, clip:`rect(0px ${squishedWidth}px ${photoHeight}px 0px)`, ease:'fade'});
					}
				});
			});
		}
	}

	_restorePhotos(){

		this.$navItems.each((index, value) => {

			let $navItem = $(value);
			let $description = $navItem.find('.description');
			let $photo = $navItem.find('.photo');
			let $cropMask = $photo.find('.crop-mask');
			let $croppedPhoto = $photo.find('.cropped-photo');

			let croppedWidth = $photo.outerWidth();
			let photoHeight = $photo.outerHeight();
			let photoX = Math.round(0 - ($croppedPhoto.outerWidth() - $photo.outerWidth())/2);

			TweenMax.killTweensOf([$description, $cropMask, $croppedPhoto]);

			if($navItem.hasClass('is-active')){
				TweenMax.to($description, 0.3, {x:0, ease:'fade'});
			}
			else {
				let delay = 0.28;
				TweenMax.to($description, 0.3, {opacity:1, delay:delay, ease:'fade'});
				TweenMax.to($description, 0.1, {x:0, ease:'fade'});
			}

			TweenMax.to($cropMask, 0.3, {x:0, clip:`rect(0px ${croppedWidth}px ${photoHeight}px 0px)`, ease:'fade'});
			TweenMax.to($croppedPhoto, 0.3, {x: photoX, ease:'fade', onComplete:() => {
				if($navItem.hasClass('is-active')){
					$navItem.removeClass('is-active');
				}
			}});
		});
	}

	//

	_show(){}

	_hide(){}

	_enable(){ }
	_disable(){ }

	_domUpdate(){

	}
	_resize(){

		this.$photos.each((index, value) => {

			let $photo = $(value);
			let $cropMask = $photo.find('.crop-mask');
			let $croppedPhoto = $photo.find('.cropped-photo');
			let croppedWidth = $photo.outerWidth();
			let photoHeight = $photo.outerHeight();
			let photoWidth = window.SETTINGS.breakpoint.minWidth('screen-small') ? photoHeight * (3/2) : croppedWidth;
			let photoX = Math.round(0 - (photoWidth - $photo.outerWidth())/2);

			TweenMax.set([$cropMask, $croppedPhoto], {width: photoWidth, height: photoHeight});
			TweenMax.set($cropMask, {clip:`rect(0px ${croppedWidth}px ${photoHeight}px 0px)`});
			TweenMax.set($croppedPhoto, {x:photoX});
		});

		this._restorePhotos();
	}
}

module.exports = ExpandingPhotoCols;

},{"../../../../90_utils/base/BaseModule":131}],70:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],71:[function(require,module,exports){
const BaseModule = require('../../../../90_utils/base/BaseModule');

class IconStats extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$statItemsWrapper = this.$el.find('.stat-items');
		this.$statItems = this.$el.find('.stat-item');
	}

	// basemodule methods

	_domReady(){
	}

	_addListeners(){
	}

	_removeListeners(){
	}

	//

	_matchHeight(){
		this.$statItems.css('height', '');
		this.$statItems.css('height', this.$statItemsWrapper.outerHeight());
	}

	//

	_show(){}

	_hide(){}

	_enable(){ }
	_disable(){ }

	_domUpdate(){
		this._matchHeight();
	}
	_resize(){
		this._matchHeight();
	}
}

module.exports = IconStats;

},{"../../../../90_utils/base/BaseModule":131}],72:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],73:[function(require,module,exports){
const BaseModule = require('../../../../90_utils/base/BaseModule');

class ReadMoreText extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$window = $(window);
		this.$readMore = this.$el.find('.read-more-goop .goop-button');
		this.$expandedContent = this.$el.find('.expanded-content');
		this.$overlayPanel = this.$el.find('.overlay-panel');

		this.expandedContentId = 'expanded-content' + (++window.SETTINGS.vars.svgIndex);
		this.transitionDelay;
		this.isIn = false;
	}

	// basemodule methods


	_domReady(){

		this.$expandedContent.css('height', 0);

		// enable modals from read more (weird)

		let modalId = this.$el.attr('data-modal-id') ? '#modal--' + this.$el.attr('data-modal-id') : '';

		if(modalId){
			this.$readMore.attr('data-modaal-href', modalId);
			this.$readMore.modaal();
		}

		this._resize();
	}

	_addListeners(){
		this.$readMore.on('click', $.proxy(this._onReadMoreClick, this));
		this.$window.on('scroll', $.proxy(this._onScroll, this));
	}

	_removeListeners(){
		this.$readMore.off('click', $.proxy(this._onReadMoreClick, this));
		this.$window.off('scroll', $.proxy(this._onScroll, this));
	}

	// listener methods

	_onReadMoreClick(e){
		this._toggleExpanded();
	}

	_onScroll(){

		let scrollTop = this.$window.scrollTop();
		let bounds = window.utils.PositioningUtils.getScrollOffset(this.$overlayPanel);
		let winHeight = window.SETTINGS.coords.winHeight;

		if((bounds.top < winHeight/2) || (bounds.height < winHeight && bounds.bottom < winHeight)){
			if((bounds.top < winHeight/3) || (bounds.height < winHeight && bounds.bottom <= winHeight)){
				if(!this.$el.hasClass('is-in')){
					this.$el.removeClass('is-in-slow');
					this.$el.addClass('is-in');
					this.isIn = true;

					if(this.transitionDelay){
						window.clearTimeout(this.transitionDelay);
					}
					this.transitionDelay = window.setTimeout(() => {
						this.$el.addClass('is-in-showing');
						this.transitionDelay = null;
						this._showText();
					}, 50);
				}
			}
			else {
				if(!this.$el.hasClass('is-in-slow')){
					this.$el.removeClass('is-in');
					this.$el.addClass('is-in-slow');
					this.isIn = true;

					if(this.transitionDelay){
						window.clearTimeout(this.transitionDelay);
					}
					this.transitionDelay = window.setTimeout(() => {
						this.$el.addClass('is-in-showing');
						this.transitionDelay = null;
						this._showText();
					}, 400);
				}
			}
		}
		else if(bounds.bottom < winHeight/4
			|| bounds.top > winHeight/4*3){

			if(this.isIn){
				this.$el.removeClass('is-in is-in-slow is-in-showing');
				this.isIn = false;
				this._hideText();

				if(this.transitionDelay){
					window.clearTimeout(this.transitionDelay);
					this.transitionDelay = null;
				}
			}
		}
	}

	// animate text

	_showText(){

		if(window.SETTINGS.breakpoint.minHeight('screen-medium')){

			let $title = this.$overlayPanel.find('.title');
			let $description = this.$overlayPanel.find('.description');
			let $expanded = this.$overlayPanel.find('.expanded-content');
			let $readMore = this.$overlayPanel.find('.read-more-goop');

			TweenMax.killTweensOf([$title, $description, $expanded, $readMore]);

			TweenMax.to($title, 0.4, {opacity:1, y:0, ease:'fade'});
			TweenMax.to($description, 0.4, {opacity:1, y:0, delay:0.1, ease:'fade'});
			TweenMax.to($expanded, 0.4, {opacity:1, y:0, delay:0.16, ease:'fade'});
			TweenMax.to($readMore, 0.4, {opacity:1, y:0, delay:0.2, ease:'fade'});
		}
	}

	_hideText(){

		if(window.SETTINGS.breakpoint.minHeight('screen-medium')){

			let $title = this.$overlayPanel.find('.title');
			let $description = this.$overlayPanel.find('.description');
			let $expanded = this.$overlayPanel.find('.expanded-content');
			let $readMore = this.$overlayPanel.find('.read-more-goop');

			TweenMax.killTweensOf([$title, $description, $expanded, $readMore]);

			TweenMax.to($title, 0.4, {opacity:0, y:0, ease:'fade'});
			TweenMax.to($description, 0.4, {opacity:0, y:0, delay:0.1, ease:'fade'});
			TweenMax.to($expanded, 0.4, {opacity:0, y:0, delay:0.16, ease:'fade'});
			TweenMax.to($readMore, 0.4, {opacity:0, y:0, delay:0.2, ease:'fade', onComplete:() => {
				TweenMax.set([$title, $description, $expanded, $readMore], {opacity: 0, y:20});
				TweenMax.set([$readMore], {opacity: 0, y:5});
			}});
		}
	}

	// toggle expanded content

	_toggleExpanded(){

		this.$el.toggleClass('is-expanded');
		this._checkExpandedHeight();
	}

	_checkExpandedHeight(instant){

		let $innerWrapper = this.$el.find('.overlay-panel');
		let $textContent = this.$el.find('.text-content');
		let $description = this.$el.find('.description');

		let elPadding = window.SETTINGS.breakpoint.minWidth('screen-small') ? 120 : 60;
		let contentPadding = window.SETTINGS.breakpoint.minWidth('screen-small') ? 160 : 60;
		let tweenTime = instant ? 0 : 0.3;

		if(this.$el.hasClass('is-expanded')){

			TweenMax.set(this.$expandedContent, {clearProps:'height'});

			let wrapperHeightFrom = $innerWrapper.outerHeight();
			let wrapperHeightTo = $textContent.outerHeight() + contentPadding;

			if($textContent.outerHeight() >= $innerWrapper.outerHeight() - contentPadding){
				TweenMax.to($innerWrapper, tweenTime, {opacity:1, height: wrapperHeightTo, ease:Cubic.easeOut});
			}

			if(wrapperHeightTo > this.$el.outerHeight() - elPadding){
				TweenMax.to(this.$el, tweenTime, {height: wrapperHeightTo + elPadding, ease:Cubic.easeOut});
			}

			// animate content expanding

			TweenMax.fromTo(this.$expandedContent, tweenTime, {opacity:0, height: 0},
				{opacity:1, height: this.$expandedContent.outerHeight(), ease:Cubic.easeOut});
		}
		else {

			// correct wrapper

			let wrapperHeightFrom = $innerWrapper.outerHeight();
			TweenMax.set($innerWrapper, {clearProps:'height'});

			TweenMax.set(this.$expandedContent, {height:0});
			let wrapperHeightTo = $textContent.outerHeight() + contentPadding;

			TweenMax.set($innerWrapper, {height: wrapperHeightFrom});
			TweenMax.to($innerWrapper, tweenTime, {height: wrapperHeightTo, ease:Cubic.easeOut});

			// resize wrapper

			let closedHeight = Math.max(window.SETTINGS.coords.winHeight, wrapperHeightTo + elPadding);
			TweenMax.to(this.$el, tweenTime, {height: closedHeight, ease:Cubic.easeOut});

			// shrink expanded content

			TweenMax.set(this.$expandedContent, {clearProps:'height'});
			TweenMax.to(this.$expandedContent, tweenTime, {opacity:0, height: 0, ease:Cubic.easeOut});
		}
	}

	//

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){

		let $innerWrapper = this.$el.find('.overlay-panel');
		let $textContent = this.$el.find('.text-content');

		TweenMax.set([this.$el, $innerWrapper], {clearProps: 'height'});

		let fitHeight = Math.max(window.SETTINGS.coords.winHeight, $innerWrapper.outerHeight() + 120);

		TweenMax.killTweensOf(this.$el);
		TweenMax.set(this.$el, {height: fitHeight});

		//

		if(!this.isIn){

			let $title = this.$overlayPanel.find('.title');
			let $description = this.$overlayPanel.find('.description');
			let $expanded = this.$overlayPanel.find('.expanded-content');
			let $readMore = this.$overlayPanel.find('.read-more-goop');

			if(window.SETTINGS.breakpoint.minHeight('screen-medium')){
				TweenMax.set([$title, $description, $expanded, $readMore], {opacity: 0, y:12});
				TweenMax.set([$description, $expanded], {opacity: 0, y:6});
				TweenMax.set([$readMore], {opacity: 0, y:3});
			}
			else {
				TweenMax.set([$title, $description, $expanded, $readMore], {clearProps: 'all'});
			}
		}

		//

		this._checkExpandedHeight(true);
	}
}

module.exports = ReadMoreText;

},{"../../../../90_utils/base/BaseModule":131}],74:[function(require,module,exports){
const BaseModule = require('../../../../90_utils/base/BaseModule');

class ScrollOverlaySlides extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$photoBlock = this.$el.find('.photo-block');
		this.$textBlock = this.$el.find('.text-block');
		this.$slidesWrapper = this.$el.find('.slides-wrapper');
		this.$photoSlides = this.$el.find('.photo-slides >li');
		this.$textSlides = this.$el.find('.text-slides >li');
		this.$textSlidesInner = this.$textSlides.find('.inner-wrapper');
		this.$textSlide;
		this.$textSlideInner;
		this.$window = $(window);

		this.slidesTotal = this.$el.find('.text-slides >li').length;
		this.slideIndex = -1;
		this.transitionDelays = [];
		this.isIns = [];

		this.bounds;
		this.isMobile = false;
		this.isTrans = false;
	}

	// basemodule methods

	_domReady(){

		for(let i=0; i<this.$textSlides.length; i++){

			let $textSlide = this.$textSlides.eq(i);
			let $expandedContent = $textSlide.find('.expanded-content');

			$expandedContent.css('height', 0);

			// enable modals from read more (weird)

			let $readMore = $textSlide.find('.read-more-goop .goop-button');
			let modalId = $textSlide.attr('data-modal-id') ? '#modal--' + $textSlide.attr('data-modal-id') : '';

			if(modalId){
				$readMore.attr('data-modaal-href', modalId);
				$readMore.modaal();
			}
		}

		this._resize();
	}

	_addListeners(){

		this.$el.find('.read-more-goop .goop-button').on('click', $.proxy(this._onReadMoreClick, this));

		this.$window.on('scroll', $.proxy(this._onScroll, this));
		this.$window.on('mousewheel', $.proxy(this._onMouseWheel, this));

		window.vent.on('modalOpen', this._onModalOpen, this);
		window.vent.on('modalClose', this._onModalClose, this);
	}

	_removeListeners(){

		this.$el.find('.read-more-goop .goop-button').off('click', $.proxy(this._onReadMoreClick, this));

		this.$window.off('scroll', $.proxy(this._onScroll, this));
		this.$window.off('mousewheel', $.proxy(this._onMouseWheel, this));

		window.vent.off('modalOpen', this._onModalOpen, this);
		window.vent.off('modalClose', this._onModalClose, this);
	}

	// listener methods

	_onReadMoreClick(e){

		let $target = $(e.currentTarget);
		let $textSlide = $target.closest('.text-slide');

		if(!$target.attr('data-modaal-href')){
			this._toggleExpanded($textSlide);
		}
	}

	_onMouseWheel(e){
		this._checkScroll(this.$window.scrollTop() - e.deltaY, true);
	}

	_onScroll(e){
		this._checkScroll(this.$window.scrollTop());
	}

	_onModalOpen(){
		this.isModalOpen = true;
	}

	_onModalClose(){
		this.isModalOpen = false;
	}

	// toggle expanded content

	_toggleExpanded($textSlide){

		this.$textSlides.each((index, value) => {
			let $value = $(value);
			if($textSlide[0] === $value[0]){
				$value.toggleClass('is-expanded');
			}
			else {
				// $value.removeClass('is-expanded');
			}
		});

		this._checkSizes(0.3, $textSlide);
	}

	//

	_checkSizes(animationTime, $triggerSlide){

		animationTime = typeof(animationTime) === 'undefined' ? 0 : animationTime;

		for(let i=0; i<this.$textSlides.length; i++){

			let $textSlide = this.$textSlides.eq(i);
			let $scrollArea = this.$el.find('.scroll-area li').eq(i);
			let $photoSlide = this.$el.find('.photo-slide').eq(i);

			let $innerWrapper = $textSlide.find('.inner-wrapper');
			let $textContent = $textSlide.find('.text-content');
			let $description = $textSlide.find('.description');
			let $expandedContent = $textSlide.find('.expanded-content');

			TweenMax.killTweensOf([$innerWrapper, $textSlide, $scrollArea, $photoSlide], {height:true});

			if($textSlide.hasClass('is-expanded')){

				if(window.SETTINGS.breakpoint.minWidth('screen-medium')){

					if(animationTime === 0){

						TweenMax.set([$innerWrapper, $scrollArea, $textSlide, $expandedContent], {clearProps:'top, height'});

						if($textContent.outerHeight() >= $innerWrapper.outerHeight() - 160){

							let wrapperHeightFrom = $innerWrapper.outerHeight();
							let wrapperHeightTo = $textContent.outerHeight() + 160;
							TweenMax.set($innerWrapper, {y:Math.round((wrapperHeightFrom - wrapperHeightTo)/2), opacity:1, height: wrapperHeightTo});

							if(wrapperHeightTo > $scrollArea.outerHeight() - 80){
								TweenMax.set([$textSlide, $scrollArea], {height: wrapperHeightTo + 80});
							}
						}
					}
					else {

						TweenMax.set([$innerWrapper, $scrollArea, $textSlide, $expandedContent], {clearProps:'top, height'});

						if($textContent.outerHeight() >= $innerWrapper.outerHeight() - 160){

							let wrapperHeightFrom = $innerWrapper.outerHeight();
							let wrapperHeightTo = $textContent.outerHeight() + 160;
							let ySlide = Math.round((wrapperHeightFrom - wrapperHeightTo)/2);

							this.isTrans = true;

							TweenMax.set($innerWrapper, {y:0, height:wrapperHeightFrom});
							TweenMax.to($innerWrapper, animationTime, {y:ySlide, opacity:1, height: wrapperHeightTo, ease:'scrollEase', onComplete:() => {
								this._resize(true);
							}});

							if(wrapperHeightTo > $scrollArea.outerHeight() - 80){
								TweenMax.to([$textSlide, $scrollArea], animationTime, {height: wrapperHeightTo + 80, ease:'scrollEase', onComplete:() => {
									this._resize(true);
								}});
							}

							if($triggerSlide && $triggerSlide[0] === $textSlide[0]){
								// window.vent.trigger('scrollTo', {scrollTop: this.$window.scrollTop() + ySlide, animationTime: animationTime});
							}
						}
					}
				}
				else {

					let wrapperHeightFrom = $innerWrapper.outerHeight();
					TweenMax.set([$expandedContent], {clearProps:'height'});
					let wrapperHeightTo = $textContent.outerHeight();
					let wrapperY = Math.round((wrapperHeightFrom - wrapperHeightTo)/2);
					let containerHeight = $textContent.outerHeight();

					// need to resize outer box?

					if(wrapperHeightTo > window.SETTINGS.coords.winHeight - 160){

						TweenMax.to([$scrollArea, $textSlide, $photoSlide], animationTime, {height: wrapperHeightTo + 160, ease:Cubic.easeOut, onComplete:() => {
							this._resize(true);
						}});
					}

					TweenMax.to($innerWrapper, animationTime, {opacity:1, y: wrapperY, height: wrapperHeightTo, ease:Cubic.easeOut});
				}

				// animate expanding field... expanding

				if(animationTime === 0){
					TweenMax.set([$expandedContent], {clearProps:'height', opacity:1});
					this.bounds = window.utils.PositioningUtils.getExtendedOffset(this.$el);
				}
				else {

					if(parseFloat($expandedContent.css('opacity')) === 0){

						TweenMax.fromTo($expandedContent, animationTime, {opacity:0, height: 0},
							{opacity:1, height: $expandedContent.outerHeight(), ease:Cubic.easeOut, onUpdate:() => {
								this.bounds = window.utils.PositioningUtils.getExtendedOffset(this.$el);
								this._onScroll();
							}});
					}
				}
			}
			else {

				let expandedContentHeight = $expandedContent.outerHeight();
				TweenMax.set($expandedContent, {height:0});

				// collapsing expanded text

				if(animationTime === 0){

					TweenMax.set([$innerWrapper, $textSlide, $photoSlide, $scrollArea], {clearProps: 'all'});
					let wrapperHeightTo = $textContent.outerHeight();

					// need to resize outer box?

					if(wrapperHeightTo > window.SETTINGS.coords.winHeight - 160){
						TweenMax.to([$scrollArea, $textSlide, $photoSlide], animationTime, {height: wrapperHeightTo + 160, ease:Cubic.easeOut, onComplete:() => {
							this._resize(true);
						}});
					}
				}
				else {

					// inner wrapper

					let wrapperHeightFrom = $innerWrapper.outerHeight();
					TweenMax.set($innerWrapper, {clearProps:'height'});

					let wrapperHeightTo = $innerWrapper.outerHeight();
					$innerWrapper.css('height', wrapperHeightFrom);

					// text height

					let textHeightFrom = $textSlide.outerHeight();
					TweenMax.set($textSlide, {clearProps:'height'});

					let textHeightTo = $textSlide.outerHeight();
					$textSlide.css('height', textHeightFrom);

					// text height

					let photoHeightFrom = $photoSlide.outerHeight();
					TweenMax.set($photoSlide, {clearProps:'height'});

					let photoHeightTo = $photoSlide.outerHeight();
					$photoSlide.css('height', photoHeightFrom);

					// scroll height

					let scrollHeightFrom = $scrollArea.outerHeight();
					TweenMax.set($scrollArea, {clearProps:'height'});

					let scrollHeightTo = $scrollArea.outerHeight();
					$scrollArea.css('height', scrollHeightFrom);

					// correct wrapper

					if(window.SETTINGS.breakpoint.minWidth('screen-medium')){

						let ySlide = Math.round((wrapperHeightFrom - wrapperHeightTo)/2);

						this.isTrans = true;

						TweenMax.to($innerWrapper, animationTime, {y:0, height: wrapperHeightTo, ease:'scrollEase'});
						TweenMax.to($textSlide, animationTime, {y:0, height: textHeightTo, ease:'scrollEase'});
						TweenMax.to($scrollArea, animationTime, {y:0, height: scrollHeightTo, ease:'scrollEase'});
						TweenMax.set([$photoSlide], {clearProps: 'all'});

						if($triggerSlide && $triggerSlide[0] === $textSlide[0]){
							window.vent.trigger('scrollTo', {scrollTop: $textSlide.offset().top + ySlide - 80, animationTime: animationTime});
						}
					}
					else {

						TweenMax.set([$innerWrapper, $textSlide, $photoSlide, $scrollArea], {clearProps: 'all'});
						let wrapperHeightTo = $textContent.outerHeight();
						let ySlide = Math.round((wrapperHeightFrom - wrapperHeightTo)/2);

						// need to resize outer box?

						if(wrapperHeightTo > window.SETTINGS.coords.winHeight - 160){
							TweenMax.to([$scrollArea, $textSlide, $photoSlide], animationTime, {height: wrapperHeightTo + 160, ease:Cubic.easeOut, onComplete:() => {
								this._resize(true);
							}});
						}

						if($triggerSlide && $triggerSlide[0] === $textSlide[0]){
							window.vent.trigger('scrollTo', {scrollTop: $textSlide.offset().top + ySlide - 80, animationTime: animationTime});
						}
					}
				}

				// animate expanding field... SHRINKING

				if(animationTime === 0){
					TweenMax.set([$expandedContent], {opacity:0, height:0});
					this.bounds = window.utils.PositioningUtils.getExtendedOffset(this.$el);
				}
				else {

					TweenMax.set($expandedContent, {height:expandedContentHeight});
					TweenMax.to($expandedContent, animationTime, {opacity:0, height: 0, ease:'scrollEase', onUpdate:() => {
						this.isTrans = false;
						this.bounds = window.utils.PositioningUtils.getExtendedOffset(this.$el);
						this._onScroll();
					}});
				}
			}
		}

		this._resize(true);
	}

	//

	_checkScroll(scrollTop, isFromScrollWheel){

		let newSlideIndex = this.slideIndex;
		let winHeight = window.SETTINGS.coords.winHeight;

		if(!this.isModalOpen && !this.isMobile && !this.isTrans){

			if(scrollTop >= this.bounds.top){

				if(scrollTop + winHeight < this.bounds.bottom){

					this.$slidesWrapper.addClass('is-fixed');
					this.$slidesWrapper.removeClass('bottomed');

					let innerScroll = scrollTop - this.bounds.top - winHeight/2;
					newSlideIndex = Math.round((innerScroll + winHeight/3) / (winHeight * 1.33));
					newSlideIndex = Math.min(this.slidesTotal-1, newSlideIndex);
				}
				else {
					this.$slidesWrapper.removeClass('is-fixed');
					this.$slidesWrapper.addClass('bottomed');
					newSlideIndex = this.slidesTotal-1;
				}
			}
			else {
				this.$slidesWrapper.removeClass('is-fixed bottomed');
				newSlideIndex = 0;
			}

			if(newSlideIndex !== this.slideIndex){
				this._swapContentByIndex(newSlideIndex);
			}

			// add center class if selected slide is visible

			if(this.$textSlideInner && this.$textSlideInner.length) {

				let textBounds = window.utils.PositioningUtils.getScrollOffset(this.$textSlideInner);

				if(textBounds.bottom < winHeight - winHeight * 0.05 && textBounds.bottom > winHeight * 0.15){
					this.$textSlide.addClass('is-centered');
				}
				else {
					this.$textSlide.removeClass('is-centered');
				}
			}
		}
		else if(this.isMobile){

			this.$textSlides.each((index, value) => {

				let $textSlideInner = $(value).find('> .inner-wrapper');

				let scrollTop = this.$window.scrollTop();
				let bounds = window.utils.PositioningUtils.getScrollOffset($textSlideInner);

				if((bounds.top < winHeight/2) || (bounds.height < winHeight && bounds.bottom < winHeight)){
					if((bounds.top < winHeight/3) || (bounds.height < winHeight && bounds.bottom <= winHeight)){
						if(!$textSlideInner.hasClass('is-in')){
							$textSlideInner.removeClass('is-in-slow');
							$textSlideInner.addClass('is-in');
							this.isIns[index] = true;

							if(this.transitionDelays[index]){
								window.clearTimeout(this.transitionDelays[index]);
							}
							this.transitionDelays[index] = window.setTimeout(() => {
								$textSlideInner.addClass('is-in-showing');
								this.transitionDelays[index] = null;
							}, 50);
						}
					}
					else {
						if(!$textSlideInner.hasClass('is-in-slow')){
							$textSlideInner.removeClass('is-in');
							$textSlideInner.addClass('is-in-slow');
							this.isIns[index] = true;

							if(this.transitionDelays[index]){
								window.clearTimeout(this.transitionDelays[index]);
							}
							this.transitionDelays[index] = window.setTimeout(() => {
								$textSlideInner.addClass('is-in-showing');
								this.transitionDelays[index] = null;
							}, 400);
						}
					}
				}
				else if(bounds.bottom < winHeight/4
					|| bounds.top > winHeight/4*3){

					if(this.isIns[index]){
						$textSlideInner.removeClass('is-in is-in-slow is-in-showing');
						this.isIns[index] = false;

						if(this.transitionDelays[index]){
							window.clearTimeout(this.transitionDelays[index]);
							this.transitionDelays[index] = null;
						}
					}
				}
			});
		}
	}

	//

	_swapContentByIndex(newSlideIndex){

		if(newSlideIndex !== this.slideIndex){

			let $oldPhoto = (this.slideIndex >= 0) ? this.$photoSlides.eq(this.slideIndex) : null;
			if($oldPhoto){ $oldPhoto.css('opacity', 1); }

			this.slideIndex = newSlideIndex;

			TweenMax.fromTo(this.$photoSlides.eq(this.slideIndex), 0.3, {opacity:0}, {opacity:1, ease:'fade', onComplete:() => {
				if($oldPhoto){ $oldPhoto.css('opacity', ''); }
			}});

			this.$photoSlides.removeClass('is-active');
			this.$photoSlides.eq(this.slideIndex).addClass('is-active');

			this.$textSlides.removeClass('is-active');
			this.$textSlide = this.$textSlides.eq(this.slideIndex).addClass('is-active');

			this.$textSlideInner = this.$textSlidesInner.eq(this.slideIndex);

			if(!this.$textSlide.length || !this.$textSlideInner.length){
				this.$textSlide = this.$textSlides.addClass('is-active');
				this.$textSlideInner = this.$textSlidesInner;
			}
		}
	}

	//

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){
	}
	_resize(dontCheckSizes){

		this.isMobile = window.SETTINGS.breakpoint.maxWidth('screen-medium');

		if(this.isMobile){
			this.$el.find('.is-fixed').removeClass('is-fixed');
		}

		this.bounds = window.utils.PositioningUtils.getExtendedOffset(this.$el);
		if(dontCheckSizes !== true){ this._checkSizes(0); }
		this._checkScroll(this.$window.scrollTop());
	}
}

module.exports = ScrollOverlaySlides;

},{"../../../../90_utils/base/BaseModule":131}],75:[function(require,module,exports){
const BaseModule = require('../../../../90_utils/base/BaseModule');

class ScrollSplitSlides extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$photoBlock = this.$el.find('.photo-block');
		this.$textBlock = this.$el.find('.text-block');
		this.$slidesWrapper = this.$el.find('.slides-wrapper');
		this.$photoSlides = this.$photoBlock.find('.photo-slides >li');
		this.$textSlides = this.$el.find('.text-slides >li');
		this.$textSlidesInner = this.$textSlides.find('.inner-wrapper');
		this.$textSlide;
		this.$textSlideInner;
		this.$window = $(window);

		this.slidesTotal = this.$el.find('.text-slides >li').length;
		this.slideIndex = -1;
		this.transitionDelays = [];
		this.isIns = [];
		this.bounds;

		this.tickValue = null;
		this.isTickTriggered = false;

		this.isModalOpen = false;
		this.isMobile = false;
	}

	// basemodule methods

	_domReady(){

		for(let i=0; i<this.$textSlides.length; i++){

			let $textSlide = this.$textSlides.eq(i);
			let $expandedContent = $textSlide.find('.expanded-content');

			$expandedContent.css('height', 0);

			// enable modals from read more (weird)

			let $readMore = $textSlide.find('.read-more-goop .goop-button');
			let modalId = $textSlide.attr('data-modal-id') ? '#modal--' + $textSlide.attr('data-modal-id') : '';

			if(modalId){
				$readMore.attr('data-modaal-href', modalId);
				$readMore.modaal();
			}
		}

		this._resize();
	}

	_addListeners(){

		this.$el.find('.read-more-goop .goop-button').on('click', $.proxy(this._onReadMoreClick, this));

		this.$window.on('scroll', $.proxy(this._onScroll, this));
		this.$window.on('mousewheel', $.proxy(this._onMouseWheel, this));

		window.vent.on('modalOpen', this._onModalOpen, this);
		window.vent.on('modalClose', this._onModalClose, this);
	}

	_removeListeners(){

		this.$el.find('.read-more-goop .goop-button').off('click', $.proxy(this._onReadMoreClick, this));

		this.$window.off('scroll', $.proxy(this._onScroll, this));
		this.$window.off('mousewheel', $.proxy(this._onMouseWheel, this));

		window.vent.off('modalOpen', this._onModalOpen, this);
		window.vent.off('modalClose', this._onModalClose, this);
	}

	// listener methods

	_onReadMoreClick(e){

		let $target = $(e.currentTarget);
		let $textSlide = $target.closest('.text-slide');

		if(!$target.attr('data-modaal-href')){
			this._toggleExpanded($textSlide);
		}
	}

	_onMouseWheel(e){
		this._scrollTick(this.$window.scrollTop() - e.deltaY, true);
	}

	_onScroll(e){
		this._scrollTick(this.$window.scrollTop());
	}

	_onModalOpen(){
		this.isModalOpen = true;
	}

	_onModalClose(){
		this.isModalOpen = false;
	}

	// scroll tick (only register mousewheel value if present)

	_scrollTick(scrollTop, isFromScrollWheel){

		let tickTrigger = () => {
			if(this.tickValue !== null){
				this._checkScroll(this.tickValue);
				this.isTickTriggered = true;
			}
		}

		if(this.tickValue === null || isFromScrollWheel){
			this.tickValue = scrollTop;
			if(isFromScrollWheel){
				tickTrigger();
			}
		}

		window.SETTINGS.animationFrame.one(() => {
			if(!this.isTickTriggered){
				tickTrigger();
			}
			this.isTickTriggered = false;
			this.tickValue = null;
		});
	}

	// toggle expanded content

	_toggleExpanded($textSlide){

		let $innerWrapper = $textSlide.find('.inner-wrapper');
		let $textContent = $textSlide.find('.text-content');
		let $description = $textSlide.find('.description');
		let $expandedContent = $textSlide.find('.expanded-content');

		let slideIndex = $textSlide.index();
		let $scrollArea = this.$el.find('.scroll-area li').eq(slideIndex);
		let $photoSlide = this.$el.find('.photo-slide').eq(slideIndex);

		$textSlide.toggleClass('is-expanded');

		if($textSlide.hasClass('is-expanded')){

			TweenMax.set($expandedContent, {clearProps:'height'});

			let wrapperHeightFrom = $innerWrapper.outerHeight();

			if(window.SETTINGS.breakpoint.minWidth('screen-medium')){

				TweenMax.set([$scrollArea, $photoSlide, $textSlide, $innerWrapper], {clearProps: 'top, height'});

				if($textContent.outerHeight() >= $innerWrapper.outerHeight() - 160){

					let wrapperHeightTo = $textContent.outerHeight() + 160;

					TweenMax.to($innerWrapper, 0.3, {y:Math.round((wrapperHeightFrom - wrapperHeightTo)/2), opacity:1, height: wrapperHeightTo, ease:Cubic.easeOut, onComplete:() => {
						this._resize();
					}});

					if(wrapperHeightTo > $scrollArea.outerHeight() - 80){
						TweenMax.to([$textSlide, $photoSlide, $scrollArea], 0.3, {height: wrapperHeightTo + 80, ease:Cubic.easeOut, onComplete:() => {
							this._resize();
						}});
					}
				}
			}
			else {

				let wrapperHeightTo = $textContent.outerHeight();

				if($textContent.outerHeight() >= $innerWrapper.outerHeight()){
					TweenMax.to($innerWrapper, 0.3, {y:0, opacity:1, height: wrapperHeightTo, ease:Cubic.easeOut});
				}

				if(wrapperHeightTo > window.SETTINGS.coords.winHeight - 160){
					TweenMax.to($innerWrapper, 0.3, {top:40, ease:Cubic.easeOut});
					TweenMax.to([$scrollArea, $photoSlide, $textSlide], 0.3, {height: wrapperHeightTo + 160, ease:Cubic.easeOut, onComplete:() => {
						this._resize();
					}});
				}
			}

			// animate

			TweenMax.fromTo($expandedContent, 0.3, {opacity:0, height: 0},
				{opacity:1, height: $expandedContent.outerHeight(), ease:Cubic.easeOut});
		}
		else {

			// correct wrapper

			let wrapperHeightFrom = $innerWrapper.outerHeight();
			TweenMax.set($innerWrapper, {clearProps:'height'});

			if(window.SETTINGS.breakpoint.minWidth('screen-medium')){

				this._resize();

				let wrapperHeightTo = $innerWrapper.outerHeight();
				$innerWrapper.css('height', wrapperHeightFrom);

				TweenMax.to($innerWrapper, 0.3, {y:0, height: wrapperHeightTo, ease:Cubic.easeOut});
			}
			else {

				TweenMax.to($innerWrapper, 0.3, {y:0, ease:Cubic.easeOut});
				TweenMax.set([$scrollArea, $photoSlide, $textSlide, $innerWrapper], {clearProps: 'top, height'});
			}

			// shrink content

			TweenMax.to($expandedContent, 0.3, {opacity:0, height: 0, ease:Cubic.easeOut});
		}
	}

	//

	_checkScroll(scrollTop){

		let newSlideIndex = this.slideIndex;
		let winHeight = window.SETTINGS.coords.winHeight;

		if(!this.isModalOpen && !this.isMobile && scrollTop !== null){

			if(scrollTop >= this.bounds.top){

				if(scrollTop + winHeight < this.bounds.bottom){

					this.$slidesWrapper.addClass('is-fixed');
					this.$slidesWrapper.removeClass('bottomed');

					this.$textSlides.each((index, value) => {

						let $textSlideInner = $(value).find('> .inner-wrapper');
						let bounds = window.utils.PositioningUtils.getScrollOffset($textSlideInner);

						if(bounds.centerY - winHeight/2 < winHeight/2 && bounds.centerY > 0){
							newSlideIndex = index;
						}
					});
				}
				else {
					this.$slidesWrapper.removeClass('is-fixed');
					this.$slidesWrapper.addClass('bottomed');
					newSlideIndex = this.slidesTotal-1;
				}
			}
			else {
				this.$slidesWrapper.removeClass('is-fixed bottomed');
				newSlideIndex = 0;
			}

			if(newSlideIndex !== this.slideIndex || (!this.$textSlideInner || !this.$textSlideInner.length)){
				this._swapContentByIndex(newSlideIndex);
			}

			// add center class if selected slide is visible

			let textBounds = window.utils.PositioningUtils.getScrollOffset(this.$textSlideInner);

			if(textBounds.bottom < winHeight - winHeight * 0.05 && textBounds.bottom > winHeight * 0.15){
				this.$textSlide.addClass('is-centered');
			}
			else {
				this.$textSlide.removeClass('is-centered');
			}
		}
		else if(this.isMobile){

			this.$textSlides.each((index, value) => {

				let $textSlideInner = $(value).find('> .inner-wrapper');

				let scrollTop = this.$window.scrollTop();
				let bounds = window.utils.PositioningUtils.getScrollOffset($textSlideInner);

				if((bounds.top < winHeight/2) || (bounds.height < winHeight && bounds.bottom < winHeight)){
					if((bounds.top < winHeight/3) || (bounds.height < winHeight && bounds.bottom <= winHeight)){
						if(!$textSlideInner.hasClass('is-in')){
							$textSlideInner.removeClass('is-in-slow');
							$textSlideInner.addClass('is-in');
							this.isIns[index] = true;

							if(this.transitionDelays[index]){
								window.clearTimeout(this.transitionDelays[index]);
							}
							this.transitionDelays[index] = window.setTimeout(() => {
								$textSlideInner.addClass('is-in-showing');
								this.transitionDelays[index] = null;
							}, 50);
						}
					}
					else {
						if(!$textSlideInner.hasClass('is-in-slow')){
							$textSlideInner.removeClass('is-in');
							$textSlideInner.addClass('is-in-slow');
							this.isIns[index] = true;

							if(this.transitionDelays[index]){
								window.clearTimeout(this.transitionDelays[index]);
							}
							this.transitionDelays[index] = window.setTimeout(() => {
								$textSlideInner.addClass('is-in-showing');
								this.transitionDelays[index] = null;
							}, 400);
						}
					}
				}
				else if(bounds.bottom < winHeight/4
					|| bounds.top > winHeight/4*3){

					if(this.isIns[index]){
						$textSlideInner.removeClass('is-in is-in-slow is-in-showing');
						this.isIns[index] = false;

						if(this.transitionDelays[index]){
							window.clearTimeout(this.transitionDelays[index]);
							this.transitionDelays[index] = null;
						}
					}
				}
			});
		}
	}

	//

	_swapContentByIndex(newSlideIndex){

		if(newSlideIndex !== this.slideIndex){

			this.slideIndex = newSlideIndex;

			this.$photoSlides.removeClass('last-active');
			this.$photoBlock.find('.is-active').addClass('last-active');
			this.$photoSlides.removeClass('is-active');
			this.$photoSlides.eq(this.slideIndex).addClass('is-active');

			this.$textSlides.removeClass('is-active');

			this.$textSlide = this.$textSlides.eq(this.slideIndex).addClass('is-active');
			this.$textSlideInner = this.$textSlidesInner.eq(this.slideIndex);

			if(!this.$textSlide.length || !this.$textSlideInner.length){
				this.$textSlide = this.$textSlides.addClass('is-active');
				this.$textSlideInner = this.$textSlidesInner;
			}

			let $activeSlide = this.$photoSlides.eq(this.slideIndex).find('> figure');

			TweenMax.killTweensOf([this.$photoBlock.find('.is-active > figure'), this.$photoBlock.find('.last-active > figure')]);
			TweenMax.set(this.$photoBlock.find('.last-active > figure'), {clearProps: 'opacity'});

			TweenMax.killTweensOf($activeSlide);
			TweenMax.fromTo($activeSlide, 0.3, {opacity:0}, {opacity:1, ease:Cubic.easeOut});
		}
	}

	//

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){
	}
	_resize(){

		this.isMobile = window.SETTINGS.breakpoint.maxWidth('screen-medium');

		if(this.isMobile){
			this.$el.find('.is-fixed').removeClass('is-fixed');
		}
		else {

			this.$textSlides.each((index, value) => {

				let $textSlide = $(value);
				let $scrollArea = this.$el.find('.scroll-area li').eq(index);
				let $photoSlide = this.$el.find('.photo-slide').eq(index);
				let $innerWrapper = $textSlide.find('.inner-wrapper');
				let $textContent = $textSlide.find('.text-content');

				TweenMax.killTweensOf([$textSlide, $scrollArea, $photoSlide]);
				TweenMax.set([$textSlide, $scrollArea, $photoSlide], {clearProps: 'height'});

				let innerWrapperHeight = $innerWrapper.outerHeight() + 80;

				if(innerWrapperHeight > $scrollArea.outerHeight()){
					TweenMax.set([$textSlide, $scrollArea, $photoSlide], {height: innerWrapperHeight});
				}
				else {
					TweenMax.set([$textSlide, $scrollArea, $photoSlide], {clearProps: 'height'});
				}
			});
		}

		this.bounds = window.utils.PositioningUtils.getExtendedOffset(this.$el);
		this._checkScroll(this.$window.scrollTop());
	}
}

module.exports = ScrollSplitSlides;

},{"../../../../90_utils/base/BaseModule":131}],76:[function(require,module,exports){
const BaseModule = require('../../../../90_utils/base/BaseModule');
const VerticalGraph = require('../../../../80_bits/vertical-graph/script');

class SplitReadMoreGraph extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$readMore = this.$el.find('.read-more-goop .goop-button');
		this.$expandedContent;
		this.expandedContentId = 'expanded-content' + (++window.SETTINGS.vars.svgIndex);

		this.$graph = this.$el.find('.vertical-graph');
		this.graph = new VerticalGraph(this.$graph);
	}

	// basemodule methods

	_domReady(){

		let $expandedContent = this.$el.find('.expanded-content');
		$expandedContent.css('height', 0);

		// enable modals from read more (weird)

		let modalId = this.$el.attr('data-modal-id') ? '#modal--' + this.$el.attr('data-modal-id') : '';

		if(modalId){
			this.$readMore.attr('data-modaal-href', modalId);
			this.$readMore.modaal();
		}

		this._resize();
	}

	_addListeners(){
		this.$readMore.on('click', $.proxy(this._onReadMoreClick, this));
	}

	_removeListeners(){
		this.$readMore.off('click', $.proxy(this._onReadMoreClick, this));
	}

	// listener methods

	_onReadMoreClick(e){
		this._toggleExpanded();
	}

	// toggle expanded content

	_toggleExpanded(){

		let $innerWrapper = this.$el.find('.text-block');
		let $textContent = this.$el.find('.text-content');
		let $description = this.$el.find('.description');
		let $expandedContent = this.$el.find('.expanded-content');

		this.$el.toggleClass('is-expanded');

		if(this.$el.hasClass('is-expanded')){

			TweenMax.set($expandedContent, {clearProps:'height'});

			let wrapperHeightFrom = $innerWrapper.outerHeight();

			if(window.SETTINGS.breakpoint.minWidth('screen-large')){
				if($textContent.outerHeight() >= $innerWrapper.outerHeight() - 160){
					let wrapperHeightTo = $textContent.outerHeight() + 160;
					TweenMax.to($innerWrapper, 0.3, {y: 0, opacity:1, height: wrapperHeightTo, ease:Cubic.easeOut});
				}
			}
			else {
				if($textContent.outerHeight() + 120 >= $innerWrapper.outerHeight()){
					let wrapperHeightTo = $textContent.outerHeight() + 120;
					TweenMax.to($innerWrapper, 0.3, {y: 0, opacity:1, height: wrapperHeightTo, ease:Cubic.easeOut});
				}
			}

			// animate

			TweenMax.fromTo($expandedContent, 0.3, {opacity:0, height: 0},
				{opacity:1, height: $expandedContent.outerHeight(), ease:Cubic.easeOut});
		}
		else {

			// correct wrapper

			let wrapperHeightFrom = $innerWrapper.outerHeight();
			TweenMax.set($innerWrapper, {clearProps:'height, y'});

			if(window.SETTINGS.breakpoint.minWidth('screen-large')){

				let wrapperHeightTo = $innerWrapper.outerHeight();
				$innerWrapper.css('height', wrapperHeightFrom);

				TweenMax.to($innerWrapper, 0.3, {y:0, height: wrapperHeightTo, ease:Cubic.easeOut});
			}
			else {

				let wrapperHeightTo = $textContent.outerHeight() - $expandedContent.outerHeight(true) + 160;
				$innerWrapper.css('height', wrapperHeightFrom);

				TweenMax.to($innerWrapper, 0.3, {y:0, height: wrapperHeightTo, ease:Cubic.easeOut});
			}

			// shrink content

			TweenMax.to($expandedContent, 0.3, {opacity:0, height: 0, ease:Cubic.easeOut});
		}
	}

	//

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){

		let $textBlock = this.$el.find('>.text-block');
		let $graphBlock = this.$el.find('>.graph-block');
		let $graph = $graphBlock.find('.vertical-graph');

		let textBlockHeight = $textBlock.outerHeight();
		let graphBlockHeight = $graphBlock.outerHeight();
		let graphHeight = Math.min(textBlockHeight, window.SETTINGS.coords.winHeight, graphBlockHeight - 160);

		if(window.SETTINGS.breakpoint.minWidth('screen-phablet') && window.SETTINGS.breakpoint.maxWidth('screen-large')){

			$graph.css({
				top: '',
				width: '',
				height: ''
			});

		} else if(window.SETTINGS.breakpoint.minWidth('screen-large')){

			let textBounds = window.utils.PositioningUtils.getScrollOffset($textBlock);

			$graph.css({
				top: `calc(50% - ${graphHeight/2}px)`,
				width: Math.min(textBounds.left, $graphBlock.outerWidth()),
				height: graphHeight
			});
		}

		// set proper text box height

		let $innerWrapper = this.$el.find('.text-block');
		let $textContent = this.$el.find('.text-content');
		let $description = this.$el.find('.description');
		let $expandedContent = this.$el.find('.expanded-content');

		if(this.$el.hasClass('is-expanded')){

			TweenMax.killTweensOf([$innerWrapper, $expandedContent]);
			TweenMax.set($expandedContent, {clearProps:'height'});

			let wrapperHeightFrom = $innerWrapper.outerHeight();

			if(window.SETTINGS.breakpoint.minWidth('screen-large')){
				if($textContent.outerHeight() >= $innerWrapper.outerHeight() - 160){
					let wrapperHeightTo = $textContent.outerHeight() + 160;
					TweenMax.set($innerWrapper, {y: 0, opacity: 1, height: wrapperHeightTo});
				}
			}
			else {
				if($textContent.outerHeight() >= $innerWrapper.outerHeight()){
					let wrapperHeightTo = $textContent.outerHeight();
					TweenMax.set($innerWrapper, 0.3, {y: Math.round((wrapperHeightFrom - wrapperHeightTo)/2), opacity: 1, height: wrapperHeightTo});
				}
			}

			TweenMax.set($expandedContent, {opacity: 1, height: $expandedContent.outerHeight()});
		}
		else {

			// reset wrapper

			TweenMax.killTweensOf([$innerWrapper, $expandedContent]);

			let wrapperHeightFrom = $innerWrapper.outerHeight();
			TweenMax.set($innerWrapper, {clearProps:'height, y'});

			if(window.SETTINGS.breakpoint.minWidth('screen-large')){

				let wrapperHeightTo = $innerWrapper.outerHeight();
				$innerWrapper.css('height', wrapperHeightFrom);

				TweenMax.set($innerWrapper, {y:0, height: wrapperHeightTo});
			}
			else {

				let wrapperHeightTo = $textContent.outerHeight() - $expandedContent.outerHeight(true) + 160;
				$innerWrapper.css('height', wrapperHeightFrom);

				TweenMax.set($innerWrapper, {y:0, height: wrapperHeightTo});
			}

			// shrink content

			TweenMax.set($expandedContent, {opacity: 0, height: 0});
		}
	}
}

module.exports = SplitReadMoreGraph;

},{"../../../../80_bits/vertical-graph/script":122,"../../../../90_utils/base/BaseModule":131}],77:[function(require,module,exports){
const BaseModule = require('../../../../90_utils/base/BaseModule');

class SplitTextStatImage extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$expandedContent;
		this.$window = $(window);
		this.$readMore = this.$el.find('.read-more');
		this.$mobilePhoto = this.$el.find('.mobile-photo');

		this.expandedContentId = 'expanded-content' + (++window.SETTINGS.vars.svgIndex);
		this.transitionDelay;
		this.isIn = false;
	}

	// basemodule methods

	_domReady(){

		let $template = this.$el.find('.expanded-content-template');
		if($template.length){

			this.$expandedContent = $($template.html());
			$template.remove();

			let templateObj = _.findWhere(window.SETTINGS.templates.modals, {id: 'empty'});

			if(templateObj){

				let modalTemplate = _.template(templateObj.template);
				let title = this.$el.find('.title').html();
				let description = this.$expandedContent.html();
				let readMoreURL = this.$expandedContent.attr('data-modal-read-more-url');
				let $modal = $(modalTemplate({
					id: this.expandedContentId,
					title: title,
					description: description,
					viewMoreLinkURL: readMoreURL
				}));

				$('#modal-templates').append($modal);
				$modal.attr('id', 'modal--' + this.expandedContentId);

				this.$el.attr('data-modaal-href', '#modal--' + this.expandedContentId);
				this.$readMore.attr('data-modaal-href', '#modal--' + this.expandedContentId);
				this.$readMore.modaal();
			}
		}
	}

	_addListeners(){
		this.$window.on('scroll', $.proxy(this._onScroll, this));
	}

	_removeListeners(){
		this.$window.off('scroll', $.proxy(this._onScroll, this));
	}

	_onScroll(){

		if(window.SETTINGS.breakpoint.maxWidth('screen-medium')){

			let scrollTop = this.$window.scrollTop();
			let bounds = window.utils.PositioningUtils.getScrollOffset(this.$mobilePhoto);
			let winHeight = window.SETTINGS.coords.winHeight;

			if((bounds.top < winHeight/2) || (bounds.height < winHeight && bounds.bottom < winHeight)){
				if((bounds.top < winHeight/3) || (bounds.height < winHeight && bounds.bottom <= winHeight)){
					if(!this.$el.hasClass('is-in')){
						this.$el.removeClass('is-in-slow');
						this.$el.addClass('is-in');
						this.isIn = true;

						if(this.transitionDelay){
							window.clearTimeout(this.transitionDelay);
						}
						this.transitionDelay = window.setTimeout(() => {
							this.$el.addClass('is-in-showing');
							this.transitionDelay = null;
						}, 50);
					}
				}
				else {
					if(!this.$el.hasClass('is-in-slow')){
						this.$el.removeClass('is-in');
						this.$el.addClass('is-in-slow');
						this.isIn = true;

						if(this.transitionDelay){
							window.clearTimeout(this.transitionDelay);
						}
						this.transitionDelay = window.setTimeout(() => {
							this.$el.addClass('is-in-showing');
							this.transitionDelay = null;
						}, 400);
					}
				}
			}
			else if(bounds.bottom < winHeight/4
				|| bounds.top > winHeight/4*3){

				if(this.isIn){
					this.$el.removeClass('is-in is-in-slow is-in-showing');
					this.isIn = false;

					if(this.transitionDelay){
						window.clearTimeout(this.transitionDelay);
						this.transitionDelay = null;
					}
				}
			}
		}
	}

	//

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){ }
}

module.exports = SplitTextStatImage;

},{"../../../../90_utils/base/BaseModule":131}],78:[function(require,module,exports){
const BaseModule = require('../../../../90_utils/base/BaseModule');

class StatBanner extends BaseModule {

	constructor(el, params) {

		super(el);
	}

	// basemodule methods

	_domReady(){ }

	_addListeners(){ }

	_removeListeners(){ }

	// listener methods

	_onReadMoreClick(e){
		e.preventDefault();
	}

	//

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){

	}

	_resize(){ }
}

module.exports = StatBanner;

},{"../../../../90_utils/base/BaseModule":131}],79:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],80:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],81:[function(require,module,exports){
const BaseModule = require('../../../../90_utils/base/BaseModule');
const FracturedGraph = require('../../../../80_bits/fractured-graph/script');

class FracturedGraphBlock extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$fracturedGraph = this.$el.find('.fractured-graph');
		this.fracturedGraph = new FracturedGraph(this.$fracturedGraph);

		this.$tabsContainer = this.$el.find('.tabs');
		this.$tabs = this.$tabsContainer.find('.tab');

		this.tabData = {};
		this.tabIndex = this.$tabs.find('>.is-active').index() >= 0 ? this.$tabs.find('>.is-active').index() : 0;

		this.isFirstBuild = true;
	}

	// basemodule methods

	_domReady(){
		this._rebuild();
	}

	_addListeners(){
		this.$tabs.on('click', this._onTabClick.bind(this));
	}
	_removeListeners(){ }

	// listener methods

	_onTabClick(e){

		let $target = $(e.currentTarget);
		this._rebuild($target.index());

		e.preventDefault();
	}

	//

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){

	}
	_resize(){}

	// graph construction

	_rebuild(newIndex){

		if(typeof(newIndex) === 'undefined'){ newIndex = this.tabIndex; }

		if(this.isFirstBuild || (newIndex >= 0 && newIndex < this.$tabs.length && newIndex !== this.tabIndex)){

			this.$tabs.removeClass('is-active');
			this.$tabs.eq(newIndex).addClass('is-active');

			this.tabIndex = newIndex;

			this._retrieveData();
			this._rebuildFrame();
		}
	}

	_retrieveData(){

		let $curTab = this.$tabs.eq(this.tabIndex);
		let $tabData = $curTab.find('.tab-data');

		this.tabData = {
			maxValue: $tabData.attr('data-max-value')
		};

		// center

		let $centerData = $tabData.find('.center');

		this.tabData.center = {
			value: $centerData.attr('data-value'),
			unit: $centerData.attr('data-unit'),
			subheader: $centerData.attr('data-subheader'),
			supheader: $centerData.attr('data-supheader')
		}

		// frame

		let $frameData = $tabData.find('.frame');

		if($frameData.length){

			this.tabData.frame = {
				title: $frameData.attr('data-title'),
				supheader: $frameData.attr('data-supheader'),
				subheader: $frameData.attr('data-subheader'),
				expandedCaption: $frameData.attr('data-expanded-caption')
			}
		}

		// data points

		let $dataPoints = $tabData.find('.data-point');
		this.tabData.dataPoints = [];

		$dataPoints.each((index, value) => {

			let $dataPoint = $(value);

			this.tabData.dataPoints.push({
				label: $dataPoint.attr('data-label'),
				subheader: $dataPoint.attr('data-subheader'),
				value: $dataPoint.attr('data-value')
			});
		});
	}

	_rebuildGraph(){
		if(this.tabData && this.tabData.dataPoints.length){
			this.fracturedGraph.swapData(this.tabData);
		}
	}

	_rebuildFrame(){

		if(this.tabData && this.tabData.frame){

			let frame = this.tabData.frame;
			let $elements = this.$el.find('.text-content >.title, .text-content >.supheader, .block-content >.subheader, .block-content >.disclaimer, .expanded-caption-wrapper, .fractured-graph');

			TweenMax.staggerTo($elements, 0.2, {
				opacity: 0,
				ease: 'fade'
			}, 0.05, ()=>{
				this.$el.find('.text-content >.title').html(frame.title || '');
				this.$el.find('.text-content >.supheader').html(frame.supheader || '');
				this.$el.find('.block-content >.subheader').html(frame.subheader || '');

				if(frame.expandedCaption){
					this.$el.find('.expanded-caption-wrapper').removeClass('is-hidden');
					this.$el.find('.expanded-caption .caption').html(frame.expandedCaption || '');
				}
				else {
					this.$el.find('.expanded-caption-wrapper').addClass('is-hidden');
				}

				this._rebuildGraph();

				let $elements = this.$el.find('.text-content >.title, .text-content >.supheader, .block-content >.subheader, .block-content >.disclaimer .expanded-caption-wrapper, .fractured-graph');

				TweenMax.staggerTo($elements, 0.4, {
					opacity: 1,
					ease: 'fade',
					clearProps: 'opacity'
				});
			})
		}
	}

	_showNewGraph(){

	}

	_hideOldGraph(){

	}
}

module.exports = FracturedGraphBlock;

},{"../../../../80_bits/fractured-graph/script":114,"../../../../90_utils/base/BaseModule":131}],82:[function(require,module,exports){
const BaseModule = require('../../../../90_utils/base/BaseModule');
const HorizontalGraph = require('../../../../80_bits/horizontal-graph/script');

class HorizontalGraphBlock extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$graph = this.$el.find('.horizontal-graph');
		this.graph = new HorizontalGraph(this.$graph);

		this.graphData = {};
		this.isFirstBuild = true;
	}

	// basemodule methods

	_domReady(){
		this._rebuild();
	}

	_addListeners(){ }
	_removeListeners(){ }

	//

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){ }

	// graph construction

	_rebuild(){

		if(this.isFirstBuild){
			this._retrieveData();
			this._rebuildGraph();
		}
	}

	_retrieveData(){
		// will need to rebuild if graph is ever in a tab
		// otherwise, graph itself will pull data
	}

	_rebuildGraph(){

		// graph will build itself - will need to re-enable if graph is ever in a tab

		// if(this.graphData && this.graphData.dataPoints.length){
		// 	this.graph.swapData(this.graphData);
		// }
	}

	_showNewGraph(){

	}

	_hideOldGraph(){

	}
}

module.exports = HorizontalGraphBlock;

},{"../../../../80_bits/horizontal-graph/script":116,"../../../../90_utils/base/BaseModule":131}],83:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],84:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],85:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],86:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],87:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],88:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],89:[function(require,module,exports){
const BaseModule = require('../../../../90_utils/base/BaseModule');

class StatBlock extends BaseModule {

	constructor(el, params) {

		super(el);
	}

	// basemodule methods

	_domReady(){

	}

	_addListeners(){ }
	_removeListeners(){ }

	//

	_show(){

		// let $statdata = this.$el.find('.stat-text--numeric');
		// let text = $statdata.text().replace(/,/g, "");
		// let data = parseInt(text);

		// if( !isNaN(data) ){
		// 	console.log(data);
		// }
	}
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){ }

}

module.exports = StatBlock;

},{"../../../../90_utils/base/BaseModule":131}],90:[function(require,module,exports){
const BaseModule = require('../../../../90_utils/base/BaseModule');
const VerticalGraph = require('../../../../80_bits/vertical-graph/script');

class VerticalGraphBlock extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$graph = this.$el.find('.vertical-graph');
		this.graph = new VerticalGraph(this.$graph);

		this.graphData = {};
		this.isFirstBuild = true;
	}

	// basemodule methods

	_domReady(){
		this._rebuild();
	}

	_addListeners(){ }
	_removeListeners(){ }

	//

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){ }

	// graph construction

	_rebuild(){

		if(this.isFirstBuild){
			this._retrieveData();
			this._rebuildGraph();
		}
	}

	_retrieveData(){
		// will need to rebuild if graph is ever in a tab
		// otherwise, graph itself will pull data
	}

	_rebuildGraph(){

		// graph will build itself - will need to re-enable if graph is ever in a tab

		// if(this.graphData && this.graphData.dataPoints.length){
		// 	this.graph.swapData(this.graphData);
		// }
	}

	_showNewGraph(){

	}

	_hideOldGraph(){

	}
}

module.exports = VerticalGraphBlock;

},{"../../../../80_bits/vertical-graph/script":122,"../../../../90_utils/base/BaseModule":131}],91:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],92:[function(require,module,exports){
// action

const ClickToPlayVideo = require('./action/content-blocks/click-to-play-video/script');
const ExpandingPhotoCols = require('./action/content-blocks/expanding-photo-cols/script');
const IconStats = require('./action/content-blocks/icon-stats/script');
const ReadMoreText = require('./action/content-blocks/read-more-text/script');
const ScrollOverlaySlides = require('./action/content-blocks/scroll-overlay-slides/script');
const ScrollSplitSlides = require('./action/content-blocks/scroll-split-slides/script');
const SplitReadMoreGraph = require('./action/content-blocks/split-read-more-graph/script');
const SplitTextStatImage = require('./action/content-blocks/split-text-stat-image/script');
const StatBanner = require('./action/content-blocks/stat-banner/script');

// impact

const FracturedGraphBlock = require('./impact/content-blocks/fractured-graph-block/script');
const HorizontalGraphBlock = require('./impact/content-blocks/horizontal-graph-block/script');
const VerticalGraphBlock = require('./impact/content-blocks/vertical-graph-block/script');
const StatBlock = require('./impact/content-blocks/stat-block/script');

// vision

const CEOHero = require('./vision/ceo-hero/script');
const Mission = require('./vision/mission/script');
const Quote = require('./vision/quote/script');

//

window.SETTINGS.domScan.addContainer( null, ($scanContainer) => {

	window.SETTINGS.domScan.addElement($scanContainer, '[data-click-to-play-video]', function () {
		new ClickToPlayVideo($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-expanding-photo-cols]', function () {
		new ExpandingPhotoCols($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-icon-stats]', function () {
		new IconStats($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-read-more-text]', function () {
		new ReadMoreText($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-scroll-overlay-slides]', function () {
		new ScrollOverlaySlides($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-scroll-split-slides]', function () {
		new ScrollSplitSlides($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-split-read-more-graph]', function () {
		new SplitReadMoreGraph($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-split-text-stat-image]', function () {
		new SplitTextStatImage($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-stat-banner]', function () {
		new StatBanner($(this));
	});

	// vision

	window.SETTINGS.domScan.addElement($scanContainer, '[data-ceo-hero]', function() {
		new CEOHero(this, {});
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-mission]', function() {
		new Mission(this, {});
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-quote]', function() {
		new Quote(this, {});
	});

	// impact

	window.SETTINGS.domScan.addElement($scanContainer, '[data-fractured-graph-block]', function () {
		new FracturedGraphBlock($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-horizontal-graph-block]', function () {
		new HorizontalGraphBlock($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-stat-block]', function () {
		new StatBlock($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-vertical-graph-block]', function () {
		new VerticalGraphBlock($(this));
	});
});

},{"./action/content-blocks/click-to-play-video/script":68,"./action/content-blocks/expanding-photo-cols/script":69,"./action/content-blocks/icon-stats/script":71,"./action/content-blocks/read-more-text/script":73,"./action/content-blocks/scroll-overlay-slides/script":74,"./action/content-blocks/scroll-split-slides/script":75,"./action/content-blocks/split-read-more-graph/script":76,"./action/content-blocks/split-text-stat-image/script":77,"./action/content-blocks/stat-banner/script":78,"./impact/content-blocks/fractured-graph-block/script":81,"./impact/content-blocks/horizontal-graph-block/script":82,"./impact/content-blocks/stat-block/script":89,"./impact/content-blocks/vertical-graph-block/script":90,"./vision/ceo-hero/script":93,"./vision/mission/script":94,"./vision/quote/script":95}],93:[function(require,module,exports){
const BaseModule = require('../../../90_utils/base/BaseModule');

class CEOHero extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$expandedInfo = this.$el.find('.expanded-info');
	}

	// basemodule methods

	_domReady(){
	}

	_addListeners(){
		this.$el.find('.goop-button').on('click', this._onClick.bind(this));
	}

	_removeListeners(){

	}

	//

	_onClick(e){
		this.toggle();
	}

	_onOut(e){
		if(!this.$expandedInfo[0].contains(e.target)){
			this.toggle(false);
		}
	}

	//

	toggle(value){

		if(value === true){
			this.$el.addClass('is-expanded');
		}
		else if(value === false){
			this.$el.removeClass('is-expanded');
		}
		else {
			this.$el.toggleClass('is-expanded');
		}

		$('#main').off('click', $.proxy(this._onOut, this));

		if(this.$el.hasClass('is-expanded')){
			window.requestAnimationFrame(() => {
				$('#main').on('click', $.proxy(this._onOut, this));
			});
		}
	}

	//

	_show(){}

	_hide(){}

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }

	_resize(){

		let $textContent = this.$el.find('.text-content');
		let $contentWrapper = this.$el.find('.content-wrapper');
		let $expandedInfo = this.$el.find('.expanded-info');

		if(window.SETTINGS.breakpoint.minWidth('screen-small')){

			TweenMax.set([$textContent, $contentWrapper, $expandedInfo], {clearProps: 'all'});

			let textHeight = $textContent.outerHeight();
			let winHeight = window.SETTINGS.coords.winHeight;

			if(textHeight + 160 > winHeight){
				$contentWrapper.css('height', textHeight + 160);
			}
			else {
				$contentWrapper.css('height', '');
			}
		}
		else if(window.SETTINGS.breakpoint.minWidth('screen-phablet') && window.SETTINGS.breakpoint.maxWidth('screen-small')){

			TweenMax.set([$textContent, $contentWrapper, $expandedInfo], {clearProps: 'all'});

			let textHeight = $textContent.outerHeight();

			$expandedInfo.css({
				top: `calc(50% - ${Math.round((textHeight + 160)/2)}px`,
				height: textHeight + 160
			});
		}
		else {
			TweenMax.set([$textContent, $contentWrapper, $expandedInfo], {clearProps: 'all'});
		}
	}
}

module.exports = CEOHero;

},{"../../../90_utils/base/BaseModule":131}],94:[function(require,module,exports){
const BaseModule = require('../../../90_utils/base/BaseModule');

class Mission extends BaseModule {

	constructor(el, params){

		super(el);

		this.$logos = this.$el.find('.logos .logo');
		this.interval;
	}

	_domReady(){

		this.$arrows = this.$el.find('svg #right-arrow, svg #left-arrow');
		this.$el.find('.logo').addClass('is-out');
	}

	_addListeners(){
		this.$el.find('.logo a').on('click', $.proxy(this._onButtonClick, this));
		this.$el.find('.logo a').on('mouseenter', $.proxy(this._onButtonClick, this));
		this.$el.find('.logo a').on('mouseleave', $.proxy(this._onButtonLeave, this));
	}

	_removeListeners(){
		this.$el.find('.logo a').off('click', $.proxy(this._onButtonClick, this));
		this.$el.find('.logo a').off('mouseenter', $.proxy(this._onButtonHover, this));
		this.$el.find('.logo a').off('mouseleave', $.proxy(this._onButtonLeave, this));
		$('body').off('click', $.proxy(this._onOut, this));
	}

	//

	_onButtonClick(e){

		e.stopImmediatePropagation();

		let $target = $(e.currentTarget);
		let $logo = $target.closest('.logo');

		this.$logos.each((index, value) => {
			let $value = $(value);
			if($value[0] !== $logo[0]){
				$value.removeClass('is-active is-out');
			}
		});

		if($logo.hasClass('is-active')){
			$logo.removeClass('is-active is-out');
		}
		else {
			$logo.addClass('is-active');
			$logo.removeClass('is-out');
		}

		window.SETTINGS.animationFrame.one(() => {
			$('body').off('click', $.proxy(this._onOut, this));
			$('body').on('click', $.proxy(this._onOut, this));
		});
	}

	_onButtonLeave(e){

		if(e.stopImmediatePropagation){
			e.stopImmediatePropagation();
		}

		let $target = $(e.currentTarget);
		let $logo = $target.closest('.logo');

		$logo.addClass('is-out');
		$logo.removeClass('is-active');

		$('body').off('click', $.proxy(this._onOut, this));
	}

	_onOut(e){
		e.stopImmediatePropagation();
		this._onButtonLeave({currentTarget:this.$el.find('.is-active')});
	}

	//

	_show(){

		// arrows animation

		/*

		let $arrowright = this.$el.find('svg #arrow-right');
		let $arrowrightstem = $arrowright.find('path');
		let $arrowrightcap = $arrowright.find('polyline');
		let arrowrightStemLen = $arrowrightstem.get(0).getTotalLength();
		let arrowrightCapLen = $arrowrightcap.get(0).getTotalLength();

		let $arrowleft = this.$el.find('svg #arrow-left');
		let $arrowleftstem = $arrowleft.find('path');
		let $arrowleftcap = $arrowleft.find('polyline');
		let arrowleftStemLen = $arrowleftstem.get(0).getTotalLength();
		let arrowleftCapLen = $arrowleftcap.get(0).getTotalLength();

		$arrowrightstem.attr({ 'stroke-dasharray': arrowrightStemLen, 'stroke-dashoffset': arrowrightStemLen });
		$arrowleftstem.attr({ 'stroke-dasharray': arrowleftStemLen, 'stroke-dashoffset': (arrowleftStemLen * -1) });

		// TweenMax.set($arrowleftcap, { opacity: 0 });
		// TweenMax.set($arrowrightcap, { opacity: 0 });

		let tweenObjLeft = { len: (arrowleftStemLen * -1) };
		let tweenObjRight = { len: (arrowrightStemLen * -1) };

		TweenMax.to(tweenObjLeft, 2.5, {
			len: arrowleftStemLen,
			ease: 'fade',
			repeat: -1,
			onUpdate: ()=>{
				$arrowleftstem.attr({ 'stroke-dashoffset': tweenObjLeft.len });
			},
			onRepeat: ()=>{
				$arrowleftstem.attr({ 'stroke-dasharray': arrowleftStemLen, 'stroke-dashoffset': (arrowleftStemLen * -1) });
			}
		});

		// TweenMax.to($arrowleftcap, 0.6, {
		// 	opacity: 1,
		// 	ease: 'fade',
		// 	yoyo: true,
		// 	repeat: -1,
		// 	repeatDelay: 0.5
		// });

		//

		TweenMax.to(tweenObjRight, 2.5, {
			len: arrowrightStemLen,
			ease: 'fade',
			repeat: -1,
			onUpdate: ()=>{
				$arrowrightstem.attr({ 'stroke-dashoffset': tweenObjRight.len });
			},
			onRepeat: ()=>{
				$arrowrightstem.attr({ 'stroke-dasharray': arrowrightStemLen, 'stroke-dashoffset': arrowrightStemLen });
			}
		});

		// TweenMax.to($arrowrightcap, 0.6, {
		// 	opacity: 1,
		// 	ease: 'fade',
		// 	yoyo: true,
		// 	repeat: -1,
		// 	repeatDelay: 0.5
		// });

		*/
	}
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){ }
}

module.exports = Mission;

},{"../../../90_utils/base/BaseModule":131}],95:[function(require,module,exports){
const BaseModule = require('../../../90_utils/base/BaseModule');

class CEOHero extends BaseModule {

	constructor(el, params) {

		super(el);
	}

	// basemodule methods

	_domReady(){ }

	_addListeners(){ }

	_removeListeners(){ }

	//

	_show(){

		let $lines = this.$el.find('.overline, .underline');

		TweenMax.set($lines, { scaleX: 0, transformOrigin: 'center' });

		TweenMax.staggerTo($lines, 0.4, {
			scaleX: 1,
			ease: 'progressSlide'
		}, 0.2);
	}

	_hide(){}

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }

	_resize(){ }
}

module.exports = CEOHero;

},{"../../../90_utils/base/BaseModule":131}],96:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],97:[function(require,module,exports){
window.SETTINGS.domScan.addContainer( null, ($scanContainer) => {

	window.SETTINGS.domScan.addElement($scanContainer, '[data-modal-link]', function(){

		let openScrollPos;

		let player = null;
		let plyrInstance = null;
		let $target = $(this);
		let $closeModalGoop;

		let args = {
			before_open: function(){

				window.vent.trigger('closeModal');
				window.vent.trigger('modalOpen');

				openScrollPos = $(window).scrollTop();

				$('body').addClass('no-scroll');

				TweenMax.set($('#main .main-inner-wrapper'), {y:-openScrollPos});
				TweenMax.set($('#primary-content-wrapper'), {width: window.SETTINGS.coords.docWidth});
				TweenMax.set($('.is-fixed'), {y: openScrollPos});
			},
			// if video
			after_open: function(){

				let $modal = $('.modaal-wrapper');
				let $plyr = $modal.find('.modal-video-player .plyr-video');

				if ( $plyr.length ) {

					let $modalVideoPlayer = $modal.find('.modal-video-player');
					let $player           = $plyr.find('.player');
					let $domData          = $plyr.find('.dom-data');
					let controlsTemplate  = $plyr.find('#plyr__controls_template').html();
					let id                = $domData.attr('data-plyr-video-id');
					let provider          = $domData.attr('data-plyr-video-provider');
					let autostart         = $domData.attr('data-plyr-autostart') === 'true';

					$player.attr('data-type', provider);
					$player.attr('data-video-id', id);

					if(window.SETTINGS.breakpoint.maxWidth('screen-medium')){
						autostart = false;
					}

					player = plyr.setup($plyr, {
						clickToPlay: false,
						disableContextMenu: true,
						hideControls: false,
						html: controlsTemplate,
						autoplay: autostart
					});

					player[0].on('ready', (e) => {

						plyrInstance = e.detail.plyr;

						plyrInstance.on('playing', (e) => {
							console.log("is playing", $player.find('.plyr__controls'));
							$modalVideoPlayer.find('.plyr__controls').addClass('is-playing');
						});
					});
				}

				$('.modaal-wrapper .close-modal').off('click');
				$('.modaal-wrapper .close-modal').on('click', () => {
					window.vent.trigger('closeModal');
				});

				window.vent.trigger('domUpdate');
				$closeModalGoop = $('.modaal-wrapper .close-modal-goop .close-modal');
			},
			before_close: function() {

				if(plyrInstance){
					plyrInstance.destroy();
				}

				console.log('>>> player removed');

				$('body').css('cursor', '');
			},
			after_close: function() {

				$('body').removeClass('no-scroll');

				TweenMax.set($('#main .main-inner-wrapper'), {clearProps:'y'});
				TweenMax.set($('#primary-content-wrapper'), {clearProps:'width'});
				TweenMax.set($('.is-fixed'), {clearProps: 'y'});
				$(window).scrollTop(openScrollPos);

				window.vent.trigger('modalClose');
			}
		};

		let onCloseModal = () => {
			if($('.modaal-wrapper').length){
				$target.modaal('close');
			}
		}

		window.vent.on('changePageContent', onCloseModal, this);
		window.vent.on('closeModal', onCloseModal, this);

		if ( $target.attr('data-modal-args') ) {

			let lamma = $target.attr('data-modal-args').split(',');

			for ( let l of lamma ) {
				let str = l.split(':');
				args[str[0]] = str[1];
			}
		}

		$target.attr('data-modaal-href', '#modal--' + $target.attr('data-modal-link'));
		$target.modaal(args);

		$('.close').on('click', function(e){
			if($target && $target.length){
				$target.modaal('close');
			}
		});

	});

	/*

	window.SETTINGS.domScan.addElement($scanContainer, '[data-inline-popup]', function(){

		let $this		= $(this);
		let $fixedElems	= $('#header, #mobile-header, .affix');
		let regWinWidth	= 0;
		let modalId 	= $this.attr('href').substr(1);

		// resize handler for width shifts in fixed elements

		window.vent.on('windowResize', onWindowResize);
		onWindowResize();

		function onWindowResize(){
			regWinWidth = window.SETTINGS.coords.winWidth;
		}

		// track which modal has been opened for modal trigger button

		$this.on('click', function(e){

			window.SETTINGS.vars.$modalTriggerButton = $this;

			if(typeof($this.attr('data-modal-link-back')) !== 'undefined'){
				window.SETTINGS.vars.$modalOriginTriggerButton = $('[href=\"#' + $this.attr('data-modal-link-back') +  '\"]').eq(0);
			}

			window.requestAnimationFrame(function(){
				window.vent.trigger('windowResize');
			});
		});

		//

		$this.magnificPopup({

			overflowY: 'scroll', // as we know that popup content is tall we set scroll overflow by default to avoid jump, mostly in cases of modals in short windows cutting off the close btn if placed outside the modal
			// removalDelay: 500, //delay removal by X to allow out-animation
			midClick: true, // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.

			fixedContentPos: true,

			callbacks: {

				beforeOpen: function(e) {

					let attr			= this.st.el.attr('data-effect');
					this.st.mainClass	= typeof attr !== typeof undefined && attr !== false ? attr : 'mfp-fade-in';

					window.vent.trigger('modalBeforeOpen', {$target: $this, modalId:modalId});
				},

				open: function() {

					let $content = this.content;

					$fixedElems.css({'width': 'calc(100% - ' + (window.innerWidth - regWinWidth) + 'px)'});

					window.vent.trigger('modalOpen', {$target: $content, modalId: modalId, $link: $this});
					window.vent.trigger('domUpdate', {$scanContainer: $content});
					window.vent.trigger('windowResize', {$scanContainer: $content});
				},

				beforeClose: function () {

				},

				close: function() {

					let $this = this.content;

					$fixedElems.css({'width': ''});

					window.vent.trigger('modalClose', {$target: $this, modalId:modalId});
				},

				afterClose:function(){
					window.vent.trigger('modalAfterClose', {$target: $this, modalId:modalId});
				}
			}
		});

	});

	// compare modal

	window.SETTINGS.domScan.addElement($scanContainer, '.mfp-close', function(){

		$(this).on('click', () => {
			$.magnificPopup.close();
		});
	});

	*/

});

},{}],98:[function(require,module,exports){
class Accordion {

	constructor(el) {
		this.$el       = el;
		this.$toggles  = el.find('> * > .accordion--toggle');
		this.$contents = el.find('> * > .accordion--content');
		this.$window   = $(window);

		this.heights   = [];
		this.isOpen    = [];

		this.openClass = 'is-open';

		this.measure();
		this.addEventListeners();
	}

	measure() {
		this.heights = [];

		for (let e of this.$contents) {
			this.heights.push($(e).find('> div, > ul').outerHeight(true));
		}
	}

	setHeight(index, height = 0) {
		this.$contents.eq(index).css({'height': height});
	}

	open(index) {
		this.isOpen.push(index);
		this.$toggles.eq(index).parent().addClass(this.openClass);

		if (!this.heights[index]) {
			this.measure();
		}

		this.setHeight(index, this.heights[index]);
	}

	close(index) {
		this.isOpen = this.isOpen.filter(value => {
			return value != index;
		});

		this.$toggles.eq(index).parent().removeClass(this.openClass);
		this.setHeight(index);
	}

	togglesOnClick(e) {
		let $el   = $(e.currentTarget),
			index = $el.parent().index();

		$el.parent().hasClass(this.openClass) ? this.close(index) : this.open(index);
	}

	windowOnResize() {
		this.measure();
		for (let index of this.isOpen) {
			this.setHeight(index, this.heights[index]);
		}
	}

	addEventListeners() {
		this.togglesOnClick = this.togglesOnClick.bind(this);
		this.windowOnResize = this.windowOnResize.bind(this);

		this.$toggles.on('click', this.togglesOnClick);
		this.$window.on('resize', this.windowOnResize);
	}

	removeEventListeners() {
		this.$toggles.off('click', this.togglesOnClick);
		this.$window.off('resize', this.windowOnResize);
	}

}

module.exports = Accordion;

},{}],99:[function(require,module,exports){
// alerts

window.SETTINGS.domScan.addContainer( null, ($scanContainer) => {

	window.SETTINGS.domScan.addElement($scanContainer, '[data-alert]', function(){

		var $this = $(this);

		$this.on('click', '[data-alert-close]', function(e){
			$this.fadeTo(300, 0.001).slideUp();
		});

	});

});

},{}],100:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class AutoRotator extends BaseModule {

	constructor(el, params) {

		super(el);

		// param defaults

		this.defaults = {
			slideDelay: 			4, // seconds
			introDelay: 			0.5, // seconds
			elementId: 				'data-ar-item'
		};

		this.updateParams(params);

		// vars

		this.$activeSlide;

		this._isPaused = false;
		this._isHoverPaused = false;

		this._interval;
		this._introTimeout;
	}

	updateParams(params){

		this.params = params || {};

		this.slideDelay = parseFloat(this.checkVal(this.params.slideDelay, this.defaults.slideDelay));
		this.introDelay = parseFloat(this.checkVal(this.params.introDelay, this.defaults.introDelay));
		this.elementId = this.checkVal(this.params.elementId, this.defaults.elementId);
	}

	// private methods

	_domReady(){

		this.$slides = this.$el.find('[' + this.elementId + ']');
		this.resume();

		super._domReady();
	}

	_addListeners(){

		if(!this._isListening){

			this._isListening = true;

			this.$el.on('mouseenter', this._onOver.bind(this));
			this.$el.on('mouseleave', this._onOut.bind(this));
		}

		super._addListeners();
	}

	_removeListeners(){

		if(this._isListening){

			this._isListening = false;

			this.$el.off('mouseenter', this._onOver.bind(this));
			this.$el.off('mouseleave', this._onOut.bind(this));
		}

		super._removeListeners();
	}

	// element event listeners

	_onOver(){
		this.pause(true);
	}

	_onOut(){
		this.resume(true);
	}

	// pause / resume slideshow

	pause(fromHover){

		if(!this._isPaused){

			if(fromHover && !this._isHoverPaused){
				this._isPaused = true;
				this._isHoverPaused = true;
			}
			else if(!fromHover && !this._isHoverPaused) {
				this._isPaused = true;
				this._isHoverPaused = false;
			}
		}

		if(this._isPaused){
			this.clearInterval();
		}
	}

	resume(fromHover){

		if(this._isPaused){

			if(fromHover && this._isHoverPaused){
				this._isPaused = false;
				this._isHoverPaused = false;
			}
			else if(!fromHover && !this._isHoverPaused) {
				this._isPaused = false;
				this._isHoverPaused = false;
			}
		}

		if(!this._isPaused){
			this.resetInterval();
		}
	}

	//

	resetInterval(){

		if(this._interval){ this.clearInterval(); }
		this._interval = window.setInterval(this.		tick.bind(this), this.slideDelay * 1000);

		if(!this.$activeSlide || !this.$activeSlide.length){ this.tick(); }
	}

	clearInterval(){

		if(this._interval){
			window.clearInterval(this._interval);
			this._interval = null;
		}
	}

	//

	tick(){

		let index = this.$activeSlide && this.$activeSlide.length ? this.$activeSlide.index() : -1;
		let nextIndex = window.utils.NumberUtils.getRangeIndex(index+1, 0, this.$slides.length, true);
		let $nextSlide = this.$slides.eq(nextIndex);

		if(this.$activeSlide){ this.$activeSlide.removeClass('is-active'); }

		this.$activeSlide = $nextSlide;

		// interval

		if(this._introTimeout){ window.clearTimeout(this._introTimeout); }

		this._introTimeout = window.setTimeout(() => {
			this.$activeSlide.addClass('is-active');
			this._introTimeout = null;
		}, this.introDelay * 1000);
	}

	//

	_domUpdate(){ } // use me!
	_resize(){ } // use me!
}

module.exports = AutoRotator;

},{"../../90_utils/base/BaseModule":131}],101:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class ColorSelector extends BaseModule {

	constructor(el, params) {

		super(el);

		// element vars

		this.$thumbs = this.$el.find('li[data-color]');

		this.$currentColor = null;
		this.$currentColorTitle = this.$el.find('[data-current-color-title]');
	}

	// private methods

	_domReady(){
		super._domReady();
	}

	_addListeners(){

		if(!this._isListening){

			this._isListening = true;

			//

			this.$thumbs.on('mouseenter', this._onThumbOver.bind(this));
			this.$thumbs.on('mouseleave', this._onThumbOut.bind(this));
			this.$thumbs.on('activate', this._onThumbActivate.bind(this));

			this.$currentColor = this.$thumbs.find('.is-active');

			if(this.$currentColor.length){
				this._changeColorByThumb(this.$currentColor);
			}
			else {
				this.$currentColor = this.$thumbs.eq(0);
				this._changeColorByThumb(this.$thumbs.eq(0));
			}
		}

		super._addListeners();
	}

	_removeListeners(){

		if(this._isListening){
			this._isListening = false;
		}

		super._removeListeners();
	}

	// element event listeners

	_onThumbOver(e){
		let $target = $(e.currentTarget);
		this._changeColorByThumb($target);

	}

	_onThumbOut(e){
		this._changeColorByThumb(this.$currentColor);
	}

	_onThumbActivate(e){

		let $target = $(e.currentTarget);

		this.$currentColor = $target;
		this._changeColorByThumb($target);

		this.$el.triggerHandler('select', e);
		this.$el.triggerHandler('activate', e);
	}

	//

	_resize(){

	}

	// change color

	_changeColorByThumb($target){

		let color = $target.attr('data-color-title');
		this.$currentColorTitle.html(color);
	}
}

module.exports = ColorSelector;

},{"../../90_utils/base/BaseModule":131}],102:[function(require,module,exports){
class CursorZoom {

	constructor($el, $container) {

		this.$el = $el;
		this.$container = $container;

		//

		this.$inner = this.$el.find('.cursor-zoom--inner');
		this.$outer = this.$el.find('.cursor-zoom--outer');

		this._frameStep;
		this._shakeInterval;
		this._lastX;
		this._lastY;

		//

		$(() => {
			this._onDomReady();
		});
	}

	//

	_onDomReady(){
		this._addListeners();
	}

	//

	_addListeners(){

		this.$container.on('mouseenter', this._onPhotoOver.bind(this));
		this.$container.on('mouseleave', this._onPhotoOut.bind(this));
		this._tick(true); // start following mouse
	}

	//

	_onPhotoOver(){
		this.enable();
	}

	_onPhotoOut(){
		this.disable();
	}

	//

	enable(){

		if(!this._shakeInterval){
			this._shakeInterval = window.setInterval(() => {
				this._shake();
			}, window.SETTINGS.frameInterval);
		}

		// this._tick(true); // start loop
		this.$el.addClass('is-active');
	}

	disable(){

		if(this._shakeInterval){
			window.clearInterval(this._shakeInterval);
			this._shakeInterval = null;
		}

		// this._frameStep = false; // kill loop
		this.$el.removeClass('is-active');

		TweenMax.set([this.$outer, this.$inner], {clearProps:'x, y, rotation, scale, force3D'});
	}

	//

	_tick(frameStep){

		if(typeof(frameStep) === 'boolean'){ this._frameStep = frameStep; }

		if(this._frameStep){
			this._moveCursor();
			window.requestAnimationFrame(this._tick.bind(this, null));
		}
	}

	_moveCursor(){

		let pageX = window.SETTINGS.coords.pageX;
		let pageY = window.SETTINGS.coords.pageY;
		let bounds = window.utils.PositioningUtils.getExtendedOffset(this.$container);

		if(!isNaN(pageX) && !isNaN(pageY)){

			TweenMax.set(this.$el, {x:pageX - bounds.left, y:pageY - bounds.top});

			if(isNaN(this._lastX) || isNaN(this._lastY)){
				this._lastX = pageX;
				this._lastY = pageY;
			}
		}

		// if(!isNaN(this._lastX) && !isNaN(this._lastY)){

		// 	let delta = (pageX - this._lastX) * (pageY - this._lastY);
		// 	let multiplier = 0.5;

		// 	TweenMax.set(this.$inner, {rotation: delta * multiplier});

		// 	this._lastX = pageX;
		// 	this._lastY = pageY;
		// }
	}

	_shake(shakeIntensity){

		if(!shakeIntensity){ shakeIntensity = 1; }

		let rotationIntensity = shakeIntensity * 5;

		TweenMax.set(this.$outer, {
			x:shakeIntensity/2 - Math.random() * shakeIntensity,
			y:shakeIntensity/2 - Math.random() * shakeIntensity,
			rotation: rotationIntensity/2 - Math.random() * rotationIntensity
		});

		this._shakeIndex++;
	}

	//
}

module.exports = CursorZoom;

},{}],103:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class ImageSwappable extends BaseModule {

	constructor(el, params) {

		super(el);

		// flags

		this._isListening = false;

		// element vars

		this.$currentImage = this.$el.find('.double-wrap');
		this.$nextImage;

		this.imageLoading;
		this.nextImageURL;
	}

	// private methods

	_addListeners(){

		if(!this._isListening){

			this._isListening = true;
			this.$el.on('swap', this._onSwap.bind(this));
		}

		super._addListeners();
	}

	_removeListeners(){

		if(this._isListening){

			this._isListening = false;

		}

		super._removeListeners();
	}

	// listener methods

	_onSwap(e, obj){
		console.log("swap image", e, obj);
	}

	_swapImage(imageURL, delta){

		if(delta !== 1 || delta !== -1){ delta = 1; }

		if(!this.imageLoading || (this.imageLoading && this.nextImageURL != imageURL)){

		}
	}
}

module.exports = ImageSwappable;

},{"../../90_utils/base/BaseModule":131}],104:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');
const CursorZoom = require('../../70_ui/cursor-zoom/script');
const WigglePhoto = require('../../70_ui/wiggle-photo/script');

class ImageZoom extends BaseModule {

	constructor(el) {

		super(el);

		//

		this._wigglePhoto;
		this._cursor;

		this.$image;
		this.$fullImage;
		this.imageLoading;
	}

	// add/remove listeners

	_addListeners(){

		super._addListeners();

		this.$el.on('click', this._onClick.bind(this));
	}

	_removeListeners(){
		super._removeListeners();
	}

	// global listener methods

	_domReady(){

		super._domReady();

		this.$image = this.$el.find('.image--low-res');
		this.$fullImage = this.$el.find('.image--high-res');
	}

	_resize(){

	}

	// local listener methods

	_onClick(){
		this.hide();
	}

	_onContainerOver(){
		this._cursor.enable();
	}

	_onContainerOut(){
		this._cursor.disable();
	}

	//

	_enableModules(){

		// wiggle photos

		if(!this._wigglePhoto){

			let $photo = this.$el.find('.images-wrapper');
			let $doubleWrap = this.$el.find('.double-wrap');

			this._wigglePhoto = new WigglePhoto($doubleWrap, $photo, $doubleWrap, $doubleWrap);

		}
		else { this._wigglePhoto.enable(); }

		// cursor

		if(!this._cursor){

			let $cursor = this.$el.find('[data-cursor-zoom]');

			if($cursor.length){

				this.$el.on('mouseenter', this._onContainerOver.bind(this));
				this.$el.on('mouseleave', this._onContainerOut.bind(this));

				this._cursor = new CursorZoom($cursor, this.$el);
			}
			else { this._cursor.enable(); }
		}
	}

	_disableModules(){

		if(this._wigglePhoto){ this._wigglePhoto.disable(); }
		if(this._cursor){ this._cursor.disable(); }
	}

	// image loading

	_loadImages(imageURL, fullImageURL){

		this.$image.css('background-image', 'url("' + imageURL + '")');

		this.$fullImage.css('background-image', 'url("' + fullImageURL + '")');
	}

	//

	show(imageURL, fullImageURL){

		super.show();

		this.$el.addClass('is-active');
		this._enableModules();
		this._loadImages(imageURL, fullImageURL);
	}

	hide(){

		super.hide();

		this.$el.removeClass('is-active');
		this._disableModules();
	}

	//
}

module.exports = ImageZoom;


/*

class PDPZoom {

	constructor($el, $container) {

		var $this				= $(this);
		var $cursor				= $this.find('.cursor');
		var $backButton			= $this.find('.back-btn');
		var $productImages		= $this.find('.product-image');
		var $thumbnails			= $this.find('.thumbnails');
		var $swatches			= $this.find('.swatch');
		var $activeImages		= $this.find('.active-images');
		var $currentImage		= $activeImages.find('.is-active');
		var $currentImgWrapper	= $activeImages.find('.is-active .img-wrapper');
		var $zoomImage 			= null;

		// image setting

		var colorIndex			= $this.find('.swatch.is-active').index();
		var imageRatio			= 1;
		var isImageFixed		= null;
		var isVideo				= false;
		var isIsolated			= false;

		// zoom settings

		var isCursorInit		= false;
		var isZoomed			= false;
		var isZoomComplete		= false;

		var zoomFactor			= 2;
		var zoomFactorDefault 	= 2;
		var initialZoomX		= null;
		var initialZoomY		= null;
		var initialZoomXRatio	= null;
		var initialZoomYRatio	= null;
		var zoomWidthDiff		= null;
		var zoomHeightDiff		= null;
		var productImageXOffset = 0;

		var lastShiftX			= 0;
		var lastShiftY			= 0;

		// bounds

		var backBounds			= null;
		var thumbBounds			= null;

		// cursor position / size variables

		var cursorWidth			= null;
		var cursorHeight		= null;
		var cursorHWidth		= null;
		var cursorHHeight		= null;
		var cursorX				= null;
		var cursorY				= null;
		var lastCursorX			= null;
		var lastCursorY			= null;

		// visibility state

		var currentStateId		= null;
		var untoggledStateId	= null;

		// window vars

		var docWidth 			= null;
		var winWidth			= null;
		var winHeight			= null;
		var containerOffset		= null;
		var containerWidth		= null;
		var containerHeight		= null;
		var viewportHeight		= null;

		//

		if($cursor.find('svg').length){
			initCursor();
		}
		else {
			$cursor.find('.svg').on('complete', initCursor.bind($this));
		}

		zoomFactor = parseFloat($currentImage.data('zoom-factor') || zoomFactorDefault);

		// listeners

		$this.on('mousemove', onMouseMove);
		$this.on('click', onClick);

		$thumbnails.on('thumbSelected', onThumbSelected);
		$swatches.on('click', onSwatchClicked);
		$this.find('.add-cart').on('click', onAddCartClick);

		$this.find('.dd-size-selector').on('change', onAddCartClick);
		$this.find('.dd-size-selector').on('selectEnabled', onSelectEnabled);
		$this.find('.dd-size-selector').on('selectDisabled', onSelectDisabled);

		$(window).on('hashchange', onHashChange);
		$(window).on('scroll', onScroll);
		window.vent.on('windowResize', onWindowResize);

		// ajax load init events
		window.vent.on('variationLoad', function() {
			$activeImages = $this.find('.active-images');
			$currentImage = $activeImages.find('.is-active');
			$currentImgWrapper = $activeImages.find('.is-active .img-wrapper');
			$cursor = $this.find('.cursor');
			$details = $this.find('.details');
			$productImages = $this.find('.product-image');
			$thumbnails = $this.find('.thumbnails');

			isImageFixed = null;

			$this.find('.dd-size-selector').on('change', checkErrorStatus);
			$this.find('.dd-size-selector').on('selectEnabled', onSelectEnabled);
			$this.find('.dd-size-selector').on('selectDisabled', onSelectDisabled);

			if($cursor.find('svg').length){
				initCursor();
			}
			else {
				$cursor.find('.svg').on('complete', initCursor.bind($this));
			}
			onWindowResize();
		});

		window.vent.on('mainImageSwap', function() {
			$activeImages = $this.find('.active-images');
			$currentImage = $activeImages.find('.is-active');
			$currentImgWrapper = $activeImages.find('.is-active .img-wrapper');
			$thumbnails = $this.find('.thumbnails');
			onWindowResize();
		});

		if(window.Resources === 'undefined') {
			checkHash();
		}

		onWindowResize();

		//

		if($currentImage.find(".pdp-hero-player").length) {

			$currentImage.find("img").on('load', function(){
				window.requestAnimationFrame(onWindowResize);
			});

		} else {

			$currentImgWrapper.on('load', function(){
				window.requestAnimationFrame(onWindowResize);
			});
		}

	}

	// methods

	initCursor(){

		$this.addClass('loaded');
		isCursorInit	= true;

		cursorWidth		= $cursor.outerWidth();
		cursorHeight	= $cursor.outerHeight();
		cursorHWidth	= Math.round(cursorWidth/2);
		cursorHHeight	= Math.round(cursorHeight/2);

		$activeImages.on('mouseenter', onPhotoOver.bind($this));
		$activeImages.on('mouseleave', onPhotoOut.bind($this));
		$activeImages.find('li').on('click', onPhotoClick.bind($this));

		// set cursor to mouse pos

		moveCursor();
	}

	onMouseMove(e){

		cursorX = e.pageX;
		cursorY = e.pageY;

		if(isCursorInit){ moveCursor(); }
		if(isZoomed){ moveZoomedImage(); }
	}

	onClick(e){
		onWindowResize();
	}

	moveCursor(){
		TweenMax.set($cursor, {x:cursorX - cursorHWidth - productImageXOffset, y:cursorY - cursorHHeight});
	}

	onThumbSelected(e, obj){

		var $target = obj.$thumb;
		var $nextImage = $activeImages.find('li').eq($target.index());
		var $lastImage = $currentImage;

		if(!$nextImage.hasClass('is-active')){

			$activeImages.find('.is-active').removeClass('is-active');
			$nextImage.addClass('is-active');

			if(!$nextImage.find(".pdp-hero-player").length) {
				isZoomed = false;
				zoomOutCursor();
				zoomOut();
				showDetails();
			}

			$currentImage = $nextImage;
			$currentImgWrapper = $nextImage.find('.img-wrapper');

			zoomFactor = parseFloat($currentImage.data('zoom-factor') || zoomFactorDefault);

			if(currentPlayer) {
				currentPlayer.pause();
			}

			if($currentImage.find('.pdp-hero-player').length) {

				$scanContainer.addClass("hide-cursor");

				currentPlayer = $currentImage.find(".plyr-video").parent().get(0).plyr;
				$currentImage.find(".pdp-video-poster").removeClass("show");
				currentPlayer.restart();
				currentPlayer.play();
				$currentImage.find(".plyr-video").parent().get(0).addEventListener("ended", function() {
					$currentImage.find(".pdp-video-poster").addClass("show");
				});

			} else {
				$scanContainer.removeClass("hide-cursor");
			}

			if(isZoomed){
				TweenMax.set($currentImgWrapper, {transformOrigin: (initialZoomXRatio * 100) + '% ' + (initialZoomYRatio * 100) + '%', scale:zoomFactor});
				loadZoomedImage();
				moveZoomedImage();

				window.requestAnimationFrame(function(){
					TweenMax.set($lastImage, {clearProps: 'scale, x, y'});
				});
			}
		}
	}

	// swatches

	onSwatchClicked(e){

		var $swatch = $(this);

		// swap thumbs

		if ( $swatch.index() !== colorIndex ) {
			colorIndex = $swatch.index();
			$thumbnails.trigger('swapThumbs');
		}

		// swap swatches

		$swatch.siblings('.is-active').removeClass('is-active');
		$swatch.addClass('is-active');

		// change stock status

		var $error = $details.find('.row.error');

		if($swatch.data('unavailable') === true){
			toggleHeroState('no-color-stock', true);
			$error.removeClass('display-none');
		}
		else {
			toggleHeroState(untoggledStateId, true);
			$error.addClass('display-none');
		}
	}

	//

	onAddCartClick(e){
		checkErrorStatus();
	}

	onSelectEnabled(){
		toggleHeroState(untoggledStateId, true);
	}

	onSelectDisabled(){
		if(currentStateId !== 'no-size-stock'){
			untoggledStateId = currentStateId;
			toggleHeroState('no-size-stock', true);
		}
	}

	checkErrorStatus(){

		$this.find('.dd-size-selector').each(function(){

			var $sizeSelector	= $(this);
			var $errorRow		= $details.find('.error-row');

			if ( ! $sizeSelector.data('value') ) {
				$sizeSelector.addClass('error');
				$errorRow.removeClass('display-none');
			} else {
				$sizeSelector.removeClass('error');
				$errorRow.addClass('display-none');
			}

		});
	}

	// photo-related

	onPhotoClick(e){

		if(Modernizr.mq('(min-width: ' + window.SETTINGS.tabletMaxWidthUp + 'px)')){

			isZoomed = !isZoomed;

			if ( isZoomed ) {
				zoomInCursor();
				zoomOnPhoto();
				hideDetails();
			} else {
				zoomOutCursor();
				zoomOut();
				showDetails();
			}
		}
	}

	onPhotoOver(e){

		if(!$currentImage.find('.pdp-hero-player').length) {
			TweenMax.killTweensOf($cursor);
			TweenMax.to($cursor, 0.3, {opacity:1, ease:Sine.easeIn});
			TweenMax.to($cursor, 0.5, {opacity:1, delay:0.16, ease:Quint.easeOut});
		}
	}

	onPhotoOut(e){

		TweenMax.killTweensOf($cursor);
		TweenMax.to($cursor, 0.16, {opacity:0, ease:Sine.easeIn});
		TweenMax.to($cursor, 0.16, {opacity:0, delay:0.06, ease:Quint.easeOut});
	}

	// zooming

	zoomInCursor(){

		var $center		= $cursor.find('#center');
		var $horizLine	= $cursor.find('#horiz-line');
		var d			= 0.06;

		TweenMax.fromTo($center, 0.2, {transformOrigin:'50% 50%', rotation:0}, {rotation:90, delay:d, ease:Cubic.easeIn});
		TweenMax.to($center, 0.6, {rotation:90, delay:d + 0.08, ease:Quint.easeOut});

		TweenMax.fromTo($horizLine, 0.3, {transformOrigin:'50% 50%'}, {scaleX:0, ease:Quint.easeOut});
	}

	zoomOutCursor(){

		var $center		= $cursor.find('#center');
		var $horizLine	= $cursor.find('#horiz-line');
		var d			= 0.06;

		TweenMax.to($center, 0.2, {rotation:180, delay:d, ease:Cubic.easeIn});
		TweenMax.to($center, 0.6, {rotation:180, delay:d + 0.08, ease:Quint.easeOut});

		TweenMax.to($horizLine, 0.4, {scaleX:1, delay:0, ease:Quint.easeOut});
	}

	zoomOnPhoto(e){

		var photoBounds		= $currentImgWrapper.offset();
		photoBounds.width	= $currentImgWrapper.outerWidth();
		photoBounds.height	= $currentImgWrapper.outerHeight();

		initialZoomX		= cursorX;
		initialZoomY		= cursorY;
		initialZoomXRatio	= (cursorX - photoBounds.left)/containerWidth; //photoBounds.width;
		initialZoomYRatio	= (cursorY - photoBounds.top)/photoBounds.height;

		zoomFactor = parseFloat($currentImage.data('zoom-factor') || zoomFactorDefault);

		zoomWidthDiff		= photoBounds.width * zoomFactor - containerWidth;
		zoomHeightDiff		= photoBounds.height * zoomFactor - containerHeight;

		lastShiftX 			= null;
		lastShiftY 			= null;
		isZoomComplete		= false;

		removeZoomImage();

		TweenMax.killTweensOf([$currentImgWrapper, $backButton]);

		TweenMax.set($currentImgWrapper, {transformOrigin: (initialZoomXRatio * 100) + '% ' + (initialZoomYRatio * 100) + '%'});
		TweenMax.to($currentImgWrapper, 0.2, {scale:zoomFactor, force3D:true, ease:Sine.easeIn});
		TweenMax.to($currentImgWrapper, 0.3, {scale:zoomFactor, delay:0.08, ease:Quint.easeOut, onComplete:function(){
			loadZoomedImage();
			isZoomComplete = true;
		}});

		hideBackButton();
	}

	zoomOut(){

		isZoomComplete = false;
		removeZoomImage();

		TweenMax.killTweensOf([$currentImgWrapper, $currentImage, $backButton]);

		TweenMax.to($currentImgWrapper, 0.2, {scale:1, force3D:true, ease:Sine.easeIn});
		TweenMax.to($currentImgWrapper, 0.3, {scale:1, delay:0.08, ease:Quint.easeOut});

		TweenMax.to($currentImage, 0.2, {x:0, y:0, force3D:true, ease:Sine.easeIn});
		TweenMax.to($currentImage, 0.3, {x:0, y:0, delay:0.08, ease:Quint.easeOut});

		showBackButton();
	}

	loadZoomedImage(){

		var zoomImageURL = $this.find('.active-images .is-active').attr('data-zoom-image');

		if(zoomImageURL){

			removeZoomImage();

			$zoomImage = $(new Image());
			$zoomImage.addClass('img img--zoom');
			$zoomImage.css({
				opacity: 0
			});

			$zoomImage.on('load', function(){
				TweenMax.killTweensOf($zoomImage);
				TweenMax.to($zoomImage, 0.32, {opacity:1, ease:Quad.easeIn});
				TweenMax.to($zoomImage, 1, {opacity:1, delay:0.12, ease:Cubic.easeOut});
			});

			$zoomImage[0].src = zoomImageURL;
			$currentImgWrapper.append($zoomImage);
		}
	}

	removeZoomImage(){

		if($zoomImage){
			TweenMax.killTweensOf($zoomImage);
			$zoomImage.remove();
			$zoomImage = null;
		}
	}

	hideThumbnails(){

		if ( !$thumbnails.data('is-hidden') ) {
			$thumbnails.data('is-hidden', true);
			TweenMax.set($thumbnails, {opacity: 0});
		}
	}

	showThumbnails(){

		if ( $thumbnails.data('is-hidden') ) {
			$thumbnails.data('is-hidden', false);
			TweenMax.set($thumbnails, {opacity: 1});
		}
	}

	showBackButton(){

		if ( !$backButton.data('is-showing') ) {
			$backButton.data('is-showing', true);
			TweenMax.set($backButton, {x: 0});
			TweenMax.fromTo($backButton, 0.3, {display:'block', opacity:0}, {opacity:1, ease:Sine.easeIn});
			TweenMax.to($backButton, 0.4, {opacity:1, delay:0.12, ease:Quint.easeOut, onComplete:function(){
				$backButton.css('pointer-events', 'auto');
			}});
		}
	}

	hideBackButton(){

		if ( $backButton.data('is-showing') ) {
			$backButton.data('is-showing', false);
			TweenMax.to($backButton, 0.3, {opacity:0, ease:Sine.easeIn});
			TweenMax.to($backButton, 0.4, {opacity:0, delay:0.12, ease:Quint.easeOut, onComplete:function(){
				$backButton.css('pointer-events', 'none');
			}});
		}
	}

	moveZoomedImage(){

		var $movingImage 	= ($zoomImage && $zoomImage.length) ? $zoomImage : $currentImgWrapper;
		var photoBounds		= $movingImage.offset();
		photoBounds.width 	= $movingImage.outerWidth() * zoomFactor;
		photoBounds.height 	= $movingImage.outerHeight() * zoomFactor;

		photoBounds.right 	= photoBounds.left + photoBounds.width;
		photoBounds.bottom 	= photoBounds.top + photoBounds.height;

		var wanderFactorX 	= containerWidth * 0.42; //360 * (photoBounds.width / 2000);
		var wanderFactorY 	= viewportHeight * 0.42; //360 * (photoBounds.height / 2000);

		var xRatio			= 0 - (cursorX - initialZoomX) / wanderFactorX;
		var yRatio			= 0 - (cursorY - initialZoomY) / wanderFactorY;

		var xBleed			= Math.max(0, photoBounds.width - containerWidth);
		var yBleed			= Math.max(0, photoBounds.height - viewportHeight);

		//

		var newX			= xRatio * (xBleed/2);
		var newY			= yRatio * (yBleed/2);

		if(lastShiftX === null){ lastShiftX = newX; }
		if(lastShiftY === null){ lastShiftY = newY; }

		var leftBleedOff	= photoBounds.left + (newX - lastShiftX);
		var rightBleedOff	= photoBounds.right + (newX - lastShiftX);
		var topBleedOff		= photoBounds.top + (newY - lastShiftY);
		var bottomBleedOff	= photoBounds.bottom + (newY - lastShiftY);

		var headerHeight 	= 118;

		// accurate all the way from the left, 100 off from the right
		// weird compensation, figure out why

		if(!isIsolated){

			if(photoBounds.width > containerWidth){

				if ( leftBleedOff > 0 ) {
					newX -= leftBleedOff;
				}
				else if ( rightBleedOff < containerWidth ) {
					newX += containerWidth - rightBleedOff;
				}
			}
			else {
				newX = 0;
			}

			if(photoBounds.height > viewportHeight){

				if ( topBleedOff > headerHeight ) {
					newY -= (topBleedOff - headerHeight);
				}
				else if ( bottomBleedOff < viewportHeight + headerHeight ) {
					newY += (viewportHeight + headerHeight) - bottomBleedOff;
				}
			}
			else {
				newY = 0;
			}
		}

		TweenMax.set($currentImage, {
			x: newX,
			y: newY
		});

		lastShiftX = newX;
		lastShiftY = newY;
	}

	//

	showDetails(){

		var detailsWidth	= $details.outerWidth();
		var detailsHeight	= $details.outerHeight();

		//

		TweenMax.killTweensOf([$detailsContent, $details]);
		TweenMax.to($detailsContent, 0.4, {opacity:1, ease:Cubic.easeOut});

		TweenMax.fromTo($details, 0.12, {visibility:'visible'}, {opacity:1, ease:Sine.easeIn});
		TweenMax.to($details, 0.16, {opacity:1, delay:0.08, ease:Quint.easeOut, clearProps:'all'});
	}

	hideDetails(){

		var detailsContentWidth	= $detailsContent.outerWidth();
		var detailsWidth		= $details.outerWidth();
		var detailsHeight		= $details.outerHeight();

		//

		TweenMax.killTweensOf([$detailsContent, $details]);
		TweenMax.set($detailsContent, {width: detailsContentWidth});
		TweenMax.to($detailsContent, 0.4, {opacity:0, ease:Cubic.easeOut});

		TweenMax.fromTo($details, 0.2, {opacity:1, visibility:'visible', overflow:'hidden'}, {opacity:0, ease:Sine.easeIn});
		TweenMax.to($details, 0.24, {opacity:0, delay:0.08, ease:Quint.easeOut, onComplete:function(){
			TweenMax.set($details, {
				visibility: 'hidden',
				clearProps: 'clip'
			});
		}});
	}

	//

	updateContainerVars(){

		var isDesktop = Modernizr.mq('(min-width: ' + window.SETTINGS.tabletMaxWidthUp + 'px)');

		containerOffset	= $this.offset();
		containerWidth	= $this.outerWidth();
		containerHeight	= $this.outerHeight();

		thumbBounds	= window.utils.PositioningUtils.getExtendedOffset($thumbnails);
		backBounds	= window.utils.PositioningUtils.getExtendedOffset($backButton);

		viewportWidth = isDesktop ? $details.offset().left - thumbBounds.right : docWidth;
		viewportHeight = isDesktop ? Math.min(winHeight, containerHeight) - 100 : $productImages.outerHeight();
	}

	onHashChange(){
		checkHash();
	}

	onWindowResize(){

		var isDesktop = Modernizr.mq('(min-width: ' + window.SETTINGS.tabletMaxWidthUp + 'px)');

		docWidth 	= $('body').width();
		winWidth	= window.innerWidth;
		winHeight	= window.innerHeight;

		productImageXOffset = Math.max(Math.round((docWidth - 1920)/2), 0);

		if($currentImage.find(".pdp-hero-player")) {
			productImageXOffset = Math.max(Math.round((docWidth - 1920)/2), 0);
		}

		updateContainerVars();

		TweenMax.set($backButton, {left: productImageXOffset + 40});

		if(!isZoomed && isDesktop){
			showBackButton();
		}
		else {
			hideBackButton();
		}

		if ( $currentImage && $currentImage.length ) {

			isVideo = $currentImage.find('.pdp-hero-player').length;
			isIsolated = ($currentImage.attr('data-isolated') == 'true');

			var detailsOffset = window.utils.PositioningUtils.getExtendedOffset($details);
			var backBottom = parseInt($backButton.css('top')) + backBounds.height;
			var thumbOffset = backBottom + Math.round((viewportHeight - 40 - backBottom - thumbBounds.height)/2) + 20;
			var layoutXOffset = Math.max(0, Math.round((docWidth - containerWidth)/2));

			thumbBounds.right += 40;
			detailsOffset.left -= 40;

			if(!isDesktop){
				thumbOffset = Math.round(($productImages.outerHeight() - thumbBounds.height)/2);
			}

			var thumbRoom = viewportHeight - backBottom - 40;
			var thumbScale = Math.min(1, thumbRoom / thumbBounds.height);

			TweenMax.set($thumbnails, {
				top: thumbOffset,
				scale: thumbScale,
				transformOrigin: '50% 50%'
			});

			if($currentImage.attr('data-image-width') && $currentImage.attr('data-image-height')){
				imageRatio	= parseInt($currentImage.data('image-width')) / parseInt($currentImage.data('image-height'));
			}
			else {
				imageRatio = 1;
			}

			// center image

			if ( isDesktop || isVideo ) {

				resizeImage()

			} else {

				// var leftOffset = Math.round((winWidth - $currentImgWrapper.outerWidth())/2);

				var leftOffset = Math.round($currentImage.outerWidth() * 0.12);
				var topOffset = 0;

				if(isIsolated){
					leftOffset = Math.round((winWidth - $currentImgWrapper.outerWidth() - thumbBounds.right)/2) + thumbBounds.right;
					$currentImgWrapper.css({
						'width': '',
						'height': '',
						'margin-left': leftOffset,
						'margin-top': topOffset
					});
				}
				else {
					window.utils.PositioningUtils.sizeToFit($currentImgWrapper, imageRatio, containerWidth, viewportHeight, false, false, true);
					leftOffset = 0;
					$currentImgWrapper.css({
						'margin-left': leftOffset
					});
				}
			}

			resizeImage(){

				var navOffset 		= 118;

				if(isVideo){

					if(isIsolated){
						window.utils.PositioningUtils.sizeToFit($currentImage, imageRatio, viewportWidth, viewportHeight, true, true, false);
					}
					else {
						window.utils.PositioningUtils.sizeToFit($currentImage, imageRatio, containerWidth, viewportHeight, true, false, true);
					}
				}
				else {

					if(isIsolated){
						window.utils.PositioningUtils.sizeToFit($currentImgWrapper, imageRatio, viewportWidth, viewportHeight - navOffset - 40, true, true, false);
					}
					else {
						window.utils.PositioningUtils.sizeToFit($currentImgWrapper, imageRatio, containerWidth, viewportHeight, true, false, true);
					}
				}

				var photoBounds		= $currentImgWrapper.offset();
				photoBounds.width	= $currentImgWrapper.outerWidth();
				photoBounds.height	= $currentImgWrapper.outerHeight();

				zoomWidthDiff		= photoBounds.width * zoomFactor - containerWidth;
				zoomHeightDiff		= photoBounds.height * zoomFactor - containerHeight;

				var leftOffset		= 0;
				var topOffset		= navOffset + 40;

				if(isDesktop){

					if(isIsolated){
						leftOffset 	= Math.round((detailsOffset.left - thumbBounds.right - photoBounds.width)/2 + thumbBounds.right) - layoutXOffset;
						topOffset	+= Math.max(0, Math.round((viewportHeight - navOffset - 40 - photoBounds.height)/2));
					} else {
						leftOffset	= Math.round((winWidth - photoBounds.width)*((detailsOffset.left / 2) / winWidth));
						leftOffset 	= Math.min(leftOffset, 0);
						topOffset 	= navOffset - (navOffset - 100)
					}
				}

				if(!isVideo){

					$currentImgWrapper.css({
						'margin-left': leftOffset,
						'margin-top' : topOffset
					});
				}
			}

			//

			onScroll();
		}

		if ( !isDesktop ) {
			$detailsContent.css({
				'width': '',
				'min-height': ''
			});
		}

		//

		$detailsContent.css('min-height', '');

		window.requestAnimationFrame(function(){
			$detailsContent.css('min-height', $details.outerHeight());
			window.vent.trigger('domUpdate', {$scanContainer: $this});
		});
	}

	onScroll(){

		var scrollTop = $(window).scrollTop();

		if ( Modernizr.mq('(min-width: ' + window.SETTINGS.tabletMaxWidthUp + 'px)') ) {

			thumbBounds	= window.utils.PositioningUtils.getExtendedOffset($thumbnails);
			backBounds	= window.utils.PositioningUtils.getExtendedOffset($backButton);

			if ( containerOffset.top + containerHeight < scrollTop + winHeight ) {

				if ( isImageFixed || isImageFixed === null ) {

					var bottomOffset = Math.min(0, winHeight - containerHeight);

					$productImages.css({
						position: 'absolute',
						top: 'auto',
						bottom: bottomOffset,
						width: '',
						left: ''
					});

					isImageFixed = false;
				}

				if ( !isZoomed ) {

					if ( thumbBounds && backBounds && thumbBounds.top < backBounds.top + $backButton.outerHeight() + 40 ) {
						hideBackButton();
					} else {
						showBackButton();
					}
				}
			} else {

				if ( ! isImageFixed ) {

					if(docWidth > 1920){

						$productImages.css({
							width: 1920,
							left: productImageXOffset
						});
					}
					else {

						productImageXOffset = 0;

						$productImages.css({
							width: '',
							left: ''
						});
					}

					$productImages.css({
						position: 'fixed',
						top: '0px',
						bottom: 'auto'
					});
					isImageFixed = true;

					showThumbnails();
					showBackButton();
				}
			}
		} else {

			$productImages.css({
				position: '',
				top: '',
				bottom: '',
				width: '',
				left: ''
			});

			isImageFixed = false;
		}
	}
}

*/

},{"../../70_ui/cursor-zoom/script":102,"../../70_ui/wiggle-photo/script":112,"../../90_utils/base/BaseModule":131}],105:[function(require,module,exports){
arguments[4][15][0].apply(exports,arguments)
},{"dup":15}],106:[function(require,module,exports){
class RatingStars {

	constructor(el) {
		this.$el          	= el;
		this.$starsFilled 	= el.find('.stars-filled');
		this.$countField 	= el.find('.count-field');

		this.rating     	= 0;
		this.count 			= 0;
		this.valuePercent	= 0;
		this.displayPercent	= 0;

		this.set;

		this.update();
		this.addEventListeners();
	}

	getRating() {
		this.rating = parseFloat(this.$el.data('rating'));
		this.count = parseInt(this.$el.data('rating-count'));
	}

	setRating(i) {
		this.$el.data({'rating': i});
		this.update();
	}

	calculate() {

		// value vs display percent - because you only want % to appear in the icon areas, not the gaps in between

		let poly0Rect = this.$el.find('.star-row polygon')[0].getBoundingClientRect();
		let poly1Rect = this.$el.find('.star-row polygon')[1].getBoundingClientRect();
		let polygonWidth = poly0Rect.width;
		let polygonDistance = poly1Rect.left - poly0Rect.left - polygonWidth;
		let totalWidth = (polygonWidth + polygonDistance) * 4 + polygonWidth;

		this.valuePercent = this.rating / 5;
		this.displayPercent = ((parseInt(this.valuePercent * 5) * (polygonWidth + polygonDistance) + ((this.valuePercent * 5 - parseInt(this.valuePercent * 5)) * polygonWidth)) / totalWidth);
	}

	setWidth() {
		this.$starsFilled.css({'width': `${this.displayPercent * 100}%`});
	}

	printCount() {
		if(this.$countField.length){
			let $valueField = this.$countField.find('.count-field-value');
			$valueField.html(this.count);
		}
	}

	update() {
		this.getRating();
		this.calculate();
		this.setWidth();
		this.printCount();
	}

	// listener methods

	_onUpdate() {
		this.update();
	}

	_onLiMouseEnter(e) {
		this.setRating($(e.currentTarget).index() + 1);
	}

	_onLiClick(e) {
		let i = $(e.currentTarget).index() + 1;
		this.setRating(i);
		this.set = i;
	}

	_onLiMouseLeave() {
		this.set ? this.setRating(this.set) : this.setRating(0);
	}

	// add listeners

	addEventListeners() {

		this.$el.on('update', this._onUpdate.bind(this));

		if (this.$el.data('editable')) {
			this.$el.find('li').on('mouseenter', this._onLiMouseEnter.bind(this));
			this.$el.find('ul').on('mouseleave', this._onLiMouseLeave.bind(this));
			this.$el.find('li').on('click', this._onLiClick.bind(this));
		}
	}

	removeEventListeners() {
		this.$el.on('update', this._onUpdate.bind(this));
		this.$el.find('li').off('mouseenter', this._onLiMouseEnter.bind(this));
		this.$el.find('ul').off('mouseleave', this._onLiMouseLeave.bind(this));
		this.$el.find('li').off('click', this._onLiClick.bind(this));
	}

}

module.exports = RatingStars;

},{}],107:[function(require,module,exports){
const Accordion              = require('./accordion/accordion');
const AutoRotator      		 = require('./auto-rotator/script');
const ColorSelector          = require('./color-selector/script');
const ImageSwappable         = require('./image-swappable/script');
const RatingStars            = require('./rating-stars/script');
const SimpleSlider           = require('./simple-slider/script');
const SimpleToggle           = require('./toggle/toggle');
const SizeSelector           = require('./size-selector/script');
const Tabs                   = require('./tabs/tabs');
const WigglePhoto            = require('./wiggle-photo/script');

require('./alerts/alerts');

window.SETTINGS.domScan.addContainer( null, ($scanContainer) => {

	window.SETTINGS.domScan.addElement($scanContainer, '[data-accordion]', function () {
		new Accordion(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-auto-rotator]', function () {
		new AutoRotator(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-color-selector]', function () {
		new ColorSelector(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-image-swappable]', function () {
		new ImageSwappable(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-rating-stars]', function () {
		new RatingStars(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-simple-slider]', function () {
		new SimpleSlider(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-toggle]', function () {
		new SimpleToggle(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-size-selector]', function () {
		new SizeSelector(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-wiggle-photo]', function () {
		new WigglePhoto(this);
	});

	// mini-modules that do not necessitate classes (yet)

	window.SETTINGS.domScan.addElement($scanContainer, '[data-heart-toggle]', function () {

		let $this = $(this);

		$this.on('click', () => {

			if ( $this.hasClass('is-active') ) {
				$this.removeClass('is-active');
			} else {
				$this.addClass('is-active');
				$this.triggerHandler('activate');
			}
		});
	});

	// synched height groups

	window.SETTINGS.domScan.addElement($scanContainer, '[data-sync-height-group]', function(){

		let $this		= $(this);
		let $cols		= $this.find('[data-sync-height]');
		let minWidth	= $this.data('sh-min-width') || null;
		let groupIds 	= [];

		let checkHeightDebouncer = _.throttle(checkHeightSync, 500);

		window.vent.on('windowResize', checkHeightDebouncer);
		window.vent.on('fontsActive', checkHeightDebouncer);

		function checkHeightSync(){

			groupIds = [''];

			$cols.each((index, value) => {
				let $col = $(value);
				let id = $col.data('sync-height');
				if(id && groupIds.indexOf(id) === -1){
					groupIds.push(id);
				}
			});

			for(let i=0; i<groupIds.length; i++){

				let maxHeight = 0;
				let $filteredCols = groupIds[i] ? $cols.filter('[data-sync-height=\"' + groupIds[i] + '\"]') : $cols.filter('[data-sync-height]');
				let $masterCol	= $filteredCols.find('[data-sh-master]');

				if ( !minWidth || window.innerWidth > minWidth ){

					$filteredCols.each((index, value) => {

						let $col = $(value);
						$col.css('min-height', '');

						let colHeight = $col.outerHeight();

						if ( $masterCol.length ){
							maxHeight = $masterCol.outerHeight();
						} else if ( colHeight > maxHeight ){
							maxHeight = colHeight;
						}
					});
				} else {
					maxHeight = '';
				}

				$filteredCols.each((index, value) => {
					$(value).css('min-height', maxHeight);
				});
			}
		}

		window.requestAnimationFrame(() => {
			checkHeightSync();
		});
	});

	// swap groups (like tabs)

	window.SETTINGS.domScan.addElement($scanContainer, '[data-swap-group]', function(){

		let $this			= $(this);
		let $buttons		= $this.find('[data-sg-button]'); // param: include id(s), comma separated
		let $targets		= $this.find('[data-sg-target]'); // param: include matching id
		let swapClass		= $this.attr('data-sg-class') || 'is-active';

		$buttons.on('click', (e) => {
			let $target  = $(e.currentTarget);
			swapClassByButton($target);
		});

		if(!$buttons.hasClass(swapClass)){
			swapClassByButton($buttons.eq(0));
		}

		function swapClassByButton($button){

			let toggleId 	= $button.attr('data-sg-button');
			let idArray 	= toggleId.split(',');
			let $toggleOff 	= $buttons.add($targets);
			let $toggleOn	= null;

			for(let i=0; i<idArray.length; i++){

				let id = idArray[i];
				let $target = $this.find('[data-sg-target=\"' + id + '\"]').add($button);

				if($target.length){
					if($toggleOn){ $toggleOn.add($target); }
					else { $toggleOn = $target; }
				}
			}

			$toggleOff.removeClass(swapClass);
			$toggleOn.addClass(swapClass);

			// fire event when active

			$toggleOn.each((index, value) => {
				$(value).triggerHandler('activate');
			});
		}
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-sticky-group]', function(){

		let $this = $(this);
		let $cols = $this.find('[data-sg-col]');

		$cols.stick_in_parent({
			parent: $this
		});
	});

});

},{"./accordion/accordion":98,"./alerts/alerts":99,"./auto-rotator/script":100,"./color-selector/script":101,"./image-swappable/script":103,"./rating-stars/script":106,"./simple-slider/script":108,"./size-selector/script":109,"./tabs/tabs":110,"./toggle/toggle":111,"./wiggle-photo/script":112}],108:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class SimpleSlider extends BaseModule {

	constructor(el, params) {

		super(el);

		// param defaults

		this.defaults = {
			indexOffset: 			0,
			slidesPerSet: 			1, // number of visible slides
			slidesMovedPerClick: 	1, // slide distance per click (this can be left blank - defaults to slidesPerSet)
			indexShiftPerClick: 	1, // index shift per click (this can be left blank - defaults to slidesMovedPerClick)
			isHorizontal: 			true,
		};

		// flags

		this._isFirstConfig = true;
		this._isListening = false;
		this._isEnabled = false;

		//

		this.updateParams(params);
	}

	// reinitialize entire configuration based on new params

	updateParams(params){

		// disable while updating

		this.disable();

		//

		this.params = params || [];

		this.indexOffset = parseInt(this.checkVal(this.params.indexOffset, this.defaults.indexOffset));
		this.slidesPerSet = parseInt(this.checkVal(this.params.slidesPerSet, this.defaults.slidesPerSet));
		this.slidesMovedPerClick = parseInt(this.checkVal(this.params.slidesMovedPerClick, this.slidesPerSet));
		this.indexShiftPerClick = parseInt(this.checkVal(this.params.indexShiftPerClick, this.slidesMovedPerClick));
		this.isHorizontal = this.checkVal(this.params.isHorizontal, this.defaults.isHorizontal);

		this.$leftArrow = this.checkVals([this.params.$leftArrow, this.$el.find('.arrow--left')]);
		this.$rightArrow = this.checkVals([this.params.$rightArrow, this.$el.find('.arrow--right')]);
		this.$upArrow = this.checkVals([this.params.$upArrow, this.$el.find('.arrow--up')]);
		this.$downArrow = this.checkVals([this.params.$downArrow, this.$el.find('.arrow--down')]);

		this.$progress = this.checkVals([this.params.$progress, this.$el.find('.progress')]);

		if(this.$progress){
			this.$progressIndex = this.checkVals([this.params.$progressIndex, this.$progress.find('.progress-numbers--index')]);
			this.$progressTotal = this.checkVals([this.params.$progressTotal, this.$progress.find('.progress-numbers--total')]);
		}

		this.$slidesContainer = this.checkVals([this.params.$slidesContainer, this.$el.find('ul.slides')]);

		// find slides

		this.$slides = this.$slidesContainer.find('>li');

		// throw error if slides cannot be found

		if(!this.$slides.length){ throw new Error('Could not find slides (>li) within $slidesContainer:', this.$slidesContainer); }

		//

		this.index = this.indexOffset;

		this._lastIndex = 0;
		this._clickIndex = 0;
		this._total = this.$slides.length;
		this._slideWidth = 0;

		// if total slides are too few for full set moves, limit slides per click

		if(this._total - this.slidesMovedPerClick < this.slidesMovedPerClick){
			this.slidesMovedPerClick = this._total - this.slidesMovedPerClick;
		}

		if(this._total - this.indexShiftPerClick < this.indexShiftPerClick){
			this.indexShiftPerClick = this._total - this.indexShiftPerClick;
		}

		if(this._isFirstConfig){

			this._isFirstConfig = false;

			$(() => {
				this._domReady(); // will re-enable
			});
		}
	}

	//

	_domReady(){

		super._domReady();

		this._updateProgress();
	}

	// listeners

	_addListeners(){

		super._addListeners();

		if(!this._isListening){

			this._isListening = true;

			if(this.$leftArrow){
				this.$leftArrow.on('click', this._onLeftClick.bind(this));
				this.$leftArrow.on('mouseenter', this._onLeftOver.bind(this));
				this.$leftArrow.on('mouseleave', this._onLeftOut.bind(this));
			}

			if(this.$rightArrow){
				this.$rightArrow.on('click', this._onRightClick.bind(this));
				this.$rightArrow.on('mouseenter', this._onRightOver.bind(this));
				this.$rightArrow.on('mouseleave', this._onRightOut.bind(this));
			}

			if(this.$upArrow){
				this.$upArrow.on('click', this._onUpClick.bind(this));
				this.$upArrow.on('mouseenter', this._onUpOver.bind(this));
				this.$upArrow.on('mouseleave', this._onUpOut.bind(this));
			}

			if(this.$downArrow){
				this.$downArrow.on('click', this._onDownClick.bind(this));
				this.$downArrow.on('mouseenter', this._onDownOver.bind(this));
				this.$downArrow.on('mouseleave', this._onDownOut.bind(this));
			}
		}
	}

	_removeListeners(){

		super._removeListeners();

		if(this._isListening){

			this._isListening = false;

			if(this.$leftArrow){
				this.$leftArrow.off('click', this._onLeftClick.bind(this));
				this.$leftArrow.off('mouseenter', this._onLeftOver.bind(this));
				this.$leftArrow.off('mouseleave', this._onLeftOut.bind(this));
			}

			if(this.$rightArrow){
				this.$rightArrow.off('click', this._onRightClick.bind(this));
				this.$rightArrow.off('mouseenter', this._onRightOver.bind(this));
				this.$rightArrow.off('mouseleave', this._onRightOut.bind(this));
			}

			if(this.$upArrow){
				this.$upArrow.off('click', this._onUpClick.bind(this));
				this.$upArrow.off('mouseenter', this._onUpOver.bind(this));
				this.$upArrow.off('mouseleave', this._onUpOut.bind(this));
			}

			if(this.$downArrow){
				this.$downArrow.off('click', this._onDownClick.bind(this));
				this.$downArrow.off('mouseenter', this._onDownOver.bind(this));
				this.$downArrow.off('mouseleave', this._onDownOut.bind(this));
			}
		}
	}

	// global event methods

	_resize(){
		this._resetSlidesContainer();
	}

	// element event methods
	// left

	_onLeftClick(){
		this.prev();
	}

	_onLeftOver(){ }
	_onLeftOut(){ }

	// right

	_onRightClick(){
		this.next();
	}

	_onRightOver(){ }
	_onRightOut(){ }

	// up

	_onUpClick(){
		this.prev();
	}

	_onUpOver(){ }
	_onUpOut(){ }

	// down

	_onDownClick(){
		this.next();
	}

	_onDownOver(){ }
	_onDownOut(){ }

	// slide controls

	next(){
		this.triggerEvent('next', {index:this.index + this.indexShiftPerClick, total:this._total});
		this.seekTo(this.index + this.indexShiftPerClick, 1);
	}

	prev(){
		this.triggerEvent('prev', {index:this.index - this.indexShiftPerClick, total:this._total});
		this.seekTo(this.index - this.indexShiftPerClick, -1);
	}

	seekTo(newIndex, indexDelta){

		if(typeof(newIndex) !==	'undefined' && !isNaN(newIndex)){

			newIndex = this.getRangeIndex(newIndex);

			if(newIndex !== this.index){

				if(isNaN(indexDelta)){
					if(newIndex > this.index){ indexDelta = this.slidesMovedPerClick; }
					else { indexDelta = 0 - this.slidesMovedPerClick; }
				}
				else {
					indexDelta *= this.slidesMovedPerClick;
				}

				// set new index

				this._lastIndex = this.index;
				this.index = newIndex;
				this._clickIndex += indexDelta; // motion does not always max index

				// make sure slides are properly ordered

				this._arrangeSlides();

				// update progress numbers

				this._updateProgress();

				// slide to new position

				this.$el.addClass('is-sliding');
				this.$el.removeClass('is-peeking');

				if(this.isHorizontal){
					TweenMax.set(this.$slidesContainer, {x:0 - this._clickIndex * this._slideWidth, y:0, force3D:true});
				}
				else {
					TweenMax.set(this.$slidesContainer, {x:0, y:0 - this._clickIndex * this._slideHeight, force3D:true});
				}

				window.utils.AnimationUtils.offTransitionComplete(this.$slidesContainer);
				window.utils.AnimationUtils.oneTransitionComplete(this.$slidesContainer, () => {
					// start callback
				}, () => {
					this.$el.removeClass('is-sliding');
				}, true);

				// fire event

				this.triggerEvent('seek', {index:this.index, total:this._total});
			}
		}
	}

	// move slide container

	_resetSlidesContainer(){

		TweenMax.set(this.$slidesContainer, {clearProps: 'width, height'});

		// slide specs

		let $currentSlide = this.$slides.eq(this.index);
		this._slideWidth = $currentSlide.outerWidth(true);
		this._slideHeight = $currentSlide.outerHeight(true);

		// container specs

		let transformObj = {x:0, y:0};

		if(this.isHorizontal){
			transformObj.width = this._slideWidth * this.slidesPerSet;
			transformObj.height = this._slideHeight;
		}
		else {
			transformObj.width = this._slideWidth;
			transformObj.height = this._slideHeight * this.slidesPerSet;
		}

		TweenMax.set(this.$slidesContainer, transformObj);

		//

		this._clickIndex = 0;
		this._arrangeSlides();
	}

	// arrange slides depending on index

	_arrangeSlides(){

		let workingIndex = this.getRangeIndex(this.index);
		let nextIndex = this.getRangeIndex(workingIndex + (this.slidesPerSet - 1) + this.indexShiftPerClick);
		let prevIndex = this.getRangeIndex(workingIndex - this.indexShiftPerClick);

		let $currentSlide = this.$slides.eq(workingIndex);
		let $nextSlide = this.$slides.eq(nextIndex);
		let $prevSlide = this.$slides.eq(prevIndex);

		// move slides to correct locations

		this.$slides.removeClass('is-front');

		//

		$currentSlide.addClass('is-front');

		for(let i=0; i<this.slidesPerSet; i++){

			// slides in set

			let $setNeighbor = this.$slides.eq(this.getRangeIndex($currentSlide.index() + i));
			$setNeighbor.addClass('is-front');

			if(this.isHorizontal){
				TweenMax.set($setNeighbor, {x:(this._clickIndex + i) * this._slideWidth, y:0});
			}
			else {
				TweenMax.set($setNeighbor, {x:0, y:(this._clickIndex + i) * this._slideHeight});
			}

			// last slides

			let $lastSlide = this.$slides.eq(this.getRangeIndex(this._lastIndex + i));
			$lastSlide.addClass('is-front is-prev');
		}
	}

	// update numbers

	_updateProgress(){

		if(this.$progressIndex && this.$progressIndex.length){
			this.$progressIndex.html(window.utils.NumberUtils.formatNumber(this.index + 1, 2));
		}

		if(this.$progressTotal && this.$progressTotal.length){
			this.$progressTotal.html(window.utils.NumberUtils.formatNumber(this._total, 2));
		}
	}

	// utils

	getRangeIndex(newIndex, wrap){

		// return valid index based on newIndex compared to valid range
		// will wrap by default (meaning -2 will become total - 2)
		// if wrap is disabled, index will return at lower or higher limit of range

		return window.utils.NumberUtils.getRangeIndex(newIndex, 0, this._total, wrap);
	}
}

module.exports = SimpleSlider;

},{"../../90_utils/base/BaseModule":131}],109:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class SizeSelector extends BaseModule {

	constructor(el, params) {

		super(el);

		// element vars

		this.$thumbs = this.$el.find('li[data-size]');

		this.$currentSize = null;
		this.$currentSizeTitle = this.$el.find('[data-current-size-title]');
	}

	// private methods

	_domReady(){
		super._domReady();
	}

	_addListeners(){

		if(!this._isListening){

			this._isListening = true;

			//

			this.$thumbs.on('mouseenter', this._onThumbOver.bind(this));
			this.$thumbs.on('mouseleave', this._onThumbOut.bind(this));
			this.$thumbs.on('activate', this._onThumbActivate.bind(this));

			this.$currentSize = this.$thumbs.find('.is-active');

			if(this.$currentSize.length){
				this._changeSizeByThumb(this.$currentSize);
			}
			else {
				this.$currentSize = this.$thumbs.eq(0);
				this._changeSizeByThumb(this.$thumbs.eq(0));
			}
		}

		super._addListeners();
	}

	_removeListeners(){

		if(this._isListening){

			this._isListening = false;
		}

		super._removeListeners();
	}

	// element event listeners

	_onThumbOver(e){
		let $target = $(e.currentTarget);
		this._changeSizeByThumb($target);

	}

	_onThumbOut(e){
		this._changeSizeByThumb(this.$currentSize);

	}

	_onThumbActivate(e){

		let $target = $(e.currentTarget);

		this.$currentSize = $target;
		this._changeSizeByThumb($target);
	}

	//

	_domUpdate(){ } // use me!
	_resize(){ } // use me!

	// change size

	_changeSizeByThumb($target){
		let size = $target.attr('data-size-title');
		this.$currentSizeTitle.html(size);
	}
}

module.exports = SizeSelector;

},{"../../90_utils/base/BaseModule":131}],110:[function(require,module,exports){
window.SETTINGS.domScan.addContainer($('body'), function($scanContainer) {

	window.SETTINGS.domScan.addElement($scanContainer, '[data-type="tabs"]:not([data-tabs-nested])', function() {

		const $this	   = $(this),
			  $tab	   = $this.find('[data-tab]'),
			  $content = $this.find('[data-tab-content]');

		//  Add active states to first tab and link

		let firstTabType = $tab.eq(0).data('tab');
		$tab.eq(0).addClass('is-active');

		if ( firstTabType ) {
			$content.filter('[data-tab-content="' + firstTabType + '"]').addClass('is-active');
		} else {
			$content.eq(0).addClass('is-active');
		}

		//

		$tab.on('click', function(e) {

			const $el = $(this);

			e.preventDefault();

			if ( $el.is('.is-active') ) return;

			$tab.removeClass('is-active');
			$content.removeClass('is-active');

			$el.addClass('is-active');
			$content.filter('[data-tab-content="' + $el.data('tab') + '"]').addClass('is-active');

		});

	});

	// nested tabs cuz this shit is so fucking gay - fuck you designers, wtf are you thinking - god damn nested tabs - bullshit ronnie god damn bullshit
	window.SETTINGS.domScan.addElement($scanContainer, '[data-type="tabs"][data-tabs-nested]', function() {

		const $this	   = $(this),
			  $tab	   = $this.find('> * > [data-tab]'),
			  $content = $this.find('> [data-tab-content]');

		//  Add active states to first tab and link

		let firstTabType = $tab.eq(0).data('tab');
		$tab.eq(0).addClass('is-active');

		if ( firstTabType ) {
			$content.filter('[data-tab-content="' + firstTabType + '"]').addClass('is-active');
		} else {
			$content.eq(0).addClass('is-active');
		}

		//

		$tab.on('click', function(e) {

			const $el = $(this);

			e.preventDefault();

			if ( $el.is('.is-active') ) return;

			$tab.removeClass('is-active');
			$content.removeClass('is-active');

			$el.addClass('is-active');
			$content.filter('[data-tab-content="' + $el.data('tab') + '"]').addClass('is-active');

		});

	});

});

},{}],111:[function(require,module,exports){
class SimpleToggle {

	constructor(el) {
		this.$el = el;
		this.$values = el.find('a');

		this.addEventListeners();
	}

	toggleOnClick(e) {
		let $el = $(e.currentTarget);

		this.$values.removeClass('is-active');
		$el.addClass('is-active');

		this.$el.trigger('change', $el.data('value'));
	}

	addEventListeners() {

		this.toggleOnClick = this.toggleOnClick.bind(this);

		this.$values.on('click', this.toggleOnClick);

	}

	removeEventListeners() {
		this.$values.off('click', this.toggleOnClick);
	}

}

module.exports = SimpleToggle;

},{}],112:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');
const CursorZoom = require('../cursor-zoom/script');

class WigglePhoto extends BaseModule {

	constructor(el, $img, $container, $mouseTarget, bleedFactor) {

		super(el);

		//


		this.$img = this.checkVals([$img, this.$el.find('figure')]);
		this.$container = this.checkVals([$container, this.$el]);
		this.$mouseTarget = this.checkVals([$mouseTarget, this.$el]);
		this.bleedFactor = this.checkVals([bleedFactor, parseFloat(this.$el.attr('data-bleed-factor'))], 0.25);

		//

		this._frameStep;
		this._cursor = null;
	}

	//

	_addListeners(){

		super._addListeners();

		//

		this.$mouseTarget.on('mouseenter', this._onPhotoOver.bind(this));
		this.$mouseTarget.on('mouseleave', this._onPhotoOut.bind(this));

		if(!this._cursor){

			let $cursor = this.$el.find('[data-cursor-zoom]');

			if($cursor.length){

				this.$container.on('mouseenter', this._onContainerOver.bind(this));
				this.$container.on('mouseleave', this._onContainerOut.bind(this));

				this._cursor = new CursorZoom($cursor, this.$el);
			}
		}
		else { this._cursor.enable(); }
	}

	_removeListeners(){

		super._removeListeners();

		//

		this.$mouseTarget.off('mouseenter', this._onPhotoOver.bind(this));
		this.$mouseTarget.off('mouseleave', this._onPhotoOut.bind(this));

		if(this._cursor){ this._cursor.enable(); }
	}

	//

	_onPhotoOver(){
		this.enable();
	}

	_onPhotoOut(){
		this.disable();
	}

	//

	_onContainerOver(){
		this._cursor.enable();
	}

	_onContainerOut(){
		this._cursor.disable();
	}

	//

	enable(){

		super.enable();

		this._tick(true); // start loop
		this.$el.addClass('is-wiggling');
	}

	disable(){

		super.disable();

		this._frameStep = false; // kill loop
		this.$el.removeClass('is-wiggling');

		TweenMax.set(this.$img, {clearProps:'x, y, scale, force3D'});
	}

	//

	_tick(frameStep){

		if(typeof(frameStep) === 'boolean'){ this._frameStep = frameStep; }

		if(this._frameStep){
			this._wiggle();
			window.requestAnimationFrame(this._tick.bind(this, null));
		}
	}

	_wiggle(){

		if(this.$img && this.$img.length){

			let boundingRect = this.$img[0].getBoundingClientRect();
			let bleed = Math.min(boundingRect.width - this.$el.width(), boundingRect.height - this.$el.height())/(2/this.bleedFactor);

			let clientX = window.SETTINGS.coords.clientX;
			let clientY = window.SETTINGS.coords.clientY;
			let xRatio = (clientX - (boundingRect.left + boundingRect.width/2))/(boundingRect.width/2);
			let yRatio = (clientY - (boundingRect.top + boundingRect.height/2))/(boundingRect.height/2) + 0.3;

			if(!isNaN(xRatio) && !isNaN(yRatio)){
				TweenMax.set(this.$img, {x:0 - Math.round(xRatio * bleed), y:0 - Math.round(yRatio * bleed), force3D:true});
			}
		}
	}

	//
}

module.exports = WigglePhoto;

},{"../../90_utils/base/BaseModule":131,"../cursor-zoom/script":102}],113:[function(require,module,exports){
var Delaunay;

(function() {
  "use strict";

  var EPSILON = 1.0 / 1048576.0;

  function supertriangle(vertices) {
    var xmin = Number.POSITIVE_INFINITY,
        ymin = Number.POSITIVE_INFINITY,
        xmax = Number.NEGATIVE_INFINITY,
        ymax = Number.NEGATIVE_INFINITY,
        i, dx, dy, dmax, xmid, ymid;

    for(i = vertices.length; i--; ) {
      if(vertices[i][0] < xmin) xmin = vertices[i][0];
      if(vertices[i][0] > xmax) xmax = vertices[i][0];
      if(vertices[i][1] < ymin) ymin = vertices[i][1];
      if(vertices[i][1] > ymax) ymax = vertices[i][1];
    }

    dx = xmax - xmin;
    dy = ymax - ymin;
    dmax = Math.max(dx, dy);
    xmid = xmin + dx * 0.5;
    ymid = ymin + dy * 0.5;

    return [
      [xmid - 20 * dmax, ymid -      dmax],
      [xmid            , ymid + 20 * dmax],
      [xmid + 20 * dmax, ymid -      dmax]
    ];
  }

  function circumcircle(vertices, i, j, k) {
    var x1 = vertices[i][0],
        y1 = vertices[i][1],
        x2 = vertices[j][0],
        y2 = vertices[j][1],
        x3 = vertices[k][0],
        y3 = vertices[k][1],
        fabsy1y2 = Math.abs(y1 - y2),
        fabsy2y3 = Math.abs(y2 - y3),
        xc, yc, m1, m2, mx1, mx2, my1, my2, dx, dy;

    /* Check for coincident points */
    if(fabsy1y2 < EPSILON && fabsy2y3 < EPSILON)
      throw new Error("Eek! Coincident points!");

    if(fabsy1y2 < EPSILON) {
      m2  = -((x3 - x2) / (y3 - y2));
      mx2 = (x2 + x3) / 2.0;
      my2 = (y2 + y3) / 2.0;
      xc  = (x2 + x1) / 2.0;
      yc  = m2 * (xc - mx2) + my2;
    }

    else if(fabsy2y3 < EPSILON) {
      m1  = -((x2 - x1) / (y2 - y1));
      mx1 = (x1 + x2) / 2.0;
      my1 = (y1 + y2) / 2.0;
      xc  = (x3 + x2) / 2.0;
      yc  = m1 * (xc - mx1) + my1;
    }

    else {
      m1  = -((x2 - x1) / (y2 - y1));
      m2  = -((x3 - x2) / (y3 - y2));
      mx1 = (x1 + x2) / 2.0;
      mx2 = (x2 + x3) / 2.0;
      my1 = (y1 + y2) / 2.0;
      my2 = (y2 + y3) / 2.0;
      xc  = (m1 * mx1 - m2 * mx2 + my2 - my1) / (m1 - m2);
      yc  = (fabsy1y2 > fabsy2y3) ?
        m1 * (xc - mx1) + my1 :
        m2 * (xc - mx2) + my2;
    }

    dx = x2 - xc;
    dy = y2 - yc;
    return {i: i, j: j, k: k, x: xc, y: yc, r: dx * dx + dy * dy};
  }

  function dedup(edges) {
    var i, j, a, b, m, n;

    for(j = edges.length; j; ) {
      b = edges[--j];
      a = edges[--j];

      for(i = j; i; ) {
        n = edges[--i];
        m = edges[--i];

        if((a === m && b === n) || (a === n && b === m)) {
          edges.splice(j, 2);
          edges.splice(i, 2);
          break;
        }
      }
    }
  }

  Delaunay = {
    triangulate: function(vertices, key) {
      var n = vertices.length,
          i, j, indices, st, open, closed, edges, dx, dy, a, b, c;

      /* Bail if there aren't enough vertices to form any triangles. */
      if(n < 3)
        return [];

      /* Slice out the actual vertices from the passed objects. (Duplicate the
       * array even if we don't, though, since we need to make a supertriangle
       * later on!) */
      vertices = vertices.slice(0);

      if(key)
        for(i = n; i--; )
          vertices[i] = vertices[i][key];

      /* Make an array of indices into the vertex array, sorted by the
       * vertices' x-position. */
      indices = new Array(n);

      for(i = n; i--; )
        indices[i] = i;

      indices.sort(function(i, j) {
        return vertices[j][0] - vertices[i][0];
      });

      /* Next, find the vertices of the supertriangle (which contains all other
       * triangles), and append them onto the end of a (copy of) the vertex
       * array. */
      st = supertriangle(vertices);
      vertices.push(st[0], st[1], st[2]);
      
      /* Initialize the open list (containing the supertriangle and nothing
       * else) and the closed list (which is empty since we havn't processed
       * any triangles yet). */
      open   = [circumcircle(vertices, n + 0, n + 1, n + 2)];
      closed = [];
      edges  = [];

      /* Incrementally add each vertex to the mesh. */
      for(i = indices.length; i--; edges.length = 0) {
        c = indices[i];

        /* For each open triangle, check to see if the current point is
         * inside it's circumcircle. If it is, remove the triangle and add
         * it's edges to an edge list. */
        for(j = open.length; j--; ) {
          /* If this point is to the right of this triangle's circumcircle,
           * then this triangle should never get checked again. Remove it
           * from the open list, add it to the closed list, and skip. */
          dx = vertices[c][0] - open[j].x;
          if(dx > 0.0 && dx * dx > open[j].r) {
            closed.push(open[j]);
            open.splice(j, 1);
            continue;
          }

          /* If we're outside the circumcircle, skip this triangle. */
          dy = vertices[c][1] - open[j].y;
          if(dx * dx + dy * dy - open[j].r > EPSILON)
            continue;

          /* Remove the triangle and add it's edges to the edge list. */
          edges.push(
            open[j].i, open[j].j,
            open[j].j, open[j].k,
            open[j].k, open[j].i
          );
          open.splice(j, 1);
        }

        /* Remove any doubled edges. */
        dedup(edges);

        /* Add a new triangle for each edge. */
        for(j = edges.length; j; ) {
          b = edges[--j];
          a = edges[--j];
          open.push(circumcircle(vertices, a, b, c));
        }
      }

      /* Copy any remaining open triangles to the closed list, and then
       * remove any triangles that share a vertex with the supertriangle,
       * building a list of triplets that represent triangles. */
      for(i = open.length; i--; )
        closed.push(open[i]);
      open.length = 0;

      for(i = closed.length; i--; )
        if(closed[i].i < n && closed[i].j < n && closed[i].k < n)
          open.push(closed[i].i, closed[i].j, closed[i].k);

      /* Yay, we're done! */
      return open;
    },
    contains: function(tri, p) {
      /* Bounding box test first, for quick rejections. */
      if((p[0] < tri[0][0] && p[0] < tri[1][0] && p[0] < tri[2][0]) ||
         (p[0] > tri[0][0] && p[0] > tri[1][0] && p[0] > tri[2][0]) ||
         (p[1] < tri[0][1] && p[1] < tri[1][1] && p[1] < tri[2][1]) ||
         (p[1] > tri[0][1] && p[1] > tri[1][1] && p[1] > tri[2][1]))
        return null;

      var a = tri[1][0] - tri[0][0],
          b = tri[2][0] - tri[0][0],
          c = tri[1][1] - tri[0][1],
          d = tri[2][1] - tri[0][1],
          i = a * d - b * c;

      /* Degenerate tri. */
      if(i === 0.0)
        return null;

      var u = (d * (p[0] - tri[0][0]) - b * (p[1] - tri[0][1])) / i,
          v = (a * (p[1] - tri[0][1]) - c * (p[0] - tri[0][0])) / i;

      /* If we're outside the tri, fail. */
      if(u < 0.0 || v < 0.0 || (u + v) > 1.0)
        return null;

      return [u, v];
    }
  };

  if(typeof module !== "undefined")
    module.exports = Delaunay;
})();

},{}],114:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class FracturedGraph extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$graphWrapper = this.$el.find('.graph-wrapper');
		this.$svg = this.$el.find('.svg-graph');
		this.$domData = this.$el.find('.dom-data');

		this.centerTemplate = _.template(this.$el.find('#center-template').html());
		this.graphTemplate = _.template(this.$el.find('#graph-template').html());
		this.sectorLabelTemplate = _.template(this.$el.find('#sector-label-template').html());

		this.$el.find('#graph-template').remove();
		this.$el.find('#sector-label-template').remove();

		this.isFirstBuild = true;
		this.shouldAnimate = false;
	}

	// basemodule methods

	_domReady(){

		this.$domData = this.$el.find('.dom-data');

		if(this.$domData.length){
			this._retrieveDomData();
			this._rebuild();
		}
	}

	_addListeners(){

	}

	_removeListeners(){

	}

	//

	_show(){
		this.shouldAnimate = true;
		this._animateBars();
	}
	_hide(){ }

	_enable(){ }
	_disable(){ }

	// public swap data / rebuild method

	swapData(graphData){
		this.graphData = graphData;
		this.shouldAnimate = true;
		this._rebuild();
		this._animateBars();
	}

	//

	_animateBars(){

		if( this.shouldAnimate && !window.utils.BrowserUtils.isIE() ){

			let $bars = this.$el.find('.svg-graph #inner-circles circle');

			$bars.each((i, el)=>{

				let $el = $(el);
				let dasharray = $el.css('stroke-dasharray');

				if( dasharray ){
					let strokeoffset = dasharray.split(',');
					let offset1 = parseFloat(strokeoffset[ 0 ]);
					let offset2 = parseFloat(strokeoffset[ 1 ]);

					let offset = { length: 0 };

					TweenMax.set($el, { 'stroke-dasharray': offset.length + ' ' + offset2 });
					TweenMax.to(offset, 0.6, {
						length: offset1,
						ease: 'progressSlide',
						delay: (i*0.1),
						onUpdate: ()=>{
							TweenMax.set($el, { 'stroke-dasharray': offset.length + ' ' + offset2 });
						}
					});
				}
			});

			this.shouldAnimate = false;
		}
	}

	_retrieveDomData(){

		this.graphData = {
			maxValue: this.$domData.attr('data-max-value')
		};

		// center

		let $centerData = this.$domData.find('.center');

		this.graphData.center = {
			value: $centerData.attr('data-value'),
			unit: $centerData.attr('data-unit'),
			supheader: $centerData.attr('data-supheader'),
			subheader: $centerData.attr('data-subheader')
		}

		// data points

		let $dataPoints = this.$domData.find('.data-point');

		this.graphData.dataPoints = [];

		$dataPoints.each((index, value) => {

			let $dataPoint = $(value);

			this.graphData.dataPoints.push({
				label: $dataPoint.attr('data-label'),
				subheader: $dataPoint.attr('data-subheader'),
				value: $dataPoint.attr('data-value')
			});
		});
	}

	_rebuild(){

		let $bgCircle = this.$el.find('#bg-circle');
		let $svgWrapper = this.$el.find('.svg-wrapper');
		let $sectorLabels = this.$el.find('.sector-labels');

		let graphViewBox = {
			width: 580,
			height: 580
		}

		let minRadius = 160;
		let lineWidth = window.SETTINGS.breakpoint.minWidth('screen-phablet') ? 10 : 16;
		let labelDistance = 32;
		let maxLabelDistance = window.utils.BrowserUtils.isIE() ? 30 : 60;

		let totalPoints = this.graphData.dataPoints.length;
		let maxRadius = minRadius + totalPoints * lineWidth;

		let circleCompleteRatio = 0;

		// resize bg circle

		let bg = {
			strokeWidth: totalPoints * lineWidth,
			r: minRadius - lineWidth/2 + totalPoints * lineWidth / 2,
			cx: graphViewBox.width/2,
			cy: graphViewBox.height/2
		};

		// rebuild inner circles

		let innerCircles = [];
		let sectorLabels = [];

		for(let i=0; i<totalPoints; i++){

			// divide into sectors

			let dataPoint = this.graphData.dataPoints[i];
			let radius = lineWidth * (totalPoints - i - 1) + minRadius;
			let ratio = dataPoint.value / this.graphData.maxValue;
			let circumference = radius * 2 * Math.PI;
			let dashArray = `${circumference * ratio} ${circumference}`;
			let dashOffset = 0 - circumference * circleCompleteRatio;
			let lineStyle = `stroke-dasharray: ${dashArray}; stroke-dashoffset: ${dashOffset};`;
			let rotation = (-90) + 360 * circleCompleteRatio;

			innerCircles.push({
				id: 'inner-circle' + i,
				lineWidth: lineWidth,
				style: lineStyle,
				r: radius,
				cx: graphViewBox.width/2,
				cy: graphViewBox.height/2,
				transform: `rotate(-90 ${graphViewBox.width/2} ${graphViewBox.height/2})`
			});

			// position labels

			let graphBounds = window.utils.PositioningUtils.getExtendedOffset($svgWrapper);
			let svgOffset = $svgWrapper.position()
			let resizeRatio = graphBounds.width / graphViewBox.width;

			if(resizeRatio < 1){
				// resizeRatio *= 1.2;
				labelDistance /= (1 - resizeRatio) * 0.6;
			} // scale distance up slightly as graph gets smaller

			labelDistance = Math.min(labelDistance, maxLabelDistance);

			let rad = (circleCompleteRatio + ratio/2 - 0.25) * 2 * Math.PI;
			let labelX = Math.cos(rad) * (maxRadius + labelDistance) * resizeRatio + graphBounds.width/2 + svgOffset.left;
			let labelY = Math.sin(rad) * (maxRadius + labelDistance) * resizeRatio + graphBounds.height/2 + svgOffset.top;

			let xModifier = Math.min(0, Math.cos(rad)) * (dataPoint.label.length * 4);

			// console.log('graph bounds', graphBounds.width, 'viewbox', graphViewBox.width, 'rad', rad, 'maxRadius', maxRadius, 'labelDistance', labelDistance, 'resizeRatio', resizeRatio, 'coords:', labelX, labelY, dataPoint.label, dataPoint.subheader);

			sectorLabels.push({
				top: labelY,
				left: labelX + xModifier,
				label: dataPoint.label,
				subheader: dataPoint.subheader
			});

			circleCompleteRatio += ratio;
		}

		// console.log('---');

		// center area

		let $graphCenter = this.$el.find('.graph-center');
		let centerData = this.graphData.center;

		let center = {
			supheader: centerData.supheader,
			subheader: centerData.subheader,
			unit: centerData.unit,
			title: window.utils.NumberUtils.addCommas(centerData.value)
		};

		if(!center.title){
			this.$el.addClass('empty-center');
		}
		else {
			this.$el.removeClass('empty-center');
		}

		//

		$graphCenter.html(this.centerTemplate(center));

		$svgWrapper.html(this.graphTemplate({
			bg: bg,
			innerCircles: innerCircles
		}));

		$sectorLabels.html(this.sectorLabelTemplate({
			sectorLabels: sectorLabels
		}));

		// 'refresh' svg (won't display otherwise)

		this.$graphWrapper.html(this.$graphWrapper.html())
	}

	//

	_domUpdate(){

	}

	_resize(){
		if(this.graphData){
			this._rebuild();
		}
	}

}

module.exports = FracturedGraph;

},{"../../90_utils/base/BaseModule":131}],115:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class GradientShape extends BaseModule {

	constructor(el, params) {

		super(el);

		this.startColor;
		this.endColor;
		this.$shape;
		this.$gradient;
		this.$gradientStops;
	}

	// basemodule methods

	_domReady(){

		this.$shape = this.$el.find('.svg');
		this.$gradient = this.$shape.find('#gradient');
		this.$gradientStops = this.$gradient.find('stop');

		if(isNaN(window.SETTINGS.vars.svgIndex)){ window.SETTINGS.vars.svgIndex = 0; }
		else { window.SETTINGS.vars.svgIndex++; }

		let gradientId = window.SETTINGS.vars.svgIndex;
		this.$gradient.attr('id', 'gradient' + gradientId);
		this.$shape.find('path').attr('fill', 'url(#gradient' + gradientId + ')');

		this._domUpdate();
		this.color();
	}

	_addListeners(){ }
	_removeListeners(){ }

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){

		this.startColor = this.checkVal(this.$el.data('gradient-start-color'), '#25c4f6');
		this.endColor = this.checkVal(this.$el.data('gradient-end-color'), '#f6379a');

	}
	_resize(){}

	//

	color(){
		// console.log(this.startColor, this.endColor, this.$shape, this.$gradient, this.$gradientStops);
		this.$gradientStops.eq(0).attr('stop-color', this.startColor);
		this.$gradientStops.eq(1).attr('stop-color', this.endColor);
	}
}

module.exports = GradientShape;

},{"../../90_utils/base/BaseModule":131}],116:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class HorizontalGraph extends BaseModule {

	constructor(el, params) {

		super(el);

		this.graphTemplate = _.template(this.$el.find('#graph-template').html());
		this.$el.find('#graph-template').remove();

		this.domData;

		this.isFirstBuild = true;
	}

	// basemodule methods

	_domReady(){
		if(this.isFirstBuild){
			this._retrieveDomData();
			this._rebuild();
		}
	}

	_addListeners(){

	}

	_removeListeners(){

	}

	//

	_show(){

		let $lines = this.$el.find('.lines li');
		let $bars = this.$el.find('.bar svg rect');
		let $values = this.$el.find('.bar svg text');
		let $labels = this.$el.find('.label');
		let $linewrappers = this.$el.find('.line-wrapper');

		TweenMax.set($linewrappers, { overflow: 'hidden' });
		TweenMax.set([$lines, $labels, $values], { opacity: 0 });
		TweenMax.set($bars, { x: '-100%' });

		TweenMax.staggerTo($lines, 0.3, {
			opacity: 1,
			clearProps: 'opacity',
			ease: 'fade'
		}, 0.008);

		TweenMax.staggerTo($bars, 0.8, {
			x: '0%',
			ease: 'progressSlide',
			clearProps: 'x',
			onComplete: ()=>{

				TweenMax.set($linewrappers, { clearProps: 'overflow' });

				TweenMax.staggerTo($values, 0.3, {
					opacity: 1,
					ease: 'fade'
				}, 0.1);
			}
		}, 0.15);

		TweenMax.staggerTo($labels, 0.3, {
			opacity: 1,
			ease: 'fade',
			delay: 0.2
		}, 0.1);
	}
	_hide(){ }

	_enable(){ }
	_disable(){ }

	// public swap data / rebuild method

	swapData(graphData){
		this.graphData = graphData;
		this._rebuild();
	}

	//

	_retrieveDomData(){

		let $domData = this.$el.find('.dom-data');

		this.domData = {
			maxValue: $domData.data('max-value'),
			increment: $domData.data('increment'),
			incrementCount: $domData.data('increment-count'),
			dataPoints: [],
			lineLabels: []
		}

		let $dataPoints = $domData.find('>.data-point');

		$dataPoints.each((index, value) => {

			let $dataPoint = $(value);

			this.domData.dataPoints.push({
				label: $dataPoint.data('label'),
				bar: null,
				greyBar: null
			});

			let dataPoint = this.domData.dataPoints[index];
			let $bar = $dataPoint.find('.bar--primary');
			let $greyBar = $dataPoint.find('.bar--grey');

			dataPoint.bar = {
				value: $bar.data('value'),
				unit: $bar.data('unit'),
				valueLabel: $bar.data('value-label')
			};

			if($greyBar.length){
				dataPoint.greyBar = {
					value: $greyBar.data('value'),
					unit: $greyBar.data('unit'),
					valueLabel: $bar.data('value-label')
				};
			}
		});

		for(let i=0; i<this.domData.incrementCount; i++){
			if(i%5 === 0){
				this.domData.lineLabels.push({
					label: window.utils.NumberUtils.formatNumber(this.domData.maxValue - i * this.domData.increment, 2),
					textY: 0
				});
			}
		}

		this.domData.minValue = this.domData.maxValue - this.domData.incrementCount * this.domData.increment;

		this.domData.lineLabels.push({
			label: window.utils.NumberUtils.formatNumber(this.domData.minValue, 2),
			textY: 0
		});

		this.domData.lineLabels.reverse();
	}

	_rebuild(){

		let $bgLines = this.$el.find('.lines');
		this.domData.graphWidth = $bgLines.outerWidth();
		this.domData.maxLineWidth = this.domData.graphWidth + 10;

		// line labels

		let numBreaks = this.domData.lineLabels.length;

		for(let i=1; i<numBreaks-1; i++){
			this.domData.lineLabels[i].textX = this.domData.graphWidth / (numBreaks - 1) * i; // -1 removes extra at end
		}

		this.domData.lineLabels[numBreaks-1].textX = this.domData.graphWidth;

		// graph content

		for(let i=0; i<this.domData.dataPoints.length; i++){

			let dataPoint = this.domData.dataPoints[i];

			if(dataPoint.bar){

				let barData = dataPoint.bar;
				let valueLabel = window.utils.NumberUtils.addCommas(barData.value);
				let lineWidth = parseFloat($bgLines.outerWidth()) * (barData.value/this.domData.maxValue) + 10;
				let textX = lineWidth + 10;

				if(barData.unit === '$'){ valueLabel = barData.unit + valueLabel; }
				else { valueLabel = valueLabel + barData.unit; }

				barData.view = {
					svgId: ++window.SETTINGS.vars.svgIndex,
					lineWidth: lineWidth,
					textX: textX,
					valueLabel: barData.valueLabel ? barData.valueLabel : valueLabel
				};
			}

			if(dataPoint.greyBar){

				let barData = dataPoint.greyBar;
				let valueLabel = window.utils.NumberUtils.addCommas(barData.value);
				let lineWidth = parseFloat($bgLines.outerWidth()) * (barData.value/this.domData.maxValue) + 10;
				let textX = lineWidth + 10;

				if(barData.unit === '$'){ valueLabel = barData.unit + valueLabel; }
				else { valueLabel = valueLabel + barData.unit; }

				barData.view = {
					lineWidth: lineWidth,
					textX: textX,
					valueLabel: barData.valueLabel ? barData.valueLabel : valueLabel
				};
			}
		}

		this.$el.find('.template-wrapper').html(this.graphTemplate(this.domData));

		this.isFirstBuild = false;
	}

	//

	_domUpdate(){

	}

	_resize(){
		if(this.domData){
			this._rebuild();
		}
	}

}

module.exports = HorizontalGraph;

},{"../../90_utils/base/BaseModule":131}],117:[function(require,module,exports){
const Delaunay = require('./../delaunay/script');

class FragmentBackground {

    constructor(el) {

        this.$el = el;
        this.$window = $(window);

        this.dimension = {
            width: 0,
            height: 0
        };

        this.size = {
            width: 532,
            height: 266
        };

        this.rendere;
        this.scene;
        this.lights = {};
        this.camera;
        this.mesh = {};

        this.gradient;
        this.grid;

        this.points = [];
        this.fragments = [];
        this.map = {};

        this.changed = false;

        this.parseGradient(el.data('gradient'));
        this.parseGrid(el.data('grid'));

        this.measure();

        this.setScene();
        this.addLights();
        this.addCamera();

        this.addBackground(el.data('background-image')).then(() => {
            this.addPolygonGrid(25, this.mesh.background ? true : false);
            this.addPolygonGrid(75);
            this.render();
        });

        this.addEventListeners();

    }

    loadTexture(url) {
        return new Promise((resolve, reject) => {
            let texture = new THREE.TextureLoader();
            texture.load(url, resolve);
        });
    }

    generatePoints() {
        let points = [];
        let column = this.size.width / this.grid[0],
            row = this.size.height / this.grid[1];
        for (let c = 0; c <= this.grid[0]; ++c) {
            for (let r = 0; r <= this.grid[1]; ++r) {
                let x = c * column + (Math.random() * column - column * .5),
                    y = r * row + (Math.random() * row - row * .5);
                points.push([Math.floor(x), Math.floor(y)]);
            }
        }
        return points;
    }

    parseGradient(gradient) {
        let gd = gradient.split('-');
        this.gradient = {
            degree: gd[0],
            colors: [gd[1].split(','), gd[2].split(',')]
        };
    }

    parseGrid(grid) {
        this.grid = grid.split(',');
    }

    measure() {
        this.dimension = {
            width: this.$el.width(),
            height: this.$el.height()
        };
    }

    resize() {
    	if(window.SETTINGS.breakpoint.minWidth('screen-medium')){
    		this.$el.removeClass('display-none');
	        this.renderer.setSize(this.dimension.width, this.dimension.height);
	        this.camera.aspect = this.dimension.width / this.dimension.height;
	        this.camera.updateProjectionMatrix();
    	}
    	else {
    		this.$el.addClass('display-none');
    	}
    }

    setScene() {
        this.scene = new THREE.Scene();
        this.renderer = new THREE.WebGLRenderer({alpha: true, antialias: true});
        this.renderer.setSize(this.dimension.width, this.dimension.height);
        this.$el.append(this.renderer.domElement);
    }

    addLights() {
        this.lights.ambient = new THREE.AmbientLight(0xFFFFFF);
        this.lights.spotlight = new THREE.SpotLight(0x666666, .5, 0, Math.PI / 3, 1);
        this.lights.spotlight.position.z = 1000;
        this.scene.add(this.lights.ambient);
        this.scene.add(this.lights.spotlight);
    }

    addCamera() {
        this.camera = new THREE.PerspectiveCamera(25, this.dimension.width / this.dimension.height, 1, 10000);
        this.camera.position.z = 500;
        this.scene.add(this.camera);
    }

    addBackground(background) {
        return new Promise((resolve, reject) => {
            if (background) {
                this.loadTexture(background).then((texture) => {
                    let geometry = new THREE.PlaneGeometry(this.size.width, this.size.height),
                        material = new THREE.MeshBasicMaterial({map: texture});
                    this.mesh.background = new THREE.Mesh(geometry, material);
                    this.scene.add(this.mesh.background);
                    resolve();
                });
            } else {
                resolve();
            }
        });
    }

    // TODO! separate functionality
    addPolygonGrid(margin, multiply) {
        let points = this.generatePoints(),
            triangles = Delaunay.triangulate(points);

        for (let i = triangles.length; i;) {

            let geometry = new THREE.Geometry();

            let position = [0, 0],
                hash = [];

            for (let ii = 0; ii < 3; ++ii) {
                --i;
                geometry.vertices.push(new THREE.Vector3(points[triangles[i]][0] - this.size.width * .5, points[triangles[i]][1] - this.size.height * .5, 0));
                position[0] += points[triangles[i]][0];
                position[1] += points[triangles[i]][1];
                hash.push({
                    id: points[triangles[i]][0] + '-' + points[triangles[i]][1],
                    point: ii
                });
            }

            geometry.faces.push(new THREE.Face3(0, 1, 2));
            geometry.dynamic = true;
            geometry.computeFaceNormals();
            geometry.computeVertexNormals();

            position[0] /= 3;
            position[1] /= 3;

            let level = [
                position[0] / this.size.width,
                position[1] / this.size.height
            ];

            let color = (level[1] + (level[0] * (this.gradient.degree / 90))) / (1 + this.gradient.degree / 90);

            let rgb = [
                Math.round(this.gradient.colors[0][0] - ((this.gradient.colors[0][0] - this.gradient.colors[1][0]) * color)),
                Math.round(this.gradient.colors[0][1] - ((this.gradient.colors[0][1] - this.gradient.colors[1][1]) * color)),
                Math.round(this.gradient.colors[0][2] - ((this.gradient.colors[0][2] - this.gradient.colors[1][2]) * color))
            ];

            let material = new THREE.MeshPhongMaterial({
                color: `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`,
                specular: 0x25c4f6,
                shading: THREE.FlatShading,
                side: THREE.DoubleSide,
                blending: multiply ? THREE.MultiplyBlending : false,
                shininess: 100,
                transparent: true,
                opacity: Math.random() * 0.10 + 0.05
            });

            let mesh = new THREE.Mesh(geometry, material);
            mesh.position.z = margin;

            this.fragments.push({
                mesh,
                points: [
                    {z: [0, 0]},
                    {z: [0, 0]},
                    {z: [0, 0]}
                ]
            });

            for (let h of hash) {
                if (!this.map[h.id]) this.map[h.id] = [];
                this.map[h.id].push({
                    fragment: this.fragments.length - 1,
                    point: h.point
                });
            }

            this.scene.add(mesh);
        }

        for (let p of points) this.points.push(p);
    }

    update() {
        for (let p of this.points) {
            let value = Math.random() * 50 - 25;
            for (let m of this.map[p[0] + '-' + p[1]]) {
                let difference = this.fragments[m.fragment].points[m.point].z[1] - this.fragments[m.fragment].points[m.point].z[0];
                if (Math.abs(difference) < 1) this.fragments[m.fragment].points[m.point].z[1] = value;
                this.fragments[m.fragment].points[m.point].z[0] += difference * .0075;
                this.fragments[m.fragment].mesh.geometry.vertices[m.point].z = this.fragments[m.fragment].points[m.point].z[0];
                this.fragments[m.fragment].mesh.geometry.verticesNeedUpdate = true;
            }
        }
        this.changed = true;
    }

    render() {
        this.update();
        this.renderer.render(this.scene, this.camera);
    }

    destroy() {
        this.$el.remove();
        this.removeEventListeners();
    }

    windowOnResize() {
        this.measure();
        this.resize();
    }

    addEventListeners() {
        window.vent.on('windowResize', this.resize, this);
    }

    removeEventListeners() {
        window.vent.off('windowResize', this.resize, this);
    }

}

module.exports = FragmentBackground;

},{"./../delaunay/script":113}],118:[function(require,module,exports){
class RenderEngine {

    constructor() {
        this.$window = $(window);

        this.viewport = {
            width: 0,
            height: 0,
            top: 0
        };

        this.count = 0;

        this.animation = {};
        this.size = {};
        this.visible = [];

        this.animationFrame;
        this.interval;

        this.isRunning = false;
        this.isPaused = false;

        this.measureViewport();

        this.addEventListeners();
    }

    add(animation) {
        let i = ++this.count;
        this.animation[i] = animation;
        this.measure(i);
        return i;
    }

    remove(i) {
        delete this.animation[i];
        delete this.size[i];
    }

    measure(i) {
        if (!i) for (let a in this.animation) {
            this.measure(a); return;
        }
        if(this.animation[i]){
	        let el = this.animation[i].$el;
	        this.size[i] = {
	            width: el.outerWidth(),
	            height: el.outerHeight(),
	            offset: el.offset()
	        };
	    }
    }

    measureViewport() {
        this.viewport = {
            width: this.$window.width(),
            height: this.$window.height()
        };
    }

    scrollTop() {
        this.viewport.top = this.$window.scrollTop();
    }

    markVisible() {
        this.visible = [];
        for (let a in this.animation) {
            if (this.viewport.top + this.viewport.height > this.size[a].offset.top && this.viewport.top < this.size[a].offset.top + this.size[a].height) {
                this.visible.push(a);
            }
        }
        this.visible.length ? this.start() : this.stop();
    }

    update() {
        for (let i of this.visible) {
            let animation = this.animation[i];
            if (animation.update) animation.update();
        }
    }

    heartbeat() {
        this.interval = setInterval(() => {
            if(!this.isPaused){
            	this.update();
            }
        }, 1000 / 60);
    }

    loop() {
        this.animationFrame = requestAnimationFrame((time) => {
    		this.loop();
        });
        if(!this.isPaused){
        	this.frame();
        }
    }

    frame() {
        for (let i of this.visible) {
            let animation = this.animation[i];
            if (animation.changed) {
                if (animation.clear) animation.clear();
                animation.render();
                animation.changed = false;
            }
        }
    }

    start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.heartbeat();
        this.loop();
    }

    stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        cancelAnimationFrame(this.animationFrame);
        clearInterval(this.interval);
    }

    unpause() {
        if (!this.isPaused) return;
        this.isPaused = false;
    }

    pause() {
        if (this.isPaused) return;
        this.isPaused = true;
    }

    reset() {
        this.size = {};
        this.visible = [];
        for (let a in this.animation) {
            if (this.animation[a].destroy) this.animation[a].destroy();
        }
        this.animation = {};
    }

    windowOnLoad() {
        this.measure();
        this.scrollTop();
        this.markVisible();
    }

    windowOnScroll() {
        this.scrollTop();
        this.markVisible();
    }

    windowOnResize() {
        this.measure();
        this.measureViewport();
        this.scrollTop();
        this.markVisible();
    }

    addEventListeners() {
        this.windowOnLoad = this.windowOnLoad.bind(this);
        this.windowOnScroll = this.windowOnScroll.bind(this);
        this.windowOnResize = this.windowOnResize.bind(this);

        this.$window.on('load', this.windowOnLoad);
        this.$window.on('scroll', this.windowOnScroll);
        this.$window.on('resize', this.windowOnResize);
    }

}

module.exports = RenderEngine;

},{}],119:[function(require,module,exports){
const FracturedGraph = require('./fractured-graph/script');
const FragmentBackground = require('./polygon-background/script');
const GradientShape = require('./gradient-shape/script');
const Stat = require('./stat/script');
const TextSplitter = require('./text-splitter/script');

window.SETTINGS.domScan.addContainer( null, ($scanContainer) => {

	window.SETTINGS.domScan.addElement($scanContainer, '[data-fractured-graph]', function () {
		new FracturedGraph($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-gradient-shape]', function () {
		new GradientShape($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-split-text]', function () {
		// new TextSplitter($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-stat]', function () {
		new Stat($(this));
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-polygon-background]', function () {
		// window.RENGINE.add(new FragmentBackground(this));
	});

});

},{"./fractured-graph/script":114,"./gradient-shape/script":115,"./polygon-background/script":117,"./stat/script":120,"./text-splitter/script":121}],120:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class Stat extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$statNumber = this.$el.find('.stat-number');
	}

	// basemodule methods

	_domReady(){
		this._domUpdate();
	}

	_addListeners(){ }

	_removeListeners(){ }

	// listener methods

	_onReadMoreClick(e){
		e.preventDefault();
	}

	//

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){
		let numString = this.$statNumber.text().replace(/\,/g,'');
		let numDec = numString.indexOf('.') >= 0 ? numString.length - numString.indexOf('.') - 1 : 0;
		let commaNumber = window.utils.NumberUtils.formatNumber(parseFloat(numString), 1, numDec, true);
		console.log(this.$statNumber.text(), numString, parseFloat(numString));
		this.$statNumber.html(commaNumber);
	}

	_resize(){ }
}

module.exports = Stat;

},{"../../90_utils/base/BaseModule":131}],121:[function(require,module,exports){
class TextSplitter {

	constructor(el, params) {

		// core vars

		this.$el = $(el);
		this.params = params;

		// param vars

		// This adds line and word classes to each element, making it easier to detect the positioning of objects
		// without having to make a new TextSplitter().
		// If your text is looking weird, make sure the FONT IS LOADED FIRST!

		this._defaults = {

			type: 'words,lines',

			// label classes

			charsClass: 'char',
			wordsClass: 'word',
			linesClass: 'line',

			// word delimiter

			wordDelimiter: ' ',

			// double-wrap divs for masking or animation effects

			doubleWrapLine: false,
			doubleWrapWord: false,
			doubleWrapChar: false,

			// check window resize and rebuild

			responsive: true
		}

		this._options = this._mergeDefaults(params);

		// main split var

		this._split;

		// don't allow splitting too often (that's stilly)

		this._splitThrottler = _.throttle(this._splitText, 400);

		// flags

		this._isEnabled = false;

		//

		$(() => {
			this._onDomReady();
		});
	}

	// listeners linked to public methods

	_addModuleAccess(){

		// events linked to methods (do this often)

		this.$el.on('enable', this.enable.bind(this));
		this.$el.on('disable', this.disable.bind(this));
		this.$el.on('revert', this.revert.bind(this));

		// link to module from $el object (use with caution)

		if(!this.$el[0].modules){ this.$el[0].modules = {}; }
		this.$el[0].modules.simpleSlider = this;
	}

	// private methods

	_onDomReady(){
		this._addModules();
		this._addListeners();
		this.enable();
	}

	_addModules(){

	}

	// listeners

	_addListeners(){
		window.vent.on('domUpdate', this._onDomUpdate, this);
		window.vent.on('windowResize', this._onResize, this);
	}

	_removeListeners(){

	}

	// listener methods

	_onDomUpdate(){
		this._splitThrottler();
	}

	_onResize(){
		this._resize();
	}

	//

	_resize(){
		this._splitThrottler();
	}

	// split methods

	_splitText(){

		if(this._isEnabled){

			this._GSAPSplit();
			this._GSAPSplit(); // needs to be doubled due to a bug (TODO: fix)
			this._addClasses();
		}
	}

	_GSAPSplit(){
		if(this._split){ this._split.revert(); }
		this._split = new SplitText(this.$el, {position:'absolute', type:this._options.type});
	}

	_addClasses(){

		let lineIndex = 0;
		let lineWordIndex = 0;
		let totalWordIndex = 0;

		if(this._split.lines && this._split.lines.length > 0){

			for(let i = 0; i<this._split.lines.length; i++){

				let $line = $(this._split.lines[i]);
				$line.addClass('line');

				if(this._options.doubleWrapLine){

					let $lineWrapper = $('<div class="line-wrapper"></div>');
					$lineWrapper.addClass('line-wrapper-' + i);
					$lineWrapper.css({
						position: 'absolute',
						top: $line.css('top'),
						left: $line.css('left'),
						width: $line.css('width'),
						height: $line.css('height'),
					});

					$line.css({
						top: 0,
						left: 0,
					});

					$line.parent().append($lineWrapper);
					$line.remove();
					$lineWrapper.html($line);
				}
			}
		}

		if(this._split.words && this._split.words.length > 0){

			let lastTop = $(this._split.words[0]).offset().top;

			for(let i = 0; i<this._split.words.length; i++){

				let $word = $(this._split.words[i]);
				let chars = $word.children();
				let top = $word.offset().top;

				if(top != lastTop){
					lastTop = top;
					lineWordIndex = 0;
					lineIndex ++;
				}

				let lineClass = 'line-' + lineIndex;
				let lineWordClass = 'line-word-' + lineWordIndex;
				let totalWordClass = 'total-word-' + i;

				$word.addClass('word');
				$word.addClass(lineClass);
				$word.addClass(lineWordClass);
				$word.addClass(totalWordClass);

				for(let k=0; k<chars.length; k++){

					let $char = $(chars[k]);

					$char.addClass('char');
					$char.addClass(lineClass);
					$char.addClass(lineWordClass);
					$char.addClass(totalWordClass);

					// double wrap

					if(this._options.doubleWrapChar){

						let $charWrapper = $('<div class="char-wrapper"></div>');
						$charWrapper.addClass('char-wrapper-' + i);
						$charWrapper.css({
							position: 'absolute',
							top: $char.css('top'),
							left: $char.css('left'),
							width: $char.css('width'),
							height: $char.css('height'),
						});

						$char.css({
							top: 0,
							left: 0,
						});

						$char.parent().append($charWrapper);
						$char.remove();
						$charWrapper.html($char);
					}
				}

				// double wrap

				if(this._options.doubleWrapWord){

					let $wordWrapper = $('<div class="word-wrapper"></div>');
					$wordWrapper.addClass('word-wrapper-' + i);
					$wordWrapper.css({
						position: 'absolute',
						top: $word.css('top'),
						left: $word.css('left'),
						width: $word.css('width'),
						height: $word.css('height'),
					});

					$word.css({
						top: 0,
						left: 0,
					});

					$word.parent().append($wordWrapper);
					$word.remove();
					$wordWrapper.html($word);
				}

				//

				lineWordIndex ++;
				totalWordIndex ++;
			}
		}
	}

	//

	enable(){
		if(!this._isEnabled){
			this._isEnabled = true;
			this._resize();
		}
	}

	disable(){
		if(this._isEnabled){
			this._isEnabled = false;
		}
	}

	revert(){
		this.disable();
		if(this._split){ this._split.revert(); }
	}

	// defaults

	_mergeDefaults(options){

		let modifiedOptions = $.extend({}, options);

		for(let key in modifiedOptions){
			let val = (modifiedOptions[key] === 'undefined') ? null : modifiedOptions[key];
			if(val == undefined || val == null){ modifiedOptions[key] = this._defaults[key]; }
		}

		return $.extend({}, this._defaults, modifiedOptions);
	}
}

module.exports = TextSplitter;

},{}],122:[function(require,module,exports){
const BaseModule = require('../../90_utils/base/BaseModule');

class VerticalGraph extends BaseModule {

	constructor(el, params) {

		super(el);

		this.graphTemplate = _.template(this.$el.find('#graph-template').html());
		this.$el.find('#graph-template').remove();

		this.domData;

		this.isFirstBuild = true;
	}

	// basemodule methods

	_domReady(){
		if(this.isFirstBuild){
			this._retrieveDomData();
			this._rebuild();
		}
	}

	_addListeners(){

	}

	_removeListeners(){

	}

	//

	_show(){

		let $lines = this.$el.find('.lines li');
		let $bars = this.$el.find('.bar svg rect');
		let $values = this.$el.find('.bar svg text');
		let $labels = this.$el.find('.label');
		let $linewrappers = this.$el.find('.line-wrapper svg');

		TweenMax.set($linewrappers, { overflow: 'hidden' });
		TweenMax.set([$lines, $labels, $values], { opacity: 0 });
		TweenMax.set($bars, { y: '100%' });

		TweenMax.staggerTo($lines, 0.3, {
			opacity: 1,
			clearProps: 'opacity',
			ease: 'fade'
		}, -0.008);

		TweenMax.staggerTo($bars, 0.8, {
			y: '0%',
			ease: 'progressSlide',
			clearProps: 'y',
			onComplete: ()=>{

				TweenMax.set($linewrappers, { clearProps: 'overflow' });

				TweenMax.staggerTo($values, 0.3, {
					opacity: 1,
					ease: 'fade'
				}, 0.1);
			}
		}, 0.15);

		TweenMax.staggerTo($labels, 0.3, {
			opacity: 1,
			ease: 'fade',
			delay: 0.2
		}, 0.1);
	}
	_hide(){ }

	_enable(){ }
	_disable(){ }

	// public swap data / rebuild method

	swapData(graphData){
		this.graphData = graphData;
		this._rebuild();
	}

	//

	_retrieveDomData(){

		let $domData = this.$el.find('.dom-data');

		this.domData = {
			minValue: 0,
			maxValue: $domData.data('max-value'),
			increment: $domData.data('increment'),
			incrementCount: $domData.data('increment-count'),
			dataPoints: [],
			lineLabels: []
		}

		let $gradient = $domData.find('>.gradient');

		if($gradient.length){
			this.domData.gradient = {
				start: $gradient.attr('data-start'),
				stop: $gradient.attr('data-stop')
			}
		}

		let $dataPoints = $domData.find('>.data-point');

		$dataPoints.each((index, value) => {

			let $dataPoint = $(value);

			this.domData.dataPoints.push({
				label: $dataPoint.data('label'),
				bar: null,
				greyBar: null
			});

			let dataPoint = this.domData.dataPoints[index];
			let $bar = $dataPoint.find('.bar--primary');
			let $greyBar = $dataPoint.find('.bar--grey');

			dataPoint.bar = {
				value: $bar.data('value'),
				unit: $bar.data('unit'),
				valueLabel: $bar.data('value-label')
			};

			if($greyBar.length){
				dataPoint.greyBar = {
					value: $greyBar.data('value'),
					unit: $greyBar.data('unit'),
					valueLabel: $bar.data('value-label')
				};
			}
		});

		for(let i=0; i<this.domData.incrementCount; i++){
			if(i%5 === 0){
				this.domData.lineLabels.push({
					label: window.utils.NumberUtils.formatNumber(this.domData.maxValue - i * this.domData.increment, 2),
					textY: 0
				});
			}
		}

		this.domData.minValue = this.domData.maxValue - this.domData.incrementCount * this.domData.increment;

		this.domData.lineLabels.push({
			label: window.utils.NumberUtils.formatNumber(this.domData.minValue, 2),
			textY: 0
		});
	}

	_rebuild(){

		let $bgLines = this.$el.find('.lines');
		this.domData.graphHeight = $bgLines.outerHeight();
		this.domData.maxLineHeight = this.domData.graphHeight + 10;

		// line labels

		let numBreaks = this.domData.lineLabels.length;

		for(let i=1; i<numBreaks-1; i++){
			this.domData.lineLabels[i].textY = this.domData.graphHeight / (numBreaks - 1) * i; // -1 removes extra at end
		}

		this.domData.lineLabels[numBreaks-1].textY = this.domData.graphHeight;

		// graph content

		let barValueRange = this.domData.maxValue - this.domData.minValue;
		let barValueOffset = this.domData.maxValue - barValueRange;

		for(let i=0; i<this.domData.dataPoints.length; i++){

			let dataPoint = this.domData.dataPoints[i];

			if(dataPoint.bar){

				let barData = dataPoint.bar;
				let valueLabel = window.utils.NumberUtils.addCommas(barData.value);
				let lineHeight = parseFloat($bgLines.outerHeight()) * ((barData.value - barValueOffset)/(this.domData.maxValue - barValueOffset)) + 10;
				let lineY = this.domData.graphHeight - (lineHeight - 10);
				let textY = lineY - 15;

				if(barData.unit === '$'){ valueLabel = barData.unit + valueLabel; }
				else { valueLabel = valueLabel + barData.unit; }

				barData.view = {
					svgId: ++window.SETTINGS.vars.svgIndex,
					lineHeight: lineHeight,
					lineY: lineY,
					textY: textY,
					valueLabel: barData.valueLabel ? barData.valueLabel : valueLabel
				};
			}

			if(dataPoint.greyBar){

				let barData = dataPoint.greyBar;
				let valueLabel = window.utils.NumberUtils.addCommas(barData.value);
				let lineHeight = parseFloat($bgLines.outerHeight()) * ((barData.value - barValueOffset)/(this.domData.maxValue - barValueOffset)) + 10;
				let lineY = this.domData.graphHeight - (lineHeight - 10);
				let textY = lineY - 15;

				if(barData.unit === '$'){ valueLabel = barData.unit + valueLabel; }
				else { valueLabel = valueLabel + barData.unit; }

				barData.view = {
					lineHeight: lineHeight,
					lineY: lineY,
					textY: textY,
					valueLabel: barData.valueLabel ? barData.valueLabel : valueLabel
				};
			}
		}

		this.$el.find('.template-wrapper').html(this.graphTemplate(this.domData));

		this.isFirstBuild = false;
	}

	//

	_domUpdate(){

	}

	_resize(){
		if(this.domData){
			this._rebuild();
		}
	}

}

module.exports = VerticalGraph;

},{"../../90_utils/base/BaseModule":131}],123:[function(require,module,exports){
// animation assistance methods

if(typeof(window.utils) === 'undefined' || !window.utils){ window.utils = {}; }

window.window.utils.AnimationUtils = {

	onTransitionComplete: function($el, startCallback, completeCallback, frameDelay){

		if(startCallback){
			window.requestAnimationFrame(() => {
				startCallback.apply(null, []);
				checkFrameDelay();
			});
		}
		else { checkFrameDelay(); }

		function checkFrameDelay(){
			if(frameDelay){ window.requestAnimationFrame(addListener); }
			else { addListener(); }
		}

		function addListener(){
			$el.off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend');
			$el.on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', completeCallback);
		}
	},

	oneTransitionComplete: function($el, startCallback, completeCallback, frameDelay){

		if(startCallback){
			window.requestAnimationFrame(() => {
				startCallback.apply(null, []);
				checkFrameDelay();
			});
		}
		else { checkFrameDelay(); }

		function checkFrameDelay(){
			if(frameDelay){ window.requestAnimationFrame(addListener); }
			else { addListener(); }
		}

		function addListener(){
			$el.off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend');
			$el.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', completeCallback);
		}
	},

	offTransitionComplete: function($el, completeCallback){
		$el.off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', completeCallback);
	},

	animate($el, setClass, transitionClass, toClass, completeClass, setCallback, completeCallback){

		$el.removeClass(setClass, transitionClass, toClass, completeClass);
		$el.addClass(setClass);

		window.utils.AnimationUtils.oneTransitionComplete($el, () => {

			$el.addClass(transitionClass + ' ' + toClass);
			$el.removeClass(setClass);

			if(setCallback){
				setCallback.apply(null, []);
			}

		}, () => {

			$el.removeClass(transitionClass);
			$el.addClass(completeClass);

			if(completeCallback){
				completeCallback.apply(null, []);
			}

		}, true);
	},

	makeMaskWrapper: function($target){

		var $maskWrapper = $('<div class="mask-wrapper"></div>');
		$maskWrapper.addClass('mask-wrapper');
		$maskWrapper.css({
			position: $target.css('position'),
			display: $target.css('display'),
			top: $target.css('top'),
			left: $target.css('left'),
			width: $target.css('width'),
			height: $target.css('height'),
			overflow: 'hidden',
		});

		$target.css({
			top: 0,
			left: 0,
			position: 'absolute',
			display: 'block',
		});

		$target.parent().append($maskWrapper);
		$target.remove();
		$maskWrapper.html($target);
	},

	splitTextPlus: function($target, options){

		// This adds line and word classes to each element, making it easier to detect the positioning of objects
		// without having to make a new SplitText().
		// If your text is looking weird, make sure the FONT IS LOADED FIRST!

		var defaults = {

			// double-wrap divs for masking or animation effects

			type: 'lines',

			doubleWrapLine: false,
			doubleWrapWord: false,
			doubleWrapChar: false,
		}

		var modifiedOptions = $.extend({}, options);

		for(var key in modifiedOptions){
			var val = (modifiedOptions[key] === 'undefined') ? null : modifiedOptions[key];
			if(val == undefined || val == null){ modifiedOptions[key] = defaults[key]; }
		}

		options = $.extend({}, defaults, modifiedOptions);

		//


		var split = new SplitText($target, {position:'absolute', type:options.type});

		var lineIndex = 0;
		var lineWordIndex = 0;
		var totalWordIndex = 0;

		if(split.lines && split.lines.length > 0){

			for(var i = 0; i<split.lines.length; i++){

				var $line = $(split.lines[i]);
				$line.addClass('line');

				if(options.doubleWrapLine){

					var $lineWrapper = $('<div class="line-wrapper"></div>');
					$lineWrapper.addClass('line-wrapper-' + i);
					$lineWrapper.css({
						position: 'absolute',
						top: $line.css('top'),
						left: $line.css('left'),
						width: $line.css('width'),
						height: $line.css('height'),
					});

					$line.css({
						top: 0,
						left: 0,
					});

					$line.parent().append($lineWrapper);
					$line.remove();
					$lineWrapper.html($line);
				}
			}
		}

		if(split.words && split.words.length > 0){

			var lastTop = $(split.words[0]).offset().top;

			for(var i = 0; i<split.words.length; i++){

				var $word = $(split.words[i]);
				var chars = $word.children();
				var top = $word.offset().top;

				if(top != lastTop){
					lastTop = top;
					lineWordIndex = 0;
					lineIndex ++;
				}

				var lineClass = 'line-' + lineIndex;
				var lineWordClass = 'line-word-' + lineWordIndex;
				var totalWordClass = 'total-word-' + i;

				$word.addClass('word');
				$word.addClass(lineClass);
				$word.addClass(lineWordClass);
				$word.addClass(totalWordClass);

				for(var k=0; k<chars.length; k++){

					var $char = $(chars[k]);

					$char.addClass('char');
					$char.addClass(lineClass);
					$char.addClass(lineWordClass);
					$char.addClass(totalWordClass);

					// double wrap

					if(options.doubleWrapChar){

						var $charWrapper = $('<div class="char-wrapper"></div>');
						$charWrapper.addClass('char-wrapper-' + i);
						$charWrapper.css({
							position: 'absolute',
							top: $char.css('top'),
							left: $char.css('left'),
							width: $char.css('width'),
							height: $char.css('height'),
						});

						$char.css({
							top: 0,
							left: 0,
						});

						$char.parent().append($charWrapper);
						$char.remove();
						$charWrapper.html($char);
					}
				}

				// double wrap

				if(options.doubleWrapWord){

					var $wordWrapper = $('<div class="word-wrapper"></div>');
					$wordWrapper.addClass('word-wrapper-' + i);
					$wordWrapper.css({
						position: 'absolute',
						top: $word.css('top'),
						left: $word.css('left'),
						width: $word.css('width'),
						height: $word.css('height'),
					});

					$word.css({
						top: 0,
						left: 0,
					});

					$word.parent().append($wordWrapper);
					$word.remove();
					$wordWrapper.html($word);
				}

				//

				lineWordIndex ++;
				totalWordIndex ++;
			}
		}

		return split;

	}
}

},{}],124:[function(require,module,exports){

if(typeof(window.utils) === 'undefined' || !window.utils){ window.utils = {}; }

window.window.utils.BrowserUtils = {

	// get vars from url params

	getUrlParameters: function(str) {
		if(!str) str = window.location.search;
		var returnObj = str.replace(/(^\?)/,'').split("&").map(function(n){return n = n.split("="),this[n[0]] = decodeURIComponent(n[1]),this}.bind({}))[0];

		for(var key in returnObj){
			if(returnObj[key] === 'undefined'){
				returnObj[key] = null;
			}
		}

		return returnObj;
	},

	//

	mergeURLParams: function(newString, oldString){

		var newObj = this.getUrlParameters(newString);
		var oldObj = this.getUrlParameters(oldString);
		var mergedObj = _.clone(oldObj);

		for(var key in newObj){
			mergedObj[key] = newObj[key];
		}

		for(var key in mergedObj){
			if(mergedObj[key] === 'undefined'){
				mergedObj[key] = null;
			}
		}

		return mergedObj;
	},

	// create url string from object

	param: function(obj){

		var mergedString = '';
		var i = 0;

		for(var key in obj){
			if(i > 0){ mergedString += '&'; }
			mergedString += String(key);
			if(obj[key]){
				mergedString += '=' + String(obj[key]);
				i++;
			}
		}

		return mergedString;
	},

	// convert url to absolute

	qualifyURL(url){

		function escapeHTML(s) {
			return s.split('&').join('&amp;').split('<').join('&lt;').split('"').join('&quot;');
		}

		var el= document.createElement('div');
		el.innerHTML= '<a href="'+escapeHTML(url)+'">x</a>';
		return el.firstChild.href;
	},

	// ie detection ----------------------------------------------------------------------------  /

	isIE: function() {

		// from http://stackoverflow.com/questions/17907445/how-to-detect-ie11

		return ((navigator.appName == 'Microsoft Internet Explorer') || ((navigator.appName == 'Netscape') && (new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})").exec(navigator.userAgent) != null)));
	},

	isOldIE: function(){

		if(!this.isIE()){ return false; }

		// from http://www.jquerybyexample.net/2014/06/how-to-detect-ie-11-using-javascript-jquery.html

		var sAgent = window.navigator.userAgent;
		var Idx = sAgent.indexOf("MSIE");
		var versionNumber = 0;

		// If IE, return version number.

		if (Idx > 0){
			// older versions user agent match
			versionNumber = parseInt(sAgent.substring(Idx+ 5, sAgent.indexOf(".", Idx)));
		}
		else if (!!navigator.userAgent.match(/Trident\/7\./)){
			// If IE 11 then look for Updated user agent string.
			versionNumber = 11;
		}

		return (versionNumber < 11);
	},

	isFF: function(){
		return navigator.userAgent.match(/firefox/i) !== null;
	},

	isSafari: function(){

		var uagent = navigator.userAgent.toLowerCase();
		if(/safari/.test(uagent) && !/chrome/.test(uagent)){ return true; }

		return false;
	},

	// mobile detection -----------------------------------------------------------  /

	isTouch: function(){
		return $('html').hasClass('touch');
	},

	isMobile: function(detectTablets, detectPhones){

		if(typeof(detectTablets) === 'undefined'){ detectTablets = false; }
		if(typeof(detectPhones) === 'undefined'){ detectPhones = true; }

		if(detectTablets && this.isTablet()) { return true; }
		if(detectPhones && this.isPhone()) { return true; }

		return false;
	},

	isDesktop: function(){
		return !this.isMobile(true, true);
	},

	isPhone: function(){
		if(/android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase())) { return true; }
		return false;
	},

	isTablet: function(){
		if(/ipad|(android|chrome) ([.0-9]*)(.*)(mobile)/i.test(navigator.userAgent.toLowerCase())){ return true; }
		return false;
	},

	// force download --------------------------------------------------------------------------  /

	forceDownload: function(url) {

		var hiddenIFrameID = 'hiddenDownloader',
				iframe = document.getElementById(hiddenIFrameID);
		if (iframe === null) {
				iframe = document.createElement('iframe');
				iframe.id = hiddenIFrameID;
				iframe.style.display = 'none';
				document.body.appendChild(iframe);
		}
		iframe.src = url;
	}

	// -----------------------------------------------------------------------------------------  /
}


},{}],125:[function(require,module,exports){

/* Utilities for DOM-related methods */

if(typeof(window.utils) === 'undefined' || !window.utils){ window.utils = {}; }

window.utils.DOMUtils = {

	docWidth: 0,
	docHeight: 0,

	breakSizes: null,

	// wait for object to change size (for example, text rendering) ----------------------------  /

	onSizeChange: function($element, callBack, context, maxIntervals, displayWarning){

		if(!maxIntervals){ maxIntervals = 50; }

		var intervals = 0;
		var warningLimit = 25;
		var limitHit = false;
		var complete = false;

		var initial = {
			width: $element.outerWidth(),
			height: $element.outerHeight(),
		};

		tick();

		function onTick(){

			intervals ++;
			limitHit = (intervals == maxIntervals);

			if($element.outerWidth() != initial.width || $element.outerHeight() != initial.height || limitHit){
				if(limitHit && displayWarning == true){ console.log("Warning: DOMUtils.onSizeChange limit reached. Giving up.", $element); }
				callBack.apply(context, [!limitHit]);
				complete = true;
			}
			else if(intervals >= warningLimit){
				if(displayWarning == true){ console.log("Warning: DOMUtils.onSizeChange has hit", intervals, "for", $element); }
				warningLimit *= 10;
			}
		}

		function tick(){

			onTick();

			window.requestAnimationFrame(function(){
				if(!complete){ tick(); }
			});
		}
	},

	// dom ready that actually works -----------------------------------------------------------  /

	onRender: function($element, callBack, context, maxIntervals, displayWarning){

		if(!maxIntervals){ maxIntervals = 50; }

		var intervals = 0;
		var warningLimit = 25;
		var limitHit = false;
		var complete = false;

		tick();

		function onTick(){

			intervals ++;
			limitHit = (intervals == maxIntervals);

			if($element.outerWidth() > 0 || $element.outerHeight() > 0 || limitHit){
				if(limitHit && displayWarning == true){ console.log("Warning: DOMUtils.onRender limit reached. Giving up.", $element); }
				callBack.apply(context, [!limitHit]);
				complete = true;
			}
			else if(intervals >= warningLimit){
				if(displayWarning == true){ console.log("Warning: DOMUtils.onRender has hit", intervals, "for", $element); }
				warningLimit *= 10;
			}
		}

		function tick(){

			onTick();

			window.requestAnimationFrame(function(){
				if(!complete){ tick(); }
			});
		}
	},

	// wait one tick (have callback occur in next code loop) -----------------------------------   /

	wait: function(callBack, ticks, context){

		ticks = _.isNumber(ticks) ? ticks : 0;

		var count = 0;

		function tick(){

			window.requestAnimationFrame(function(){
				count ++;
				if(count >= ticks){ callBack.apply(context); }
				else { tick(); }
			});
		}
	},

	// set overflow for body based on size of window (removes chances of weird things happening)- /

	updateBodyOverflow: function(){

		var self = this;
		var winWidth = $(window).width();
		var winHeight = $(window).height();

		var minWidth = $('html').css('min-width') || $('body').css('min-width');
		if(minWidth){ minWidth = parseInt(minWidth); }

		var minHeight = $('html').css('min-height') || $('body').css('min-height');
		if(minHeight){ minHeight = parseInt(minHeight); }

		var overflow = (!minWidth || (minWidth && winWidth > minWidth)) && (!minHeight || (minHeight && winHeight > minHeight)) ? "hidden" : "auto";

		$('body').css({overflow:overflow});
	},

	// gets document width based on min-width and window width ---------------------------------  /

	getDocWidth: function(refresh){

		var self = this;

		if(!self.docWidth || refresh === true){
			if(!self.docWidth){ $(window).resize(onResize); }
			onResize();
		}

		return self.docWidth;

		// caches width value, updated via resize event.
		// use to avoid redundant $(window).resize() listeners
		// will also respect min-width and return values only >=

		function onResize(){

			var minWidth = parseInt($('html').css('min-width')) || parseInt($('body').css('min-width'));

			if(minWidth){

				var winWidth = window.innerWidth;

				if(winWidth > minWidth){ self.docWidth = winWidth; }
				else { self.docWidth = minWidth; }
			}
			else {
				self.docWidth = window.innerWidth;
			}
		}
	},

	// gets document height based on min-height and window height ----------------------------  /

	getDocHeight: function(refresh) {

		var self = this;

		if(!self.docHeight || refresh === true){
			if(!self.docHeight){ $(window).resize(onResize); }
			onResize();
		}

		return self.docHeight;

		// caches height value, updated via resize event.
		// use to avoid redundant $(window).resize() listeners
		// will also respect min-height and return values only >=

		function onResize(){

			var minHeight = parseInt($('html').css('min-height')) || parseInt($('body').css('min-height'));

			if(minHeight){

				var winHeight = window.innerHeight;

				if(winHeight > minHeight){ self.docHeight = winHeight; }
				else { self.docHeight = minHeight; }
			}
			else {
				self.docHeight = window.innerHeight;
			}
		}
	},

	// reverse natural z-index sorting for specified elements.
	// elements higher on the page will have higher z-index
	// elements lower on page will have lower z-index

	sortZIndexElements: function($container){

		var self = this;
		var $zIndexElements = $container.find('.descending-z-index');

		var sortedZIndexElements = $zIndexElements.sort(

			function(a, b){

				var $a = $(a);
				var $b = $(b);
				var aOffset = $a.offset();
				var bOffset = $b.offset();

				if(aOffset.top < bOffset.top){
					return 1;
				}
				else if(aOffset.top == bOffset.top){

					if(aOffset.left < bOffset.left){ return -1; }
					else if(aOffset.left == bOffset.left){ return 0; }
					else { return 1; }
				}

				return -1;
			}
		);

		for(var i=0; i<sortedZIndexElements.length; i++){
			var $zIndexElement = $(sortedZIndexElements[i]);
			var zIndex = parseInt($zIndexElement.css('z-index')) || 0;
			$zIndexElement.css('z-index', zIndex+(i+1));
		}
	},

	// check media break points

	createMediaBreakPoints: function(sizes){

		if(!sizes){ sizes = [768,992,1200,1480]; }

		var self = this;

		// remove any old media breaks

		if(self.breakSizes){
			$('#media-breaks').remove();
			$('#media-breaks-styles').remove();
		}

		// create new media breaks markup

		self.breakSizes = sizes;

		var $breaks = $('<div id="media-breaks"></div>').appendTo($('head'));
		var $style = $('<style id="media-breaks-styles" type="text/css"></style>').appendTo($('head'));
		var styleText = '';

		for(var i=0; i<self.breakSizes.length; i++){

			var breakSize = self.breakSizes[i];
			var nextBreakSize = (i < self.breakSizes.length-1) ? self.breakSizes[i+1]-1 : -1;

			$breaks.append('<div class="break-' + breakSize + '"></div>');
			styleText += '#media-breaks .break-' + breakSize + ' { opacity:0; } \n';

			if(nextBreakSize > 0){
				styleText += '@media (min-width: ' + breakSize + 'px) and (max-width: ' + nextBreakSize + 'px){ #media-breaks .break-' + breakSize + ' { opacity:1; }} \n';
			}
			else {
				styleText += '@media (min-width: ' + breakSize + 'px){ #media-breaks .break-' + breakSize + ' { opacity:1; }} \n';
			}
		}

		$style[0].innerHTML = styleText;
	},

	isBreakPoint: function(size){

		var self = this;
		var $breakPoint = $('#media-breaks').find('.break-' + size);

		if(parseInt($breakPoint.css('opacity')) === 1){ return true; }
		return false;
	},

	isLessThanBreakPoint: function(size){

		// check current break point against size
		// returns true if break point is GREATER THAN (not inclusive) param

		var self = this;
		size = parseInt(size);

		if(isNaN(size)){ return false; }

		for(var i=0; i<self.breakSizes.length; i++){
			var breakSize = self.breakSizes[i];
			if(self.isBreakPoint(breakSize)){
				if(breakSize < size){ return true; }
				return false;
			}
		}

		return false;
	},

	isGreaterThanBreakPoint: function(size){

		var self = this;
		size = parseInt(size);

		if(isNaN(size)){ return false; }

		// check current break point against size
		// returns true if break point is LESS THAN (not inclusive) param

		for(var i=0; i<self.breakSizes.length; i++){
			var breakSize = self.breakSizes[i];
			if(self.isBreakPoint(breakSize)){
				if(breakSize > size){ return true; }
				return false;
			}
		}

		return false;
	},

	isBreakPointOrSmaller: function(size){

		// check current break point against size
		// returns true if break point is GREATER THAN (not inclusive) param

		var self = this;
		size = parseInt(size);

		if(isNaN(size)){ return false; }

		for(var i=0; i<self.breakSizes.length; i++){
			var breakSize = self.breakSizes[i];
			if(self.isBreakPoint(breakSize)){
				if(breakSize <= size){ return true; }
				return false;
			}
		}

		return false;
	},

	isBreakPointOrLarger: function(size){

		var self = this;
		size = parseInt(size);

		if(isNaN(size)){ return false; }

		// check current break point against size
		// returns true if break point is LESS THAN (not inclusive) param

		for(var i=0; i<self.breakSizes.length; i++){
			var breakSize = self.breakSizes[i];
			if(self.isBreakPoint(breakSize)){
				if(breakSize >= size){ return true; }
				return false;
			}
		}

		return false;
	},

	// ie detection ----------------------------------------------------------------------------  /

	isIE: function() {

		// from http://stackoverflow.com/questions/17907445/how-to-detect-ie11

		return ((navigator.appName == 'Microsoft Internet Explorer') || ((navigator.appName == 'Netscape') && (new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})").exec(navigator.userAgent) != null)));
	},

	isOldIE: function(){

		if(!this.isIE()){ return false; }

		// from http://www.jquerybyexample.net/2014/06/how-to-detect-ie-11-using-javascript-jquery.html

		var sAgent = window.navigator.userAgent;
		var Idx = sAgent.indexOf("MSIE");
		var versionNumber = 0;

		// If IE, return version number.

		if (Idx > 0){
			// older versions user agent match
			versionNumber = parseInt(sAgent.substring(Idx+ 5, sAgent.indexOf(".", Idx)));
		}
		else if (!!navigator.userAgent.match(/Trident\/7\./)){
			// If IE 11 then look for Updated user agent string.
			versionNumber = 11;
		}

		return (versionNumber < 11);
	},

	isFF: function(){
		return navigator.userAgent.match(/firefox/i) !== null;
	},

	isSafari: function(){

		var uagent = navigator.userAgent.toLowerCase();
		if(/safari/.test(uagent) && !/chrome/.test(uagent)){ return true; }

		return false;
	},

	// mobile detection -----------------------------------------------------------  /

	isTouch: function(){
		return $('html').hasClass('touch');
	},

	isMobile: function(detectTablets, detectPhones){

		if(typeof(detectTablets) === 'undefined'){ detectTablets = false; }
		if(typeof(detectPhones) === 'undefined'){ detectPhones = true; }

		if(detectTablets && this.isTablet()) { return true; }
		if(detectPhones && this.isPhone()) { return true; }

		return false;
	},

	isDesktop: function(){
		return !this.isMobile(true, true);
	},

	isPhone: function(){
		if(/android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase())) { return true; }
		return false;
	},

	isTablet: function(){
		if(/ipad|(android|chrome) ([.0-9]*)(.*)(mobile)/i.test(navigator.userAgent.toLowerCase())){ return true; }
		return false;
	}

	// -----------------------------------------------------------------------------------------  /

}

},{}],126:[function(require,module,exports){
class Loader {

	constructor(params){

		this.params = params

		this.loadQueue = [];
		this.totalLoadItems;
		this.currentLoadItem;
		this.nextLoadItem;

		this.xhr;

		this.autoStart = this.params && this.params.autoStart !== false;
		this.onCompleteCallback = this.params && _.isFunction(this.params.onCompleteCallback) ? this.params.onCompleteCallback : null;
		this.onCancelCallback = this.params && _.isFunction(this.params.onCancelCallback) ? this.params.onCancelCallback : null;
		this.isLoading = false;
	}

	// public methods

	addToQueue(a, b, c){

		if(this._validateQueueItem(a, b)){

			// single item (url, callback, pushToFront)

			let obj = {
				url: a,
				callback: b
			};

			this._addItemToQueue(obj, c);
		}
		else if($.isPlainObject(a) && this._validateQueueItem(a.url, a.callback)){
			// single item (object containing url, callback, pushToFront, additional params)
			this._addItemToQueue(a, a.pushToFront);
		}
		else if($.isArray(a)){

			// array of items

			for(let i=0; i<a.length; i++){

				let obj = a[i];
				let queueObj = Object.assign({}, obj);
				delete queueObj.pushToFront;

				if(this._validateQueueItem(obj.url, obj.callback)){
					this._addItemToQueue(queueObj, obj.pushToFront);
				}
			}
		}
	}

	emptyQueue(){
		this.stop();
		this.loadQueue = [];
	}

	start(){
		this.totalLoadItems = this.loadQueue ? this.loadQueue.length : 0;
		this._nextLoadItem();
	}

	stop(){

		if(this.xhr){
			this.xhr.abort();
			this.xhr = null;
		}

		this.isLoading = false;

		if(this.onCancelCallback){
			this.onCancelCallback.apply(null, []);
		}
	}

	// internal methods

	_validateQueueItem(url, callback){
		return (typeof url === 'string' || url instanceof String) && ($.isFunction(callback) || !callback);
	}

	_addItemToQueue(obj, pushToFront){

		let isSuccess = false;

		if(pushToFront === true){
			this.loadQueue.unshift(obj);
			isSuccess = true;
		}
		else {
			this.loadQueue.push(obj);
			isSuccess = true;
		}

		if(isSuccess){
			if(!this.isLoading && this.autoStart){
				this.start();
			}
		}
	}

	_nextLoadItem(){
		if(this.nextLoadItem){ this._loadQueueItem(this.nextLoadItem); }
		else if(this.loadQueue.length){ this._loadQueueItem(this.loadQueue[0]); }
	}

	_loadQueueItem(obj){

		if(obj && obj.url){
			if(!this.currentLoadItem){

				this.nextLoadItem = null;
				this.currentLoadItem = obj;
				this.isLoading = true;

				// complete

				let onLoadComplete = (e, isSuccess) => {

					let pos = this.loadQueue.indexOf(this.currentLoadItem);
					if(pos >= 0){ this.loadQueue.splice(pos, 1); }

					if(this.currentLoadItem.callback && _.isFunction(this.currentLoadItem.callback)){
						this.currentLoadItem.callback.apply(null, [{
							originalEvent:e,
							data: e.data,
							success: isSuccess,
							loadItem: this.currentLoadItem,
							progress: this.loadQueue.length > 0 ? 1 - this.loadQueue.length/this.totalLoadItems : 1
						}]);
					}

					this.currentLoadItem = null;
					this._checkCompleteStatus();

					if(this.loadQueue.length){
						// need delay or computer will explode
						window.setTimeout(() => {
							this._nextLoadItem();
						}, 20);
					}
				}

				// ajax call

				this.xhr = $.ajax({

					type: 'GET',
					url: this.currentLoadItem.url,
					async: false,
					dataType: 'text',
					success: (data) => {
						onLoadComplete({data:data}, true);
					},
					error: (e) => {

						console.log("Loader Error");
						console.log(e.message);
						console.log(this.loadQueue);

						onLoadComplete(e, false);
					}
				});
			}
			else {
				this.nextLoadItem = obj;
			}
		}
	}

	_checkCompleteStatus(){
		if(!this.loadQueue.length && this.isLoading){
			this.isLoading = false;
			if(this.onCompleteCallback){
				this.onCompleteCallback.apply(null, []);
			}
		}
	}
}

module.exports = Loader;

},{}],127:[function(require,module,exports){
/* HACKED APART BY DAVID ROBBINS - 01-18-2017
	> ADDED COMMA SEPARATED ROUTES
	> ADDED GET() METHODS
	> MISC CLEANUP
*/

const PARAMETER_REGEXP = /([:*])(\w+)/g;
const WILDCARD_REGEXP = /\*/g;
const REPLACE_VARIABLE_REGEXP = '([^\/]+)';
const REPLACE_WILDCARD = '(?:.*)';
const FOLLOWED_BY_SLASH_REGEXP = '(?:\/$|$)';

class Navigo{

	constructor(r, useHash) {
		this.root = null;
		this._routes = [];
		this._useHash = useHash;
		this._paused = false;
		this._destroyed = false;
		this._lastRouteResolved = null;
		this._notFoundHandler = null;
		this._defaultHandler = null;
		this._usePushState = !useHash && Navigo.isPushStateAvailable();

		if (r) {
			this.root = r.replace(/\/$/, '');
		} else if (useHash) {
			this.root = this._cLoc().split('#')[0].replace(/\/$/, '/#');
		}

		this._listen();
		this.updatePageLinks();
	}

	navigate (path, absolute) {
		var to;
		path = path || '';

		if (this._usePushState) {
			to = (!absolute ? this._getRoot() + '/' : '') + path.replace(/^\/+/, '/');
			to = to.replace(/([^:])(\/{2,})/g, '$1/');
			history[this._paused ? 'replaceState' : 'pushState']({}, '', to);
			this.resolve();
		} else if (typeof window !== 'undefined') {
			window.location.href = window.location.href.replace(/#(.*)$/, '') + '#' + path;
		}
		return this;
	}

	on (...args) {
		if (typeof args[0] === 'function') {
			this._defaultHandler = { handler: args[0], hooks: args[1] };
		} else if (args.length >= 2) {
			if (args[0] === '/') {
				this._defaultHandler = { handler: args[1], hooks: args[2] };
			} else {
				this._add(args[0], args[1], args[2]);
			}
		} else if (typeof args[0] === 'object') {

			let routes = {};
			Object.keys(args[0]).forEach(route => {
				let split = route.split(',');
				split.forEach(splitRoute => {
					routes[splitRoute.trim()] = args[0][route];
				});
			});

			let orderedRoutes = Object.keys(routes).sort(Navigo.compareUrlDepth);
			orderedRoutes.forEach(route => {
				this._add(route, routes[route]);
			});
		}
		return this;
	}

	notFound (handler, hooks) {
		this._notFoundHandler = { handler, hooks: hooks };
		return this;
	}

	resolve (current) {
		var handler, m;
		var url = (current || this._cLoc()).replace(this._getRoot(), '');

		this.route = url;

		if (this._useHash) {
			url = url.replace(/^\/#/, '/');
		}

		let { onlyURL, GETParameters } = Navigo.extractGETParameters(url, this._useHash);

		this.params = GETParameters;

		if (
			this._paused ||
			(
				this._lastRouteResolved &&
				onlyURL === this._lastRouteResolved.url &&
				GETParameters === this._lastRouteResolved.query
				)
			) { return false; }

			m = Navigo.match(onlyURL, this._routes);

		if (m) {
			this._lastRouteResolved = { url: onlyURL, query: GETParameters };
			handler = m.route.handler;
			Navigo.manageHooks(() => {
				m.route.route instanceof RegExp ?
				handler(...(m.match.slice(1, m.match.length))) :
				handler(m.params, GETParameters);
			}, m.route);
			return m;
		} else if (this._defaultHandler && (onlyURL === '' || onlyURL === '/' || onlyURL === '#')) {
			Navigo.manageHooks(() => {
				this._lastRouteResolved = { url: onlyURL, query: GETParameters };
				this._defaultHandler.handler(GETParameters);
			}, this._defaultHandler);
			return true;
		} else if (this._notFoundHandler) {
			Navigo.manageHooks(() => {
				this._lastRouteResolved = { url: onlyURL, query: GETParameters };
				this._notFoundHandler.handler(GETParameters);
			}, this._notFoundHandler);
		}
		return false;
	}

	destroy () {
		this._routes = [];
		this._destroyed = true;
		clearTimeout(this._listenningInterval);
		typeof window !== 'undefined' ? window.onpopstate = null : null;
	}

	updatePageLinks () {
		var self = this;

		if (typeof document === 'undefined') return;

		this._findLinks().forEach(link => {
			if (!link.hasListenerAttached) {
				link.addEventListener('click', function (e) {
					var location = link.getAttribute('href');

					if (!self._destroyed) {
						e.preventDefault();
						self.navigate(Navigo.clean(location));
					}
				});
				link.hasListenerAttached = true;
			}
		});
	}

	generate (name, data = {}) {
		var result = this._routes.reduce((result, route) => {
			var key;

			if (route.name === name) {
				result = route.route;
				for (key in data) {
					result = result.replace(':' + key, data[key]);
				}
			}
			return result;
		}, '');

		return this._useHash ? '#' + result : result;
	}

	link (path) {
		return this._getRoot() + path;
	}

	pause (status = true) {
		this._paused = status;
	}

	resume () {
		this.pause(false);
	}

	disableIfAPINotAvailable () {
		if (!Navigo.isPushStateAvailable()) {
			this.destroy();
		}
	}

	_add (route, handler = null, hooks = null) {
		let pushObj = {}
		if (typeof handler === 'object') {
			pushObj = {
				route,
				handler: handler.uses,
				name: handler.as,
				hooks: hooks || handler.hooks
			}
		} else {
			pushObj = {
				route,
				handler,
				hooks: hooks
			}
		}
		let split = route.split(',');
		split.forEach(splitRoute => {
			pushObj.route = splitRoute;
			this._routes.push(pushObj);
		});
		return this._add;
	}

	_getRoot () {
		if (this.root !== null) return this.root;
		this.root = Navigo.root(this._cLoc(), this._routes);
		return this.root;
	}

	_listen () {
		if (this._usePushState) {
			window.onpopstate = () => {
				this.resolve();
			};
		} else if (Navigo.isHashChangeAPIAvailable()) {
			window.onhashchange = () => {
				this.resolve();
			};
		} else {
			let cached = this._cLoc(), current, check;

			check = () => {
				current = this._cLoc();
				if (cached !== current) {
					cached = current;
					this.resolve();
				}
				this._listenningInterval = setTimeout(check, 200);
			};
			check();
		}
	}

	_cLoc () {
		if (typeof window !== 'undefined') {
			return Navigo.clean(window.location.href);
		}
		return '';
	}

	_findLinks () {
		return [].slice.call(document.querySelectorAll('[data-navigo]'));
	}

	getLastRouteResolved() {
		return this._lastRouteResolved;
	}

	getParams(){
		return this.params;
	}

	getRoute(useHash) {
		if (useHash) {
			return this.route.replace(/^\/#/, '/');
		}
		return this.route;
	}

	getFullPath(useHash){
		if (useHash) {
			return this._getRoot() + this.route.replace(/^\/#/, '/');
		}
		return this._getRoot() + this.route;
	}

	// STATIC METHODS

	static clean(s) {
	  if (s instanceof RegExp) return s;
	  return s.replace(/\/+$/, '').replace(/^\/+/, '/');
	}

	static regExpResultToParams(match, names) {
	  if (names.length === 0) return null;
	  if (!match) return null;
	  return match
	    .slice(1, match.length)
	    .reduce((params, value, index) => {
	      if (params === null) params = {};
	      params[names[index]] = value;
	      return params;
	    }, null);
	}

	static replaceDynamicURLParts(route) {
	  var paramNames = [], regexp;

	  if (route instanceof RegExp) {
	    regexp = route;
	  } else {
	    regexp = new RegExp(
	      Navigo.clean(route)
	      .replace(PARAMETER_REGEXP, function (full, dots, name) {
	        paramNames.push(name);
	        return REPLACE_VARIABLE_REGEXP;
	      })
	      .replace(WILDCARD_REGEXP, REPLACE_WILDCARD) + FOLLOWED_BY_SLASH_REGEXP
	    );
	  }
	  return { regexp, paramNames };
	}

	static getUrlDepth(url) {
	  return url.replace(/\/$/, '').split('/').length;
	}

	static compareUrlDepth(urlA, urlB) {
	  return Navigo.getUrlDepth(urlA) < Navigo.getUrlDepth(urlB);
	}

	static findMatchedRoutes(url, routes = []) {
	  return routes
	    .map(route => {
	      var { regexp, paramNames } = Navigo.replaceDynamicURLParts(route.route);
	      var match = url.match(regexp);
	      var params = Navigo.regExpResultToParams(match, paramNames);

	      return match ? { match, route, params } : false;
	    })
	    .filter(m => m);
	}

	static match(url, routes) {
	  return Navigo.findMatchedRoutes(url, routes)[0] || false;
	}

	static root(url, routes) {
	  var matched = Navigo.findMatchedRoutes(
	    url,
	    routes.filter(route => {
	      let u = Navigo.clean(route.route);

	      return u !== '' && u !== '*';
	    })
	  );
	  var fallbackURL = Navigo.clean(url);

	  if (matched.length > 0) {
	    return matched
	      .map(m => Navigo.clean(url.substr(0, m.match.index)))
	      .reduce((root, current) => {
	        return current.length < root.length ? current : root;
	      }, fallbackURL);
	  }
	  return fallbackURL;
	}

	static isPushStateAvailable() {
	  return !!(
	    typeof window !== 'undefined' &&
	    window.history &&
	    window.history.pushState
	  );
	}

	static isHashChangeAPIAvailable() {
	  return !!(
	    typeof window !== 'undefined' &&
	    'onhashchange' in window
	  );
	}

	static extractGETParameters(url, useHash) {
	  var [ onlyURL, ...query ] = url.split(/\?(.*)?$/);

	  if (!useHash) {
	    onlyURL = onlyURL.split('#')[0];
	  }
	  return { onlyURL, GETParameters: query.join('') };
	}

	static manageHooks(handler, route) {
	  if (route && route.hooks && typeof route.hooks === 'object') {
	    if (route.hooks.before) {
	      route.hooks.before((shouldRoute = true) => {
	        if (!shouldRoute) return;
	        handler();
	        route.hooks.after && route.hooks.after();
	      });
	    } else if (route.hooks.after) {
	      handler();
	      route.hooks.after && route.hooks.after();
	    }
	    return;
	  }
	  handler();
	};

}

module.exports = Navigo;



},{}],128:[function(require,module,exports){

if(typeof(window.utils) === 'undefined' || !window.utils){ window.utils = {}; }

window.window.utils.NumberUtils = {

	addCommas: function(num) {
		var numString = String(num);
		if(numString.length > 3){
			var numCommas = parseInt((numString.length-1)/3);
			for(var i=1; i<=numCommas; i++){
				numString = numString.substring(0, numString.length - 3*i - (i-1)) + "," + numString.substr(numString.length - 3*i - (i-1));
			}
		}
		return numString;
	},

	// add leading / trailing zeroes

	formatNumber: function(value, minUnitPlaces, maxDecimalPlaces, addCommas) {

		// default values

		if(typeof minUnitPlaces == 'undefined'){ minUnitPlaces = 0; }
		if(typeof maxDecimalPlaces == 'undefined'){ maxDecimalPlaces = 0; }
		if(typeof addCommas == 'undefined'){ addCommas = true; }

		//

		var numParts = value.toString().split(".");
		var units = "";
		var decimals = "";

		// decimals

		if(numParts.length > 1){ decimals = numParts[1]; }
		while(decimals.length < maxDecimalPlaces){ decimals += "0"; }

		// units

		units = numParts[0];

		while(units.length < minUnitPlaces){ units = "0" + units; }

		// return combined value

		if(addCommas == true){ units = this.addCommas(units); }

		return (decimals == "") ? units : units + "." + decimals.substr(0, maxDecimalPlaces);;
	},

	// change number of decimals places

	setDecimalPlaces: function(value, decimalPlaces) {

		// default values

		if(typeof decimalPlaces == 'undefined'){ decimalPlaces = 2; }

		//

		var power = Math.pow(10, decimalPlaces);
		return Math.floor(value * power) / power;
	},

	// convert boolean to int

	boolToInt: function(bool) {
		return parseInt(bool);
	},

	// get number within wrapped range (less than 0 is max - diff)

	getRangeIndex: function(index, rangeLow, rangeHigh, wrap){

		// return valid index based on index compared to valid range
		// will wrap by default (meaning -2 will become total - 2)
		// if wrap is disabled, index will return at lower or higher limit of range

		if(typeof(wrap) === 'undefined'){ wrap = true; }

		if(index >= rangeHigh){
			if(wrap){ index = index % rangeHigh; }
			else { index = rangeHigh-1; }
		}
		else if(index < rangeLow){
			if(wrap){ index = rangeHigh - (Math.abs(index) + rangeHigh) % rangeHigh; }
			else { index = rangeLow; }
		}

		return index;
	},

	// min max

	restrictBounds: function(value, minBound, maxBound){

		if(value < minBound){ return minBound; }
		else if(value > maxBound){ return maxBound; }

		return value;
	},

};

},{}],129:[function(require,module,exports){

if(typeof(window.utils) === 'undefined' || !window.utils){ window.utils = {}; }

window.window.utils.PositioningUtils = {

	// convert one offset to another

	localToLocal: function($originContainer, $destinationContainer, x, y){
		var originPos = this.localToGlobal($originContainer, x, y);
		return this.globalToLocal($destinationContainer, originPos.x, originPos.y);
	},

	// convert local offset to global

	localToGlobal: function($container, x, y){
		var globalOffset = $container.offset();
		return {x:x+globalOffset.left, y:y+globalOffset.top};
	},

	// convert global offset to local

	globalToLocal: function($container, x, y){
		var globalOffset = $container.offset();
		return {x:x-globalOffset.left, y:y-globalOffset.top};
	},

	// get element offset relative to given parent

	getPositionRelativeTo: function($child, $container){

		var childOffset = $child.offset();
		var containerOffset = $container.parent().length == 0 ? {top:0, left:0} : $container.offset();

		return {
			top: childOffset.top - containerOffset.top,
			bottom: childOffset.top - containerOffset.top + $child.outerHeight(),
			left: childOffset.left - containerOffset.left,
			right: childOffset.left - containerOffset.left + $child.outerWidth()
		};
	},

	// get full position or offset (including right & bottom)

	getExtendedPosition: function($el){

		var position = $el.position();

		position.right = position.left + $el.outerWidth();
		position.bottom = position.top + $el.outerHeight();
		position.width = position.right - position.left;
		position.height = position.bottom - position.top;
		position.centerX = position.left + Math.round(position.width/2);
		position.centerY = position.top + Math.round(position.height/2);

		return position;
	},

	getExtendedOffset: function($el){

		var offset = $el.offset();

		offset.right = offset.left + $el.outerWidth();
		offset.bottom = offset.top + $el.outerHeight();
		offset.width = offset.right - offset.left;
		offset.height = offset.bottom - offset.top;
		offset.centerX = offset.left + Math.round(offset.width/2);
		offset.centerY = offset.top + Math.round(offset.height/2);

		return offset;
	},

	getScrollOffset: function($el){

		var scrollTop = $(window).scrollTop();
		var offset = $el.offset();

		offset.top = offset.top - scrollTop;
		offset.right = offset.left + $el.outerWidth();
		offset.bottom = offset.top + $el.outerHeight();
		offset.width = offset.right - offset.left;
		offset.height = offset.bottom - offset.top;
		offset.centerX = offset.left + Math.round(offset.width/2);
		offset.centerY = offset.top + Math.round(offset.height/2);

		return offset;
	},

	// fit to the dimensions of another object -------------------------------------------------  /

	fitToObject: function($content, $container, contentRatio, centerX, centerY, fillObject, useOutsideDimensions) {

		// defaults

		if(typeof(centerX) === 'number' && isNaN(centerX)){ centerX = 0.5; }
		else if(typeof(centerX) === 'boolean'){
			if(centerX === true){ centerX = 0.5; }
			else { centerX = 0; }
		}

		if(typeof(centerY) === 'number' && isNaN(centerY)){ centerY = 0.5; }
		else if(typeof(centerY) === 'boolean'){
			if(centerY === true){ centerY = 0.5; }
			else { centerY = 0; }
		}

		fillObject = (fillObject == true);
		useOutsideDimensions = (useOutsideDimensions == true);

		//

		if($content && $content.length > 0 && $container && $container.length > 0){

			var maxWidth = useOutsideDimensions ? $container.outerWidth() : $container.width();
			var maxHeight = useOutsideDimensions ? $container.outerHeight() : $container.height();

			this.sizeToFit($content, contentRatio, maxWidth, maxHeight, centerX, centerY, fillObject);
		}
		else {
			console.log("ERROR: fitToObject: Invalid target. $content=", $content, "$container=", $container);
		}

	},

	// utility to fit into certain dimensions --------------------------------------------------  /

	sizeToFit: function($content, contentRatio, maxWidth, maxHeight, centerX, centerY, fillObject) {

		// defaults

		if(typeof(centerX) === 'number' && isNaN(centerX)){ centerX = 0.5; }
		else if(typeof(centerX) === 'boolean'){
			if(centerX === true){ centerX = 0.5; }
			else { centerX = 0; }
		}

		if(typeof(centerY) === 'number' && isNaN(centerY)){ centerY = 0.5; }
		else if(typeof(centerY) === 'boolean'){
			if(centerY === true){ centerY = 0.5; }
			else { centerY = 0; }
		}

		fillObject = (fillObject == true);

		//

		var contentWidth = parseInt($content.innerWidth());
		var contentHeight = parseInt($content.innerHeight());
		var idealRatio = maxWidth / maxHeight;

		var newWidth = 0;
		var newHeight = 0;

		if(fillObject){

			if(contentRatio > idealRatio){
				newHeight = maxHeight;
				newWidth = newHeight * contentRatio;
			}
			else {
				newWidth = maxWidth;
				newHeight = newWidth / contentRatio;
			}
		}
		else {

			if(contentRatio > idealRatio){
				newWidth = maxWidth;
				newHeight = newWidth / contentRatio;
			}
			else {
				newHeight = maxHeight;
				newWidth = newHeight * contentRatio;
			}
		}

		newWidth = Math.round(newWidth);
		newHeight = Math.round(newHeight);

		// complete

		$content.css({width: newWidth, height: newHeight});

		// if centering, change margin, else don't touch margin values

		if(centerX){
			var newX = Math.round((maxWidth - newWidth) * centerX);
			$content.css({marginLeft:newX});
		}

		if(centerY){
			var newY = Math.round((maxHeight - newHeight) * centerY);
			$content.css({marginTop:newY});
		}
	}

	// -----------------------------------------------------------------------------------------  /

};

},{}],130:[function(require,module,exports){
/*

** ScrollStepListener.js **

Watches provided $el for rolls of the mouse wheel.
Even works with touch scrolling (which is finicky!).

Will only trigger with each new roll, given delay is complete or manually completed.

--

Dependencies:

- jQuery

Todo:

--

Last update 03.20.17 by David Robbins

*/

class ScrollStepListener {

	constructor(el, options){

		this.el = el;
		this.$el = $(this.el);

		// default options

		this.defaults = {
			$touchEl: null,
			autoInit: true,
			minTrendingDeltas: 2, // number of inputs in the same direction minimum
			triggerSensitivity: 1.1, // 1.1 recommended
			triggerDelay: 500, // min time between triggers
			initialDelay: 500, // time before listening
			onTriggerCallback: null,
			onScrollCompleteCallback: null,
		};

		// private vars

		this._initialized = false;
		this._initialDelayTimeout = null;
		this._lastDelta = 0;
		this._deltaTrend = [];
		this._deltaTimeout = null;
		this._deltaInterval = null;
		this._dragStartY = 0;
		this._triggerSensitivity = 1;

		// public vars

		this.options = this._fillMissingOptions(options);
		this.isTriggering = false;
		this.isScrollEnabled = true;
		this.isTriggerDelayComplete = false;

		//

		this.$touchEl = this.options.$touchEl && this.options.$touchEl.length ? this.options.$touchEl : this.$el;

		//

		this._triggerSensitivity = window.utils.DOMUtils.isIE() ? 1 : this.options.triggerSensitivity;
		this._initialDelayTimeout = window.setTimeout($.proxy(this._onInitialTimeoutComplete, this), this.options.initialDelay);
	}

	// run init (or wait for user) -------------------------------------------------------------  /

	_onInitialTimeoutComplete(){
		this.isTriggerDelayComplete = true;
		if(this.options.autoInit === true){ this.init(); }
	}

	/* private methods */

	// add / remove listeners ----------------------------------------------------------  /

	_addListeners(){

		// mouse

		this.$el.mousewheel($.proxy(this._onMouseWheel, this));

		// touch

		let options = {preventDefault:true, threshold:1};

		this.$touchEl.hammer(options)
			.on('panup pandown panmove panstart', $.proxy(this._onDragStart, this))
			.on('panend', $.proxy(this._onDragEnd, this));
	}

	_removeListeners(){

		// mouse

		this.$el.unmousewheel($.proxy(this._onMouseWheel, this));

		// touch

		this.$touchEl.hammer()
			.off('panup pandown panmove panstart', $.proxy(this._onDragStart, this))
			.off('panend', $.proxy(this._onDragEnd, this));

		// intervals

		if(this._deltaTimeout){ window.clearTimeout(this._deltaTimeout); }
		if(this._deltaInterval){ window.clearInterval(this._deltaInterval); }

		this._deltaTimeout = null;
		this._deltaInterval = null;
	}

	_onDragStart(e){

		if(!this._dragStartY && parseInt(e.gesture.deltaY)){
			this._dragStartY = e.gesture.deltaY;
		}

		e.preventDefault();
	}

	_onDragEnd(e){

		let deltaY = e.gesture.deltaY;

		if(this.isScrollEnabled && Math.abs(deltaY - this._dragStartY) > 10){

			if(deltaY - this._dragStartY > 0){ this._trigger(-1); }
			else { this._trigger(1); }

			this._dragStartY = 0;
		}

		e.preventDefault();
	}

	// mouse wheel ---------------------------------------------------------------------  /

	_onMouseWheel(e){

		if(this.isScrollEnabled){

			let delta = e.deltaY;
			this._deltaTrend.push(delta);

			// convert mousewheel delta into steps

			let stepDelta = 0;
			if(delta > 0){ stepDelta = -1; }
			else if(delta < 0){ stepDelta = 1; }

			if(Math.abs(delta) >= Math.abs(this._lastDelta) * this._triggerSensitivity && this._getDeltaTrendStatus() === true){
				if(stepDelta !== 0){
					this._trigger(stepDelta);
				}
			}

			this._lastDelta = delta;

			if(this._deltaInterval){ window.clearInterval(this._deltaInterval); }

			this._deltaInterval = window.setInterval(() => {

				if(this._lastDelta == delta){

					this._lastDelta = 0;
					window.clearInterval(this._deltaInterval);

					if(this.options.onScrollCompleteCallback){
						this.options.onScrollCompleteCallback.apply(null, [stepDelta]);
					}
				}
			}, 200);
		}
	}

	// validate that x number of previous deltas were going the same direction -----------------  /

	_getDeltaTrendStatus(){

		let minTrendingDeltas = this.options.minTrendingDeltas;

		if(this._deltaTrend.length < minTrendingDeltas){ return false; }
		else {

			let firstDeltaPositive = null;

			for(let i=0; i<minTrendingDeltas; i++){
				let isPositive = (this._deltaTrend[this._deltaTrend.length-(i+1)] > 0);
				if(i == 0){ firstDeltaPositive = isPositive; }
				else if(firstDeltaPositive != isPositive){ return false; }
			}
		}

		return true;
	}

	// trigger (when mouse scroll has exceeded triggerDistance) --------------------------------  /

	_trigger(delta){

		if(this.isTriggerDelayComplete){

			this.isTriggerDelayComplete = false;
			this._deltaTrend = [];

			if(this._deltaTimeout){
				window.clearTimeout(this._deltaTimeout);
				this._deltaTimeout = null;
			}

			// fire callback

			if(this.options.onTriggerCallback){ this.options.onTriggerCallback.apply(null, [delta]); }

			// dispatch event

			this.$el.triggerHandler('scroll', delta);

			// reset timer

			if(this.options.triggerDelay > 0){
				this._deltaTimeout = window.setTimeout($.proxy(this.setTriggerDelayComplete, this), this.options.triggerDelay);
			}
		}
	}

	// fill any missing options with defaults

	_fillMissingOptions(options){

		let modifiedOptions = $.extend({}, options);

		for(let key in modifiedOptions){
			let val = (modifiedOptions[key] === 'undefined') ? null : modifiedOptions[key];
			if(val == undefined || val == null){ modifiedOptions[key] = this.defaults[key]; }
		}

		return $.extend({}, this.defaults, modifiedOptions);;
	}

	// manual trigger delay complete

	setTriggerDelayComplete(){
		this.isTriggerDelayComplete = true;
	}

	// public methods --------------------------------------------------------------------------  /

	init(){

		if(!this._initialized){
			this._initialized = true;
			this._addListeners();
		}
	}

	setNewOptions(newOptions){

		newOptions = $.extend({}, this.options);

		for(let key in newOptions){
			newOptions[key] = newOptions[key];
		}

		this.options = newOptions;
	}

	destroy(){
		this._removeListeners();
		this.options.onTriggerCallback = null;
	}
}

module.exports = ScrollStepListener;

},{}],131:[function(require,module,exports){
class BaseModule {

	constructor(el) {

		if(!el || !el.length){
			throw new Error("super() requires el parameter.");
		}

		this.$el = $(el);

		// flags

		this._isDestroyed = false;
		this._isDomReady = false;
		this._isEnabled = false;
		this._isListening = false;
		this._isShowing = false;

		this._autoEnable = true;

		// add attr identifying $el as module

		this.$el.attr('data-js-module', '');

		// allow external access to module

		this._configEventMethods();

		//

		$(() => {
			window.SETTINGS.animationFrame.one(() => {
				this.domReady();
			});
		});
	}

	// COMPLETE THESE METHODS WHEN INHERITING BASEMODULE --------------------------------------  //

	_domReady(){ }

	_addListeners(){ }
	_removeListeners(){ }

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){ }

	// CORE FUNCTIONALITY BELOW - DO NOT EDIT - DO NOT INHERIT --------------------------------  //

	// public & event-linked methods

	domReady(){

		if(!this._isDomReady){

			if(this._autoEnable){ this.enable(); }

			this._isDomReady = true;
			this._domReady();
		}
	}

	addListeners(){

		if(!this._isListening){

			this._isListening = true;

			//

			window.vent.on('domUpdate', this._onDomUpdate, this);
			window.vent.on('windowResize', this._onResize, this);

			this._addListeners();
			this._resize();
		}
	}

	removeListeners(){

		if(this._isListening){

			this._isListening = false;

			window.vent.off('domUpdate', this._onDomUpdate, this);
			window.vent.off('windowResize', this._onResize, this);

			this._removeListeners();
		}
	}

	show(){

		if(!this._isShowing && !this._isDestroyed){
			this._isShowing = true;
			this.enable();
			this._show();
		}
	}

	hide(){

		if(this._isShowing && !this._isDestroyed){
			this._isShowing = false;
			this.disable();
			this._hide();
		}
	}

	enable(){

		if(!this._isEnabled && !this._isDestroyed){
			this._isEnabled = true;
			this.addListeners();
			this._enable();
		}
	}

	disable(){

		if(this._isEnabled && !this._isDestroyed){
			this._isEnabled = false;
			this.removeListeners();
			this._disable();
		}
	}

	destroy(){

		if(!this._isDestroyed){
			this._isDestroyed = true;
			this.disable();
			this.$el.remove();
		}
	}

	// global event listeners

	_onDomUpdate(){
		this._domUpdate();
	}

	_onResize(){
		this._resize();
	}

	// listeners linked to public methods -----------------------------------------------------  //

	_configEventMethods(){

		// events linked to methods (do this often)

		this.$el.on('enable', this.enable.bind(this));
		this.$el.on('disable', this.disable.bind(this));
		this.$el.on('show', this.show.bind(this));
		this.$el.on('hide', this.hide.bind(this));
		this.$el.on('destroy', this.destroy.bind(this));

		// link to module from $el object (use with caution)

		let className = this.constructor.name;

		if(!this.$el[0].modules){ this.$el[0].modules = {}; }
		this.$el[0].modules[className] = this;
	}

	// utils ----------------------------------------------------------------------------------  //

	checkVal(val, fallbackVal, emptyVal){

		// check val
		// if invalid, return fallbackVal
		// if empty, return emptyVal

		if(typeof(val) !== 'undefined'){
			if(val === '' && typeof(emptyVal) !== undefined){ return emptyVal; }
			else if(val !== null && !(typeof(val) === 'number' && isNaN(val)) && !(val instanceof jQuery && !val.length)){ return val; }
		}

		return fallbackVal;
	}

	checkVals(vals, fallbackVal, emptyVal){

		// check values (requires an array)
		// if invalid, return fallbackVal
		// if empty, return emptyVal

		if(typeof(vals) !== 'undefined' && vals.length){

			let failObj = {failed:true};

			for(let i=0; i<vals.length; i++){
				let returnVal = this.checkVal(vals[i], failObj, failObj);
				if(returnVal !== failObj){ return returnVal; }
			}
		}

		return fallbackVal;
	}

	triggerEvent(eventName, obj){

		let stdReturnObj = {
			module: this,
			$el: this.$el
		};

		this.$el.triggerHandler(eventName, $.extend({}, stdReturnObj, obj));
	}
}

module.exports = BaseModule;

},{}],132:[function(require,module,exports){
const AngledLine = require('./shapes/AngledLine.js');
const RandomOutline = require('./shapes/RandomOutline.js');
const RandomRect = require('./shapes/RandomRect.js');

window.SETTINGS.domScan.addContainer( null, ($scanContainer) => {

	window.SETTINGS.domScan.addElement($scanContainer, '[data-random-outline]', function () {
		new RandomOutline(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-random-rect]', function () {
		new RandomRect(this);
	});

	window.SETTINGS.domScan.addElement($scanContainer, '[data-angled-line]', function () {
		new AngledLine(this);
	});

});

},{"./shapes/AngledLine.js":133,"./shapes/RandomOutline.js":134,"./shapes/RandomRect.js":135}],133:[function(require,module,exports){
class AngledLine {

	constructor(el, params) {

		// param vars

		this.$el = $(el);
		this.params = params;

		//

		this._width = isNaN(parseFloat(this.$el.attr('data-al-width'))) ? 200 : parseFloat(this.$el.attr('data-al-width'));
		this._height = isNaN(parseFloat(this.$el.attr('data-al-height'))) ? 11 : parseFloat(this.$el.attr('data-al-height'));
		this._stroke = isNaN(parseFloat(this.$el.attr('data-al-stroke'))) ? 3 : parseFloat(this.$el.attr('data-al-stroke'));
		this._vertInset = isNaN(parseFloat(this.$el.attr('data-al-vert-inset'))) ? 2 : parseFloat(this.$el.attr('data-al-vert-inset'));
		this._horizInset = isNaN(parseFloat(this.$el.attr('data-al-horiz-inset'))) ? -2 : parseFloat(this.$el.attr('data-al-horiz-inset'));
		this._isResponsive = typeof(this.$el.data('responsive')) !== 'undefined' && this.$el.data('responsive') !== false;
		this._isSmall = typeof(this.$el.data('small')) !== 'undefined' && this.$el.data('small') !== false;

		//

		this.redraw();

		//

		$(() => {
			this._onDomReady();
		});
	}

	// private methods

	_onDomReady(){
		this._addListeners();
		this._onResize();
	}

	_addListeners(){

		this.$el.on('redraw', this._onRedraw.bind(this));

		window.vent.on('domUpdate', this._onDomUpdate, this);
		window.vent.on('windowResize', this._onResize, this);
	}

	_removeListeners(){
		window.vent.off('domUpdate', this._onDomUpdate, this);
		window.vent.off('windowResize', this._onResize, this);
	}

	_onRedraw(){
		this.redraw();
	}

	_onDomUpdate(e, obj){
		if(obj && obj.$scanContainer[0].contains(this.$el[0])){
			this.redraw();
		}
	}

	_onResize(){

		if(this._isResponsive){
			this._width = this.$el.outerWidth();
			this._height = this.$el.outerHeight();
			this.redraw();
		}
	}

	// public methods

	redraw(){

		// random rect

		let $outlines = this.$el.find('svg');

		if(this.$el.is('svg')){ $outlines = this.$el; }

		$outlines.each((index, value) => {

			let $value = $(value);
			let points = [];
			let pointsShape = {};
			let pointsString = '';
			let coordsIndex = 0;

			// create shape

			for(let i=0; i<4; i++){

				let shiftAmount = this._stroke/4;
				let shiftX = Math.random() < 0.5 ? -shiftAmount : shiftAmount;
				let shiftY = Math.random() < 0.5 ? -shiftAmount : shiftAmount;
				let coords;

				switch(i){

					case 0:
					coords = {
						x: this._horizInset + shiftX,
						y: this._height - this._vertInset + shiftY
					};
					break;

					case 1:
					coords = {
						x: points[0].x + this._stroke/4*3 + shiftX,
						y: points[0].y + this._stroke/4*3 + shiftY
					};
					break;

					case 2:
					coords = {
						x: this._width - this._horizInset + shiftX,
						y: this._vertInset + shiftY
					};
					break;

					case 3:
					coords = {
						x: points[2].x + this._stroke/4*3 + shiftX,
						y: points[2].y + this._stroke/4*3 + shiftY
					};
					break;
				}

				points.push(coords);

				if(i > 0){ pointsString += ' '; }
				pointsString += coords.x + ',' + coords.y;

				coordsIndex++;
			}

			// fix viewbox

			$value.removeAttr('viewBox');
			$value[0].setAttribute('viewBox', '0 0 ' + this._width + ' ' + this._height);

			// fix shape

			$value.find('polygon').attr('points', pointsString);
		});
	}

	// getters / setters

	get width(){ return this._width; }
	set width(value){
		this.width = value;
		this.redraw();
	}

	get height(){ return this._height; }
	set height(value){
		this.height = value;
		this.redraw();
	}
}

module.exports = AngledLine;

},{}],134:[function(require,module,exports){
class RandomOutline {

	constructor(el, params) {

		// param vars

		this.$el = $(el);
		this.params = params;

		//

		this._width = !this.params || isNaN(parseFloat(this.params.width)) ? 60 : parseFloat(this.params.width);
		this._height = !this.params || isNaN(parseFloat(this.params.height)) ? 60 : parseFloat(this.params.height);

		let attrShiftX = this.$el.attr('data-shift-x');
		this._shiftX = typeof(attrShiftX) !== 'undefined' && !isNaN(parseFloat(attrShiftX)) ? parseFloat(attrShiftX) : 1;

		let attrShiftY = this.$el.attr('data-shift-y');
		this._shiftY = typeof(attrShiftY) !== 'undefined' && !isNaN(parseFloat(attrShiftY)) ? parseFloat(attrShiftY) : 1;

		//

		this.redraw();

		//

		$(() => {
			this._onDomReady();
		});
	}

	// private methods

	_onDomReady(){
		this._addListeners();
	}

	_addListeners(){

		this.$el.on('redraw', this._onRedraw.bind(this));

		window.vent.on('domUpdate', this._onDomUpdate, this);
	}

	_onRedraw(){
		this.redraw();
	}

	_onDomUpdate(e, obj){
		if(obj && obj.$scanContainer[0].contains(this.$el[0])){
			this.redraw();
		}
	}

	// public methods

	redraw(){

		// random rect

		let $outlines = this.$el.find('svg');

		$outlines.each((index, value) => {

			let $value = $(value);
			let d = 'M' + (this.width - 1) + ',1L' + (this.width - 1) + ',' + (this.height - 1) + 'L1,' + (this.height - 1) + 'L1,1 M' + (this.width + 0.5) + ',-0.5L-0.5,-0.5L-0.5,' + (this.height + 0.5) + 'L' + (this.width + 0.5) + ',' + (this.height + 0.5) + 'L' + (this.width + 0.5) + ',-0.5';
			let dSets = d.split(' ');
			let dShapeInner = {};
			let startPos = 0;
			let curSet = dSets[0];
			let coordsIndex = 0;
			let lineWidth = 2;

			// inner rect

			for(let i=0; i<curSet.length; i++){

				let char = curSet.charAt(i);

				if((isNaN(parseInt(char)) && String('-.,').indexOf(char) === -1) || i >= curSet.length-1){

					let coordsGroup = i >= curSet.length-1 ? curSet.substring(startPos+1) : curSet.substring(startPos+1, i);

					if(coordsGroup.indexOf(',') >= 0){

						let coords = {x:0, y:0}
						let coordsSplit = coordsGroup.split(',');

						for(let k=0; k<coordsSplit.length; k++){

							let num = parseFloat(coordsSplit[k]);

							let shiftXAmount = this._isSmall ? this._shiftX/2 : this._shiftX;
							let shiftX = Math.round(shiftXAmount - Math.random() * shiftXAmount * 2);

							let shiftYAmount = this._isSmall ? this._shiftY/2 : this._shiftY;
							let shiftY = Math.round(shiftYAmount - Math.random() * shiftYAmount * 2);

							if(k === 0){
								coords.x = num + shiftX;
							}
							else {
								coords.y = num + shiftY;
							}
						}

						switch(coordsIndex){
							case 0: dShapeInner.tr = coords; break;
							case 1: dShapeInner.br = coords; break;
							case 2: dShapeInner.bl = coords; break;
							case 3: dShapeInner.tl = coords; break;
						}

						coordsIndex++;
					}

					startPos = i;
				}
			}

			// config outer shape

			let oShape = {};
			oShape.tr = {x:dShapeInner.tr.x + lineWidth, y:dShapeInner.tr.y - lineWidth};
			oShape.br = {x:dShapeInner.br.x + lineWidth, y:dShapeInner.br.y + lineWidth};
			oShape.bl = {x:dShapeInner.bl.x - lineWidth, y:dShapeInner.bl.y + lineWidth};
			oShape.tl = {x:dShapeInner.tl.x - lineWidth, y:dShapeInner.tl.y - lineWidth};

			// rebuild svg

			let newD = '';

			newD += 'M' + dShapeInner.tr.x + ',' + dShapeInner.tr.y + 'L' + dShapeInner.br.x + ',' + dShapeInner.br.y + 'L' + dShapeInner.bl.x + ',' + dShapeInner.bl.y + 'L' + dShapeInner.tl.x + ',' + dShapeInner.tl.y;
			newD += ' ';
			newD += 'M' + oShape.tr.x + ',' + oShape.tr.y + 'L' + oShape.tl.x + ',' + oShape.tl.y + 'L' + oShape.bl.x + ',' + oShape.bl.y + 'L' + oShape.br.x + ',' + oShape.br.y + 'L' + oShape.tr.x + ',' + oShape.tr.y + 'z';

			$value.find('path').attr('d', newD);
		});

		//
	}

	// getters / setters

	get width(){ return this._width; }
	set width(value){
		this.width = value;
		this.redraw();
	}

	get height(){ return this._height; }
	set height(value){
		this.height = value;
		this.redraw();
	}
}

module.exports = RandomOutline;

},{}],135:[function(require,module,exports){
class RandomRect {

	constructor(el, params) {

		// param vars

		this.$el = $(el);
		this.params = params;

		//

		this._width = !this.params || isNaN(parseFloat(this.params.width)) ? 60 : parseFloat(this.params.width);
		this._height = !this.params || isNaN(parseFloat(this.params.height)) ? 60 : parseFloat(this.params.height);
		this._stroke = !this.params || isNaN(parseFloat(this.params.stroke)) ? 2 : parseFloat(this.params.stroke);

		let attrShiftX = this.$el.attr('data-shift-x');
		this._shiftX = typeof(attrShiftX) !== 'undefined' && !isNaN(parseFloat(attrShiftX)) ? parseFloat(attrShiftX) : 1;

		let attrShiftY = this.$el.attr('data-shift-y');
		this._shiftY = typeof(attrShiftY) !== 'undefined' && !isNaN(parseFloat(attrShiftY)) ? parseFloat(attrShiftY) : 1;

		this._isResponsive = typeof(this.$el.data('responsive')) !== 'undefined' && this.$el.data('responsive') !== false;
		this._isSmall = typeof(this.$el.data('small')) !== 'undefined' && this.$el.data('small') !== false;
		this._isRandomTexture = true;

		//

		this.redraw();

		//

		$(() => {
			this._onDomReady();
		});
	}

	// private methods

	_onDomReady(){
		this._addListeners();
		this._onResize();
	}

	_addListeners(){

		this.$el.on('redraw', this._onRedraw.bind(this));
		this.$el.on('resize', this._onResize.bind(this));

		window.vent.on('domUpdate', this._onDomUpdate, this);
		window.vent.on('windowResize', this._onResize, this);
	}

	_removeListeners(){
		window.vent.off('domUpdate', this._onDomUpdate, this);
		window.vent.off('windowResize', this._onResize, this);
	}

	_onRedraw(){
		this.redraw();
	}

	_onDomUpdate(e, obj){
		if(obj && obj.$scanContainer[0].contains(this.$el[0])){
			this.redraw();
		}
	}

	_onResize(){
		this.resize();
	}

	// public methods

	redraw(){

		this.resize(true);

		// random rect

		let $outlines = this.$el.find('svg');

		if(this.$el.is('svg')){ $outlines = this.$el; }

		$outlines.each((index, value) => {

			let $value = $(value);
			let d = 'M' + (this._width - 1) + ',1L' + (this._width - 1) + ',' + (this._height - 1) + 'L1,' + (this._height - 1) + 'L1,1';
			let dSets = d.split(' ');
			let dShapeInner = {};
			let startPos = 0;
			let curSet = dSets[0];
			let coordsIndex = 0;

			// inner rect

			for(let i=0; i<curSet.length; i++){

				let char = curSet.charAt(i);

				if((isNaN(parseInt(char)) && String('-.,').indexOf(char) === -1) || i >= curSet.length-1){

					let coordsGroup = i >= curSet.length-1 ? curSet.substring(startPos+1) : curSet.substring(startPos+1, i);

					if(coordsGroup.indexOf(',') >= 0){

						let coords = {x:0, y:0}
						let coordsSplit = coordsGroup.split(',');

						for(let k=0; k<coordsSplit.length; k++){

							let num = parseFloat(coordsSplit[k]);

							let shiftXAmount = this._isSmall ? this._shiftX/2 : this._shiftX;
							let shiftX = Math.round(shiftXAmount - Math.random() * shiftXAmount * 2);

							let shiftYAmount = this._isSmall ? this._shiftY/2 : this._shiftY;
							let shiftY = Math.round(shiftYAmount - Math.random() * shiftYAmount * 2);

							if(k === 0){
								coords.x = num + shiftX;
							}
							else {
								coords.y = num + shiftY;
							}
						}

						switch(coordsIndex){
							case 0: dShapeInner.tr = coords; break;
							case 1: dShapeInner.br = coords; break;
							case 2: dShapeInner.bl = coords; break;
							case 3: dShapeInner.tl = coords; break;
						}

						coordsIndex++;
					}

					startPos = i;
				}
			}

			// config outer shape

			let oShape = {};
			oShape.tr = {x:dShapeInner.tr.x - this._stroke, y:dShapeInner.tr.y + this._stroke};
			oShape.br = {x:dShapeInner.br.x - this._stroke, y:dShapeInner.br.y - this._stroke};
			oShape.bl = {x:dShapeInner.bl.x + this._stroke, y:dShapeInner.bl.y - this._stroke};
			oShape.tl = {x:dShapeInner.tl.x + this._stroke, y:dShapeInner.tl.y + this._stroke};

			// rebuild svg

			let newD = '';

			newD += 'M' + oShape.tr.x + ',' + oShape.tr.y + 'L' + oShape.br.x + ',' + oShape.br.y + 'L' + oShape.bl.x + ',' + oShape.bl.y + 'L' + oShape.tl.x + ',' + oShape.tl.y + 'L' + oShape.tr.x + ',' + oShape.tr.y + 'z';

			// fix viewbox

			$value.removeAttr('viewBox');
			$value[0].setAttribute('viewBox', '0 0 ' + this._width + ' ' + this._height);

			// if texture, randomize location

			if(this.$el.hasClass('textured')){

				let $pattern = this.$el.find('defs pattern');
				let $image = this.$el.find('defs image');

				let oShapeWidth = Math.max(oShape.tr.x, oShape.br.x) - Math.max(oShape.tl.x, oShape.bl.x);
				let oShapeHeight = Math.max(oShape.br.y, oShape.bl.y) - Math.max(oShape.tr.y, oShape.tl.y);

				let randX = Math.round(Math.random() * (oShapeWidth - parseFloat($pattern.attr('width'))));
				let randY = Math.round(Math.random() * (oShapeHeight - parseFloat($pattern.attr('height'))));

				$pattern.removeAttr('x');
				$pattern.removeAttr('y');
				$pattern[0].setAttribute('x', randX + 'px');
				$pattern[0].setAttribute('y', randY + 'px');

				$image.removeAttr('x');
				$image.removeAttr('y');
				$image[0].setAttribute('cx', randX);
				$image[0].setAttribute('cy', randY);
			}

			// fix shape

			$value.find('path').attr('d', newD);
		});
	}

	resize(noRedraw){

		if(this._isResponsive){

			this._width = this.$el.outerWidth();
			this._height = this.$el.outerHeight();

			if(!noRedraw){ this.redraw(); }
		}
	}

	// getters / setters

	get width(){ return this._width; }
	set width(value){
		this.width = value;
		this.redraw();
	}

	get height(){ return this._height; }
	set height(value){
		this.height = value;
		this.redraw();
	}
}

module.exports = RandomRect;

},{}],136:[function(require,module,exports){
/*===============================
=            FOR SHAME          =
===============================*/

(function($){

	/* jshint devel:true */
	'use strict';

	window.SHAME = {};

	var SHAME = window.SHAME;

	var $window      = $(window),
		$body        = $(document.body),
		$html        = $(document.documentElement);

	SHAME.init = function(){
		(function(l){var i,s={touchend:function(){}};for(i in s)l.addEventListener(i,s)})(document); // sticky hover fix in iOS
	};

	$(document).ready(function(){
		SHAME.init();
	});

})(window.jQuery);

/*====  End of FOR SHAME  =====*/


/*============================================
=            Example JS Functions            =
============================================*/

// // this is best
// // Locally scoped Object Literal

// var Module = (function () {

// 	// locally scoped Object
// 	var myObject = {};

// 	// declared with `var`, must be "private"
// 	var _privateMethod = function () {

// 	};

// 	myObject.someMethod = function () {
// 		// take it away Mr. Public Method
// 	};

// 	return myObject;

// })();


// // revealing pattern
// var Module = (function () {

// 	var _privateMethod = function () {
// 		// private
// 	};

// 	var someMethod = function () {
// 		// public
// 		_privateMethod();
// 	};

// 	var anotherMethod = function () {
// 		// public
// 	};

// 	return {
// 		someMethod: someMethod,
// 		anotherMethod: anotherMethod
// 	};

// })();






// (function( root, $, undefined ) {

// 	"use strict";

// 	$(function () {

// 		// DOM ready, take it away

// 		var tour = new tour();
// 		tour.init();
// 		tour.elems();

// 		alerts();

// 		function tour() {
// 			self.init = function() {
// 				console.log('tour init');
// 				foobar();
// 			}
// 			self.elems = function(){
// 				console.log('set elems');
// 			}
// 			function foobar() {
// 				console.log('foobar');
// 			}
// 			return self;
// 		}

// 		function alerts() {

// 			init();

// 			function init(){
// 				console.log('alerts init');
// 				elems();
// 			}

// 			function elems(){
// 				console.log('alerts elem init');
// 				foobar();
// 			}

// 			function foobar() {
// 				console.log('alerts foobar');
// 			}
// 		}

// 	});

// } ( this, jQuery ));




// (function( root, $, undefined ) {

// 	"use strict";

	// $(function () {

		// DOM ready, take it away


	// });

// } ( this, jQuery ));




// (function (root, factory) {
// 	if (typeof define === 'function' && define.amd) {
// 		define(factory);
// 	} else if (typeof exports === 'object') {
// 		module.exports = factory;
// 	} else {
// 		root.MYPROJECT = factory();
// 	}
// })(this, function () {

// 	'use strict';

// 	var exports = {};

// 	exports.init = function () {};

// 	return exports;

// });


/*=====  End of Example JS Functions  ======*/

},{}]},{},[1])

